(function () {
  'use strict';

  angular
    .module('erpRetail', [
      'ngAnimate',
      'ngCookies',
      'ngLocale',
      'ngMessages',
      'ngResource',
      'ngSanitize',
      'ngStorage',
      'ngTouch',
      'angular-table',
      'angular.filter',
      'angularFileUpload',
      'angularUtils.directives.dirPagination',
      'angularValidator',
      'as.sortable',
      'bootstrapLightbox',
      'CookieComponent',
      'gridster',
      'jlareau.pnotify',
      'oc.lazyLoad',
      'pascalprecht.translate',
      'truncate',
      'ui.ace',
      'ui.bootstrap',
      'ui.cgdevtools',
      'ui.CGImageCache',
      'ui.router',
      'ui.sortable',
      'ui.tinymce',
      'ui.tree',
      'xeditable',
      'cgReservasEstadias',
      'pl.comps'
    ])
    .config(function ($logProvider, $stateProvider, $urlRouterProvider, $locationProvider, $httpProvider, $translateProvider, plFormatProvider, ENV, KEYCODE, $qProvider) {
      if (ENV !== 'dev') {
        $stateProvider.stateService.defaultErrorHandler(function () {
          // Do not log transitionTo errors
        });
      }

      $qProvider.errorOnUnhandledRejections(false);

      $translateProvider.useStaticFilesLoader({
        prefix: 'i18n/locale-',
        suffix: '.json'
      });
      $translateProvider.preferredLanguage('pt-pt');
      $translateProvider.useCookieStorage();
      $translateProvider.useSanitizeValueStrategy('escaped');

      moment.locale('pt-pt');

      plFormatProvider.setFormat({
        decimalsSeparator: ',',
        decimalsSeparatorCode: KEYCODE.COMMA,
        decimalsLimit: 2,
        thousandsSeparator: '.'
      });

      $stateProvider
        .state('home', {
          url: '/',
          title: 'Home',
          abstract: true,
          templateUrl: 'app/index.html',
          controller: function (configSite) {
          },
          controllerAs: 'ctrl',
          resolve: {
            configSite: ['configFactory', function (configFactory) {
              return configFactory.getConfigSite();
            }]
          }
        });
    })
    .run(function ($rootScope, $window, $transitions, $state, $stateParams, $translate, Auth, editableOptions, CONFIG, configFactory, ENV, ImagensFactory,
                   $rootElement, $sce, $location, plTranslate, localStorageService) {
      $rootScope.ENV = ENV;
      $rootScope.getDatetime = new Date();
      $rootScope.$state = $state;
      $rootScope.$stateParams = $stateParams;
      $rootScope.$config = {loaded: false, getTemplate: configFactory.getTemplate, metaTitle: null};
      $rootScope.app = {};
      $rootScope.getImagem = ImagensFactory.getImagem;

      $rootScope.init = init;
      $rootScope.getLogo = getLogo;
      $rootScope.getLogoLogin = getLogoLogin;
      $rootScope.getFavicon = getFavicon;
      $rootScope.setCss = setCss;
      $rootScope.globalGoTo = globalGoTo;
      $rootScope.globalTranslate = globalTranslate;
      $rootScope.goBack = goBack;
      $rootScope.home = home;

      $rootScope.init();

      /////////////

      function init() {
        plTranslate.setTranslateFn($rootScope.globalTranslate);
        editableOptions.theme = 'bs3';

        configFactory.getConfigSite().then(function (data) {
          $rootScope.setCss(data.modelos.maincss);
        });

        $transitions.onStart({}, function ($transition) {
          var toState = $transition.$to();
          var params = $transition.params();
          $rootScope.app.state = toState.self;
          $rootScope.app.stateParams = params;

          configFactory.getConfigSite().then(
            function (response) {
              if (response.siteFixedTitle) {
                $rootScope.$config.data.metaTitle = plTranslate.translate(response.siteFixedTitle);
              }
              else if (toState.self.title) {
                // Set meta title
                var pageTitle = toState.self.title.toString().trim() !== '' ? ' - ' + plTranslate.translate(toState.self.title) : '';
                $rootScope.$config.data.metaTitle = $rootScope.$config.data.siteName + pageTitle;
              }

              // Trying to access sign up but it is disabled
              if (toState.self.name === 'signup' && parseInt(response.siteSignupEnabled) === 0) {
                $transition.router.stateService.go('login', {ReturnState: toState.self.name, Params: angular.toJson(params)});
              }

              // Trying to access sign up but it is disabled
              if (toState.self.name !== 'user.recover_email' && toState.self.name !== 'user.confirm_token' &&
                toState.self.name !== 'user.nova' && toState.self.name !== 'signup' && response.siteLojaRegisteredOnly && !Auth.isLoggedIn()) {
                $transition.router.stateService.go('login');
              }
            }
          );

          var fromState = $transition.$from();
          if (fromState.name === '') {
            var refreshed = localStorageService.get('refreshed') || false;
            $rootScope.app.refreshed = refreshed === true || refreshed === 'true';
            localStorageService.set('refreshed', false);
          }

          // Preserving query params
          var queryParams = $location.search();
          if (queryParams) {
            // Checking if we're in a detail page; if so, we don't save it's params
            for (var param in queryParams) {
              if (queryParams.hasOwnProperty(param) && param.indexOf('type') !== -1 && queryParams[param].toString().indexOf('detail') !== -1) {
                return;
              }
            }
            $rootScope.app.queryParams = queryParams;
          }

          $rootScope.app.params = params;

          if (!params) {
            return;
          }
          Auth.isLoggedInAsync(function (loggedIn) {
            if ((params.authenticate === true || params.authenticate === 'admin') && loggedIn === false) {
              $transition.router.stateService.go('login', {ReturnState: toState.self.name, Params: angular.toJson(params)});
            }
          });
        });

        // New implementation of the old $stateChangeStart
        $transitions.onSuccess({}, function ($transition) {
          var fromState = $transition.$from();
          var fromParams = $transition.params('from');
          $rootScope.app.previousState = fromState.name;
          $rootScope.app.previousStateParams = _.merge({}, $rootScope.app.queryParams, fromParams);
        });
      }

      function getLogo() {
        if ($rootScope.$config.loaded) {
          return ImagensFactory.getImagem($rootScope.$config.data.siteLogo, 'assets/images/online-store-logo.png');
        }
      }

      function getLogoLogin() {
        if ($rootScope.$config.loaded) {
          return ImagensFactory.getImagem($rootScope.$config.data.loginLogo, 'assets/images/online-store-logo.png');
        }
      }

      function getFavicon() {
        if ($rootScope.$config.loaded) {
          return $sce.trustAsResourceUrl(ImagensFactory.getImagem($rootScope.$config.data.sitefavicon, 'assets/images/favicon.ico'));
        }
      }

      function setCss(css) {
        if (angular.isUndefined($rootScope.css)) {
          $rootScope.css = angular.element('<style>');
          $rootElement.append($rootScope.css);
        }
        $rootScope.css.text('\n' + css + '\n');
      }

      function globalGoTo(name, params, options) {
        $state.go(name, params, options);
      }

      function globalTranslate(key, params, config) {
        return $translate.instant(key, params, config);
      }

      function goBack() {
        if ($rootScope.app.previousState === '' || $window.history.length === 0) {
          return $rootScope.home();
        }
        else if (!$rootScope.app.previousState || !$state.get($rootScope.app.previousState) || $rootScope.app.previousState === 'disconnected') {
          return $window.history.back();
        }
        else {
          return $state.go($rootScope.app.previousState, $rootScope.app.previousStateParams).then(null, function () {
            $rootScope.home();
          });
        }
      }

      function home() {
        return $state.go('loja.home', {id: 'inicio'});
      }
    });
})();

/* eslint-disable */
(function () {
  'use strict';

  angular.module('erpRetail')
    .config(function () {
      if (!String.prototype.format) {
        String.prototype.format = function () { // jshint ignore:line
          var args = arguments;
          return this.replace(/{(\d+)}/g, function (match, number) {
            return angular.isDefined(args[number]) ? args[number] : match;
          });
        };
      }

      /*window.deepFreeze = function deepFreeze(object) { // jshint ignore:line
        for (var property in Object.getOwnPropertyNames(object)) {
          if (object.hasOwnProperty(property)) {
            var value = object[property];
            object[property] = value && typeof value === 'object' ? deepFreeze(value) : value;
          }
        }
        return Object.freeze(object);
      };*/
    });
})();

/* jshint ignore:start */
 (function () {
    'use strict';
    // DO NOT EDIT THIS FILE, EDIT THE GULP TASK NGCONSTANT SETTINGS INSTEAD WHICH GENERATES THIS FILE
    angular
        .module('erpRetail')
        .constant('VERSION', "1.0.0.0")
        .constant('ENV', "PROD")
        .constant('API_URL', "")
;
})();
/* jshint ignore:end */

(function () {
  'use strict';

  angular.module('erpRetail')
    .constant('CONFIG', {
      USE_DEFAULT: false,
      SITE_CONFIG: {
        siteName: 'ERPRetail',
        siteUrl: '',
        siteLogo: 'assets/images/ERPRetail-services-inv.png',
        ivaIncluido: true,
        googleAnalytics: '',

        modelos: {
          box: '',
          list: '',
          detalhe: ''
        },
        modelosClassificador: {
          box: '',
          list: '',
          detalhe: ''
        },
        classificadores: [
          {
            tipo: 'familias',
            caption: 'Tipo',
            position: 0,
            visible: true
          },
          {
            tipo: 'classes',
            caption: 'Marca',
            position: 1,
            visible: true
          },
          {
            tipo: 'grandesFamilias',
            caption: 'Género',
            position: 2,
            visible: true
          },
          {
            tipo: 'subFamilias',
            caption: 'Volume',
            position: 3,
            visible: true
          },
          {
            tipo: 'categorias',
            caption: 'Categoria',
            position: 4,
            visible: true
          },
          {
            tipo: 'tipos',
            caption: 'Tipos',
            position: 5,
            visible: false
          },
          {
            tipo: 'tags',
            caption: 'Tags',
            position: 6,
            visible: false
          }
        ]
      }
    })
    .provider('REST_API', function (API_URL) {
      var provider = {
        ADMIN_CONFIG_ALL: 'api/config/todos',
        ADMIN_SYNC_ALL: 'api/sincronizar/inicio',
        ADMIN_SYNC_ALL_COMPLETE: 'api/sincronizar/completo',
        ADMIN_SYNC_IMAGES: 'api/sincronizar/imagens/0',
        ADMIN_SYNC_IMAGES_ALL: 'api/sincronizar/imagens/1',
        ADMIN_SYNC_STATUS: 'api/sincronizar/estado',
        ADMIN_CLIENTES_ALL: 'api/clientes/todos',
        USER_ME: 'api/utilizador',
        USER: 'api/utilizador/id', //:id
        USER_ALL: 'api/utilizador/todos',
        USER_EMAIL_CONFIRM: 'api/utilizador/emailconfirmacao',
        USER_EMAIL_VALIDATION: 'api/utilizador/confirmaemail',
        USER_EMAIL_RECOVER: 'api/utilizador/recuperar',
        USER_EMAIL_EXISTS: 'api/utilizador/emailexists', //:email
        USER_NOVA_PASSWORD: 'api/utilizador/nova',
        USER_MUDAR_PASSWORD: '/password',
        DOCUMENTOS_ALL: 'api/documentos/todos',
        DOCUMENTOS_CLIENTE: 'api/documentos/cliente',
        DOCUMENTOS_COMERCIAIS: 'api/documentos/docscomerciaisonline',
        DOCUMENTOS_ENCOMENDAS: 'api/documentos/encomendaspendentesonline',
        DOCUMENTOS_MOVIMENTOS: 'api/documentos/movimentosemaberto',
        DOCUMENTOS_ONLINE: 'api/documentos/documentoonline',
        DOCUMENTOS_EXPORT: 'api/documentos/exporttopdfonline',
        DOCUMENTO: 'api/documentos/doc', // :mbfaccbid
        MEIOS_PAGAMENTO: 'api/documentos/meiospagamento',
        REFERENCIASMB: 'api/documentos/referenciasmultibanco', // :mbfaccbid
        CLIENTE: 'api/clientes/eu',
        CLIENTEMORADASALTERNATIVAS: 'api/clientes/moradasalternativas',
        CLIENTEMORADASALTERNATIVASEDIT: 'api/clientes/moradaalternativa',
        CLIENTES: 'api/clientes/todos',
        PAISES: 'api/paises/paisesiso',
        CONFIG_VALUE: 'api/config/valor',
        CONFIG_INFO: 'api/config/info',
        CONFIG_SITE: 'api/config/site',
        CONFIG_SITE_ADMIN: 'api/config/siteadmin',
        CONFIG_MENU_BUILD: 'api/config/menu',
        CONFIG_CLASSIFICADORES: 'api/config/classificadores',
        CONFIG_CONDICOES_PAGAMENTO: 'api/config/condicoespagamento',
        CONFIG_TRANSPORTADORAS: 'api/config/transportadoras',
        EMAIL_CONTACT: 'api/email/sendcontact',
        LOGIN: 'api/login',
        LOGOUT: 'api/logout',
        EMPRESA: 'api/empresa',
        PRODUTOS_CATALOGOS: 'api/artigos/catalogos',
        PRODUTOS_CATALOGO: 'api/artigos/catalogo', //:catalogoCab
        PRODUTOS_IMAGE_PATH: 'api/artigos/imagem/', //:imagem
        PRODUTOS_NOIMAGE: 'assets/images/produtos/noimage.jpg',
        MODELOS: 'api/modelos', //:tipos
        MODELOS_TIPOS: 'api/modelos/tipos',
        MODELOS_ORIGINAL: 'api/modelos/original', //:typo
        CHECKOUT: 'api/artigos/checkout',
        IMAGE_UPLOAD: 'api/imagens/upload',
        IMAGE_LIST: 'api/imagens/list', // : folder
        IMAGE_GET: 'api/imagem',
        IMAGE_RENAME: 'api/imagem/renomar',
        PAGINAS_TODAS: 'api/paginas/todas',
        PAGINA: 'api/pagina', //:id
        PAGAMENTO_PAYPAL: 'api/pagamentos/paypal/inicio',
        PAGAMENTO_SET_PAYED: 'api/pagamentos/setpayed', //:mbfaccbid
        PRODUTOS_TODOS: 'api/artigos/todos',
        PRODUTO_DETALHE: 'api/artigos/detalhe',
        PRODUTO_BASKET_CALC: 'api/artigos/basketcalc',
        PRODUTO_PESQUISA: 'api/artigos/pesquisa',
        PRODUTO_TEXTO_CLASSIFICADOR: 'api/artigos/textosclassificador',
        PRODUTO_ANEXOS: 'api/artigos/documentos',
        PRODUTO_DOCUMENTO: 'api/artigos/documento',
        PAGAMENTO_CONDICOES_PAGAMENTO: 'api/pagamentos/condicoespagamento',
        PAGAMENTO_TRANSPORTADORAS: 'api/pagamentos/transportadoras',
        PAGAMENTO_REGIOES: 'api/pagamentos/regioes',
        PAGAMENTO_CUSTOCAB: 'api/pagamentos/custoCab',
        PAGAMENTO_CUSTOLIN: 'api/pagamentos/custoLin',
        TRANSPORTADORAS: 'api/transportadoras',
        CTT_CODIGO_POSTAL: 'api/ctt/codigopostal',
        $get: /*@ngInject*/ factory
      };
      return provider;

      /////////////

      function factory($location) {
        if (API_URL === '') {
          var aux = $location.absUrl();
          aux = aux.split('#');
          if (aux.length > 0) {
            API_URL = aux[0];
          }
        }

        return angular.extend({}, provider, {
          HOST: API_URL
        });
      }
    })
    .config(/*@ngInject*/ function ($ocLazyLoadProvider, plEditProvider, $urlServiceProvider) {
      $ocLazyLoadProvider.config({
        modules: [
          {
            name: 'ace',
            files: [
              'node_modules/ace-builds/src-noconflict/ace.js',
              'node_modules/ace-builds/src-noconflict/theme-monokai.js',
              'node_modules/ace-builds/src-noconflict/worker-json.js',
              'node_modules/ace-builds/src-noconflict/mode-json.js',
              'node_modules/ace-builds/src-noconflict/mode-html.js',
              'node_modules/ace-builds/src-noconflict/mode-css.js'
            ]
          }
        ]
      });

      plEditProvider.map('text', 'nif', {validators: {minlength: 9, maxlength: 9}});
      
      var REGEX_GUID = new RegExp(/^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/, 'g');
      $urlServiceProvider.config.type('guid', {
        name: 'guid',
        definition: {
          encode: function (value) {
            return encodeURI(value);
          },
          decode: function (value) {
            return decodeURI(value);
          },
          pattern: REGEX_GUID,
          equals: function (a, b) {
            return a.trim() === b.trim();
          },
          is: function (val) {
            return REGEX_GUID.test(val);
          }
        }
      });
      
    });
}());

(function () {
  'use strict';

  angular.module('erpRetail')
    .config(/*@ngInject*/ function ($stateProvider) {
      $stateProvider
        .state('login', {
          url: '/login?ReturnState?Params',
          title: 'Autenticação',
          templateUrl: 'app/account/login/login.html',
          controller: 'LoginController',
          controllerAs: 'ctrl'
        })
        .state('logout', {
          url: '/logout',
          controller: function (Auth, $state, PopAlert) {
            Auth.logout();
            $state.go('loja.home', {id: 'inicio'});
            PopAlert.showSuccess('Sessão foi terminada');
          }
        })
        .state('signup', {
          url: '/signup',
          title: 'Registar',
          templateUrl: 'app/account/signup/signup.html',
          controller: 'SignupController'
        })
        .state('user', {
          abstract: true,
          url: '/utilizador',
          template: '<ui-view/>'
        })
        .state('user.confirm_email', {
          url: '/confirmaemail',
          templateUrl: 'app/account/confirma_email/confirma_email.html',
          controller: 'UtilizadorConfirmaEmailController'
        })
        .state('user.confirm_token', {
          url: '/confirmatoken/:token',
          templateUrl: 'app/account/confirma_token/confirma_token.html',
          controller: 'UtilizadorConfirmaTokenController',
          controllerAs: 'ctrl'

        })
        .state('user.recover_email', {
          url: '/recuperar?ReturnState?Params',
          templateUrl: 'app/account/recuperar/recuperar.html',
          controllerAs: '$ctrl',
          controller: 'UtilizadorRecuperarController'
        })
        .state('user.nova', {
          url: '/nova',
          title: 'Nova palavra-passe',
          templateUrl: 'app/account/nova_palavra_passe/nova_palavra_passe.html',
          controller: 'UtilizadorNovaPalavraPasseController'
        });
    });
}());

(function () {
    'use strict';

    angular.module('erpRetail')
      .controller('UtilizadorConfirmaEmailController', ['$scope', 'Auth', '$state', function ($scope, Auth, $state) {
            $scope.email = Auth.getEmailToConfirm();


            $scope.run = function () {
                if (angular.isUndefined($scope.email) || angular.isUndefined($scope.email.email) || $scope.email.email.length === 0) {
                  $state.go('loja.home', {id: 'home'});
                }
            };

            $scope.enviar = function () {
                Auth.sendEmailToConfirm($scope.email.email);
            };

            $scope.run();

        }]);
}());

(function () {
  'use strict';

  angular.module('erpRetail')
    .controller('UtilizadorConfirmaTokenController', /*@ngInject*/ function ($rootScope, $scope, Auth, $state, $stateParams, PopAlert, configFactory, $transition$) {
      var ctrl = this;
      ctrl.token = $stateParams.token;
      ctrl.state = 'LOGIN_TOKEN_WAIT';
      ctrl.enableSignUp = true;

      ctrl.$onInit = init;

      function init() {
        ctrl.params = $transition$.params();
        configFactory.getConfigSite().then(
          function (response) {
            // Trying to access sign up but it is disabled
            if (parseInt(response.siteSignupEnabled) === 0) {
              ctrl.enableSignUp = false;
            }
          }
        );

        ctrl.state = 'LOGIN_TOKEN_WAIT';
        Auth.validatetoken(ctrl.token).then(function (result) {
          ctrl.state = result.state;
          ctrl.email = '';
          Auth.setRecover('');
          switch (ctrl.state) {
            case 'OK':
              ctrl.state = 'LOGIN_TOKEN_OK';
              PopAlert.showSuccess('Email ativado com sucesso!');
              $state.go('login');
              break;
            case 'NOT_FOUND':
              ctrl.state = 'LOGIN_TOKEN_NOT_FOUND';
              break;
            case 'EXPIRED':
              ctrl.state = 'LOGIN_TOKEN_EXPIRED';
              ctrl.email = result.email;
              break;
            case 'RECOVER':
              Auth.setRecover(ctrl.token);
              $state.go('user.nova');
              break;
            default :
              ctrl.state = 'LOGIN_TOKEN_UNKNOWN';
              break;
          }
        });
      }


      ctrl.notOk = function () {
        return !(ctrl.state === 'LOGIN_TOKEN_OK' || ctrl.state === 'LOGIN_TOKEN_WAIT');
      };

      ctrl.enviar = function () {
        Auth.sendEmailToConfirm(ctrl.email);
        ctrl.go('user.confirm_email');
      };

    });
})();

(function () {
  'use strict';

  angular.module('erpRetail')
    .controller('DisconnetedController', function ($rootScope) {
      var ctrl = this;
      ctrl.$config = $rootScope.$config;
      ctrl.back = $rootScope.goBack;
    });
})();

(function () {
  'use strict';

  angular.module('erpRetail')
    .config(function ($stateProvider) {
      $stateProvider
        .state('disconnected', {
          url: '/disconnected',
          templateUrl: 'app/account/disconnected/disconnected.html',
          controller: 'DisconnetedController',
          controllerAs: '$ctrl'
        });
    });
}());

(function () {
  'use strict';

  angular.module('erpRetail')
    .controller('LoginController', /*@ngInject*/ function ($rootScope, $scope, Auth, $location, $window, $log, $state, $stateParams, configFactory,
                                                           $timeout, Utils, PopAlert, $transition$) {
      var ctrl = this;

      ctrl.formlogin = {};
      ctrl.user = {};
      ctrl.errors = {};
      ctrl.passwordValidator = Auth.passwordValidator;
      ctrl.enableSignUp = true;
      ctrl.promise = null;

      ctrl.$onInit = init;
      ctrl.login = login;
      ctrl.loginOauth = loginOauth;
      ctrl.confirmaEmail = confirmaEmail;

      /////////////

      function init() {
        ctrl.params = $transition$.params();
        configFactory.getConfigSite().then(
          function (response) {
            // Trying to access sign up but it is disabled
            if (parseInt(response.siteSignupEnabled) === 0) {
              ctrl.enableSignUp = false;
            }
          }
        );
      }

      function login(isValid) {
        ctrl.formlogin.$setSubmitted();
        if (!isValid) {
          return;
        }

        var data = {
          email: ctrl.user.email,
          password: ctrl.user.password
        };
        ctrl.promise = Auth.login(data).then(
          function () {
            if (angular.isDefined($stateParams.ReturnState)) {
              if ($stateParams.ReturnState === 'signup') {
                $state.go('loja.home', {id: 'inicio'});
                return;
              }
              $state.go($stateParams.ReturnState, angular.fromJson($stateParams.Params));
              return;
            }
            $state.go('loja.home', {id: 'inicio'});
          },
          function (error) {
            ctrl.errors = {};
            if (Utils.isNullOrEmpty(error.data)) {
              PopAlert.showError(Utils.translate('LOGIN_ERROR_CANT_LOGIN'));
            }
            ctrl.errors.other = error.data.state;
            if (error.data.state === 'LOGIN_USER_UNVERIFIED') {
              ctrl.errors.sendemail = 'LOGIN_SEND_CONFIRMATION_MAIL';
            }
            else if (error.data.state === 'LOGIN_WRONG_PASSWORD') {
              ctrl.errors.recoveremail = 'LOGIN_RECOVER_MAIL';
            }
          }
        )['finally'](function () {
          ctrl.promise = null;
        });
      }

      function loginOauth(provider) {
        $window.location.href = '/auth/' + provider;
      }

      function confirmaEmail() {
        Auth.sendEmailToConfirm(ctrl.user.email);
        $state.go('user.confirm_email');
      }
    });
})();

(function () {
    'use strict';

    angular.module('erpRetail')
      .controller('UtilizadorNovaPalavraPasseController',
            ['$scope', 'Auth', '$filter', '$state', 'PopAlert',
                function ($scope, Auth, $filter, $state, PopAlert) {
                  $scope.token = '';
                  $scope.password = '';

                    $scope.ok = function () {
                      return (!($scope.token === null || angular.isUndefined($scope.token) || $scope.token === ''));
                    };

                    $scope.novaPassword = function (form) {
                        if (!form.$valid) {
                            PopAlert.showError($filter('translate')('FORM_INVALID'));
                            return;
                        }
                        Auth.novaPassword($scope.token, $scope.password).then(function () {
                            PopAlert.showSuccess($filter('translate')('LOGIN_PASSWORD_CHANGED'));
                          $state.go('login');
                        }, function () {
                            PopAlert.showError($filter('translate')('LOGIN_PASSWORD_ERROR'));
                        });
                    };

                    $scope.passwordValidator = Auth.passwordValidator;

                    $scope.run = function run() {
                        $scope.token = Auth.getRecover();
                    };

                    $scope.run();

                }]);
}());

(function () {
  'use strict';

  angular.module('erpRetail')
    .controller('UtilizadorRecuperarController', function ($scope, Auth, $filter, $state, $transition$, plAlertService) {
      var ctrl = this;

      ctrl.email = '';
      ctrl.params = {};
      ctrl.promise = null;

      ctrl.$onInit = init;
      ctrl.recuperar = recuperar;

      /////////////

      function init() {
        ctrl.params = $transition$.params();
      }

      function recuperar() {
        ctrl.promise = Auth.recuperar($scope.email).then(
          function () {
            plAlertService.success('LOGIN_PASS_RECOVER_SEND_EMAIL');
            $state.go('login', {ReturnState: ctrl.params.ReturnState, Params: ctrl.params.Params});
          },
          function () {
            plAlertService.error('LOGIN_ERROR_EMAIL_NOT_FOUND');
          }
        )['finally'](function () {
          ctrl.promise = null;
        });
      }
    });
})();

(function () {
  'use strict';

  angular.module('erpRetail')
    .controller('SignupController', /*@ngInject*/ function ($scope, Auth, $location, $window, $log, $state, PopAlert) {
      $scope.user = {};
      $scope.errors = {};

      $scope.register = function (form) {
        if (!form.$valid) {
          return;
        }

        var newUser = {
          name: $scope.user.name,
          email: $scope.user.email,
          password: $scope.user.password,
          baseUrl: Auth.baseUrl()
        };

        Auth.createUser(newUser).then(
          function (status) {
            switch (status.state) {
              case 'USER_EXISTS_UNVERIFIED':
                $state.go('user.confirm_email');
                break;
              case 'USER_CREATED_UNVERIFIED':
                $state.go('user.confirm_email');
                break;
              case 'USER_EXISTS':
                PopAlert.showError('A conta ' + $scope.user.email + ' já existe');
                break;
              default:
                $state.go('e404');
                break;
            }
          },
          function (error) {
            PopAlert.showError(error);
          }
        );
      };

      $scope.registerOauth = function (provider) {
        $window.location.href = '/auth/' + provider;
      };

      $scope.passwordValidator = function (password) {
        if (!password) {
          return;
        }

        if (password.length < 5) {
          return 'LOGIN_ERROR_PASS_VALIDATION';
        }

        return true;
      };
    });
})();

(function () {
  'use strict';

  angular.module('erpRetail')
    .config(function ($stateProvider) {
      $stateProvider
        .state('admin', {
          url: '/admin',
          title: 'Admin',
          params: {authenticate: 'admin'},
          redirectTo: 'admin.config',
          resolve: {
            'configSite': /*@ngInject*/ function (configFactory) {
              return configFactory.getConfigSite();
            }
          },
          views: {
            '': {
              templateUrl: 'app/admin/admin.html'
            },
            'header': {
              templateUrl: 'app/admin/header.html',
              controller: 'HomeController'
            },
            'footer': {
              templateUrl: 'app/admin/footer.html'
            }
          }
        })
        .state('admin.menu', {
          url: '/menu',
          title: 'Menu',
          params: {authenticate: 'admin'},
          templateUrl: 'app/admin/menu/menu.html',
          controllerAs: 'ctrl',
          controller: 'MenuController'
        })

        .state('admin.sincronizacao', {
          url: '/sincronizacao',
          title: 'Sincronização',
          params: {authenticate: 'admin'},
          templateUrl: 'app/admin/sincronizacao/sincronizacao.html',
          controller: 'SincronizacaoController'
        })
        .state('admin.documentos', {
          url: '/documentos/:mbfaccbId',
          title: 'Documentos',
          params: {
            authenticate: 'admin',
            mbfaccbId: { // Optional parameter
              value: null,
              squash: true,
              dynamic: true
            }
          },
          templateUrl: 'app/admin/documentos/documentos.html',
          controller: 'DocumentosController',
          controllerAs: 'ctrl'
        })
        .state('admin.clientes', {
          url: '/clientes',
          params: {authenticate: 'admin'},
          title: 'Clientes',
          templateUrl: 'app/admin/clientes/clientes.html',
          controller: 'ClientesController',
          controllerAs: 'ctrl'
        })
        .state('admin.homeedit', {
          url: '/home-editar',
          params: {authenticate: 'admin'},
          title: 'Editar home',
          templateUrl: 'app/admin/home/homeEdit.html',
          controller: 'HomeEditController'
        })
        .state('admin.modelos', {
          url: '/modelos?modelo',
          params: {authenticate: 'admin'},
          title: 'Editar modelos',
          templateUrl: 'app/admin/modelos/modelos.html',
          controller: 'ModelosController',
          resolve: {
            'config': ['configFactory', function (configFactory) {
              return configFactory.getConfigSite();
            }],
            'ace': function ($ocLazyLoad) {
              return $ocLazyLoad.load('ace');
            }
          }
        });
    });
})();

(function () {
  'use strict';

  angular.module('erpRetail')
    .controller('ClientesController', /*@ngInject*/ function ($q, $state, $http, $filter, $log, REST_API, cgClass, clienteService) {
      var ctrl = this;

      ctrl.list = [];
      ctrl.filteredList = [];
      ctrl.configClientes = {};

      ctrl.$onInit = init;
      ctrl.onLoad = onLoad;
      ctrl.updateFiltered = updateFiltered;

      /////////////////

      function init() {
        ctrl.configClientes = {
          itemsPerPage: 10,
          maxPages: 10,
          fillLastPage: true,
          orderBy: 'AIOrderBy'
        };
        ctrl.onLoad();
      }

      function onLoad() {
        var deferred = $q.defer();
        clienteService.getClienteAll()
          .then(function (response) {
            ctrl.list = response.data;
            ctrl.filteredList = ctrl.list;
            deferred.resolve();
          })
          .catch(function (reason) {
            deferred.reject(reason);
          });
        return deferred.promise;
      }

      function updateFiltered() {
        ctrl.filteredList = [];
        var search = ctrl.searchText;
        if (search === '' || search === null || angular.isUndefined(search)) {
          ctrl.filteredList = ctrl.list;
          return;
        }
        search = cgClass.accentFold(search.toLowerCase()).split(' ');
        angular.forEach(ctrl.list, function (item) {
          var ok = true;
          for (var j = 0; j < search.length; j++) {
            var key = search[j];
            ok = ok && (
              (item.nconta !== null && cgClass.accentFold(item.nconta.toLowerCase()).indexOf(key) >= 0) ||
              (item.nome !== null && cgClass.accentFold(item.nome.toLowerCase()).indexOf(key) >= 0) ||
              (item.ncontribuint !== null && item.ncontribuint.toLowerCase().indexOf(key) >= 0) ||
              (item.lugar !== null && cgClass.accentFold(item.lugar.toLowerCase()).indexOf(key) >= 0) ||
              (item.codPostal !== null && item.codPostal.toLowerCase().indexOf(key) >= 0) ||
              (item.localidade !== null && cgClass.accentFold(item.localidade.toLowerCase()).indexOf(key) >= 0) ||
              (item.telefone !== null && item.telefone.toLowerCase().indexOf(key) >= 0) ||
              (item.telemovel !== null && item.telemovel.toLowerCase().indexOf(key) >= 0) ||
              (item.rua !== null && cgClass.accentFold(item.rua.toLowerCase()).indexOf(key) >= 0) ||
              (item.email !== null && item.email.toLowerCase().indexOf(key) >= 0));
            if (!ok) {
              break;
            }
          }
          if (ok) {
            ctrl.filteredList.push(item);
          }
        });
      }
    });
})();

(function () {
  'use strict';

  angular.module('erpRetail')
    .controller('ConfigClassificadoresPropertiesController', function (classificador, save, plAlertService, configFactory) {
      var ctrl = this;

      ctrl.item = {};
      ctrl.properties = [];

      ctrl.$onInit = init;
      ctrl.doSave = doSave;

      /////////////

      function init() {
        ctrl.item = classificador;
        ctrl.properties = [
          {name: 'visible', type: 'boolean', caption: 'admin.classificadores.properties.visible'},
          {name: 'open', type: 'boolean', caption: 'admin.classificadores.properties.open'},
          {name: 'visibleInMenu', type: 'boolean', caption: 'admin.classificadores.properties.visibleInMenu'}
        ];
      }

      function doSave() {
        if (!ctrl.item) {
          plAlertService.error('admin.errors.invalidValue');
          return;
        }
        return save().then(function () {
          ctrl.$close(ctrl.item);
        });
      }
    });
})();

(function () {
  'use strict';

  angular.module('erpRetail')
    .controller('ConfigController', function (configFactory, $log, $filter, $q, $http, emailService, Utils, imagePick, $stateParams, $state, PopAlert, CGModalService,
                                              PagamentosFactory, TransportadorasFactory) {
      var ctrl = this;

      ctrl.classificadoresList = configFactory.classificadoresList;
      ctrl.condicoesPagamentoList = configFactory.condicoesPagamentoList;
      ctrl.transportadoraList = configFactory.transportadorasList;

      ctrl.myFilter = '';
      ctrl.config = {
        itemsPerPage: 20,
        maxPages: 15,
        fillLastPage: true
      };
      ctrl.info = [];
      ctrl.play = [];
      ctrl.playFiltered = [];
      ctrl.version = {};
      ctrl.configSaved = true;
      ctrl.erpSyncMethod = 'ERP';

      ctrl.tabs = [
        {name: 'estado', header: 'Estado', src: 'app/admin/config/config.estado.html'},
        {name: 'site', header: 'Site', src: 'app/admin/config/config.site.html'},
        {name: 'erp', header: 'ERP', src: 'app/admin/config/config.erp.html'},
        {name: 'social', header: 'Social', src: 'app/admin/config/config.social.html'},
        {name: 'email', header: 'Email', src: 'app/admin/config/config.email.html'},
        {name: 'classificadores', header: 'Classificadores', src: 'app/admin/config/config.classificadores.html'},
        {name: 'condicoespagamento', header: 'Condições de pagamento', src: 'app/admin/config/config.condicoespagamento.html'},
        {name: 'transportadoras', header: 'Transportadoras', src: 'app/admin/config/config.transportadoras.html'},
        {name: 'variaveis', header: 'Variáveis', src: 'app/admin/config/config.variaveis.html'},
        {name: 'play', header: 'Variáveis servidor', src: 'app/admin/config/config.playvars.html'}
      ];

      ctrl.options = {
        dropped: function () {
          for (var i = 0; i < ctrl.classificadoresList.length; i++) {
            ctrl.classificadoresList[i].position = i;
          }
          configFactory.saveClassificadores(ctrl.classificadoresList).then(
            function () {
              PopAlert.showSuccess('Configuração guardada');
            },
            function () {
              PopAlert.showError('Erro a gravar configuração, por favor tente mais tarde.');
            }
          );
        }
      };

      ctrl.optionsCondicoesPagamento = {
        dropped: function () {
          for (var i = 0; i < ctrl.condicoesPagamentoList.length; i++) {
            ctrl.condicoesPagamentoList[i].position = i;
          }
          configFactory.saveCondicoesPagamento(ctrl.condicoesPagamentoList).then(
            function () {
              ctrl.fillDescricaoCondicaoPagamento();
              PopAlert.showSuccess('Configuração guardada');
            },
            function () {
              PopAlert.showError('Erro a gravar configuração, por favor tente mais tarde.');
            }
          );
        }
      };

      ctrl.optionsTransportadoras = {
        dropped: function () {
          for (var i = 0; i < ctrl.transportadoraList.length; i++) {
            ctrl.transportadoraList[i].position = i;
          }
          configFactory.saveTransportadoras(ctrl.transportadoraList).then(
            function () {
              ctrl.fillDescricaoTransportadoras();
              PopAlert.showSuccess('Configuração guardada');
            },
            function () {
              PopAlert.showError('Erro a gravar configuração, por favor tente mais tarde.');
            }
          );
        }
      };

      ctrl.updateERPTab = function () {
        if (ctrl.config.UseRestServer === 1) {
          ctrl.erpSyncMethod = 'ERPRest';
        } else {
          ctrl.erpSyncMethod = 'ERP';
        }
      };

      ctrl.saveErp = function () {
        ctrl.configSaved = true;
        switch (ctrl.erpSyncMethod) {
          case 'ERP':
            ctrl.config.UseRestServer = 0;
            break;
          case 'ERPRest':
            ctrl.config.UseRestServer = 1;
            break;
        }
        configFactory.saveValue({configID: 'ServerName', value: ctrl.config.siteServerName}, function (ok) {
          if (!ok) {
            ctrl.configSaved = false;
          }
        });
        configFactory.saveValue({configID: 'ServerPort', value: ctrl.config.siteServerPort}, function (ok) {
          if (!ok) {
            ctrl.configSaved = false;
          }
        });
        configFactory.saveValue({configID: 'RestERPv1User', value: ctrl.config.siteERPServerURL}, function (ok) {
          if (!ok) {
            ctrl.configSaved = false;
          }
        });
        configFactory.saveValue({configID: 'centralgest.api.ErpRestToken', value: ctrl.config.ErpRestToken}, function (ok) {
          if (!ok) {
            ctrl.configSaved = false;
          }
        });
        configFactory.saveValue({configID: 'sync.userest', value: ctrl.config.UseRestServer}, function (ok) {
          if (!ok) {
            ctrl.configSaved = false;
          }
        });

        if (ctrl.configSaved) {
          PopAlert.showSuccess('Configuração guardada');
          ctrl.refresh();
        } else {
          PopAlert.showError('Erro a gravar configuração, por favor tente mais tarde.');
        }
      };

      ctrl.getImage = function () {
        imagePick.pick('', ctrl.config.siteLogo, function (folder, img) {
          ctrl.config.siteLogo = folder + img;
          configFactory.saveValue({configID: 'site.logo.url', value: ctrl.config.siteLogo}, function (ok) {
            if (ok) {
              PopAlert.showSuccess('Configuração guardada');
              configFactory.refresh(true);
              return '';
            }
          });
        });
      };

      ctrl.getImageLogin = function () {
        imagePick.pick('', ctrl.config.loginLogo, function (folder, img) {
          ctrl.config.loginLogo = folder + img;
          configFactory.saveValue({configID: 'site.logo.login', value: ctrl.config.loginLogo}, function (ok) {
            if (ok) {
              PopAlert.showSuccess('Configuração guardada');
              configFactory.refresh(true);
              return '';
            }
          });
        });
      };

      ctrl.getFavicon = function () {
        imagePick.pick('', ctrl.config.sitefavicon, function (folder, img) {
          ctrl.config.sitefavicon = folder + img;
          configFactory.saveValue({configID: 'site.favicon', value: ctrl.config.sitefavicon}, function (ok) {
            if (ok) {
              PopAlert.showSuccess('Configuração guardada');
              configFactory.refresh(true);
              return '';
            }
          });
        });
      };

      ctrl.save = function () {
        var deferred = $q.defer();
        configFactory.saveClassificadores(ctrl.classificadoresList).then(
          function (response) {
            PopAlert.showSuccess('Configuração guardada');
            deferred.resolve(response);
          },
          function (error) {
            PopAlert.showError('Erro a gravar configuração, por favor tente mais tarde.');
            deferred.reject(error);
          }
        );
        return deferred.promise;
      };

      ctrl.saveCondicoesPagamento = function () {
        var deferred = $q.defer();
        configFactory.saveCondicoesPagamento(ctrl.condicoesPagamentoList).then(
          function (response) {
            ctrl.fillDescricaoCondicaoPagamento();
            PopAlert.showSuccess('Configuração guardada');
            deferred.resolve(response);
          },
          function (error) {
            PopAlert.showError(error);
            deferred.reject(error);
          }
        );
        return deferred.promise;
      };

      ctrl.saveTransportadora = function () {
        var deferred = $q.defer();
        configFactory.saveTransportadoras(ctrl.transportadoraList).then(
          function (response) {
            ctrl.fillDescricaoTransportadoras();
            PopAlert.showSuccess('Configuração guardada');
            deferred.resolve(response);
          },
          function (error) {
            PopAlert.showError(error);
            deferred.reject(error);
          }
        );
        return deferred.promise;
      };

      ctrl.reloadCondicoesPagamento = function () {
        var deferred = $q.defer();
        PagamentosFactory.condicoesPagamento('', -1, -1).then(
          function (pagamList) {
            ctrl.pagamList = pagamList;
            deferred.resolve();
          },
          function (err) {
            deferred.reject(err);
          }
        );
        return deferred.promise;
      };

      ctrl.reloadTransportadora = function () {
        var deferred = $q.defer();
        TransportadorasFactory.all().then(
          function (data) {
            ctrl.gcTransportadora = data;
            deferred.resolve();
          },
          function (err) {
            deferred.reject(err);
          }
        );
        return deferred.promise;
      };

      ctrl.fillDescricaoCondicaoPagamento = function () {
        for (var i = 0; i < ctrl.condicoesPagamentoList.length; i++) {
          var item = ctrl.condicoesPagamentoList[i];
          for (var j = 0; j < ctrl.pagamList.length; j++) {
            var pagam = ctrl.pagamList[j];
            if (pagam.ncondpag === item.ncondpag) {
              item.descricao = pagam.descricao;
              break;
            }
          }
        }
      };

      ctrl.fillDescricaoTransportadoras = function () {
        for (var i = 0; i < ctrl.transportadoraList.length; i++) {
          var item = ctrl.transportadoraList[i];
          for (var j = 0; j < ctrl.gcTransportadora.length; j++) {
            var transp = ctrl.gcTransportadora[j];
            if (transp.codTransportadora === item.codTransportadora) {
              item.nome = transp.nome;
              break;
            }
          }
        }
      };

       ctrl.getValueOf=function(key){
        var i;
        for (i=0;i<ctrl.play.length;i++){
           if (ctrl.play[i].key===key){
             return ctrl.play[i].value;
           }
         }
      };

      ctrl.refresh = function () {
        ctrl.reloadTransportadora().then(function () {
          ctrl.reloadCondicoesPagamento().then(function () {
            configFactory.getConfigSiteAdmin().then(
              function (data) {
                ctrl.config = data;
                ctrl.classificadoresList = data.classificadores;
                ctrl.condicoesPagamentoList = data.condicoesPagamento;
                ctrl.transportadoraList = data.transportadoras;
                ctrl.fillDescricaoCondicaoPagamento();
                ctrl.fillDescricaoTransportadoras();
                ctrl.updateERPTab();
              }
            );
          });
        });

        ctrl.info = configFactory.getInfo(function (ok, info) {
          if (ok) {
            ctrl.info = info;            
            for (var item in info.playCfg) {
              if (info.playCfg.hasOwnProperty(item)) {
                var n = {key: item, value: info.playCfg[item]};
                ctrl.play.push(n);
                // angular.extend(ctrl.version, ctrl.play);
              }
            }
            ctrl.playFiltered = angular.copy(ctrl.play);
          }
        });

        for (var i = 0; i < ctrl.tabs.length; i++) {
          if ($stateParams.tab === ctrl.tabs[i].name) {
            ctrl.tabs[i].active = true;
            break;
          }
        }
      };

      ctrl.sendEmail = function () {
        PopAlert.showInfo('A enviar email para ' + ctrl.config.siteEmailContact);
        emailService.sendContact('teste', ctrl.config.siteEmailContact, 'Teste de email de contato!').then(
          function (ok) {
            PopAlert.showSuccess('Email enviado para ' + ctrl.config.siteEmailContact + '. Verifique a caixa de correio!');
          },
          function (data, status, headers, config) {

            data = angular.fromJson(data);
            if (!Utils.isNullOrUndefined(data) && !Utils.isNullOrUndefined(data.status)) {
              PopAlert.showError('Erro a enviar email para ' + ctrl.config.siteEmailContact + '. ' + data.message);
              $log.error(data);
            } else {
              PopAlert.showError('Erro a enviar email para ' + ctrl.config.siteEmailContact + '. ');
            }
          });

      };

      ctrl.tabSelect = function (tab) {
        $state.transitionTo('admin.config', {tab: tab.name}, {notify: false});
      };

      ctrl.updateMyFilter = function () {
        ctrl.playFiltered = $filter('filter')(ctrl.play, ctrl.myFilter, null, 'key');
      };

      ctrl.editProperties = function (item) {
        return CGModalService.show({
          templateUrl: 'app/admin/config/config.classificadores.properties.html',
          controller: 'ConfigClassificadoresPropertiesController',
          resolve: {
            classificador: /*@ngInject*/ function () {
              return item;
            },
            save: function () {
              return ctrl.save;
            }
          }
        });
      };

      ctrl.refresh();
    })
    .directive('configValue', function () {
      return {
        scope: {
          item: '<',
          configid: '<',
          hint: '@',
          label: '@',
          icon: '@',
          type: '@?'
        },
        bindToController: true,
        transclude: true,
        templateUrl: 'app/admin/config/config.value.html',
        controllerAs: 'ctrl',
        controller: /*@ngInject*/ function (configFactory, PopAlert) {
          var ctrl = this;

          ctrl.value = '';

          ctrl.$onInit = init;
          ctrl.$onChanges = onChanges;
          ctrl.updateItem = updateItem;

          /////////////

          function init() {
            if (!ctrl.hint) {
              ctrl.hint = 'vazio';
            }
          }

          function onChanges(config) {
            if (config) {
              if (config.item) {
                ctrl.item = config.item.currentValue;
              }
              if (config.configid) {
                ctrl.configid = config.configid.currentValue;
              }
            }
          }

          function updateItem(configID, data) {
            configFactory.saveValue({configID: configID, value: data}, function (ok) {
              if (ok) {
                PopAlert.showSuccess('Configuração guardada');
                configFactory.refresh(true);
                return '';
              }
            });
          }
        }
      };
    });
})();

/**
 * Created by Pedro Lopes on 29/07/15.
 */
(function () {
  'use strict';

  angular.module('erpRetail')
    .config(function ($stateProvider) {
      $stateProvider
        .state('admin.config', {
          url: '/config',
          title: 'Configuração',
          params: {authenticate: 'admin'},
          templateUrl: 'app/admin/config/config.html',
          controllerAs: '$ctrl',
          controller: 'ConfigController'
        });
    });
})();

(function () {
  'use strict';

  angular.module('erpRetail')
    .controller('ConfigVariaveisController', function ($http, $state, $uibModal, configFactory, REST_API, Utils, $filter, PopAlert) {
      var ctrl = this;

      ctrl.config = {
        itemsPerPage: 10,
        maxPages: 10,
        fillLastPage: true
      };

      ctrl.configlist = [];
      ctrl.configlistFiltered = [];
      ctrl.searchConfig = null;

      $http.get(REST_API.HOST + REST_API.ADMIN_CONFIG_ALL).then(
        function (data) {
          ctrl.configlist = data.data;
          ctrl.updateFilteredList();
        }
      );

      ctrl.updateFilteredList = function () {
        if (Utils.isNullOrEmpty(ctrl.searchConfig)) {
          ctrl.configlistFiltered = ctrl.configlist;
        } else {
          ctrl.configlistFiltered = $filter('filter')(ctrl.configlist, ctrl.searchConfig);
        }
      };

      ctrl.save = function (value, item) {
        if (!item) {
          PopAlert.showError('Variável ou valor inválido');
          return;
        }
        configFactory.saveValue(item, function (ok) {
          if (ok) {
            PopAlert.showSuccess('Valor atualizado');
          }
          else {
            PopAlert.showError('Ocorreu um erro ao atualizar valor');
          }
        });
      };
    });
})();

(function () {
  'use strict';

  angular.module('erpRetail')
    .controller('DocumentosController', function ($state, $transition$, $q, documentosService, documentoService, $translate, Auth) {
      var ctrl = this;

      ctrl.params = $transition$.params();
      ctrl.definition = {};
      ctrl.callback = {};

      ctrl.$onInit = init;
      ctrl.getSyncStatus = getSyncStatus;
      ctrl.getStatus = getStatus;
      ctrl.onLoad = onLoad;
      ctrl.onDocSelect = onDocSelect;
      ctrl.onDocDetail = onDocDetail;
      ctrl.confirmedPayment = confirmedPayment;

      /////////////
      function init() {
        ctrl.definition = {
          order: 'stampInsert desc',
          page: 1,
          options: {
            perPage: 10
          },
          fields: [
            {name: 'stampInsert', type: 'timestamp', visible: false, caption: ''},
            {name: 'ndocAsString', type: 'text', caption: 'ACOOUNT_DOCS_TABLE_TH_NDOC'},
            {name: 'dataDoc', type: 'date', caption: 'ACCOUNT_DOCS_TABLE_TH_DATA'},
            {name: 'statusSync', type: 'text', caption: 'ADMIN_DOCS_TABLE_TH_STATE'},
            {name: 'estado', caption: 'ACCOUNT_DOCS_TABLE_TH_ESTADO'},
            {name: 'descricao', caption: 'Motivo'},
            {name: 'total', align: 'right', type: 'currency', caption: 'ACCOUNT_DOCS_TABLE_TH_TOTAL'},
            {name: 'estadoLabel', align: 'center', caption: ' '}
          ]
        };
      }

      function getSyncStatus(item) {
        return documentosService.getStatus(item);
      }

      function getStatus(item) {
        if (item.estado === 'PaypalCompleted' || item.estado === 'PayedSettedByAdmin') {
          item.estadoLabel = '<i class="fa fa-check text-success"></i>';
        } else {
          item.estadoLabel = '<i class="fa fa-credit-card text-primary"></i>';
        }
        item.estado = $translate.instant('DOC_ESTADO_' + item.estado);
      }

      function onLoad(search, order, page, perpage) {
        var deferred = $q.defer();
        documentosService.getAll(ctrl.ndoc, page, perpage, order)
          .then(function (response) {
            var linhas = response.map(function (item) {
              item._$ctrl = ctrl;
              item.statusSync = ctrl.getSyncStatus(item.statusSync);
              ctrl.getStatus(item);
              return item;
            });
            deferred.resolve(linhas);
          })
          .catch(function (reason) {
            deferred.reject(reason);
          });
        return deferred.promise;
      }

      function onDocSelect(item) {
        item._detailOpen = !item._detailOpen;
        if (item._detailOpen) {
          return ctrl.onDocDetail(item);
        }
      }

      function onDocDetail(item) {
        if (item._thedoc) {
          return;
        }
        var deferred = $q.defer();
        documentoService.getDoc(item.mbfaccbId)
          .then(function (response) {
            item._ctrl = ctrl;
            item._thedoc = response.data;
            item._thedoc.currentUser = Auth.currentUser;
            deferred.resolve();
          })
          .catch(function (reason) {
            deferred.reject(reason);
          });
        return deferred.promise;
      }

      function confirmedPayment(item, doc) {
        item.estado = doc.mbdocLog.last.estado;
        item.descricao = doc.mbdocLog.last.descricao;
        ctrl.getStatus(item);
      }
    });
})();

(function () {
  'use strict';

  angular.module('erpRetail')
    .controller('HomeEditController', ['$scope', function () {

    }]);
}());

(function () {
  'use strict';

  angular.module('erpRetail')
    .controller('FileListController', ['$scope', 'ImagensFactory', '$filter', 'Utils', '$uibModal', 'PopAlert',
      function ($scope, ImagensFactory, $filter, Utils, $uibModal, PopAlert) {
        $scope.itemsPerPage = 12;
        $scope.currentPage = 1;

        $scope.grid = {
          list: [],
          config: {
            itemsPerPage: 10,
            maxPages: 10,
            fillLastPage: true,
            orderBy: 'AIOrderBy'
          }
        };
        $scope.searchimages = '';
        $scope.folder = '';

        $scope.filtered = [];

        $scope.getImagem = function (item) {
          return ImagensFactory.getUrlImagem($scope.folder, item.name);
        };

        $scope.deleteImagem = function (item) {
          ImagensFactory.deleteImagem($scope.folder, item.name).then(function (ret) {
            var idx = $scope.filtered.indexOf(item);
            if (idx > -1) $scope.filtered.splice(idx, 1);
            PopAlert.showSuccess($filter('translate')('IMAGE_DELETED', {name: item.name}));
          }, function (ret) {
            PopAlert.showError($filter('translate')('IMAGE_ERRO_DELETE'));
          });
        };

        $scope.showImagem = function (item) {
          var modalInstance = $uibModal.open({
            templateUrl: 'app/admin/imagens/imagens.show.html',
            controller: 'FileShowController',
            resolve: {
              item: function () {
                return item;
              },
              folder: function () {
                return $scope.folder;
              }
            }
          });

          modalInstance.result.then(
            function (data) {
              if (data === 'delete') {
                $scope.deleteImagem(item);
              }
              //PopAlert.showSuccess(data);
            },
            function (data) {
              //PopAlert.showSuccess(data);
            });


        };

        $scope.showRename = function (item) {
          var modalInstance = $uibModal.open({
            templateUrl: 'app/admin/imagens/imagens.rename.html',
            controller: 'FileRenameController',
            resolve: {
              item: function () {
                return item;
              },
              folder: function () {
                return $scope.folder;
              }
            }
          });

          modalInstance.result.then(function (name) {
            ImagensFactory.renameImagem($scope.folder, item.name, name).then(
              function () {
                item.name = name;
                PopAlert.showSuccess($filter('translate')('IMAGE_RENAMED', {from: item.name, to: name}));
              },
              function () {
                PopAlert.showError($filter('translate')('IMAGE_ERRO_RENAME'));
              });
          });

        };

        $scope.refresh = function () {
          ImagensFactory.getList($scope.folder)
            .then(function (list) {
              $scope.grid.list = list;
              $scope.updateFilter();
            }, function (err) {

            });
        };

        $scope.updateFilter = function () {
          if (Utils.isNullOrEmpty($scope.searchimages)) {
            $scope.filtered = $scope.grid.list;
          } else {
            $scope.filtered = $filter('filter')($scope.grid.list, $scope.searchimages);
          }
        };

        $scope.refresh();

      }])


    .controller('FileShowController', ['$scope', 'ImagensFactory', 'folder', 'item', '$uibModalInstance', function ($scope, ImagensFactory, folder, item, $uibModalInstance) {
      $scope.folder = folder;
      $scope.item = item;
      $scope.getImagem = function () {
        return ImagensFactory.getUrlImagem(folder, item.name);
      };

      $scope.cancel = function () {
        $uibModalInstance.dismiss('cancel');
      };


      $scope.delete = function () {
        $uibModalInstance.close('delete');
      };

    }])


    .controller('FileRenameController', ['$scope', 'ImagensFactory', 'folder', 'item', '$uibModalInstance', function ($scope, ImagensFactory, folder, item, $uibModalInstance) {
      $scope.folder = folder;
      $scope.name = item.name;
      $scope.getImagem = function () {
        return ImagensFactory.getUrlImagem(folder, item.name);
      };

      $scope.cancel = function () {
        $uibModalInstance.dismiss('cancel');
      };

      $scope.edit = function () {
        $uibModalInstance.close($scope.name);
      };

    }])

    .controller('FileUploadController', ['$scope', 'FileUploader', 'REST_API', 'Auth',
      function ($scope, FileUploader, REST_API, Auth) {
        var uploader = $scope.uploader = new FileUploader({
          url: REST_API.HOST + REST_API.IMAGE_UPLOAD,
          headers: {
            authToken: Auth.getToken()
          }
        });

        // FILTERS

        uploader.filters.push({
          name: 'imageFilter',
          fn: function (item /*{File|FileLikeObject}*/, options) {
            var type = '|' + item.type.slice(item.type.lastIndexOf('/') + 1) + '|';
            return '|jpg|png|jpeg|bmp|gif|'.indexOf(type) !== -1;
          }
        });

        //// CALLBACKS
        //
        //uploader.onWhenAddingFileFailed = function(item /*{File|FileLikeObject}*/, filter, options) {
        //    console.info('onWhenAddingFileFailed', item, filter, options);
        //};
        //uploader.onAfterAddingFile = function(fileItem) {
        //    console.info('onAfterAddingFile', fileItem);
        //};
        //uploader.onAfterAddingAll = function(addedFileItems) {
        //    console.info('onAfterAddingAll', addedFileItems);
        //};
        //uploader.onBeforeUploadItem = function(item) {
        //    console.info('onBeforeUploadItem', item);
        //};
        //uploader.onProgressItem = function(fileItem, progress) {
        //    console.info('onProgressItem', fileItem, progress);
        //};
        //uploader.onProgressAll = function(progress) {
        //    console.info('onProgressAll', progress);
        //};
        //uploader.onSuccessItem = function(fileItem, response, status, headers) {
        //    console.info('onSuccessItem', fileItem, response, status, headers);
        //};
        //uploader.onErrorItem = function(fileItem, response, status, headers) {
        //    console.info('onErrorItem', fileItem, response, status, headers);
        //};
        //uploader.onCancelItem = function(fileItem, response, status, headers) {
        //    console.info('onCancelItem', fileItem, response, status, headers);
        //};
        //uploader.onCompleteItem = function(fileItem, response, status, headers) {
        //    console.info('onCompleteItem', fileItem, response, status, headers);
        //};
        //uploader.onCompleteAll = function() {
        //    console.info('onCompleteAll');
        //};
        //
      }]);
}());

(function () {
  'use strict';
    angular.module('erpRetail')

        .config(['$stateProvider', function ($stateProvider) {
            $stateProvider
                .state('admin.imagens', {
                    abstract: true,
                    url: '/imagens',
                  title: 'imagens',
                    params: {authenticate: 'admin'},
                  templateUrl: 'app/admin/imagens/imagens.html'

                })
                .state('admin.imagens.lista', {
                    url: '/lista',
                  title: 'Imagens',
                    params: {authenticate: 'admin'},
                  templateUrl: 'app/admin/imagens/imagens.list.html',
                  controller: 'FileListController'
                })
                .state('admin.imagens.galeria', {
                    url: '/galeria',
                  title: 'Imagens',
                    params: {authenticate: 'admin'},
                  templateUrl: 'app/admin/imagens/imagens.galeria.html',
                  controller: 'FileListController'
                })
                .state('admin.imagens.upload', {
                    url: '/enviar',
                  title: 'Imagens',
                    params: {authenticate: 'admin'},
                  templateUrl: 'app/admin/imagens/imagens.upload.html',
                  controller: 'FileUploadController'
                });
        }]);
}());

(function () {
  'use strict';

  angular.module('erpRetail')
    .controller('MenuController', function (configFactory, PopAlert, $uibModal, $translate, MenuService, PaginasFactory, Utils) {
      var ctrl = this;

      ctrl.data = [{}];
      ctrl.mnuHome = {};
      ctrl.mnuContactos = {};
      ctrl.mnuTermos = {};

      ctrl.init = init;
      ctrl.moveLastToTheBeginning = moveLastToTheBeginning;
      ctrl.addEmptyMenu = addEmptyMenu;
      ctrl.newSubItem = newSubItem;
      ctrl.collapseAll = collapseAll;
      ctrl.expandAll = expandAll;
      ctrl.tipoChangeHome = tipoChangeHome;
      ctrl.save = save;
      ctrl.edit = edit;
      ctrl.refresh = refresh;

      ctrl.init();

      /////////////

      function init() {
        ctrl.mnuHome = {page: 0, tipos: [], tipo: 'sistema'};
        ctrl.mnuContactos = {page: 0, tipos: [], tipo: 'sistema'};
        ctrl.mnuTermos = {page: 0, tipos: [], tipo: 'sistema'};
        ctrl.refresh();
      }

      function moveLastToTheBeginning() {
        var a = ctrl.data.pop();
        ctrl.data.splice(0, 0, a);
      }

      function addEmptyMenu() {
        ctrl.data.push({
          title: $translate.instant('admin.menus.newMenu'),
          url: '',
          pageId: 1,
          fontAwesome: 'fa-home',
          nodes: []
        });
      }

      function newSubItem(node) {
        if (!node.nodes) {
          node.nodes = [];
        }
        node.nodes.push({
          title: node.title + '.' + (node.nodes.length + 1),
          pageId: node.pageId * 10 + node.nodes.length,
          fontAwesome: node.fontAwesome,
          nodes: []
        });
      }

      function collapseAll() {
        ctrl.$broadcast('collapseAll');
      }

      function expandAll() {
        ctrl.$broadcast('expandAll');
      }

      function tipoChangeHome(mnu) {
        if (mnu.tipo === 'sistema') {
          mnu.tipos = MenuService.getMenuSystem();
          mnu.tipos = mnu.tipos.slice(1);
        }
        else if (mnu.tipo === 'paginas') {
          mnu.tipos = [];
          PaginasFactory.getAll().then(function (data) {
            for (var i = 0; i < data.length; i++) {
              mnu.tipos.push({id: data[i].id, title: data[i].title});
            }
          });
        }
      }

      function save() {
        var values = [
          {configID: 'site.menu', value: ctrl.data},
          {configID: 'site.pages.home', value: ctrl.mnuHome.page},
          {configID: 'site.pages.contactos', value: ctrl.mnuContactos.page},
          {configID: 'site.pages.termos', value: ctrl.mnuTermos.page}
        ];
        configFactory.saveValue(values, function (ok) {
          if (ok) {
            PopAlert.showSuccess('Menu guardado');
            configFactory.refresh(true);
          }
        });
      }

      function edit(node) {
        var modalInstance = $uibModal.open({
          templateUrl: 'app/admin/menu/menu.edit.html',
          controller: 'MenuEditPopupController',
          controllerAs: 'ctrl',
          resolve: {
            node: function () {
              return node;
            }
          }
        });

        modalInstance.result.then(function (itemSave) {
          node.title = itemSave.title;
          node.pageId = itemSave.pageId;
          node.fontAwesome = itemSave.fontAwesome;
          ctrl.save();
        });
      }

      function refresh() {
        configFactory.getConfigSiteAdmin().then(
          function (data) {
            ctrl.data = data.menu;

            function mnuSync(mnu, page) {
              mnu.page = Utils.toNumber(page);
              if (mnu.page <= 0) {
                mnu.tipo = 'sistema';
              }
              else {
                mnu.tipo = 'paginas';
              }
              ctrl.tipoChangeHome(mnu);
            }

            mnuSync(ctrl.mnuHome, data.pages.home);
            mnuSync(ctrl.mnuContactos, data.pages.contactos);
            mnuSync(ctrl.mnuTermos, data.pages.termos);
          }
        );
      }
    })
    .controller('MenuEditPopupController', function (node, $uibModalInstance, MenuService, PaginasFactory) {
      var ctrl = this;

      ctrl.item = angular.copy(node);
      ctrl.tipos = [];
      ctrl.tipo = 'sistema';

      ctrl.$onInit = init;
      ctrl.refresh = refresh;
      ctrl.cancel = cancel;
      ctrl.tipoChange = tipoChange;
      ctrl.save = save;
      ctrl.remove = remove;

      /////////////

      function init() {
        ctrl.refresh();
      }

      function refresh() {
        if (ctrl.item.pageId <= 0) {
          ctrl.tipo = 'sistema';
        } else {
          ctrl.tipo = 'paginas';
        }
        ctrl.tipoChange();
      }

      function cancel() {
        $uibModalInstance.dismiss('cancel');
      }

      function tipoChange() {
        if (ctrl.tipo === 'sistema') {
          ctrl.tipos = MenuService.getMenuSystem();
        }
        else if (ctrl.tipo === 'paginas') {
          ctrl.tipos = [];
          PaginasFactory.getAll().then(function (data) {
            ctrl.tipos = [];
            for (var i = 0; i < data.length; i++) {
              ctrl.tipos.push({id: data[i].id, title: data[i].title});
            }
          });

        }
      }

      function save() {
        $uibModalInstance.close(ctrl.item);
      }

      function remove(item) {
        item.remove(item);
      }
    });
})();

(function () {
  'use strict';

  angular.module('erpRetail')
    .controller('ModelosController', function ($rootScope, $scope, Auth, ModelosFactory, $filter, Utils, storage,
                                               configFactory, config, $stateParams, $state, PopAlert) {
      $scope.config = config;
      $scope.classificadoresList = configFactory.classificadoresList;
      $scope.classificadores = configFactory.classificadores;
      $scope.texto = '';
      $scope.textotype = [];
      $scope.textoTipo = {
        name: '',
        type: $stateParams.modelo
      };
      $scope.item = {};
      $scope.ctrl = {
        config: config,
        noimage: storage.noimage,
        getImagem: storage.getImagem,
        addBasket: function (item) {
          PopAlert.showSuccess('adiciona ao cesto');
        },
        getDatetime: function () {
          return $rootScope.getDatetime;
        },
        showDetail: function (item) {
          PopAlert.showSuccess('ver detalhe');
        },
        showDetailClassificador: function (item) {
          PopAlert.showSuccess('ver detalhe classificador');
        }

      };
      $scope.storage = storage;

      var editor = ace.edit('editor');
      editor.getSession().setUseWorker(false);
      editor.setTheme('ace/theme/monokai');
      //editor.getSession().setMode("ace/mode/html");
      editor.getSession().setUseWrapMode(true);
      editor.$blockScrolling = Infinity;

      var editorj = ace.edit('editor_json');
      editorj.setTheme('ace/theme/monokai');
      editorj.getSession().setMode('ace/mode/json');
      editorj.getSession().setTabSize(2);
      editorj.getSession().setUseWrapMode(true);
      editorj.$blockScrolling = Infinity;


      $scope.editorChanged = function (data) {
        if ($scope.textoTipo.type === 'TEXT_PAGE_CSS') {

          $rootScope.setCss($scope.texto.html);
        }

      };

      $scope.loadModelo = function () {
        if ($scope.textoTipo !== null && !Utils.isNullOrEmpty($scope.textoTipo.type)) {
          ModelosFactory.getTexto($scope.textoTipo.type).then(function (texto) {

            $scope.texto = texto;
            $scope.item = texto.options.vars;
            $scope.jsonData = {item: $scope.item, config: config};
            $scope.jsonData = JSON.stringify($scope.jsonData, null, 4);
            if ($scope.textoTipo.type === 'TEXT_PAGE_CSS') {
              editor.getSession().setMode('ace/mode/css');
              $scope.myDynamicClass = 'form-group col-md-12';
            } else {
              editor.getSession().setMode('ace/mode/html');
              $scope.myDynamicClass = 'form-group col-md-8';
            }
          });
        }
      };

      $scope.refresh = function () {
        ModelosFactory.getTipos().then(function (tipos) {
          $scope.textotype = [];
          angular.forEach(tipos, function (item) {
            var type = {name: $filter('translate')(item), type: item};
            $scope.textotype.push(type);
            if ($scope.textoTipo === null || Utils.isNullOrEmpty($scope.textoTipo.type) ||
              (Utils.isNullOrEmpty($scope.textoTipo.name)) && $scope.textoTipo.type === type.type) {
              $scope.textoTipo = type;
            }
          });
          $scope.loadModelo();
        });

      };

      $scope.$watch('textoTipo', function () {
        if ($scope.textoTipo === null || $scope.textoTipo.type === $stateParams.modelo) return;
        $state.go('admin.modelos', {modelo: $scope.textoTipo.type});

      });

      $scope.jsonDataChanged = function () {
        $scope.item = angular.fromJson($scope.jsonData);
      };

      $scope.getDefault = function () {
        ModelosFactory.getOriginal($scope.textoTipo.type).then(function (data) {
          $scope.texto.html = data;
        });
      };

      $scope.getPreview = function (html, modelo) {
        var replaceAll = function (find, replace, str) {
          if (str === null || str === '') return '';
          return str.replace(new RegExp(find, 'g'), replace);
        };
        var ret = modelo;

        if (Utils.isNullOrEmpty(ret)) {
          ret = html;
          if (Utils.isNullOrEmpty(ret)) return '';
          if (angular.isDefined($scope.texto.vars)) {
            $scope.texto.vars.texto = '(texto a sustituir)';
          }
        }
        else if (angular.isDefined($scope.texto.vars)) {
          $scope.texto.vars.texto = html;
        }

        angular.forEach($scope.texto.vars, function (value, key) {
          //html += key +"= "+value+"<br>";
          ret = replaceAll('@' + key, value, ret);
        });
        return ret;
      };

      $scope.save = function () {
        ModelosFactory.save($scope.textoTipo.type, $scope.texto.subject, $scope.texto.html).then(function () {
          PopAlert.showSuccess($filter('translate')('TEXT_SAVED'));
          configFactory.refresh(true);
        });
      };

      $scope.refresh();

    });
})();

(function () {
  'use strict';

  angular.module('erpRetail')
    .controller('PaginasController', /*@ngInject*/  function ($scope, PaginasFactory, $state, $filter, PopAlert, Utils) {
      var ctrl = this;
      ctrl.updateFilter = updateFilter;
      ctrl.deletePagina = deletePagina;
      ctrl.refresh = refresh;
      ctrl.edit = edit;

      ctrl.dtformat = 'dd-MM-yyyy HH:mm:ss';
      ctrl.search = '';
      ctrl.grid = {
        list: [],
        config: {
          itemsPerPage: 10,
          maxPages: 10,
          fillLastPage: true,
          orderBy: 'AIOrderBy'
        }
      };

      ctrl.filtered = [];

      ctrl.refresh();

      function updateFilter() {
        ctrl.filtered = $filter('AIFilter')(ctrl.grid.list, ctrl.search);
      }

      function deletePagina(pagina) {
        PopAlert.confirm(Utils.translate('PAGINAS_MSG_ASK_DELETED'), function (e) {
          if (e) {
            PaginasFactory.deletePagina(pagina).then(
              function () {
                PopAlert.showInfo(Utils.translate('PAGINAS_MSG_DELETED'));
                ctrl.refresh();
              },
              function (err) {
                PopAlert.showError(Utils.translate(err));
              });
          }
        });
      }

      function refresh() {
        PaginasFactory.getAll().then(function (paginas) {
          ctrl.grid.list = paginas;
          ctrl.updateFilter();
        });
      }

      function edit(item) {
        $state.go('^.edit', {id: item.id});
      }
    })
    .controller('PaginasEditController', /*@ngInject*/  function ($scope, PaginasFactory, $state, $stateParams, Utils, WidgetsFactory, PopAlert) {
      var ctrl = this;
      ctrl.apply = apply;
      ctrl.save = save;
      ctrl.deletePagina = deletePagina;
      ctrl.cancel = cancel;
      ctrl.load = load;
      ctrl.init = init;

      ctrl.widgests = WidgetsFactory;
      ctrl.componentes = ['carroucel', 'Texto'];
      ctrl.componentes1 = ['Promoções'];
      ctrl.dtformat = 'dd-MM-yyyy HH:mm:ss';
      ctrl.showOrder = true;
      ctrl.pagina = {
        id: 0,
        title: 'Nova página',
        description: '',
        publishedOn: new Date(),
        publishedAfter: new Date(),
        items: []
        //items:[{"name":"widget-carousel","description":"carousel widget"},
        //       {"name":"widget-produtos","description":"products widget"},
        //       {"name":"widget-html","description":"html widget"}]
      };

      ctrl.init();

      function apply() {
        PaginasFactory.save(ctrl.pagina).then(
          function (pagina) {
            ctrl.pagina = pagina;
            PopAlert.showInfo(Utils.translate('PAGINAS_MSG_SAVED'));
          },
          function (err) {
            PopAlert.showError(Utils.translate('PAGINAS_MSG_SAVE_ERROR'));
          });
      }

      function save() {
        PaginasFactory.save(ctrl.pagina).then(
          function () {
            PopAlert.showInfo(Utils.translate('PAGINAS_MSG_SAVED'));
            $state.go('^.list');
          },
          function (err) {
            PopAlert.showError(Utils.translate(err));
          });
      }

      function deletePagina() {
        PopAlert.confirm(Utils.translate('PAGINAS_MSG_ASK_DELETED'), function (e) {
          if (e) {
            PaginasFactory.deletePagina(ctrl.pagina).then(
              function () {
                PopAlert.showInfo(Utils.translate('PAGINAS_MSG_DELETED'));
                $state.go('^.list');
              },
              function (err) {
                PopAlert.showError(Utils.translate(err));
              });
          }
        });
      }

      function cancel() {
        $state.go('^.list');
      }

      function load(id) {
        PaginasFactory.load(id).then(
          function (pagina) {
            ctrl.pagina = pagina;
            return pagina;
          },
          function (err) {
            PopAlert.showError(Utils.translate(err));
            $state.go('^.list');
          }
        );
      }

      function init() {
        if (!Utils.isNullOrUndefined($stateParams.id)) {
          ctrl.load($stateParams.id);
        }
      }



    });
})();

(function () {
  'use strict';
    angular.module('erpRetail')

        .config(['$stateProvider', function ($stateProvider) {
            $stateProvider
                .state('admin.paginas', {
                    abstract: true,
                    url: '/paginas',
                    params: {authenticate: 'admin'},
                  title: 'Editar páginas',
                    templateUrl: 'app/admin/paginas/paginas.html'
                })
                .state('admin.paginas.list', {
                    url: '/lista',
                    params: {authenticate: 'admin'},
                  title: 'Manutenção páginas',
                    templateUrl: 'app/admin/paginas/paginas.list.html',
                  controllerAs: 'ctrl',
                  controller: 'PaginasController'
                })
                .state('admin.paginas.nova', {
                    url: '/nova',
                    params: {authenticate: 'admin'},
                  title: 'Nova página',
                    templateUrl: 'app/admin/paginas/paginas.edit.html',
                  controllerAs: 'ctrl',
                  controller: 'PaginasEditController'

                })
                .state('admin.paginas.edit', {
                    url: '/editar/:id',
                    params: {authenticate: 'admin'},
                  title: 'Editar página',
                    templateUrl: 'app/admin/paginas/paginas.edit.html',
                  controllerAs: 'ctrl',
                  controller: 'PaginasEditController'

                });
        }]);
}());

(function () {
  'use strict';

  angular.module('erpRetail')

    .controller('SincronizacaoController', ['$scope', '$http', '$interval', 'Utils', 'REST_API', 'PopAlert', function ($scope, $http, $interval, Utils, REST_API, PopAlert) {

      var stopTime;

      $scope.syncInitialState = {
        count: 0,
        state: false,
        info: null,
        tableTotal: 0,
        tableRegistos: 0,
        step: 0,
        stepMax: 0
      };


      $scope.syncState = $scope.syncInitialState;
      updateTime();

      $scope.sincroniza = function () {
        if (angular.isDefined(stopTime) || $scope.syncState === true) {
          PopAlert.showSuccess(Utils.translate('SYNC_ERROR_IS_RUNNING'));
          return;
        }

        startTimer();
        $http.get(REST_API.HOST + REST_API.ADMIN_SYNC_ALL)
          .then(function (data) {

            //$scope.estado="Sincronização concluida";
            //stopTimer();
          }, function (data, status, headers, config) {
            $scope.estado = 'SYNC_ERROR_STATE';
            stopTimer();
          });
      };


      $scope.sincronizaImagens = function (all) {
        if (angular.isDefined(stopTime) || $scope.syncState === true) {
          PopAlert.showSuccess('SYNC_ERROR_IS_RUNNING');
          return;
        }
        startTimer();
        var url = REST_API.HOST + REST_API.ADMIN_SYNC_IMAGES;
        if (all) url = REST_API.HOST + REST_API.ADMIN_SYNC_IMAGES_ALL;
        $http.get(url)
          .then(function (data) {

            //$scope.estado="Sincronização concluida";
            //stopTimer();
          }, function (data, status, headers, config) {
            $scope.estado = 'SYNC_ERROR_STATE';
            stopTimer();
          });
      };

      $scope.sincronizaTudoCompleto = function () {
        if (angular.isDefined(stopTime) || $scope.syncState === true) {
          PopAlert.showSuccess('SYNC_ERROR_IS_RUNNING');
          return;
        }
        startTimer();
        var url = REST_API.HOST + REST_API.ADMIN_SYNC_ALL_COMPLETE;
        $http.get(url)
          .then(function (data) {

            //$scope.estado="Sincronização concluida";
            //stopTimer();
          }, function (data, status, headers, config) {
            $scope.estado = 'SYNC_ERROR_STATE';
            stopTimer();
          });
      };


      $scope.estado = '';

      function startTimer() {
        if (angular.isUndefined(stopTime)) {
          stopTime = $interval(updateTime, 500);
        }
        $scope.syncState = $scope.syncInitialState;
        $scope.estado='SYNC_ERROR_START';
      }

      function stopTimer() {
        if (angular.isDefined(stopTime)) {
          $interval.cancel(stopTime);
          stopTime = undefined;
        }
        $scope.syncState.state = false;
      }

      function updateTime() {
        
        $http.get(REST_API.HOST + REST_API.ADMIN_SYNC_STATUS)
          .then(function (data) {

            $scope.syncState = angular.copy(data.data);
            $scope.estado = data.data;
            if (data.data.count === 0) $scope.estado = data.data.info;
            if (data.data.state === false) {
              if (angular.isDefined(stopTime)) {
                $scope.estado = data.data.info;
              }
              stopTimer();
            } else
              startTimer();
          }, function (data, status, headers, config) {
            $scope.estado = 'SYNC_ERROR_STATE_LOST_LOG';
            stopTimer();
          });
      }

      $scope.$on('$destroy', function () {
        // Make sure that the interval nis destroyed too
        stopTimer();
      });

    }]);
}());

(function () {
  'use strict';

  angular.module('erpRetail')
    .controller('UtilizadoresListController', /*@ngInject*/ function ($q, $state, User, $filter, Utils) {
      var ctrl = this;

      ctrl.searchText = '';

      ctrl.edit = edit;
      ctrl.updateFiltered = updateFiltered;
      ctrl.onLoad = onLoad;
      ctrl.init = init;

      ctrl.init();

      /////////////

      function init() {
        ctrl.grid = {
          list: [],
          filteredList: [],
          config: {
            itemsPerPage: 10,
            maxPages: 10,
            fillLastPage: true,
            orderBy: 'AIOrderBy'
          }
        };
        ctrl.onLoad();
      }

      function edit(item) {
        $state.go('admin.utilizadores.edit', {id: item.id});
      }


      function updateFiltered() {
        if (Utils.isNullOrEmpty(ctrl.searchText)) {
          ctrl.grid.filteredList = ctrl.grid.list;
        } else {
          ctrl.grid.filteredList = $filter('AIFilter')(ctrl.grid.list, ctrl.searchText);
        }
      }

      function onLoad() {
        var deferred = $q.defer();
        User.getAll().then(function (users) {
          ctrl.grid.list = users;
          ctrl.updateFiltered();
          deferred.resolve(ctrl.grid.list);
        })
          .catch(function (reason) {
            deferred.reject(reason);
          });
        return deferred.promise;
      }
    });
}());



(function () {
  'use strict';

  angular.module('erpRetail')
    .controller('UtilizadoresEditController', function ($rootScope, $filter, $transition$, $q, item, Auth, User, PopAlert, clienteService, emailService,
                                                        CGModalService, plAlertService) {
      var ctrl = this;

      ctrl.tiny = {test: ''};
      ctrl.form = {};
      ctrl.emailValidator = item ? emailService.validatorEmailExists(item.email) : emailService.validatorEmailExists();
      ctrl.type = $transition$.params().type;
      ctrl.isEdit = $transition$.params().isEdit === true;
      ctrl.mailSent = false;
      ctrl.backupData = null;

      ctrl.init = init;
      ctrl.save = save;
      ctrl.edit = edit;
      ctrl.cancel = cancel;
      ctrl.getNClifos = getNClifos;
      ctrl.getNClifo = getNClifo;
      ctrl.requestChangePassword = requestChangePassword;
      ctrl.changePassword = changePassword;

      ctrl.init();

      /////////////

      function init() {
        ctrl.item = item ? angular.copy(item) : {};
        ctrl.editing = ctrl.type === 'new';
        ctrl.backupData = angular.copy(ctrl.item);
      }

      function save() {
        ctrl.form.$setSubmitted();
        if (!ctrl.form.$valid) {
          return;
        }

        var newUser = {};
        if (!ctrl.isEdit) {
          newUser = angular.copy(ctrl.item);
          newUser.baseUrl = Auth.baseUrl();
          newUser.byAdmin = true;
          newUser.nconta = newUser.erp.nconta;
          newUser.erp = undefined;
        }
        var request = item && item.id ? User.saveUser(item.id, ctrl.item) : User.createUser(newUser);
        request.then(
          function (response) {
            ctrl.editing = false;
            PopAlert.showSuccess($rootScope.globalTranslate('utilizador.edit.saveUserSuccess'));
            if (response.id) {
              $rootScope.globalGoTo('admin.utilizadores.edit', {id: response.id});
            }
          },
          function () {
            PopAlert.showError($rootScope.globalTranslate('utilizador.edit.saveUserError'));
          }
        );
      }

      function getNClifos(search, order, page, perpage) {
        return clienteService.query(search, order, page, perpage);
      }

      function getNClifo(search) {
        var deferred = $q.defer();
        clienteService.query(search, '', 1, 1).then(function (response) {
          if (response.list && response.list.length) {
            deferred.resolve(response.list[0]);
          }
          else {
            deferred.reject();
          }
        });
        return deferred.promise;
      }

      function edit() {
        ctrl.editing = !ctrl.editing;
      }

      function cancel() {
        ctrl.edit();
        ctrl.item = angular.copy(ctrl.backupData);
        if (ctrl.form) {
          ctrl.form.email.$setValidity('uniqueEmail', true);
          ctrl.form.$setPristine();
        }
      }

      function requestChangePassword() {
        ctrl.mailSent = true;
        Auth.recuperar(ctrl.item.email).then(
          function () {
            PopAlert.showSuccess($rootScope.globalTranslate('utilizador.edit.resendPwEmailSuccess'));
          },
          function () {
            PopAlert.showError($rootScope.globalTranslate('utilizador.edit.resendPwEmailError'));
          }
        )['finally'](function () {
          ctrl.mailSent = false;
        });
      }

      function changePassword() {
        var deferred = $q.defer();
        CGModalService.show({
          templateUrl: 'app/admin/utilizadores/utilizadores.edit.password.html',
          bindToController: true,
          controllerAs: 'ctrl',
          controller: /*@ngInject*/ function ($uibModalInstance) {
            var ctrl = this;

            ctrl.definition = {};
            ctrl.template = {};
            ctrl.form = {};
            ctrl.model = {};

            ctrl.$onInit = doInit;
            ctrl.submit = submit;
            ctrl.doCancel = doCancel;

            /////////////

            function doInit() {
              ctrl.definition = {
                fields: [
                  {
                    name: 'password', type: 'password', formName: 'formPassword', caption: 'LOGIN_PLACEHOLDER_PASS',
                    properties: {placeholder: 'LOGIN_PLACEHOLDER_PASS', required: true}, validators: {minlength: 5}
                  },
                  {
                    name: 'confirm', type: 'password', caption: 'LOGIN_SIGNUP_PLACEHOLDER_REPEAT_PASS',
                    properties: {placeholder: 'LOGIN_SIGNUP_PLACEHOLDER_REPEAT_PASS', required: true},
                    validators: {
                      minlength: 5, equals: {value: 'formPassword', message: 'Este campo deve ser igual ao campo Palavra-passe'}
                    }
                  }
                ]
              };

              ctrl.template = {
                items: [
                  {type: 'field', field: 'password'},
                  {type: 'field', field: 'confirm'}
                ]
              };
            }

            function submit() {
              ctrl.form.$setSubmitted();
              if (ctrl.form.$invalid) {
                return;
              }
              $uibModalInstance.close(ctrl.model);
            }

            function doCancel() {
              $uibModalInstance.dismiss('cancel');
            }
          }
        }).then(
          function (response) {
            if (response.password) {
              User.mudarPassword(item.id, response.password).then(
                function (response) {
                  deferred.resolve(response);
                  plAlertService.success('utilizador.edit.changePwSuccess');
                },
                function (error) {
                  deferred.reject(error);
                }
              );
            }
            else {
              deferred.reject();
            }
          },
          function () {
            deferred.reject();
          }
        );
        return deferred.promise;
      }
    });
}());

(function () {
  'use strict';
  angular.module('erpRetail')
    .config(/*@ngInject*/ function ($stateProvider) {
      $stateProvider
        .state('admin.utilizadores', {
          url: '/utilizadores',
          abstract: true,
          params: {authenticate: 'admin'},
          title: 'Utilizadores',
          templateUrl: 'app/admin/utilizadores/utilizadores.html'
        })
        .state('admin.utilizadores.list', {
          url: '/list',
          title: 'Lista de utilizadores',
          params: {authenticate: 'admin'},
          templateUrl: 'app/admin/utilizadores/utilizadores.list.html',
          controller: 'UtilizadoresListController',
          controllerAs: 'ctrl'
        })
        .state('admin.utilizadores.new', {
          url: '/novo',
          title: 'Novo utilizador',
          params: {
            authenticate: 'admin',
            type: {value: 'new'},
            isEdit: {value: false}
          },
          templateUrl: 'app/admin/utilizadores/utilizadores.edit.html',
          controller: 'UtilizadoresEditController',
          controllerAs: 'ctrl',
          resolve: {
            item: function () {
              return null;
            },
            translatePartialLoader: /*@ngInject*/ function ($translate, $translatePartialLoader) {
              $translatePartialLoader.addPart('utilizador.perfil');
              return $translate.refresh();
            }
          }
        })
        .state('admin.utilizadores.edit', {
          url: '/edit/:id',
          title: 'Editar utilizador',
          params: {
            authenticate: 'admin',
            type: {value: 'edit'},
            isEdit: {value: true}
          },
          templateUrl: 'app/admin/utilizadores/utilizadores.edit.html',
          controller: 'UtilizadoresEditController',
          controllerAs: 'ctrl',
          resolve: {
            item: /*@ngInject*/ function ($stateParams, User) {
              return User.getUser($stateParams.id);
            }
          }
        });
    });
}());




(function () {
  'use strict';

  angular.module('erpRetail')
    .controller('AlteraMoradaModalController', function ($q, $log, item, paisesService, clienteService, cttService, $translate, PopAlert, $rootScope) {
      var ctrl = this;

      ctrl.definition = {};
      ctrl.form = {};
      ctrl.formDelete = {};
      ctrl.isNew = true;
      ctrl.paises = [];
      ctrl.paisesDelete = [];
      ctrl.moradasAltList = clienteService.getClienteMoradasAlternativas();    

      ctrl.$onInit = init;
      ctrl.submit = submit;
      ctrl.submitDelete = submitDelete;
      ctrl.cancel = cancel;
      ctrl.findPais = findPais;
      ctrl.getPaisValue = getPaisValue;
      ctrl.setRegionByCodPostal = setRegionByCodPostal;
      ctrl.codPostValidator = codPostValidator;

      /////////////

      function init() {
        if (item) {
          ctrl.model = _.cloneDeep(item);
          ctrl.isNew = false;
        } else {
          ctrl.model = {};
        }
        ctrl.definition = {
          fields: []
        };

        ctrl.promise = paisesService.getPaises().then(function (paises) {
          ctrl.paises = paises;
          ctrl.definition = {
            fields: [
              {
                name: 'nome',
                caption: 'utilizador.perfil.moradas.identificacao',
                placeholder: 'utilizador.perfil.moradas.identificacao',
                properties: {disabled: ctrl.model.isPrincipal || ctrl.moradasAltList.length === 0},
                validators: {required: {value: true}}
              },
              {
                name: 'contactoNome',
                caption: 'utilizador.perfil.moradas.fatura.name',
                placeholder: 'utilizador.perfil.moradas.fatura.name',
                validators: {required: {value: true}}
              },
              {
                name: 'cpost', type: 'cpost', caption: 'utilizador.perfil.moradas.fatura.cp', placeholder: 'Código-Postal',
                validators: {required: {value: true}, cpost: ctrl.codPostValidator(ctrl.getPaisValue)},
                events: {
                  change: function (plEditText) {
                    ctrl.setRegionByCodPostal(plEditText.value);
                  }
                }
              },
              {
                name: 'morada',
                caption: 'utilizador.perfil.moradas.fatura.address',
                placeholder: 'utilizador.perfil.moradas.fatura.address',
                validators: {required: {value: true}}
              },
              {
                name: 'localidade',
                caption: 'utilizador.perfil.moradas.fatura.local',
                placeholder: 'utilizador.perfil.moradas.fatura.local',
                validators: {required: {value: true}}
              },
              {
                name: 'paisIso',
                type: 'select',
                caption: 'utilizador.perfil.moradas.fatura.pais',
                placeholder: 'utilizador.perfil.moradas.fatura.pais',
                validators: {required: {value: true}},
                properties: {
                  select: {list: ctrl.paises, labelProp: 'nomePais', valueProp: 'codPaisIso'},
                  disabled: !ctrl.model.canChangeNIF && ctrl.model.isPrincipal}
              },
              {
                name: 'contactoTelefone',
                caption: 'utilizador.perfil.moradas.fatura.telefone',
                placeholder: 'utilizador.perfil.moradas.fatura.telefone',
                validators: {required: {value: false}}
              },
              {
                name: 'nipc',
                type: 'nif',
                caption: 'utilizador.perfil.moradas.fatura.nif',
                placeholder: 'utilizador.perfil.moradas.fatura.nif',
                properties: {
                  visible: ctrl.model.isPrincipal || false,
                  disabled: !ctrl.model.canChangeNIF
                },
                validators: {required: {value: false}, nif: clienteService.nifValidator(ctrl.getPaisValue)}
              }
            ]
          };
          if (ctrl.model && ctrl.model.paisIso && ctrl.paises.length) {
            var pais = ctrl.findPais();
            ctrl.model.nomePais = pais.paisIso.nomePais;
            ctrl.model.paisIso = pais.codPaisIso;
          }
        });
      }

      function submit() {
        if (ctrl.getPaisValue() && clienteService.validateNif(ctrl.model.nipc) === false && ctrl.model.canChangeNIF) {
          PopAlert.showError($rootScope.globalTranslate('validators.nif'));
          return false;
        }

        ctrl.form.$setSubmitted();
        if (ctrl.form.$invalid) {
          return;
        }
        
        ctrl.model.paisIso = ctrl.findPais();
        ctrl.model.codPaisIso = ctrl.model.paisIso.codPaisIso;  
        ctrl.$close(ctrl.model);
      }

      function submitDelete() {
        ctrl.model.paisIso = ctrl.findPais();
        ctrl.model.codPaisIso = ctrl.model.paisIso.codPaisIso;
        ctrl.$close(ctrl.model);
      }

      function cancel() {
        ctrl.$dismiss();
      }

      function findPais() {
        var value = ctrl.model.paisIso;
        var isObject = angular.isObject(value);
        return ctrl.paises.find(function (pais) {
          var codPaisIso = pais.codPaisIso;
          return isObject ? codPaisIso === value.codPaisIso : codPaisIso === value;
        });
      }

      function getPaisValue() {
        var codPais = angular.isObject(ctrl.model.paisIso) ? ctrl.model.paisIso.codPaisIso : ctrl.model.paisIso;
        return codPais === 620;
      }

      function codPostValidator(value) {
        return function () {
          return {
            value: angular.isFunction(value) ? value() : value,
            message: $translate.instant('validators.cpost', {value: ''}),
            validate: function (name, ngModel) {
              if (name === false) {
                return true;
              }
              var regexCodPostal = /^\d{4}-\d{3}$/;
              return ngModel && regexCodPostal.test(ngModel) && ngModel.length === 8 && ctrl.setRegionByCodPostal(ngModel);
            }
          };
        };
      }

      function setRegionByCodPostal(codPostal) {
        if (!codPostal || (ctrl.model.paisIso.codPaisIso !== 620 && ctrl.model.paisIso !== 620)) {
          return;
        }

        cttService.getRegionByCodPostal(codPostal)
          .then(function (response) {
            var region = response.data.OK;
            if (region) {
              ctrl.model.morada = region.Localidade.Arruamentos.Rua.Designacao.content;
              ctrl.model.localidade = region.Localidade.Designacao.content;
              ctrl.model.nomePais = 'Portugal';
              ctrl.model.paisIso = 620;
            }
          })
          .catch(function (reason) {
            $log.error(reason);
          });
        return true;
      }
    });
})();

(function () {
  'use strict';

  angular.module('erpRetail')
    .factory('alteraModaraModal', function (CGModalService) {
      return {
        alteraMorada: alteraMorada,
        deleteMorada: deleteMorada
      };

      /////////////

      function alteraMorada(morada) {
        return CGModalService.show({
          templateUrl: 'app/components/alteraMoradaModal/altera.morada.modal.html',
          controller: 'AlteraMoradaModalController',
          resolve: {
            item: function () {
              return morada;
            }
          }
        });
      }

      function deleteMorada(morada) {
        return CGModalService.show({
          templateUrl: 'app/components/alteraMoradaModal/delete.morada.modal.html',
          controller: 'AlteraMoradaModalController',
          resolve: {
            item: function () {
              return morada;
            }
          }
        });
      }
    });
})();

(function () {
  'use strict';

  /*
 Add to cart fly effect with jQuery. - May 05, 2013
 (c) 2013 @ElmahdiMahmoud - fikra-masri.by
 license: http://www.opensource.org/licenses/mit-license.php
 */
  angular.element('.add-to-cart').on('click', function () {
    var cart = angular.element('.shopping-cart');
    var imgtodrag = angular.element(this).parent('.item').find('img').eq(0);
    if (imgtodrag) {
      var imgclone = imgtodrag.clone()
        .offset({
          top: imgtodrag.offset().top,
          left: imgtodrag.offset().left
        })
        .css({
          'opacity': '0.5',
          'position': 'absolute',
          'height': '150px',
          'width': '150px',
          'z-index': '100'
        })
        .appendTo(angular.element('body'))
        .animate({
          'top': cart.offset().top + 10,
          'left': cart.offset().left + 10,
          'width': 75,
          'height': 75
        }, 1000, 'easeInOutExpo');

      imgclone.animate({
        'width': 0,
        'height': 0
      }, function () {
        angular.element(this).detach();
      });
    }
  });
})();

(function () {
  'use strict';

  angular.module('erpRetail')
    .factory('PopAlert', function (plAlertService) {

      var that = {};

      that.showInfo = function (text) {
        plAlertService.success(text);
      };

      that.showSuccess = function (text) {
        plAlertService.success(text);
      };

      that.showError = function (text) {
        plAlertService.error(text);
      };

      that.prompt = function (messagem, defaultValue, fok, fcancel) {
        plAlertService.prompt(messagem, defaultValue, fok, fcancel);
      };

      that.alert = function (title, messagem, ret) {
        plAlertService.msgBoxConfirm(title, messagem).result.then(function (result) {
          if (result === 'ok')
            ret(true);
        });
      };


      that.postError = function (mensagem) {
        var aux = '';
        if (angular.isDefined(mensagem)) aux = '<br>' + mensagem;
        plAlertService.error('Erro a enviar dados para o servidor.' + aux);
      };

      that.confirm = that.alert;

      return that;
    });
}());

(function () {
  'use strict';

  angular.module('erpRetail')
    .factory('cgClass', function () {
      var factory = {
        CGKeyCount: CGKeyCount,
        accentFold: accentFold,
        accentSplit: accentSplit
      };
      return factory;

      /////////////

      function CGKeyCount() {
        this.items = {};

        this.push = function (key) {
          if (key === '' || key === null || key.length === 1) {
            return;
          }
          var num = this.items[key];
          if (angular.isUndefined(num)) {
            this.items[key] = 1;
            return true;
          }
          else {
            num++;
            this.items[key] = num;
            return false;
          }
        };

        this.pushWord = function (frase) {
          if (frase === null) {
            return;
          }
          var words = accentSplit(frase);
          for (var i = 0; i < words.length; i++) {
            var word = words[i];
            this.push(word);
          }
        };

        this.toArray = function () {
          var result = [];
          for (var key in this.items) {
            if (this.items.hasOwnProperty(key)) {
              var item = {};
              item.key = key;
              item.value = this.items[key];
              result.push(item);
            }
          }
          return result;
        };

        this.toArrayText = function () {
          var result = [];
          for (var key in this.items) {
            if (this.items.hasOwnProperty(key)) {
              var item = {};
              item.text = key;
              result.push(item);
            }
          }
          return result;
        };
      }

      function accentFold(newStringComAcento) {
        var string = ('' + newStringComAcento).toLowerCase();
        var mapaAcentosHex = {
          a: /[\xE0-\xE6]/g,
          e: /[\xE8-\xEB]/g,
          i: /[\xEC-\xEF]/g,
          o: /[\xF2-\xF6]/g,
          u: /[\xF9-\xFC]/g,
          c: /\xE7/g,
          n: /\xF1/g,
          A: /[\xC0-\xC6]/g,
          E: /[\xC9-\xCB]/g,
          I: /[\xCC-\xCF]/g,
          O: /[\xD2-\xD6]/g,
          U: /[\xD9-\xDC]/g,
          C: /\xC7/g,
          N: /\xD1/g
        };

        for (var letra in mapaAcentosHex) {
          if (mapaAcentosHex.hasOwnProperty(letra)) {
            var expressaoRegular = mapaAcentosHex[letra];
            string = string.replace(expressaoRegular, letra);
          }
        }

        return string.toLowerCase();
      }

      function accentSplit(value) {
        value = value.toLowerCase();
        var aux = factory.accentFold(value);
        var spl = '[]#$%&"\'(), *\\/-';
        var r = [];
        var p = 0;
        var s = '';
        for (var i = 0; i < aux.length; i++) {
          var c = aux.charAt(i);

          if (spl.indexOf(c) !== -1) {
            if (p === i) {
              p = i + 1;
              continue;
            }
            s = value.substring(p, i);
            r.push(s);
            p = i + 1;
          }
        }
        s = value.substring(p, i);
        r.push(s);
        return r;
      }
    });
})();

(function () {
    'use strict';

//event listener form DOM ready
    function addLoadEvent(func) {
        var oldonload = window.onload;
      if (typeof window.onload !== 'function') {
            window.onload = func;
        } else {
            window.onload = function () {
                if (oldonload) {
                    oldonload();
                }
                func();
            };
        }
    }

//call function after DOM ready
    addLoadEvent(function () {
        outdatedBrowser({
            bgColor: '#3f3f3f',
            color: '#e3e3e3',
            lowerThan: 'IE11',
          languagePath: 'node_modules/outdated-browser/outdatedbrowser/lang/pt.html'
        });
    });
}());

/**
 * Created by pedro on 20/04/2017.
 */

(function () {
  'use strict';

  angular.module('erpRetail')
    .service('plStorage', function ($location, $log, $sessionStorage) {
      var location = function (pre) {
        pre = pre ? pre + '.' : '';
        var obj = {
          set: function (name, value) {
            if (angular.isObject(name)) {
              obj.setObject(name);
              return;
            }
            if (angular.isArray(value)) {
              var v = '';
              value.forEach(function (item) {
                if (v !== '') v += ';';
                v += item;
              });
              if (v !== '') $location.search(pre + name, v);
              return;
            }
            if (angular.isObject(value)) {
              for (var propertyName in value) {
                if (value.hasOwnProperty(propertyName)) {
                  obj.set(name + '.' + propertyName, value[propertyName]);
                }
              }
              return;
            }
            return $location.search(pre + name, value);
          },
          setObject: function (myobj) {
            for (var propertyName in myobj) {
              if (myobj.hasOwnProperty(propertyName)) {
                obj.set(propertyName, myobj[propertyName]);
              }
            }
          },
          getArray: function (name, myobj) {
            return [];
          },
          getObject: function (name, myobj) {
            for (var propertyName in myobj) {
              if (myobj.hasOwnProperty(propertyName)) {
                var aux = myobj[propertyName];
                myobj[propertyName] = obj.get(name + '.' + propertyName, aux);
              }
            }
            return myobj;
          },
          get: function (name, myobj) {
            if (angular.isArray(myobj)) {
              return obj.getArray(name, myobj);
            } else if (angular.isObject(myobj)) {
              return obj.getObject(name, myobj);
            } else
              return $location.search()[pre + name];
          }
        };
        return obj;
      };
      var ss = function (pre) {
        pre = pre ? pre + '.' : '';
        var s = $sessionStorage.$default({});
        if (!s[pre]) s[pre] = {};
        s = s[pre];
        return {
          get: function (name, obj) {
            return s[name] || obj;
          },
          set: function (name, obj) {
            s[name] = obj;
          }
        };
      };

      return function (scope) {
        if (scope === 'query') {
          return location;
        }
        return ss;
      };
    });
}());

(function () {
  'use strict';

  angular.module('erpRetail')
    .directive('printDiv', function ($window) {
      return {
        restrict: 'A',
        scope: {
          printDiv: '@'
        },
        link: function (scope, element) {
          element.on('click', function () {
            var printContents = angular.element(scope.printDiv).clone();
            var print = angular.element('#print');
            print.html(printContents);
            $window.print();
            print.html();
            return true;
          });

          scope.$on('$destroy', function () {
            element.off('click');
          });
        }
      };
    });
})();

(function () {
  'use strict';

  // Loads the correct sidebar on window load, ollapses the sidebar on window resize.
  // Sets the min-height of #page-wrapper to window size
  angular.element(function () {
    angular.element(window).bind('load resize', function () {
      var topOffset = 50;
      var width = (this.window.innerWidth > 0) ? this.window.innerWidth : this.screen.width;
      if (width < 768) {
        angular.element('div.navbar-collapse').addClass('collapse');
        topOffset = 100; // 2-row-menu
      } else {
        angular.element('div.navbar-collapse').removeClass('collapse');
      }

      var height = (this.window.innerHeight > 0) ? this.window.innerHeight : this.screen.height;
      height = height - topOffset;
      if (height < 1) height = 1;
      if (height > topOffset) {
        angular.element('#page-wrapper').css('min-height', (height) + 'px');
      }
    });
  });
})();

(function () {
  'use strict';

  angular.module('erpRetail')
    .directive('autoResize', function ($timeout, KEYCODE) {
      return {
        link: function ($scope, $element, $attrs) {
          $timeout(function () {
            var $input = angular.element();
            var $parent = angular.element();
            var minWidth = 0;

            if ($element.is('input')) {
              $input = $element;
            }
            else {
              $input = $element.find('input');
              if (!$input.length) {
                return;
              }
            }

            function resize(text) {
              var $this = angular.element(this);
              if (!text.trim()) {
                var placeholder = $this.attr('placeholder');
                if (placeholder) {
                  text = $this.attr('placeholder').trim();
                }
              }
              var $span = $this.parent().find('span');
              $span.text(text);

              var $toResize = $this;
              var width = $span.width();
              if ($parent.length) {
                $toResize = $parent;
                width += minWidth;
              }
              $toResize.css({'min-width': width, 'max-width': width});
            }

            function keypress(event) {
              if (event.which && event.charCode) {
                var c = String.fromCharCode(event.keyCode | event.charCode); // jshint ignore:line
                var $this = angular.element(this);
                resize.call($this, $this.val() + c);
              }
            }

            function keyup(event) {
              if (event.keyCode === KEYCODE.BACKSPACE || event.keyCode === KEYCODE.DELETE) {
                var $this = angular.element(this);
                resize.call($this, $this.val());
              }
            }

            function blur() {
              resize.call($input, $input.val());
            }

            (function init() {
              var selector = $attrs.autoResize;
              if (selector) {
                $parent = $element.closest(selector);
                minWidth = $parent.width();
              }
              $input.after('<span style="display: none;"></span>');
              $input.on('keypress', keypress);
              $input.on('keyup', keyup);
              $input.on('blur', blur);
              resize.call($input, $input.val());

              $scope.$on('$destroy', function () {
                $input.off('keypress', keypress);
                $input.off('keyup', keyup);
                $input.off('blur', blur);
              });
            })();
          });
        }
      };
    });
})();

/*!
 * angular-ui-cgdevtools v1.0.0
 *
 * cg-number
 *
 * Copyright (c) 2013-2014 Pedro Lopes
 *
 */
(function () {
  'use strict';

  angular.module('ui.cgdevtools', [])
    .component('cgNumber', {
      require: {
        ngModel: 'ngModel'
      },
      bindings: {
        name: '@?',
        min: '<?',
        max: '<?',
        step: '<?',
        editable: '<?',
        properties: '<?'
      },
      templateUrl: 'app/components/cgdevtools/cgNumber/cgNumber.html',
      controller: /*@ngInject*/ function ($element, plAlertService) {
        var ctrl = this;
        var defaultOptions = {
          step: 1,
          min: 1,
          max: 2147483647,
          decimalsLimit: 0,
          disabled: false
        };

        ctrl.value = 1;
        ctrl.previousValue = 1;
        ctrl.options = {};

        ctrl.$onInit = init;
        ctrl.$onChanges = onChanges;
        ctrl.handleOptions = handleOptions;
        ctrl.render = render;
        ctrl.minus = minus;
        ctrl.plus = plus;
        ctrl.changed = changed;
        ctrl.setValue = setValue;

        /////////////

        function init() {
          $element.addClass('counter-container');
          ctrl.handleOptions();
          ctrl.ngModel.$render = function () {
            var value = ctrl.ngModel.$modelValue;
            var step = ctrl.options.step;
            var min = ctrl.options.min;
            var max = ctrl.options.max;

            if (min && (value < min || value - step < min) || min === 0 && value < 1) {
              value = min;
            }
            else if (max && (value > max || value + step > max)) {
              value = max;
            }
            ctrl.setValue(value);
          };
        }

        function onChanges(cgNumber) {
          if (cgNumber) {
            ctrl.handleOptions();
          }
        }

        function render() {
          ctrl.ngModel.$setViewValue(ctrl.value);
          ctrl.previousValue = ctrl.value;
        }

        function handleOptions() {
          var options = _.merge({}, defaultOptions, ctrl.options, ctrl.properties);

          // Properties
          if (options.step && options.min < options.step) {
            options.min = options.step;
          }
          if (options.step && options.max % options.step !== 0) {
            options.max--;
            while (options.max % options.step) {
              options.max--;
            }
          }

          // Bindings
          if (angular.isDefined(ctrl.step) && ctrl.step !== null && ctrl.step) {
            options.step = ctrl.step;
          }
          if (angular.isDefined(ctrl.min) && ctrl.min !== null && ctrl.min) {
            if (ctrl.step && ctrl.min < ctrl.step) {
              ctrl.min = ctrl.step;
            }
            options.min = ctrl.min;
          }
          if (angular.isDefined(ctrl.max) && ctrl.max !== null && ctrl.max) {
            if (ctrl.step && ctrl.max % ctrl.step !== 0) {
              ctrl.max--;
              while (ctrl.max % ctrl.step) {
                ctrl.max--;
              }
            }
            options.max = ctrl.max;
          }
          if (ctrl.editable === false) {
            options.disabled = true;
          }
          ctrl.options = options;
        }

        function minus() {
          var step = ctrl.options.step;
          var min = ctrl.options.min;
          if (min && (ctrl.value < min || ctrl.value - step < min) || min === 0 && ctrl.value < 1) {
            ctrl.setValue(min);
            plAlertService.error('Não é possível colocar uma quantidade inferior ao mínimo da mesma');
          }
          else if (ctrl.value % step !== 0) {
            ctrl.setValue(min);
            plAlertService.error('Não é possível colocar uma quantidade não múltipla de {0}'.format(step));
          }
          else {
            ctrl.setValue(ctrl.value - step);
          }
        }

        function plus() {
          var step = ctrl.options.step;
          var max = ctrl.options.max;
          if (max && (ctrl.value > max || ctrl.value + step > max)) {
            ctrl.setValue(max);
            plAlertService.error('Não é possível colocar uma quantidade superior ao máximo da mesma');
          }
          else if (ctrl.value % step !== 0) {
            ctrl.setValue(max);
            plAlertService.error('Não é possível colocar uma quantidade não múltipla de {0}'.format(step));
          }
          else {
            ctrl.setValue(ctrl.value + step);
          }
        }

        function changed() {
          var value = ctrl.value;
          var step = ctrl.options.step;
          var min = ctrl.options.min;
          var max = ctrl.options.max;
          var previousValue = ctrl.previousValue || min || 1;

          // If the user decides to delete the number, we will set it to 0.
          if (isNaN(ctrl.value) || !value) {
            value = previousValue;
          }

          // If a step is set, let's make sure we're within the limit.
          if (step && value % step !== 0) {
            value = previousValue;
            plAlertService.error('Não é possível colocar uma quantidade não múltipla de {0}'.format(step));
          }
          // If a minimum is set, let's make sure we're within the limit.
          else if (min && (value < min || value - step < min) || min === 0 && value < 1) {
            value = previousValue;
            plAlertService.error('Não é possível colocar uma quantidade inferior ao mínimo da mesma');
          }
          // If a maximum is set, let's make sure we're within the limit.
          else if (max && (value > max || value + step > max)) {
            value = previousValue;
            plAlertService.error('Não é possível colocar uma quantidade superior ao máximo da mesma');
          }

          ctrl.setValue(value);
        }

        function setValue(val) {
          ctrl.value = parseInt(val);
          ctrl.render();
        }
      }
    });
}());

(function () {
  'use strict';

  angular.module('erpRetail')
    .factory('CGModalService', function ($uibModal) {
      var service = {
        showVanilla: showVanilla,
        show: show,
        okCancel: okCancel
      };
      return service;

      ////////////

      function showVanilla(options) {
        var op = _.merge({}, {
          animation: true,
          size: 'lg',
          bindToController: true,
          controllerAs: '$ctrl',
          controller: /*@ngInject*/ function ($uibModalInstance) {
            var ctrl = this;

            ctrl.close = doClose;
            ctrl.cancel = doCancel;

            ////////////

            function doClose(value) {
              $uibModalInstance.close(value);
            }

            function doCancel(value) {
              $uibModalInstance.dismiss(value);
            }
          }
        }, options);
        return $uibModal.open(op);
      }

      function show(options) {
        return service.showVanilla(options).result;
      }

      function okCancel(title, message) {
        return show({
          templateUrl: 'app/components/cgmodal/okcancel.html',
          bindToController: true,
          controllerAs: '$ctrl',
          controller: /*@ngInject*/ function ($uibModalInstance, $timeout) {
            var ctrl = this;

            ctrl.title = title;
            ctrl.message = message;

            ctrl.$onInit = init;

            ////////////

            function init() {
              $timeout(function () {
                angular.element('pl-button#btModelOK button').focus();
              });
            }
          }
        });
      }
    });
})();

(function () {
  'use strict';

  angular.module('erpRetail')
    .controller('ConfirmaPagamentoModalController', function ($q, item) {
      var ctrl = this;

      ctrl.definition = {};
      ctrl.form = {};

      ctrl.$onInit = init;
      ctrl.submit = submit;
      ctrl.cancel = cancel;

      /////////////

      function init() {
        ctrl.model = {};
        ctrl.definition = {
          fields: []
        };

        ctrl.definition = {
          fields: [
            {
              name: 'motivo',
              caption: 'Motivo',
              placeholder: 'Motivo',
              validators: {required: {value: false}}
            }
          ]
        };
      }

      function submit() {
        ctrl.form.$setSubmitted();
        if (ctrl.form.$invalid) {
          return;
        }
        ctrl.$close(ctrl.model);
      }

      function cancel() {
        ctrl.$dismiss();
      }
    });
})();

(function () {
  'use strict';

  angular.module('erpRetail')
    .factory('confirmaPagamentoModal', function (CGModalService) {
      return {
        confirmaPagamento: confirmaPagamento
      };

      /////////////

      function confirmaPagamento(doc) {
        return CGModalService.show({
          templateUrl: 'app/components/confirmaPagamentoModal/confirma.pagamento.modal.html',
          controller: 'ConfirmaPagamentoModalController',
          resolve: {
            item: function () {
              return doc;
            }
          }
        });
      }
    });
})();

(function () {
  'use strict';

  angular.module('erpRetail')
    .component('cgListNav', {
      require: {
        ngModel: 'ngModel',
        loja: '?^loja'
      },
      bindings: {
        listView: '=?',
        sortList: '<?',
        sortOrder: '=?',
        onViewChange: '&?',
        onSearch: '&?',
        onSortOrder: '&?',
        properties: '<?'
      },
      templateUrl: 'app/components/directives/cgListNav/cgListNav.html',
      controllerAs: 'ctrl',
      controller: /*@ngInject*/ function ($scope) {
        var ctrl = this;
        var defaultOptions = {
          disabled: {
            btnBox: false,
            btnList: false,
            order: false,
            search: false
          }
        };

        ctrl.options = {};
        ctrl.sortList = null;
        ctrl.sortOrders = [
          {name: 'STORE_SORT_ALPHA_ASC', value: 'artigonome'},
          {name: 'STORE_SORT_ALPHA_DESC', value: 'artigonome desc'},
          {name: 'STORE_SORT_PRICE_ASC', value: 'PrecoComIva asc'},
          {name: 'STORE_SORT_PRICE_DESC', value: 'PrecoComIva desc'},
          {name: 'STORE_SORT_PROMO', value: 'PrecoPromoComIva desc'}
        ];

        ctrl.form = {};
        ctrl.listView = '';
        ctrl.sortOrder = '';
        ctrl.searchValue = '';

        $scope.$on('menu-produtos', function () {
          ctrl.cleanSearch();
        });

        ctrl.$onInit = init;
        ctrl.render = render;
        ctrl.setListView = setListView;
        ctrl.sortOrderChanged = sortOrderChanged;
        ctrl.doSearch = doSearch;
        ctrl.cleanSearch = cleanSearch;

        /////////////

        function init() {
          ctrl.listView = ctrl.listView || 'box';
          ctrl.sortOrders = ctrl.sortList || ctrl.sortOrders;
          ctrl.sortOrder = ctrl.sortOrder || ctrl.sortOrders[0].value;

          // Initialize search value
          ctrl.ngModel.$render = function () {
            ctrl.searchValue = ctrl.ngModel.$modelValue || ctrl.searchValue;
          };

          if (ctrl.loja && ctrl.loja.options) {
            angular.extend(defaultOptions, ctrl.loja.options);
          }
          ctrl.options = angular.extend({}, defaultOptions, ctrl.properties);

          if (ctrl.listView === 'box' && ctrl.options.disabled.btnBox) {
            ctrl.setListView('list');
          }
        }

        function render() {
          ctrl.ngModel.$setViewValue(ctrl.searchValue);
          ctrl.doSearch(ctrl.form.$valid);
        }

        function setListView(type) {
          if ((type === 'box' && !ctrl.options.disabled.btnBox) || (type === 'list' && !ctrl.options.disabled.btnList)) {
            ctrl.listView = type;
            if (angular.isFunction(ctrl.onViewChange)) {
              ctrl.onViewChange({listView: type});
            }
          }
        }

        function sortOrderChanged() {
          if (angular.isFunction(ctrl.onSortOrder) && !ctrl.options.disabled.order) {
            ctrl.onSortOrder({order: ctrl.sortOrder});
          }
        }

        function doSearch(isValid) {
          if (isValid && angular.isFunction(ctrl.onSearch) && !ctrl.options.disabled.search) {
            ctrl.onSearch();
          }
        }

        function cleanSearch() {
          ctrl.searchValue = '';
          ctrl.render();
        }

        /////////////

        $scope.$watch(angular.bind(ctrl, function () {
          var array = [ctrl.properties];
          if (ctrl.loja && ctrl.loja.options) {
            array.push(ctrl.loja.options);
          }
          return array;
        }), function (newVal, oldVal) {
          if (newVal && newVal !== oldVal) {
            if (ctrl.loja && ctrl.loja.options) {
              angular.extend(ctrl.options, ctrl.loja.options);
            }
            angular.extend(ctrl.options, ctrl.properties);
          }
        }, true);
      }
    });
})();

(function () {
  'use strict';

  angular.module('erpRetail')
    .directive('fallbackSrc', function () {
      return {
        link: function postLink(scope, iElement, iAttrs) {
          iElement.bind('error', function () {
            angular.element(this).attr('src', iAttrs.fallbackSrc);
          });
        }
      };
    })
    .directive('mongooseError', function () {
      return {
        restrict: 'A',
        require: 'ngModel',
        link: function (scope, element, attrs, ngModel) {
          element.on('keydown', function () {
            return ngModel.$setValidity('mongoose', true);
          });
        }
      };
    })

    .directive('nifValidator', function (clienteService) {
      return {
        require: 'ngModel',
        link: function ($scope, element, attrs, ctrl) {
          ctrl.$validators.nif = function (modelValue, viewValue) {
            var value = modelValue || viewValue;
            return clienteService.validateNif(value);
          };
        }
      };
    })

    .directive('myNavscroll', function ($window) {
      return function ($scope, element, attrs) {
        angular.element($window).bind('scroll', function () {
          if (!$scope.scrollPosition) {
            $scope.scrollPosition = 10;
          }
          $scope.boolChangeClass = this.pageYOffset > $scope.scrollPosition;
          $scope.$apply();
        });
      };
    })

    .directive('disableNgAnimate', ['$animate', function ($animate) {
      return {
        restrict: 'A',
        link: function (scope, element) {
          $animate.enabled(false, element);
        }
      };
    }])

    .directive('isolateScrolling', function () {
      return {
        restrict: 'A',
        link: function (scope, element, attr) {
          element.bind('mousewheel', function (e) {
            if ((e.deltaY > 0 && this.clientHeight + this.scrollTop === this.scrollHeight) ||
              (e.deltaY < 0 && this.scrollTop === 0)) {
              e.stopPropagation();
              e.preventDefault();
              return false;
            }

            return true;
          });
        }
      };
    })

    .directive('myEnter', function () {
      return function (scope, element, attrs) {
        element.bind('keydown keypress', function (event) {
          if (event.which === 13) {
            scope.$apply(function () {
              scope.$eval(attrs.myEnter);
            });
            event.preventDefault();
          }
        });
      };
    });
})();

(function () {
  'use strict';

  angular.module('erpRetail')
    .run(function ($templateRequest, $templateCache) {
      $templateRequest('app/components/directives/documento/documento.html').then(function (template) {
        $templateCache.put('template-documento-component', template);
      });
    })
    .component('documento', {
      bindings: {
        source: '<',
        targetId: '<',
        showPrint: '<?',
        showPdf: '<?',
        template: '@?',
        callback: '<',
        evtConfirmPayment: '&?'
      },
      template: '<div compile="$ctrl.currentTemplate"></div>',
      controllerAs: '$ctrl',
      controller: /*@ngInject*/ function ($q, documentoService, $timeout, $state, $templateCache, Utils, PopAlert, $rootScope, PagamentosFactory, confirmaPagamentoModal) {
        var ctrl = this;

        ctrl.templateDocumento = $templateCache.get('template-documento-component');
        ctrl.templateFatura = $templateCache.get('template-encomendas-fatura');

        ctrl.$onInit = init;
        ctrl.$onChanges = onChanges;
        ctrl.hasDoc = hasDoc;
        ctrl.reload = reload;
        ctrl.loadReferencias = loadReferencias;
        ctrl.sleep = sleep;
        ctrl.handleChanges = handleChanges;
        ctrl.changedShowPrint = changedShowPrint;
        ctrl.changedShowPdf = changedShowPdf;
        ctrl.canPay = canPay;
        ctrl.pay = pay;
        ctrl.confirmPayment = confirmPayment;
        ctrl.promise = null;
        ctrl.retryMB = 0;
        ctrl.stateName = $state.current.name;

        /////////////

        function init() {
          ctrl.currentTemplate = ctrl.template !== 'fatura' ? ctrl.templateDocumento : ctrl.templateFatura;
          ctrl.handleChanges();
          ctrl.reload();
        }

        function hasDoc() {
          return !!ctrl.targetId;
        }

        function onChanges(documento) {
          if (documento.showPrint && !documento.showPrint.isFirstChange()) {
            ctrl.changedShowPrint(documento.showPrint.currentValue);
          }
          if (documento.showPdf && !documento.showPdf.isFirstChange()) {
            ctrl.changedShowPdf(documento.showPdf.currentValue);
          }
          if (documento.targetId && !documento.targetId.isFirstChange() || documento.source && !documento.source.isFirstChange()) {
            ctrl.reload();
          }
        }

        function sleep() {
          var defered = $q.defer();
          $timeout(function () {
            defered.resolve();
          }, 3000);
          return defered.promise;
        }

        function loadReferencias() {
          var defered = $q.defer();

          documentoService.getReferenciasMB(ctrl.doc.faccb.mbfaccbId)
            .then(function (response) {
              ctrl.referenciasmb = response.data;
              return defered.resolve(ctrl.referenciasmb);
            })
            .catch(function (reason) {
              if (ctrl.retryMB > 10) {
                ctrl.erroMB = true;
                return defered.reject();
              } else {
                ctrl.retryMB = ctrl.retryMB + 1;
                ctrl.sleep().then(function () {
                  ctrl.loadReferencias();
                });
              }
            });

          ctrl.promise = defered.promise;
        }

        function reload() {
          if (!ctrl.hasDoc()) {
            return;
          }
          var value = ctrl.source;
          if (angular.isFunction(value)) {
            value = ctrl.source();
          }
          $q.when(value).then(function (response) {
            var doc = response.data || response;
            doc.clifo.nifReal = doc.clifo.nContribuint;
            if (doc.clifo.nifReal === '999999990' || !doc.clifo.nContribuint) {
              doc.clifo.nifReal = 'Consumidor Final';
            }
            ctrl.doc = doc;

            if (ctrl.doc.caixa && ctrl.doc.caixa.tipo === 2) {
              ctrl.loadReferencias();
            }

            if (ctrl.doc.caixa && ctrl.doc.caixa.tipo === 9) {
              ctrl.canPay(doc);
            }

            if (ctrl.doc.faccb) {
              ctrl.pdfUrl = documentoService.getPdfUrl(ctrl.doc.faccb.faccbid > 0 ? ctrl.doc.faccb.faccbid : ctrl.doc.faccb.mbfaccbId);
            } else {
              ctrl.pdfUrl = documentoService.getPdfUrl(ctrl.doc.cab.faccbId);
            }
          });
        }

        function handleChanges() {
          ctrl.changedShowPrint();
          ctrl.changedShowPdf();
        }

        function changedShowPrint(value) {
          value = value || ctrl.showPrint;
          if (typeof value !== 'boolean') {
            value = false;
          }
          ctrl.showPrint = value;
        }

        function changedShowPdf(value) {
          value = value || ctrl.showPdf;
          if (typeof value !== 'boolean') {
            value = true;
          }
          ctrl.showPdf = value;
        }

        function canPay(doc) {
          if (doc && doc.mbdocLog.last) {
            return (!Utils.isNullOrEmpty(doc) && !Utils.isNullOrEmpty(doc.mbdocLog.last) && Utils.sameText(doc.mbdocLog.last.estado, 'PaypalSend') ||
              Utils.sameText(doc.mbdocLog.last.estado, 'EsperaPagamento'));
          }
        }

        function pay(doc) {
          PagamentosFactory.goPagamento(doc.caixa.tipo, doc.mbdocLog.last.mbfaccbid);
        }

        function confirmPayment(doc) {
          return confirmaPagamentoModal.confirmaPagamento(doc).then(function (data) {
            PagamentosFactory.setPayed(doc.mbdocLog.last.mbfaccbid, data.motivo).then(function (response) {
              ctrl.doc.mbdocLog.last.estado = response.estado;
              ctrl.doc.mbdocLog.last.descricao = response.descricao;
              if (angular.isFunction(ctrl.evtConfirmPayment)) {
                ctrl.evtConfirmPayment({doc: ctrl.doc});
              }
            });
          });
        }
      }
    });
})();

(function () {
  'use strict';

  angular.module('erpRetail')
    .controller('DashboardCtrl', ['$scope', '$timeout',
      function ($scope, $timeout) {
        $scope.gridsterOptions = {
          margins: [10, 10],
          columns: 12,
          draggable: {
            handle: 'h4'
          }
        };

        $scope.dashboards = {
          '1': {
            id: '1',
            name: 'Home',
            widgets: [{
              col: 0,
              row: 0,
              sizeY: 1,
              sizeX: 1,
              name: 'Widget 1'
            }, {
              col: 2,
              row: 1,
              sizeY: 1,
              sizeX: 1,
              name: 'Widget 2'
            }]
          },
          '2': {
            id: '2',
            name: 'Other',
            widgets: [{
              col: 1,
              row: 1,
              sizeY: 1,
              sizeX: 2,
              name: 'Other Widget 1'
            }, {
              col: 1,
              row: 3,
              sizeY: 1,
              sizeX: 1,
              name: 'Other Widget 2'
            }]
          }
        };

        $scope.clear = function () {
          $scope.dashboard.widgets = [];
        };

        $scope.addWidget = function () {
          $scope.dashboard.widgets.push({
            name: 'New Widget',
            sizeX: 1,
            sizeY: 1
          });
        };

        $scope.$watch('selectedDashboardId', function (newVal, oldVal) {
          if (newVal !== oldVal) {
            $scope.dashboard = $scope.dashboards[newVal];
          } else {
            $scope.dashboard = $scope.dashboards[1];
          }
        });

        // init dashboard
        $scope.selectedDashboardId = '1';

      }
    ])

    .controller('CustomWidgetCtrl', ['$scope', '$uibModal',
      function ($scope, $uibModal) {

        $scope.remove = function (widget) {
          $scope.dashboard.widgets.splice($scope.dashboard.widgets.indexOf(widget), 1);
        };

        $scope.openSettings = function (widget) {
          $uibModal.open({
            scope: $scope,
            templateUrl: 'components/directives/grid/grid.layout.settings.html',
            controller: 'WidgetSettingsCtrl',
            resolve: {
              widget: function () {
                return widget;
              }
            }
          });
        };

      }
    ])

    .controller('WidgetSettingsCtrl', ['$scope', '$timeout', '$rootScope', '$uibModalInstance', 'widget',
      function ($scope, $timeout, $rootScope, $uibModalInstance, widget) {
        $scope.widget = widget;

        $scope.form = {
          name: widget.name,
          sizeX: widget.sizeX,
          sizeY: widget.sizeY,
          col: widget.col,
          row: widget.row
        };

        $scope.sizeOptions = [{
          id: '1',
          name: '1'
        }, {
          id: '2',
          name: '2'
        }, {
          id: '3',
          name: '3'
        }, {
          id: '4',
          name: '4'
        }];

        $scope.dismiss = function () {
          $uibModalInstance.dismiss();
        };

        $scope.remove = function () {
          $scope.dashboard.widgets.splice($scope.dashboard.widgets.indexOf(widget), 1);
          $uibModalInstance.close();
        };

        $scope.submit = function () {
          angular.extend(widget, $scope.form);

          $uibModalInstance.close(widget);
        };

      }
    ])


    // helper code
    .filter('object2Array', function () {
      return function (input) {
        var out = [];
        for (var i in input) {
          if (input.hasOwnProperty(i)) {
            out.push(input[i]);
          }
        }
        return out;
      };
    });
}());

(function () {
  'use strict';

  angular.module('erpRetail')
    .config(function (LightboxProvider) {
      LightboxProvider.templateUrl = 'app/components/directives/image/lightbox-cg.html';
    })
    .component('imageGallery', {
      bindings: {
        images: '='
      },
      templateUrl: 'app/components/directives/image/image.gallery.html',
      controllerAs: '$ctrl',
      controller: /*@ngInject*/ function (Lightbox) {
        var ctrl = this;

        ctrl.openLightboxWidgetModal = openLightboxWidgetModal;

        /////////////

        function openLightboxWidgetModal(index) {
          return Lightbox.openModal(ctrl.images, index, {templateUrl: 'app/components/directives/image/lightbox-cg.html'});
        }
      }
    });
})();

(function () {
  'use strict';


  function menuDrawController($scope, $rootScope, $state, $q, $timeout, Auth, MenuService, configFactory) {
    var ctrl = this;

    ctrl.ms = MenuService;

    ctrl.classificadoresList = configFactory.classificadoresList;
    ctrl.classificadores = configFactory.classificadores;

    ctrl.getMenuActiveClass = getMenuActiveClass;
    ctrl.menuCaption = menuCaption;
    ctrl.menuHide = menuHide;
    ctrl.menuBuild = menuBuild;
    ctrl.menuClick = menuClick;
    ctrl.menuClickEvent = menuClickEvent;
    ctrl.refreshUser = refreshUser;
    ctrl.run = run;

    ctrl.menuBuild();

/////////////

    function getMenuActiveClass(item) {
      var s = MenuService.getMenu(item.pageId);
      if (s.state === 'loja.home') {
        return (s.id === $state.params.id) ? 'active' : '';
      }
      if (s.state === 'logout') {
        return false;
      }
      return $state.includes(s.active) ? 'active' : '';
    }

    function menuCaption(item) {
      var s = MenuService.getMenu(item.pageId);
      if (s.id === MenuService.menuUser.id) {
        return Auth.getCurrentUser().name;
      }
      return item.title;

    }

    function menuHide(item) {
      var s = MenuService.getMenu(item.pageId);
      if (s.id === MenuService.menuUser.id) {
        return !Auth.isLoggedIn();
      }
      if (s.id === MenuService.menuLogin.id) {
        return Auth.isLoggedIn();
      }
      if (s.id === MenuService.menuAdmin.id) {
        return !Auth.isAdmin();
      }
    }

    function menuBuild() {
      configFactory.getMenuBuild().then(function (data) {
        ctrl.menuProdutos = data;
      });
    }

    function menuClick(item1) {

      ctrl.currentState = $state.current.name;
      if (ctrl.currentState === 'loja.produtos') {
        ctrl.menuClickEvent(item1);
      } else {
        $state.go('loja.produtos', {paramMenu: item1});
      }
    }

    function menuClickEvent(item1) {
      $rootScope.$broadcast('menu-produtos', item1);
    }

    function refreshUser() {
      ctrl.$apply();
    }

    function run() {
      $scope.$on('event-login', function (event, args) {
        ctrl.refreshUser();
      });

      $scope.$on('event-user', function (event, args) {
        ctrl.refreshUser();
      });

      $scope.$on('event-logout', function (event, args) {
        ctrl.refreshUser();
      });
    }
  }

  function siteMenu() {
    return {
      restrict: 'E',
      scope: {
        logo: '=logo',
        menu: '=menu'
      },
      bindToController: true,
      templateUrl: 'app/components/directives/menu/menu.html',
      controller: menuDrawController,
      controllerAs: 'ctrl'
    };
  }

  function siteSubMenu() {
    return {
      restrict: 'EA',
      scope: {
        menu: '=menu'
      },
      bindToController: true,
      templateUrl: 'app/components/directives/menu/menu.submenu.html',
      controller: menuDrawController,
      controllerAs: 'ctrl'
    };
  }

  function siteCarrinhoSubMenu() {
    return {
      restrict: 'EA',
      scope: {
        menu: '=menu'
      },
      bindToController: true,
      templateUrl: 'app/components/directives/menu/menu.submenu.carrinho.html',
      controller: menuDrawController,
      controllerAs: 'ctrl'
    };
  }

  function siteClassificadoresSubMenu() {
    return {
      restrict: 'EA',
      scope: {
        menu: '=menu'
      },
      bindToController: true,
      templateUrl: 'app/components/directives/menu/menu.submenu.classificadores.html',
      controller: menuDrawController,
      controllerAs: 'ctrl'
    };
  }

  angular.module('erpRetail')
    .directive('siteMenu', siteMenu)
    .directive('siteSubMenu', siteSubMenu)
    .directive('siteCarrinhoSubMenu', siteCarrinhoSubMenu)
    .directive('siteClassificadoresSubMenu', siteClassificadoresSubMenu);
})
();

(function () {
  'use strict';

  angular.module('erpRetail')
    .factory('cgexception', function () {
      var knownExceptions = [
        'ERestField',
        'ECGException',
        'EObjLock',
        'EJsonWrite',
        'ERestNotFound',
        'ELicenceLimit',
        'EEDEPTONotFound',
        'ESearchParserFieldNotFound',
        'EObjContabilidade',
        'EEPOCNotFound',
        'EPolAcesso',
        'EEntity'
      ];

      var factory = {
        knownExceptions: knownExceptions,
        isFatal: isFatal,
        get: get
      };
      return factory;

      /////////////

      function isFatal(className) {
        return factory.knownExceptions.indexOf(className) === -1;
      }

      function get(data) {
        var error = {
          class: 'unknown',
          message: 'error #' + data.status,
          fields: []
        };
        var exception;
        if (data) {
          exception = data.headers('exception');
        }
        if (exception) {
          exception = angular.fromJson(exception);
          error = {
            class: exception.exception.class,
            message: exception.exception.message,
            status: exception.exception.status,
            fields: []
          };
        }
        else {
          exception = {
            exception: {
              class: 'unknown',
              message: 'error #' + data.status,
              fields: []
            }
          };
          error = exception.exception;
        }

        if (data.status === 400 || data.status === 404 || (data.status === 500 && !factory.isFatal(exception.exception.class))) {
          if (exception && exception.exception && exception.exception.fields) {
            for (var i = 0; i < exception.exception.fields.length; i++) {
              error.fields.push(exception.exception.fields[i]);
            }
          }
          else {
            error.message = exception.exception.message;
            error.class = exception.exception.class;
          }
          return error;
        }
        else {
          return error;
        }
      }
    });
})();

(function () {
  'use strict';

  aiFilter.$inject = ['cgClass'];

  function aiFilter(cgClass) {
    return function (array, expression, comparator) {
      if (!angular.isArray(array)) {
        return array;
      }

      var predicateFn;
      var matchAgainstAnyProp;

      switch (typeof expression) {
        case 'function':
          predicateFn = expression;
          break;
        case 'boolean':
        case 'number':
        case 'string':
          matchAgainstAnyProp = true; // jshint ignore:line
        // eslint-disable-next-line no-fallthrough
        case 'object':
          predicateFn = createPredicateFn(expression, comparator, matchAgainstAnyProp, cgClass);
          break;
        default:
          return array;
      }

      return array.filter(predicateFn);
    };
  }

  // Helper functions for `filterFilter`
  function createPredicateFn(expression, comparator, matchAgainstAnyProp, cgClass) {
    var shouldMatchPrimitives = angular.isObject(expression) && ('$' in expression);
    var predicateFn;

    if (comparator === true) {
      comparator = angular.equals;
    }
    else if (!angular.isFunction(comparator)) {
      comparator = function (actual, expected) {
        if (angular.isObject(actual) || angular.isObject(expected)) {
          // Prevent an object to be considered equal to a string like `'[object'`
          return false;
        }

        actual = cgClass.accentFold(angular.lowercase('' + actual));
        expected = cgClass.accentFold(angular.lowercase('' + expected));
        return actual.indexOf(expected) !== -1;
      };
    }

    predicateFn = function (item) {
      if (shouldMatchPrimitives && !angular.isObject(item)) {
        return deepCompare(item, expression.$, comparator, false);
      }
      return deepCompare(item, expression, comparator, matchAgainstAnyProp);
    };

    return predicateFn;
  }

  function deepCompare(actual, expected, comparator, matchAgainstAnyProp, dontMatchWholeObject) {
    var actualType = (actual !== null) ? typeof actual : 'null';
    var expectedType = (expected !== null) ? typeof expected : 'null';

    if (angular.isString(expectedType) && (expected.charAt(0) === '!')) {
      return !deepCompare(actual, expected.substring(1), comparator, matchAgainstAnyProp);
    }
    else if (angular.isArray(actual)) {
      // In case `actual` is an array, consider it a match
      // if ANY of it's items matches `expected`
      return actual.some(function (item) {
        return deepCompare(item, expected, comparator, matchAgainstAnyProp);
      });
    }

    switch (actualType) {
      case 'object':
        var key;
        if (matchAgainstAnyProp) {
          for (key in actual) {
            if (actual.hasOwnProperty(key) && (key.charAt(0) !== '$') && deepCompare(actual[key], expected, comparator, true)) {
              return true;
            }
          }
          return dontMatchWholeObject ? false : deepCompare(actual, expected, comparator, false);
        }
        else if (angular.isObject(expectedType)) {
          for (key in expected) {
            if (expected.hasOwnProperty(key)) {
              var expectedVal = expected[key];
              if (angular.isFunction(expectedVal) || angular.isUndefined(expectedVal)) {
                continue;
              }

              var matchAnyProperty = key === '$';
              var actualVal = matchAnyProperty ? actual : actual[key];
              if (!deepCompare(actualVal, expectedVal, comparator, matchAnyProperty, matchAnyProperty)) {
                return false;
              }
            }
          }
          return true;
        }
        else {
          return comparator(actual, expected);
        }
        break;
      case 'function':
        return false;
      default:
        return comparator(actual, expected);
    }
  }

  angular.module('erpRetail')
    .filter('encodeURI', function ($window) {
      return $window.encodeURI;
    })

    .filter('offset', function () {
      return function (input, start) {
        start = parseInt(start, 10);
        return input.slice(start);
      };
    })

    .filter('AIOrderBy', function (orderByFilter, $parse, cgClass) {
      function map(obj, iterator, context) {
        var results = [];
        angular.forEach(obj, function (value, index, list) {
          results.push(iterator.call(context, value, index, list));
        });
        return results;
      }

      var lowercase = function (string) {
        return string;
      };

      function toBoolean(value) {
        if (angular.isFunction(value)) {
          value = true;
        }
        else if (value && value.length !== 0) {
          var v = lowercase('' + value);
          value = !(v === 'f' || v === '0' || v === 'false' || v === 'no' || v === 'n' || v === '[]');
        }
        else {
          value = false;
        }
        return value;
      }

      return function (array, sortPredicate, reverseOrder) {
        if (!angular.isArray(array)) return array;
        if (!sortPredicate) return array;
        sortPredicate = angular.isArray(sortPredicate) ? sortPredicate : [sortPredicate];
        sortPredicate = map(sortPredicate, function (predicate) {
          var descending = false, get = predicate || angular.identity;
          if (angular.isString(predicate)) {
            if ((predicate.charAt(0) === '+' || predicate.charAt(0) === '-')) {
              descending = predicate.charAt(0) === '-';
              predicate = predicate.substring(1);
            }
            get = $parse(predicate);
          }
          return reverseComparator(function (a, b) {
            return compare(get(a), get(b));
          }, descending);
        });
        var arrayCopy = [];
        for (var i = 0; i < array.length; i++) {
          arrayCopy.push(array[i]);
        }
        return arrayCopy.sort(reverseComparator(comparator, reverseOrder));

        function comparator(o1, o2) {
          for (var i = 0; i < sortPredicate.length; i++) {
            var comp = sortPredicate[i](o1, o2);
            if (comp !== 0) return comp;
          }
          return 0;
        }

        function reverseComparator(comp, descending) {
          return toBoolean(descending) ? function (a, b) {
              return comp(b, a);
            }
            : comp;
        }

        function compare(v1, v2) {
          var t1 = typeof v1;
          var t2 = typeof v2;
          if (t1 === t2) {
            if (angular.isString(v1)) {
              v1 = cgClass.accentFold(v1.toLowerCase());
              v2 = cgClass.accentFold(v2.toLowerCase());
            }
            if (v1 === v2) {
              return 0;
            }
            return v1 < v2 ? -1 : 1;
          }
          else {
            return t1 < t2 ? -1 : 1;
          }
        }
      };
    })


    /**
     * @ngdoc filter
     * @name filter
     * @kind function
     *
     * @description
     * Selects a subset of items from `array` and returns it as a new array.
     *
     * @param {Array} array The source array.
     * @param {string|Object|function()} expression The predicate to be used for selecting items from
     *   `array`.
     *
     *   Can be one of:
     *
     *   - `string`: The string is evaluated as an expression and the resulting value is used for substring match against
     *     the contents of the `array`. All strings or objects with string properties in `array` that contain this string
     *     will be returned. The predicate can be negated by prefixing the string with `!`.
     *
     *   - `Object`: A pattern object can be used to filter specific properties on objects contained
     *     by `array`. For example `{name:"M", phone:"1"}` predicate will return an array of items
     *     which have property `name` containing "M" and property `phone` containing "1". A special
     *     property name `$` can be used (as in `{$:"text"}`) to accept a match against any
     *     property of the object. That's equivalent to the simple substring match with a `string`
     *     as described above. The predicate can be negated by prefixing the string with `!`.
     *     For Example `{name: "!M"}` predicate will return an array of items which have property `name`
     *     not containing "M".
     *
     *   - `function(value, index)`: A predicate function can be used to write arbitrary filters. The
     *     function is called for each element of `array`. The final result is an array of those
     *     elements that the predicate returned true for.
     *
     * @param {function(actual, expected)|true|undefined} comparator Comparator which is used in
     *     determining if the expected value (from the filter expression) and actual value (from
     *     the object in the array) should be considered a match.
     *
     *   Can be one of:
     *
     *   - `function(actual, expected)`:
     *     The function will be given the object value and the predicate value to compare and
     *     should return true if the item should be included in filtered result.
     *
     *   - `true`: A shorthand for `function(actual, expected) { return angular.equals(expected, actual)}`.
     *     this is essentially strict comparison of expected and actual.
     *
     *   - `false|undefined`: A short hand for a function which will look for a substring match in case
     *     insensitive way.
     *
     * @example
     <example>
     <file name="index.html">
     <div ng-init="friends = [{name:'John', phone:'555-1276'},
     {name:'Mary', phone:'800-BIG-MARY'},
     {name:'Mike', phone:'555-4321'},
     {name:'Adam', phone:'555-5678'},
     {name:'Julie', phone:'555-8765'},
     {name:'Juliette', phone:'555-5678'}]"></div>

     Search: <input ng-model="searchText">
     <table id="searchTextResults">
     <tr><th>Name</th><th>Phone</th></tr>
     <tr ng-repeat="friend in friends | filter:searchText">
     <td>{{friend.name}}</td>
     <td>{{friend.phone}}</td>
     </tr>
     </table>
     <hr>
     Any: <input ng-model="search.$"> <br>
     Name only <input ng-model="search.name"><br>
     Phone only <input ng-model="search.phone"><br>
     Equality <input type="checkbox" ng-model="strict"><br>
     <table id="searchObjResults">
     <tr><th>Name</th><th>Phone</th></tr>
     <tr ng-repeat="friendObj in friends | filter:search:strict">
     <td>{{friendObj.name}}</td>
     <td>{{friendObj.phone}}</td>
     </tr>
     </table>
     </file>
     <file name="protractor.js" type="protractor">
     var expectFriendNames = function(expectedNames, key) {
         element.all(by.repeater(key + ' in friends').column(key + '.name')).then(function(arr) {
           arr.forEach(function(wd, i) {
             expect(wd.getText()).toMatch(expectedNames[i]);
           });
         });
       };

     it('should search across all fields when filtering with a string', function() {
         var searchText = element(by.model('searchText'));
         searchText.clear();
         searchText.sendKeys('m');
         expectFriendNames(['Mary', 'Mike', 'Adam'], 'friend');

         searchText.clear();
         searchText.sendKeys('76');
         expectFriendNames(['John', 'Julie'], 'friend');
       });

     it('should search in specific fields when filtering with a predicate object', function() {
         var searchAny = element(by.model('search.$'));
         searchAny.clear();
         searchAny.sendKeys('i');
         expectFriendNames(['Mary', 'Mike', 'Julie', 'Juliette'], 'friendObj');
       });
     it('should use a equal comparison when comparator is true', function() {
         var searchName = element(by.model('search.name'));
         var strict = element(by.model('strict'));
         searchName.clear();
         searchName.sendKeys('Julie');
         strict.click();
         expectFriendNames(['Julie'], 'friendObj');
       });
     </file>
     </example>
     */
    .filter('AIFilter', aiFilter)


    .filter('AIhighlight', function () {
      return function (text, search) {
        if (text && (search || angular.isNumber(search))) {
          text = text.toString();
          search = search.toString();
          // TODO acabar função AIhighlight

          return text.replace(new RegExp(search, 'gi'), '<span class="ui-match">$&</span>');
        } else {
          return text;
        }
      };
    });
}());

(function () {
  'use strict';

  /**
   * Created by pedro on 13/04/2017.
   */
  angular.module('erpRetail')
    .filter('textoArtigo', function (Utils) {
      return function (text) {
        return Utils.isNullOrEmpty(text) ? '' : text.replace(/(?:\r\n|\r|\n)/g, '<br>');
      };
    });
})();

(function () {
    'use strict';


// baseado no https://github.com/ghoullier/ng-image-cache
// <ui-image data-src="http://localhost/images/test.png" data-title="Test"></ui-image>


    function uiImageDirective() {
        return {
            link: link,
            restrict: 'E',
            replace: true,
            scope: {
                cacheSrc: '@',
                title: '@'
            },
            template: '<img title="{{title}}"/>'
        };

        function link(scope, element, attributes) {
            element.attr('src', attributes.cacheSrc);
        }
    }

  angular.module('ui.CGImageCache', [])
        .directive('cgImage', uiImageDirective)
    ;

}());

(function () {
  'use strict';

  angular.module('erpRetail')
    .controller('imagePickController', function (item, $uibModalInstance, $filter, Utils, ImagensFactory) {
      var ctrl = this;

      ctrl.folder = '';
      ctrl.searchimages = null;
      ctrl.searchartigos = null;
      ctrl.isLoading = true;
      ctrl.lastFolder = '';
      ctrl.grid = {};

      ctrl.$onInit = init;
      ctrl.refresh = refresh;
      ctrl.updateFilter = updateFilter;
      ctrl.getImagem = getImagem;
      ctrl.select = select;
      ctrl.cancel = cancel;

      /////////////

      function init() {
        ctrl.folder = item.folder || '';
        ctrl.grid = {
          filtered: [],
          list: [],
          page: 1,
          total: 0,
          config: {
            itemsPerPage: 10,
            maxPages: 10,
            fillLastPage: true,
            orderBy: 'orderBy'
          }
        };
        ctrl.refresh(ctrl.folder);
      }

      function refresh(folder) {
        ctrl.isLoading = true;
        ImagensFactory.getList(folder).then(function (returns) {
          var aux = ctrl.folder.split('/');
          aux.splice(aux.length - 1, 1);
          ctrl.lastFolder = aux.join('/');
          ctrl.grid.list = returns;
          ctrl.updateFilter();
          ctrl.folder = folder;
        });
      }

      function updateFilter() {
        ctrl.isLoading = true;
        if (Utils.isNullOrEmpty(ctrl.searchimages)) {
          ctrl.grid.filtered = ctrl.grid.list;
        }
        else {
          ctrl.grid.filtered = $filter('filter')(ctrl.grid.list, ctrl.searchimages);
        }
        ctrl.isLoading = false;
      }

      function getImagem(item) {
        if (ctrl.isLoading || Utils.isNullOrUndefined(item) || item.type === 'folder') {
          return;
        }
        return ImagensFactory.getUrlImagem(ctrl.folder, item.name);
      }

      function select(item) {
        if (item.type === 'folder') {
          var folder = ctrl.folder + '/' + item.name;
          ctrl.refresh(folder);
          return;
        }
        if (!Utils.isNullOrEmpty(ctrl.folder)) {
          ctrl.folder += ctrl.folder + '/';
        }
        $uibModalInstance.close({folder: ctrl.folder, name: item.name});
      }

      function cancel() {
        $uibModalInstance.dismiss('cancel');
      }
    });
})();

(function () {
  'use strict';

  angular.module('erpRetail')
    .factory('imagePick', function ($uibModal, Utils) {
      return {
        pick: pick
      };

      /////////////

      function pick(folder, imageUrl, callback) {
        var modalInstance = $uibModal.open({
          templateUrl: 'app/components/imagepick/image.pick.html',
          controllerAs: '$ctrl',
          controller: 'imagePickController',
          modalFade: true,
          backdrop: true,
          size: 'lg',
          resolve: {
            item: function () {
              return {
                folder: folder,
                imageUrl: imageUrl
              };
            }
          }
        });
        if (!Utils.isNullOrUndefined(callback)) {
          modalInstance.result.then(function (selectedItem) {
            callback(selectedItem.folder, selectedItem.name);
          });
        }
        return modalInstance.result;
      }
    });
})();

(function () {
  'use strict';

  angular.module('erpRetail')
    .config(function (LightboxProvider) {
      LightboxProvider.templateUrl = 'app/components/lightbox/lightbox.html';
    })
    .component('lightbox', {
      bindings: {
        src: '<',
        caption: '@',
        items: '<?',
        index: '<?',
        properties: '<?'
      },
      template: '<img class="artimage-detalhe" fallback-src="{{$ctrl.storage.noimage}}" ng-src="{{$ctrl.src}}" ng-click="$ctrl.enlargeImage()">',
      controllerAs: '$ctrl',
      controller: function (storage, Lightbox) {
        var ctrl = this;

        ctrl.storage = storage;

        ctrl.enlargeImage = enlargeImage;

        /////////////

        function enlargeImage() {
          var items = ctrl.items || [{
            url: ctrl.src || ctrl.storage.noimage,
            caption: ctrl.caption || ''
          }];
          var index = 0;
          if (angular.isNumber(ctrl.index)) {
            index = ctrl.index;
          }
          var options = angular.extend({
            templateUrl: 'app/components/lightbox/lightbox.html'
          }, ctrl.properties);
          Lightbox.openModal(items, index, options);
        }
      }
    });
})();

(function () {
  'use strict';

  angular.module('erpRetail')
    .controller('timePickerModalController', function (item, $uibModalInstance, Utils) {
      var ctrl = this;
      ctrl.item=[];
      if (Utils.isNullOrUndefined(item.item)) {
        item.item={          
            from: new Date(),
            to: new Date('1/1/2050 12:00:00 PM')
        };
      }
      ctrl.item.dateFrom=item.item.from;
      ctrl.item.timeFrom=item.item.from;
      ctrl.item.dateTo=item.item.to;
      ctrl.item.timeTo=item.item.to;

      ctrl.isLoading = true;

      ctrl.$onInit = init;
      ctrl.select = select;
      ctrl.cancel = cancel;

      /////////////

      function init() {

      }

      function select(item) {
        var ret={from: Utils.combineDateTime(ctrl.item.dateFrom, ctrl.item.timeFrom), to: Utils.combineDateTime(ctrl.item.dateTo, ctrl.item.timeTo)};
        $uibModalInstance.close(ret);
      }

      function cancel() {
        $uibModalInstance.dismiss('cancel');
      }
    });
})();

(function () {
  'use strict';

  angular.module('erpRetail')
    .factory('timePickerModal', function ($uibModal, Utils) {
      return {
        timePick: timePick
      };

      /////////////

      function timePick(item, callback) {
        var modalInstance = $uibModal.open({
          templateUrl: 'app/components/timePickerModal/time.picker.modal.html',
          controllerAs: '$ctrl',
          controller: 'timePickerModalController',
          modalFade: true,
          backdrop: true,
          size: 'lg',
          resolve: {
            item: function () {
              return {
                item: item
              };
            }
          }
        });
        if (!Utils.isNullOrUndefined(callback)) {
          modalInstance.result.then(function (selectedItem) {
            callback(selectedItem);
          });
        }
        return modalInstance.result;
      }
    });
})();

(function () {
    'use strict';
  angular.module('erpRetail')
        .run(['WidgetsFactory', function (WidgetsFactory) {
          WidgetsFactory.register('widget-breadcrumb', 'widget-breadcrumb-edit', 'Breadcrumb');
        }])

    .directive('widgetBreadcrumb', function () {

      var controller = ['$scope', 'WidgetsFactory', function ($scope, WidgetsFactory) {

                $scope.refresh = function () {
                  WidgetsFactory.log('widgestBreadcrumb refresh');
                };

                $scope.addItem = function () {
                  $scope.item.data.breadcrumb.push({'titulo': ''});
                };
                $scope.removeItem = function (item) {
                    var index = $scope.item.data.breadcrumb.indexOf(item);
                    if (index === -1) return;
                    $scope.item.data.breadcrumb.splice(index, 1);
                };

            }];

            function link(scope, element, attrs, $compile) {
                //scope.$watch('id', function () {
                //    scope.refresh();
                //});

            }

            return {
                restrict: 'E',
                scope: {
                    item: '=item'
                },
                templateUrl: 'app/components/widgets/breadcrumb/breadcrumb.html',
                link: link,
                controller: controller
            };

        })

    .directive('widgetBreadcrumbEdit', ['WidgetsFactory', function (WidgetsFactory) {

            function controller($scope, WidgetsFactory) {

                $scope.save = function () {
                  $scope.tableform.$setSubmitted();
                  if ($scope.tableform.$valid) {
                    $scope.tableform.$save();
                  }
                };

                $scope.refresh = function () {
                  WidgetsFactory.log('widgestBreadcrumb refresh');
                };

            }

            return {
                restrict: 'E',
                scope: {
                    item: '=item'
                },
                templateUrl: 'app/components/widgets/breadcrumb/breadcrumb.edit.html',
                controller: controller
            };

        }]);
}());



(function () {
  'use strict';

  angular.module('erpRetail')
    .component('widgetCarouselEdit', {
      bindings: {
        item: '='
      },
      templateUrl: 'app/components/widgets/carousel/carousel.edit.html',
      controller: function (WidgetsFactory, Utils, imagePick, ImagensFactory, timePickerModal) {
        var ctrl = this;

        ctrl.tableform = {};

        ctrl.$onInit = init;
        ctrl.getImagem = ImagensFactory.getImagem;
        ctrl.refresh = refresh;
        ctrl.edit = edit;
        ctrl.save = save;
        ctrl.addItem = addItem;
        ctrl.removeItem = removeItem;
        ctrl.addImage = addImage;
        ctrl.openTimePickerModal = openTimePickerModal;

        /////////////

        function init() {
          if (Utils.isNullOrUndefined(ctrl.item.data.carousel)) {
            var newItem = {
              carousel: {
                items: []
              }
            };
            if (Utils.isNullOrUndefined(ctrl.item.publishAfter))
              ctrl.item.publishAfter = new Date();
            if (Utils.isNullOrUndefined(ctrl.item.publishedTo))
              ctrl.item.publishedTo = new Date('1/1/2050 12:00:00 PM');
            ctrl.item.data = newItem;
          }
        }

        function refresh() {
          WidgetsFactory.log('widgestCarousel refresh');
        }

        function edit() {
          if (ctrl.item.data.carousel && ctrl.item.data.carousel.items && !ctrl.item.data.carousel.items.length) {
            ctrl.addItem();
          }
          ctrl.tableform.$show();
        }

        function save() {
          ctrl.tableform.$setSubmitted();
          if (ctrl.tableform.$valid) {
            ctrl.tableform.$save();
          }
        }

        function addItem() {
          var newItem = {
            link: '',
            linkBtnText: '',
            titulo: '',
            subTitulo: '',
            image: '',
            _index: ctrl.item.data.carousel.items.length,
            dateTime: {
              from: new Date(),
              to: new Date('1/1/2050 12:00:00 PM'),
            }
          };

          ctrl.item.data.carousel.items.push(newItem);
        }

        function removeItem(item) {
          var index = ctrl.item.data.carousel.items.indexOf(item);
          if (index === -1) {
            return;
          }
          ctrl.item.data.carousel.items.splice(index, 1);
        }

        function addImage(item) {
          return imagePick.pick('', item.image, function (folder, img) {
            item.image = folder + img;
          });
        }

        function openTimePickerModal(aitem) {
          return timePickerModal.timePick(aitem.dateTime, function (item) {
            aitem.dateTime = item;
          });
        }
      }
    });
})();

(function () {
  'use strict';

  angular.module('erpRetail')
    .run(function (WidgetsFactory) {
      WidgetsFactory.register('widget-carousel', 'widget-carousel-edit', 'Carousel');
    })
    .component('widgetCarousel', {
      bindings: {
        item: '<'
      },
      templateUrl: 'app/components/widgets/carousel/carousel.html',
      controller: function (configFactory, WidgetsFactory, ImagensFactory, $rootScope, Utils) {
        var ctrl = this;

        ctrl.myInterval = 5000;
        ctrl.active = 0;
        ctrl.actual = null;
        ctrl.index = null;
        ctrl.carouselItems=[];

        ctrl.$onInit = init;
        ctrl.$onChanges = onChanges;
        ctrl.getImagem = ImagensFactory.getImagem;
        ctrl.refresh = refresh;
        ctrl.filterItems = filterItems;
        ctrl.getDatetime = new Date();

        $rootScope.$watch('widgetChanged', function(newValue, oldValue) {          
          ctrl.getDatetime = new Date();
          refresh();
        });
        /////////////

        function init() {
          ctrl.refresh();
          if (ctrl.carouselItems.length>0)
            ctrl.index = ctrl.carouselItems[ctrl.active]._index;
        }

        function onChanges(carousel) {
          if (carousel && carousel.item && !carousel.item.isFirstChange()) {
            ctrl.refresh();
          }
        }

        function refresh() {
          WidgetsFactory.log('widgestCarousel refresh');
          
          if (ctrl.item.data.carousel) {            
            ctrl.carouselItems=[];
            angular.forEach(ctrl.item.data.carousel.items, function (item) {
              if (filterItems(item)) {
                item._index = ctrl.carouselItems.length;
                ctrl.carouselItems.push(item);
              }
            });            
          }
        }

        function filterItems(element) {
          if (Utils.isNullOrUndefined(element.dateTime)) return true;
          if (Utils.isNullOrUndefined(element.dateTime.from)) return true;
          if (Utils.isNullOrUndefined(element.dateTime.to)) return true;
             
          return ctrl.getDatetime >= new Date(element.dateTime.from) && ctrl.getDatetime <= new Date(element.dateTime.to);
        }
      }
    });
}());

(function () {
  'use strict';

  angular.module('erpRetail')
    .directive('compile', function ($compile) {
      // Directive factory creates a link function
      return function ($scope, $element, $attrs) {
        $attrs.$observe('compile', function (value) {
          // When the 'compile' expression changes assign it into the current DOM
          $element.html($scope.$eval(value));

          /* Compile the new DOM and link it to the current $scope.
           * NOTE: we only compile .childNodes so that
           * we don't get into infinite loop compiling ourselves */
          $compile($element.contents())($scope);
        });
      };
    });
})();

(function () {
  'use strict';
  angular.module('erpRetail')
    .run(['WidgetsFactory', function (WidgetsFactory) {
      WidgetsFactory.register('widget-contactos-info', 'widget-contactos-info-edit', 'Contactos');
    }])

    .directive('widgetContactosInfo', function () {
      /*@ngInject*/
      function controller($scope, WidgetsFactory, EmpresaFactory, emailService, Utils, PopAlert) {
        $scope.empresa = {};
        $scope.form = {};
        $scope.submited = false;

        $scope.refresh = function () {
          EmpresaFactory.get().then(function (empresa) {
            $scope.empresa = empresa;
          });
          WidgetsFactory.log('widgestContactosInfo refresh');
        };

        $scope.sendMail = function (form) {
          if (form.$valid) {
            emailService.sendContact($scope.form.from, $scope.form.email, $scope.form.message).then(function () {
                PopAlert.showInfo(Utils.translate('Email de contacto enviado com sucesso!'));
                $scope.submited = true;
                $scope.form.message = '';
              },
              function () {
                PopAlert.showError(Utils.translate('Ocorreu um erro ao enviar o email! Por favor tente mais tarde!'));
              });
          }
        };
        $scope.refresh();
      }


      function link(scope, element, attrs) {
        scope.$watch('item', function () {
          scope.refresh();
        });
      }

      return {
        restrict: 'E',
        scope: {
          item: '=item'
        },
        templateUrl: 'app/components/widgets/contactosInfo/contactos.info.html',
        link: link,
        controller: controller
      };

    })
    .directive('widgetContactosInfoEdit', function () {
      function controller($scope, WidgetsFactory) {
        //$scope.getImagem = ImagensFactory.getImagem;
        $scope.refresh = function () {
          WidgetsFactory.log('widgetContactosInfoEdit refresh');
          //WidgetsFactory.log($scope.item);
        };
      }

      function link(scope, element, attrs, $compile) {
        scope.$watch('item', function () {
          scope.refresh();
        });

      }

      return {
        restrict: 'E',
        scope: {
          item: '=item'
        },
        templateUrl: 'app/components/widgets/contactosInfo/contactos.info.edit.html',
        link: link,
        controller: controller
      };
    });
}());

(function () {
    'use strict';
  angular.module('erpRetail')
        .run(['WidgetsFactory', function (WidgetsFactory) {
          WidgetsFactory.register('widget-google-maps', 'widget-google-maps-edit', 'GMaps');
        }])

    .directive('widgetGoogleMaps', function () {

            var controller = function ($scope, WidgetsFactory, $sce) {
                $scope.trustSrc = function (url) {
                    return $sce.trustAsResourceUrl(url);
                };

                $scope.refresh = function () {
                  WidgetsFactory.log('widgetGoogleMaps refresh');
                };

            };


            function link(scope, element, attrs, $compile) {
                //scope.$watch('id', function () {
                //    scope.refresh();
                //});

            }

            return {
                restrict: 'E',
                scope: {
                    item: '=item'
                },
                templateUrl: 'app/components/widgets/googleMaps/google.maps.html',
                link: link,
                controller: controller
            };

        })

    .directive('widgetGoogleMapsEdit', function () {

            function controller($scope, WidgetsFactory) {
                $scope.refresh = function () {
                  WidgetsFactory.log('widgestGoogleMaps refresh');
                };

                //$scope.getImagem = ImagensFactory.getImagem;

                /*$scope.removeItem = function(item){
                    var index =  $scope.item.data.maps.indexOf(item);
                    if (index===-1) return;
                    $scope.item.data.maps.splice( index, 1 );
                };*/

                /*$scope.addImage = function () {
                    imagePick.pick("", $scope.item.data.image, function (folder, img) {
                        $scope.item.data.image = folder + img;
                    });
                };*/
            }

            return {
                restrict: 'E',
                scope: {
                    item: '=item'
                },
                templateUrl: 'app/components/widgets/googleMaps/google.maps.edit.html',
                controller: controller
            };

        });

}());

(function () {
  'use strict';

  angular.module('erpRetail')
    .run(function (WidgetsFactory) {
      WidgetsFactory.register('widget-html-col3', 'widget-html-col3-edit', 'Html 4xCol-3');
    })

    .directive('widgetHtmlCol3', function () {
      function controller($scope, WidgetsFactory, ImagensFactory) {
        $scope.getImagem = ImagensFactory.getImagem;
        $scope.refresh = function () {
          WidgetsFactory.log('widgestHtmlCol3 refresh');
        };
        $scope.img = [{imgUrl: ''}];
      }

      function link(scope, element, attrs) {
        scope.$watch('item', function () {
          scope.refresh();
        });
      }

      return {
        restrict: 'E',
        scope: {
          item: '=item'
        },
        templateUrl: 'app/components/widgets/htmlCol3/html.col3.html',
        link: link,
        controller: controller
      };
    })

    .directive('widgetHtmlCol3Edit', function () {
      function controller($scope, WidgetsFactory, imagePick, ImagensFactory) {
        $scope.getImagem = ImagensFactory.getImagem;
        $scope.refresh = function () {
          WidgetsFactory.log('widgetHtmlEdit refresh');
          //WidgetsFactory.log($scope.item);
        };

        $scope.addImage1 = function (item) {
          imagePick.pick('', item.image, function (folder, img) {
            item.data.html.imgUrl1 = folder + img;
          });
        };

        $scope.addImage2 = function (item) {
          imagePick.pick('', item.image, function (folder, img) {
            item.data.html.imgUrl2 = folder + img;
          });
        };

        $scope.addImage3 = function (item) {
          imagePick.pick('', item.image, function (folder, img) {
            item.data.html.imgUrl3 = folder + img;
          });
        };

        $scope.addImage4 = function (item) {
          imagePick.pick('', item.image, function (folder, img) {
            item.data.html.imgUrl4 = folder + img;
          });
        };

        $scope.tinymceOptions = {
          resize: false,
          toolbar: 'insertfile undo redo | styleselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | insertfile  link image',
          'file_browser_callback': function (fieldName, url, type, win) {
            win.document.getElementById(fieldName).value = 'my browser value';
          }
        };
      }

      function link(scope, element, attrs, $compile) {
        scope.$watch('item', function () {
          scope.refresh();
        });
      }

      return {
        restrict: 'E',
        scope: {
          item: '=item'
        },
        templateUrl: 'app/components/widgets/htmlCol3/html.col3.edit.html',
        link: link,
        controller: controller
      };
    });
})();

(function () {
  'use strict';

  angular.module('erpRetail')
    .run(function (WidgetsFactory) {
      WidgetsFactory.register('widget-html-col4', 'widget-html-col4-edit', 'Html 3xCol-4');
    })
    .component('widgetHtmlCol4', {
      bindings: {
        item: '<'
      },
      templateUrl: 'app/components/widgets/htmlCol4/html.col4.html',
      controllerAs: '$ctrl',
      controller: /*@ngInject*/ function ($scope, WidgetsFactory, ImagensFactory) {
        var ctrl = this;

        ctrl.getImagem = ImagensFactory.getImagem;
        ctrl.img = [];

        ctrl.$onInit = init;
        ctrl.$onChanges = onChanges;
        ctrl.refresh = refresh;

        /////////////

        function init() {
          ctrl.img = [{imgUrl: ''}];
        }

        function onChanges(htmlCol4) {
          if(htmlCol4 && htmlCol4.item && !htmlCol4.item.isFirstChange()) {
            ctrl.refresh();
          }
        }

        function refresh() {
          WidgetsFactory.log('widgestHtmlCol4 refresh');
        }
      }
    })
    .component('widgetHtmlCol4Edit', {
      bindings: {
        item: '<'
      },
      templateUrl: 'app/components/widgets/htmlCol4/html.col4.edit.html',
      controllerAs: '$ctrl',
      controller: /*@ngInject*/ function ($scope, $compile, WidgetsFactory, imagePick, ImagensFactory) {
        var ctrl = this;

        ctrl.getImagem = ImagensFactory.getImagem;

        ctrl.$onInit = init;
        ctrl.$onChanges = onChanges;
        ctrl.refresh = refresh;
        ctrl.addImage1 = addImage1;
        ctrl.addImage2 = addImage2;
        ctrl.addImage3 = addImage3;

        /////////////

        function init() {
          ctrl.tinymceOptions = {
            resize: false,
            toolbar: 'insertfile undo redo | styleselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | insertfile  link image',
            'file_browser_callback': function (fieldName, url, type, win) {
              win.document.getElementById(fieldName).value = 'my browser value';
            }
          };
        }

        function onChanges(htmlCol4Edit) {
          if(htmlCol4Edit && htmlCol4Edit.item && !htmlCol4Edit.item.isFirstChange()) {
            ctrl.refresh();
          }
        }

        function refresh() {
          WidgetsFactory.log('widgetHtmlEdit refresh');
        }

        function addImage1(item) {
          imagePick.pick('', item.image, function (folder, img) {
            item.data.html.imgUrl1 = folder + img;
          });
        }

        function addImage2(item) {
          imagePick.pick('', item.image, function (folder, img) {
            item.data.html.imgUrl2 = folder + img;
          });
        }

        function addImage3(item) {
          imagePick.pick('', item.image, function (folder, img) {
            item.data.html.imgUrl3 = folder + img;
          });
        }

      }

    });
})();

(function () {
  'use strict';

  angular.module('erpRetail')
    .run(function (WidgetsFactory) {
      WidgetsFactory.register('widget-html-col6-image', 'widget-html-col6-image-edit', 'Html Col-6 w/ image');
    })

    .directive('widgetHtmlCol6Image', function () {
      function controller($scope, WidgetsFactory, ImagensFactory) {
        $scope.getImagem = ImagensFactory.getImagem;
        $scope.refresh = function () {
          WidgetsFactory.log('widgestHtmlCol6Image refresh');
        };
        $scope.img = $scope.img || [{imgUrl: ''}];
        $scope.item.data.html = $scope.item.data.html || {};
      }

      function link(scope) {
        scope.$watch('item', function () {
          scope.refresh();
        });
      }

      return {
        restrict: 'E',
        scope: {
          item: '='
        },
        templateUrl: 'app/components/widgets/htmlCol6Image/html.col6Image.html',
        link: link,
        controller: controller
      };
    })

    .directive('widgetHtmlCol6ImageEdit', function () {
      function controller($scope, WidgetsFactory, imagePick, ImagensFactory) {
        $scope.getImagem = ImagensFactory.getImagem;
        $scope.refresh = function () {
          WidgetsFactory.log('widgetHtmlCol6ImageEdit refresh');
        };
        $scope.addImage = function (item) {
          imagePick.pick('', item.image, function (folder, img) {
            item.data.html.imgUrl = folder + img;
          });
        };
      }

      function link(scope) {
        scope.$watch('item', function () {
          scope.refresh();
        });
      }

      return {
        restrict: 'E',
        scope: {
          item: '=item'
        },
        templateUrl: 'app/components/widgets/htmlCol6Image/html.col6Image.edit.html',
        link: link,
        controller: controller
      };
    });
})();

(function () {
  'use strict';

  angular.module('erpRetail')
    .run(function (WidgetsFactory) {
      WidgetsFactory.register('widget-html-col9-col3', 'widget-html-col9-col3-edit', 'Html Col-9+Col-3');
    })

    .directive('widgetHtmlCol9Col3', function () {
      function controller($scope, WidgetsFactory, ImagensFactory) {
        $scope.getImagem = ImagensFactory.getImagem;
        $scope.refresh = function () {
          WidgetsFactory.log('widgestHtmlCol9Col3 refresh');
        };
        $scope.img = [{imgUrl: ''}];
        $scope.item.data.html = {};
      }

      function link(scope) {
        scope.$watch('item', function () {
          scope.refresh();
        });
      }

      return {
        restrict: 'E',
        scope: {
          item: '='
        },
        templateUrl: 'app/components/widgets/htmlCol9Col3/html.col9.col3.html',
        link: link,
        controller: controller
      };
    })

    .directive('widgetHtmlCol9Col3Edit', function () {
      function controller($scope, WidgetsFactory, imagePick, ImagensFactory) {
        $scope.getImagem = ImagensFactory.getImagem;
        $scope.refresh = function () {
          WidgetsFactory.log('widgetHtmlCol9Col3Edit refresh');
        };
        $scope.addImage = function (item) {
          imagePick.pick('', item.image, function (folder, img) {
            item.data.html.imgUrl = folder + img;
          });
        };
      }

      function link(scope) {
        scope.$watch('item', function () {
          scope.refresh();
        });
      }

      return {
        restrict: 'E',
        scope: {
          item: '=item'
        },
        templateUrl: 'app/components/widgets/htmlCol9Col3/html.col9.col3.edit.html',
        link: link,
        controller: controller
      };
    });
})();

(function () {
  'use strict';
  angular.module('erpRetail')
    .run(['WidgetsFactory', function (WidgetsFactory) {
      WidgetsFactory.register('widget-html-collapse', 'widget-html-collapse-edit', 'Html collapse');
    }])
    .directive('widgetHtmlCollapse', function () {

      function controller($scope, WidgetsFactory, ImagensFactory) {
        $scope.getImagem = ImagensFactory.getImagem;
        $scope.isCollapsed = false;
        $scope.refresh = function () {
          WidgetsFactory.log('widgestHtmlCollapse refresh');
        };

        $scope.img = [{imgUrl: ''}];
      }

      function link(scope, element, attrs) {
        scope.$watch('item', function () {
          scope.refresh();
        });
      }

      return {
        restrict: 'E',
        scope: {
          item: '=item'
        },
        templateUrl: 'app/components/widgets/htmlCollapse/html.collapse.html',
        link: link,
        controller: controller
      };

    })
    .directive('widgetHtmlCollapseEdit', function () {

      function controller($scope, WidgetsFactory, imagePick, ImagensFactory) {
        $scope.getImagem = ImagensFactory.getImagem;
        $scope.isCollapsed = false;
        $scope.refresh = function () {
          WidgetsFactory.log('widgetHtmlCollapseEdit refresh');
          //WidgetsFactory.log($scope.item);
        };

        $scope.addImage = function (item) {
          imagePick.pick('', item.image, function (folder, img) {
            item.data.html.imgUrl = folder + img;
          });
        };
      }

      function link(scope, element, attrs, $compile) {
        scope.$watch('item', function () {
          scope.refresh();
        });

      }

      return {
        restrict: 'E',
        scope: {
          item: '=item'
        },
        templateUrl: 'app/components/widgets/htmlCollapse/html.collapse.edit.html',
        link: link,
        controller: controller
      };
    });
}());

(function () {
  'use strict';
  angular.module('erpRetail')
    .run(['WidgetsFactory', function (WidgetsFactory) {
      WidgetsFactory.register('widget-html-full', 'widget-html-full-edit', 'Html 1xCol-12');
    }])

    .directive('widgetHtmlFull', ['WidgetsFactory', function (WidgetsFactory) {

      function controller($scope, WidgetsFactory) {
        $scope.refresh = function () {
          WidgetsFactory.log('widgestHtmlFull refresh');
        };
      }

      function link(scope, element, attrs) {
        scope.$watch('item', function () {
          scope.refresh();
        });
      }

      return {
        restrict: 'E',
        scope: {
          item: '=item'
        },
        templateUrl: 'app/components/widgets/htmlFull/html.full.html',
        link: link,
        controller: controller
      };

    }])
    .directive('widgetHtmlFullEdit', ['WidgetsFactory', function (WidgetsFactory) {
      function controller($scope, WidgetsFactory) {
        $scope.refresh = function () {
          //WidgetsFactory.log("widgetHtmlEdit refresh");
          //WidgetsFactory.log($scope.item);
        };

        $scope.tinymceOptions = {
          resize: false,
          toolbar: 'insertfile undo redo | styleselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | insertfile  link image',
          'file_browser_callback': function (fieldName, url, type, win) {
            win.document.getElementById(fieldName).value = 'my browser value';
          }

        };
      }

      function link(scope, element, attrs, $compile) {
        scope.$watch('item', function () {
          scope.refresh();
        });
      }

      return {
        restrict: 'E',
        scope: {
          item: '=item'
        },
        templateUrl: 'app/components/widgets/htmlFull/html.full.edit.html',
        link: link,
        controller: controller
      };
    }]);
}());

(function () {
  'use strict';
  angular.module('erpRetail')
    .run(['WidgetsFactory', function (WidgetsFactory) {
      WidgetsFactory.register('widget-html-full-button', 'widget-html-full-button-edit', 'Html button');
    }])

    .directive('widgetHtmlFullButton', ['WidgetsFactory', function (WidgetsFactory) {

      function controller($scope, WidgetsFactory) {
        $scope.refresh = function () {
          WidgetsFactory.log('widgestHtmlFullButton refresh');
        };
      }

      function link(scope, element, attrs) {
        scope.$watch('item', function () {
          scope.refresh();
        });
      }

      return {
        restrict: 'E',
        scope: {
          item: '=item'
        },
        templateUrl: 'app/components/widgets/htmlFullButton/html.full.button.html',
        link: link,
        controller: controller
      };

    }])
    .directive('widgetHtmlFullButtonEdit', ['WidgetsFactory', function (WidgetsFactory) {
      function controller($scope, WidgetsFactory) {
        $scope.refresh = function () {
          //WidgetsFactory.log("widgetHtmlEdit refresh");
          //WidgetsFactory.log($scope.item);
        };

      }

      /*function link(scope, element, attrs, $compile) {
        scope.$watch('item', function () {
          scope.refresh();
        });
      }*/

      return {
        restrict: 'E',
        scope: {
          item: '=item'
        },
        templateUrl: 'app/components/widgets/htmlFullButton/html.full.button.edit.html',
        controller: controller
      };

      /*return {
        restrict: 'E',
        scope: {
          item: '=item'
        },
        templateUrl: 'app/components/widgets/htmlFullButton/html.full.button.edit.html',
        link: link,
        controller: controller
      };*/
    }]);
}());

(function () {
  'use strict';
  angular.module('erpRetail')
    .run(['WidgetsFactory', function (WidgetsFactory) {
      WidgetsFactory.register('widget-html-half', 'widget-html-half-edit', 'Html 2xCol-6');
    }])

    .directive('widgetHtmlHalf', function () {

      function controller($scope, WidgetsFactory, ImagensFactory) {
        $scope.getImagem = ImagensFactory.getImagem;
        $scope.refresh = function () {
          WidgetsFactory.log('widgestHtmlHalf refresh');
        };

        $scope.img = [{imgUrl: ''}];

      }

      function link(scope, element, attrs) {
        scope.$watch('item', function () {
          scope.refresh();
        });
      }

      return {
        restrict: 'E',
        scope: {
          item: '=item'
        },
        templateUrl: 'app/components/widgets/htmlHalf/html.half.html',
        link: link,
        controller: controller
      };
    })
    .directive('widgetHtmlHalfEdit', function () {

      function controller($scope, WidgetsFactory, imagePick, ImagensFactory) {
        $scope.getImagem = ImagensFactory.getImagem;
        $scope.refresh = function () {
          WidgetsFactory.log('widgetHtmlEdit refresh');
          //WidgetsFactory.log($scope.item);
        };
        $scope.addImage = function (item) {
          imagePick.pick('', item.image, function (folder, img) {
            item.data.html.imgUrl = folder + img;
          });
        };
        $scope.tinymceOptions = {
          resize: false,
          toolbar: 'insertfile undo redo | styleselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | insertfile  link image',
          'file_browser_callback': function (fieldName, url, type, win) {
            win.document.getElementById(fieldName).value = 'my browser value';
          }
        };
      }

      function link(scope, element, attrs, $compile) {
        scope.$watch('item', function () {
          scope.refresh();
        });
      }

      return {
        restrict: 'E',
        scope: {
          item: '=item'
        },
        templateUrl: 'app/components/widgets/htmlHalf/html.half.edit.html',
        link: link,
        controller: controller
      };

    });
}());

(function () {
    'use strict';
  angular.module('erpRetail')
        .run(['WidgetsFactory', function (WidgetsFactory) {
          WidgetsFactory.register('widget-html-image-full', 'widget-html-image-full-edit', 'Image Full Width');
        }])

    .directive('widgetHtmlImageFull', function () {

            function controller($scope, WidgetsFactory, ImagensFactory) {
                $scope.getImagem = ImagensFactory.getImagem;
                $scope.refresh = function () {
                  WidgetsFactory.log('widgetHtmlImageFull refresh');
                };

                $scope.img = [{imgUrl: ''}];
            }

            function link(scope, element, attrs) {
                scope.$watch('item', function () {
                    scope.refresh();
                });
            }

            return {
                restrict: 'E',
                scope: {
                    item: '=item'
                },
                templateUrl: 'app/components/widgets/htmlImageFull/html.image.full.html',
                link: link,
                controller: controller
            };

        })
    .directive('widgetHtmlImageFullEdit', function () {

            function controller($scope, WidgetsFactory, imagePick, ImagensFactory) {

                $scope.getImagem = ImagensFactory.getImagem;

                $scope.refresh = function () {
                  WidgetsFactory.log('widgetHtmlImageFullEdit refresh');
                    //WidgetsFactory.log($scope.item);
                };

                $scope.addImage = function (item) {
                  imagePick.pick('', item.data.imgUrl, function (folder, img) {
                        item.data.imgUrl = folder + img;
                    });
                };

            }

            function link(scope, element, attrs, $compile) {
                scope.$watch('item', function () {
                    scope.refresh();
                });

            }

            return {
                restrict: 'E',
                scope: {
                    item: '=item'
                },
                templateUrl: 'app/components/widgets/htmlImageFull/html.image.full.edit.html',
                link: link,
                controller: controller
            };

        });
}());

(function () {
  'use strict';
  angular.module('erpRetail')
    .run(['WidgetsFactory', function (WidgetsFactory) {
      WidgetsFactory.register('widget-html-saft-funcs', 'widget-html-saft-funcs-edit', 'Html Saft Funcs');
    }])

    .directive('widgetHtmlSaftFuncs', ['WidgetsFactory', function (WidgetsFactory) {

      function controller($scope, WidgetsFactory) {
        $scope.refresh = function () {
          WidgetsFactory.log('widgetHtmlSaftFuncs refresh');
        };
      }

      function link(scope, element, attrs) {
        scope.$watch('item', function () {
          scope.refresh();
        });
      }

      return {
        restrict: 'E',
        scope: {
          item: '=item'
        },
        templateUrl: 'app/components/widgets/htmlSaftFuncs/html.saft.funcionalidades.html',
        link: link,
        controller: controller
      };

    }])
    .directive('widgetHtmlSaftFuncsEdit', ['WidgetsFactory', function (WidgetsFactory) {
      function controller($scope, WidgetsFactory) {
        $scope.refresh = function () {
          //WidgetsFactory.log("widgetHtmlEdit refresh");
          //WidgetsFactory.log($scope.item);
        };

        $scope.tinymceOptions = {
          resize: false,
          toolbar: 'insertfile undo redo | styleselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | insertfile  link image',
          'file_browser_callback': function (fieldName, url, type, win) {
            win.document.getElementById(fieldName).value = 'my browser value';
          }

        };
      }

      function link(scope, element, attrs, $compile) {
        scope.$watch('item', function () {
          scope.refresh();
        });
      }

      return {
        restrict: 'E',
        scope: {
          item: '=item'
        },
        templateUrl: 'app/components/widgets/htmlFull/html.saft.funcionalidades.edit.html',
        link: link,
        controller: controller
      };
    }]);
}());

(function () {
  'use strict';
  angular.module('erpRetail')
    .run(['WidgetsFactory', function (WidgetsFactory) {
      WidgetsFactory.register('widget-tabs', 'widget-tabs-edit', 'Tabs');
    }])

    .directive('widgetTabs', function () {

      var controller = function ($scope, configFactory, WidgetsFactory, ImagensFactory) {

        $scope.refresh = function () {
          WidgetsFactory.log('widgestTabs refresh');
        };

        $scope.getImagem = ImagensFactory.getImagem;

      };

      function link(scope, element, attrs, $compile) {
        //scope.$watch('id', function () {
        //    scope.refresh();
        //});

      }

      return {
        restrict: 'E',
        scope: {
          item: '=item'
        },
        templateUrl: 'app/components/widgets/htmlTabs/html.tabs.html',
        link: link,
        controller: controller
      };

    })

    .directive('widgetTabsEdit', function () {

      function controller($scope, WidgetsFactory, Utils, imagePick, ImagensFactory) {
        $scope.getImagem = ImagensFactory.getImagem;

        $scope.refresh = function () {
          WidgetsFactory.log('widgestTabs refresh');
        };
        $scope.addItem = function () {
          $scope.item.data.tab.items.push({titulo: '', text: '', image: ''});
        };
        $scope.removeItem = function (item) {
          var index = $scope.item.data.tab.items.indexOf(item);
          if (index === -1) return;
          $scope.item.data.tab.items.splice(index, 1);
        };
        $scope.addImage = function (item) {
          imagePick.pick('', item.image, function (folder, img) {
            item.image = folder + img;
          });
        };

        if (Utils.isNullOrUndefined($scope.item.data.tab)) {
          $scope.item.data = {
            tab: {
              items: []
            }
          };
        }

      }

      return {
        restrict: 'E',
        scope: {
          item: '=item'
        },
        templateUrl: 'app/components/widgets/htmlTabs/html.tabs.edit.html',
        controller: controller
      };

    });
}());


(function () {
  'use strict';

  angular.module('erpRetail')
    .run(function (WidgetsFactory) {
      WidgetsFactory.register('widget-img-gallery', 'widget-img-gallery-edit', 'Galeria');
    })
    .component('widgetImgGallery', {
      bindings: {
        item: '='
      },
      templateUrl: 'app/components/widgets/imgGallery/imgGallery.html',
      controllerAs: '$ctrl',
      controller: /*@ngInject*/ function ($scope, WidgetsFactory) {
        var ctrl = this;

        ctrl.images = [];

        ctrl.$onInit = init;
        ctrl.refresh = refresh;

        /////////////

        function init() {
          ctrl.images = [{url: '', thumbUrl: '', caption: ''}];
        }

        function refresh() {
          WidgetsFactory.log('widgestGaleria refresh');
        }
      }
    })
    .component('widgetImgGalleryEdit', {
      bindings: {
        item: '='
      },
      templateUrl: 'app/components/widgets/imgGallery/imgGallery.edit.html',
      controllerAs: '$ctrl',
      controller: /*@ngInject*/ function (WidgetsFactory, imagePick, ImagensFactory) {
        var ctrl = this;

        ctrl.tableform = {};

        ctrl.$onInit = init;
        ctrl.refresh = refresh;
        ctrl.save = save;
        ctrl.edit = edit;
        ctrl.addItem = addItem;
        ctrl.removeItem = removeItem;
        ctrl.addImage = addImage;

        /////////////

        function init() {
          if (!ctrl.item.data.imgGallery) {
            ctrl.item.data.imgGallery = {
              items: []
            };
          }
        }

        function refresh() {
          WidgetsFactory.log('widgestGaleria refresh');
        }

        function edit() {
          if (ctrl.item.data.imgGallery && ctrl.item.data.imgGallery.items && !ctrl.item.data.imgGallery.items.length) {
            ctrl.addItem();
          }
          ctrl.tableform.$show();
        }

        function save() {
          ctrl.tableform.$setSubmitted();
          if (ctrl.tableform.$valid) {
            ctrl.tableform.$save();
          }
        }

        function addItem() {
          ctrl.item.data.imgGallery.items.push({url: '', thumbUrl: '', caption: ''});
        }

        function removeItem(item) {
          var index = ctrl.item.data.imgGallery.items.indexOf(item);
          if (index !== -1) {
            ctrl.item.data.imgGallery.items.splice(index, 1);
          }
        }

        function addImage(item) {
          return imagePick.pick('', item.image, function (folder, img) {
            var url = ImagensFactory.getUrlImagem(folder, img);
            item.url = url;
            item.thumbUrl = url;
            item.caption = img;
          });
        }
      }
    });
})();

(function () {
    'use strict';
  angular.module('erpRetail')
        .run(['WidgetsFactory', function (WidgetsFactory) {
          WidgetsFactory.register('widget-jumbotron', 'widget-jumbotron-edit', 'Jumbotron');
        }])

    .directive('widgetJumbotron', function () {

            var controller = function ($scope, WidgetsFactory, ImagensFactory) {
                $scope.getImagem = ImagensFactory.getImagem;
                $scope.refresh = function () {
                  WidgetsFactory.log('widgestJumbotron refresh');
                };

            };

            function link(scope, element, attrs, $compile) {
                //scope.$watch('id', function () {
                //    scope.refresh();
                //});

            }

            return {
                restrict: 'E',
                scope: {
                    item: '=item'
                },
                templateUrl: 'app/components/widgets/jumbotron/jumbotron.html',
                link: link,
                controller: controller
            };

        })

    .directive('widgetJumbotronEdit', function () {

            function controller($scope, WidgetsFactory, imagePick, ImagensFactory) {
                $scope.refresh = function () {
                  WidgetsFactory.log('widgestJumbotron refresh');
                };

                $scope.getImagem = ImagensFactory.getImagem;

                $scope.removeItem = function (item) {
                    var index = $scope.item.data.jumbotron.indexOf(item);
                    if (index === -1) return;
                    $scope.item.data.jumbotron.splice(index, 1);
                };

                $scope.addImage = function () {
                  imagePick.pick('', $scope.item.data.image, function (folder, img) {
                        $scope.item.data.image = folder + img;
                    });
                };
            }

            return {
                restrict: 'E',
                scope: {
                    item: '=item'
                },
                templateUrl: 'app/components/widgets/jumbotron/jumbotron.edit.html',
                controller: controller
            };

        })


        .directive('backImg', function () {
            return function (scope, element, attrs) {
                var url = attrs.backImg;
                element.css({
                    'background-image': 'url(' + url + ')',
                    /*'background-image': 'url("http://www.centralgest.com/img/top/empresa/centralgest-sobre-nos.jpg")',*/
                    'background-size': 'cover',
                    'background-repeat': 'no-repeat'
                });
            };
        });
}());

(function () {
  'use strict';

  angular.module('erpRetail')
    .run(/*@ngInject*/ function (WidgetsFactory) {
      WidgetsFactory.register('loja', 'loja-edit', 'Loja');
    })
    .component('loja', {
      bindings: {
        item: '=',
        classificador: '<?',
        properties: '<?'
      },
      templateUrl: 'app/components/widgets/loja/loja.html',
      controllerAs: '$ctrl',
      controller: /*@ngInject*/ function ($q, $scope, $filter, $state, $stateParams, configFactory, $rootScope, storage, plStorage, cgClass, ProdutosFactory, plCompsService, Auth, clienteService) {
        var ctrl = this;
        var defaultOptions = {};
        var state = $state.current.name;
        var sessionSearch = state + '(search)';
        var sessionQ = state + '(q)';
        var sessionCurrentPage = state + '(currentPage)';
        var sessionSortOrder = state + '(sortorder)';
        var sessionViewClassificador = state + '(view)';

        ctrl.promise = null;
        ctrl.params = $stateParams;
        ctrl.options = {};
        ctrl.session = plStorage('session')('loja');
        ctrl.ctrl = {};
        ctrl.pageSize = 8;
        ctrl.itemsPerRow = 4;

        ctrl.paginationOptions = {
          perPage: ctrl.pageSize,
          paginationRange: 8,
          lines: [4, 8, 12, 16, 20, 24]
        };
        ctrl.filtrosEmpty = {};

        ctrl.classificadoresList = configFactory.classificadoresList;
        ctrl.classificadores = configFactory.classificadores;
        ctrl.produtos = {};

        ctrl.listView = ctrl.session.get(sessionViewClassificador, 'box');
        ctrl.currentPage = ctrl.session.get(sessionCurrentPage, ctrl.currentPage);
        ctrl.search = {};
        ctrl.q = ctrl.session.get(sessionQ, ctrl.q);
        ctrl.sortorder = ctrl.session.get(sessionSortOrder, ctrl.sortorder);

        ctrl.anexosClassificadores = null;
        ctrl.promiseAnexosClassificadores = null;

        ctrl.$onInit = init;
        ctrl.setListView = setListView;
        ctrl.getTags = getTags;
        ctrl.getClassificador = getClassificador;

        ctrl.sortOrderChanged = sortOrderChanged;
        ctrl.getClassificadorCaption = getClassificadorCaption;
        ctrl.findSearchTags = findSearchTags;
        ctrl.filtroAdd = filtroAdd;
        ctrl.clearFiltro = clearFiltro;
        ctrl.filtroRemove = filtroRemove;
        ctrl.filtroTagRemove = filtroTagRemove;
        ctrl.getFiltro = getFiltro;
        ctrl.orderFiltro = orderFiltro;
        ctrl.onPageChange = onPageChange;
        ctrl.loadTags = loadTags;
        ctrl.doSearch = doSearch;
        ctrl.shouldAffix = shouldAffix;
        ctrl.loadAnexos = loadAnexos;
        ctrl.loadAnexosClassificadores = loadAnexosClassificadores;

        $scope.$on('menu-produtos', function (event, data) {
          ctrl.clearFiltro();
          ctrl.filtroAdd({tipo: data.classificadorTipo}, {key: data.id, value: data.name});
        });

        /////////////

        ctrl.cliente = {};
        ctrl.user = Auth.getCurrentUser();

        if (angular.isDefined(ctrl.user.token)) {
          ctrl.getUserInfo = function () {
            clienteService.getCliente().then(function (cliente) {
              ctrl.cliente = cliente;
            });
          };
          ctrl.getUserInfo();
        }

        function processaClassificadores() {
          ctrl.filtros = angular.copy(ctrl.filtrosEmpty);
          var familias = ctrl.produtos.classificadores.familia;
          var subFamilias = ctrl.produtos.classificadores.subfa;
          var grandesFamilias = ctrl.produtos.classificadores.grandefamilia;
          var classes = ctrl.produtos.classificadores.classe;
          var categorias = ctrl.produtos.classificadores.categoria;
          var tipos = ctrl.produtos.classificadores.tipo;
          var tags = ctrl.produtos.classificadores.tags;
          var i;

          for (i = 0; i < familias.length; i++) {
            if (familias[i].nfamilia > 0 && familias[i].nome) {
              ctrl.filtros.familias.push({
                key: familias[i].nfamilia,
                value: familias[i].nome
              });
            }
          }

          for (i = 0; i < subFamilias.length; i++) {
            ctrl.filtros.subFamilias.push({
              key: subFamilias[i].nsubFa,
              value: subFamilias[i].nome
            });
          }

          for (i = 0; i < classes.length; i++) {
            ctrl.filtros.classes.push({
              key: classes[i].classe,
              value: classes[i].descricao
            });
          }

          for (i = 0; i < tipos.length; i++) {
            ctrl.filtros.tipos.push({
              key: tipos[i].codTpArt,
              value: tipos[i].nome
            });
          }

          for (i = 0; i < grandesFamilias.length; i++) {
            ctrl.filtros.grandesFamilias.push({
              key: grandesFamilias[i].ndepart,
              value: grandesFamilias[i].nome
            });
          }

          for (i = 0; i < categorias.length; i++) {
            if (categorias[i].descricao)
              ctrl.filtros.categorias.push({
                key: categorias[i].categoria,
                value: categorias[i].descricao
              });
          }

          //Os tags funcionam de forma diferente.
          //existe um dicionario em que a chave é o campo tagDefId (ctrl.artigoTags) e cada valor tem o array com as tags dessa definição
          for (i = 0; i < tags.length; i++) {
            var item = tags[i];
            var existe = false;
            var myNewItem = ctrl.filtros.tags[item.tagDefId];
            if (angular.isUndefined(myNewItem)) {
              myNewItem = {
                key: item.tagDefId,
                value: []
              };
              ctrl.filtros.tags[item.tagDefId] = myNewItem;
            }
            var stag = ctrl.findSearchTags({
              key: item.tagDefId,
              name: item.valor
            });
            for (var j = 0; j < item.list.length; j++) {
              var myTagValue = item.list[j];
              existe = false;
              if (stag)
                for (var n = 0; n < stag.values.length; n++) {
                  if (stag.values[n].value === myTagValue.valor) {
                    existe = true;
                    break;
                  }
                }
              if (existe) continue;
              var t = {
                key: j + 1,
                value: myTagValue.valor
              };
              if (angular.isArray(myNewItem.value)) {
                myNewItem.value.push(t);
              }
            }
          }
        }

        function getTags(id) {
          if (!ctrl.filtros || !ctrl.filtros.tags) {
            return null;
          }
          var myItem = ctrl.filtros.tags[id];
          if (myItem) {
            return myItem.value;
          }
          return null;
        }

        function getSearch() {
          var ret = angular.copy(ctrl.filtrosEmpty);
          ctrl.search.familias.forEach(function (item) {
            ret.familias.push(item.key);
          });
          ctrl.search.subFamilias.forEach(function (item) {
            ret.subFamilias.push(item.key);
          });
          ctrl.search.grandesFamilias.forEach(function (item) {
            ret.grandesFamilias.push(item.key);
          });
          ctrl.search.classes.forEach(function (item) {
            ret.classes.push(item.key);
          });
          ctrl.search.categorias.forEach(function (item) {
            ret.categorias.push(item.key);
          });
          ctrl.search.tipos.forEach(function (item) {
            ret.tipos.push(item.key);
          });
          ctrl.search.tags.forEach(function (item) {
            var o = {
              id: item.key,
              name: item.value,
              tags: []
            };
            item.values.forEach(function (tag) {
              o.tags.push({
                name: tag.value
              });
            });
            if (o.tags.length > 0) {
              ret.tags.push(o);
            }

          });

          if (ctrl.classificador) {
            // Get target property name and plurazite it
            var classif = storage.getClassificadorById(ctrl.classificador.tabela);
            var propertyName = classif.identifier.toLowerCase() + 's';
            var key = parseInt(ctrl.classificador.nChave);
            if (key && ret[propertyName] && ret[propertyName].indexOf(key) === -1) {
              ret[propertyName].push(key);
            }
          }

          return ret;
        }

        function pesquisaArtigos() {
          var offset = 0;
          if (ctrl.currentPage > 1) {
            offset = (ctrl.currentPage - 1) * ctrl.pageSize;
          }

          ctrl.session.set(sessionSearch, ctrl.search);
          ctrl.session.set(sessionQ, ctrl.q);
          ctrl.session.set(sessionCurrentPage, ctrl.currentPage);
          ctrl.session.set(sessionSortOrder, ctrl.sortorder);
          var search = getSearch();
          var r = storage.pesquisa(ctrl.q, null, null, search.familias, search.subFamilias, search.grandesFamilias, search.classes,
            search.categorias, search.tipos, ctrl.sortorder, offset, ctrl.pageSize, false, null, null, false, search.tags, true);
          r.then(function (obj) {
            ctrl.produtos = obj.data;
            ctrl.produtos.data = ctrl.produtos.data.map(function (produto) {
              produto.qtd = produto.qtdMinEncome || 1;
              produto.collapsed = true;
              return produto;
            });
            processaClassificadores();
          })['finally'](function () {
            ctrl.promise = null;
          });
          ctrl.promise = r;
          return r;
        }

        function init() {
          ctrl.affix = {
            enabled: ctrl.shouldAffix(),
            style: {
              top: '1px',
              bottom: '1px'
            }
          };
          ctrl.ctrl = {
            config: {},
            noimage: storage.noimage,
            getImagem: storage.getImagem,
            loadAnexos: ctrl.loadAnexos,
            getAnexoUrl: ProdutosFactory.getAnexoUrl,
            addBasket: function (item) {
              return configFactory.getConfigSite().then(function (data) {
                if (data.siteLojaClassificadorOverridesImagem && ctrl.classificador && angular.isArray(ctrl.classificador.imagens) && ctrl.classificador.imagens.length) {
                  item.imagem = ctrl.classificador.imagens[0].docId;
                }
                return storage.addBasket(item);
              });
            },
            getDatetime: function () {
              return $rootScope.getDatetime;
            },
            showDetail: function (item) {
              return storage.showDetail(item);
            }
          };
          ctrl.filtrosEmpty = {
            familias: [],
            subFamilias: [],
            grandesFamilias: [],
            classes: [],
            categorias: [],
            tipos: [],
            tags: []
          };
          if (!ctrl.params.clearSearch) {
            ctrl.search = ctrl.session.get(sessionSearch, ctrl.search);
          }
          ctrl.search = _.merge({}, ctrl.filtrosEmpty, ctrl.search);
          ctrl.options = _.merge({}, defaultOptions, ctrl.properties);
          configFactory.getConfigSite().then(function (data) {
            ctrl.ctrl.config = data;
            ctrl.itemsPerRow = parseInt(data.siteLojaItemsPerRow) || 4;
          });
          ctrl.setListView(ctrl.listView);
          ctrl.sortorder = ctrl.sortorder || 'artigonome';

          if ($stateParams.paramMenu.classificadorTipo) {
            clearFiltro();
            ctrl.filtroAdd({tipo: $stateParams.paramMenu.classificadorTipo}, {key: $stateParams.paramMenu.id, value: $stateParams.paramMenu.name});
          } else {
            pesquisaArtigos();
          }
        }

        function setListView(view) {
          if (view) {
            ctrl.listView = view;
          }
          if (view === 'list') {
            ctrl.boxTemplate = 'produto.list';
          } else {
            ctrl.boxTemplate = 'produto.box';
          }
          ctrl.session.set(sessionViewClassificador, view);
        }

        function getClassificador(data) {
          return configFactory.getClassificador(data);
        }

        function sortOrderChanged(order) {
          if (order) {
            ctrl.sortorder = order;
          }
          pesquisaArtigos();
        }

        function getClassificadorCaption(data) {
          return configFactory.getClassificadorCaption(data);
        }

        function findSearchTags(obj) {
          var tags = ctrl.search.tags;
          for (var i = 0; i < tags.length; i++) {
            if (tags[i].key === obj.key) {
              return tags[i];
            }
          }
          obj.values = [];
          tags.push(obj);
          return obj;
        }

        function filtroAdd(itemClassificador, item) {

          var a;
          if (itemClassificador.tipo === 'tags') {
            var id = {
              key: itemClassificador.id,
              value: itemClassificador.caption
            };
            a = ctrl.findSearchTags(id).values;
          } else {
            a = ctrl.search[itemClassificador.tipo];
          }
          item._index = a.length;
          a.push(item);
          ctrl.currentPage = 1;
          pesquisaArtigos();
        }

        function clearFiltro() {
          ctrl.search = {
            familias: [],
            subFamilias: [],
            grandesFamilias: [],
            classes: [],
            categorias: [],
            tipos: [],
            tags: []
          };
          ctrl.currentPage = 1;
        }

        function filtroRemove(name, key) {
          var aux = ctrl.search[name];
          if (name === 'tags') {
            return;
          }
          var idx = aux.indexOf(key);
          if (idx > -1) {
            aux.splice(idx, 1);
          }
          ctrl.currentPage = 1;
          pesquisaArtigos();
        }

        function filtroTagRemove(taginfo, tag) {
          var aux = ctrl.findSearchTags(taginfo);
          if (!aux.values)
            return;
          var values = aux.values;
          var idx = values.indexOf(tag);
          if (idx > -1) {
            values.splice(idx, 1);
          }
          ctrl.currentPage = 1;
          pesquisaArtigos();
        }

        function getFiltro(classificador) {
          if (!ctrl.filtros) {
            return [];
          }
          var filtro = [];
          if (classificador.tipo === 'tags') {
            filtro = ctrl.getTags(classificador.id);
          } else {
            filtro = ctrl.filtros[classificador.tipo];
          }
          return ctrl.orderFiltro(filtro);
        }

        function orderFiltro(filtro) {
          if (!angular.isArray(filtro) || !filtro.length) {
            return filtro;
          }
          var toFilter = [];
          var orderBy = 'value';
          for (var i = 0; i < filtro.length; i++) {
            var current = filtro[i];
            if (!current && current !== 0 || !current.value && current.value !== 0) {
              continue;
            }
            var value = plCompsService.parseNumber(current.value);
            if (!isFinite(value)) {
              return $filter('orderBy')(filtro, ['value', 'key']);
            }
            if (value || value === 0) {
              orderBy = 'orderedValue';
              current.orderedValue = value;
              toFilter.push(current);
            }
          }
          return $filter('orderBy')(toFilter, [orderBy, 'key']);
        }

        function onPageChange(newPageNumber, perPage) {
          ctrl.currentPage = newPageNumber;
          ctrl.pageSize = perPage;
          pesquisaArtigos();
        }

        function loadTags(query) {
          var deferred = $q.defer();

          if (!ctrl.produtos || !ctrl.produtos.classificadores || !ctrl.produtos.classificadores.tags)
            return;

          var ret = [];
          var tags = angular.fromJson(ctrl.produtos.classificadores.tags);
          for (var i = 0; i < tags.length; i++) {
            var itemTag = tags[i];
            for (var j = 0; j < itemTag.list.length; j++) {
              var item = itemTag.list[j];
              if ((item.valor || item.valor === 0) && cgClass.accentFold(item.valor).toLowerCase().indexOf(query) >= 0) {
                ret.push({
                  id: ret.length + 1,
                  text: item.valor
                });
                if (ret.length === 10)
                  break;
              }
            }
          }
          deferred.resolve(ret);
          return deferred.promise;
        }

        function doSearch() {
          ctrl.currentPage = 1;
          pesquisaArtigos();
        }

        function shouldAffix() {
          var deferred = $q.defer();
          configFactory.getConfigSite().then(
            function (response) {
              try {
                var data = angular.fromJson(response.siteClassificadoresAffix);
                data = data.loja;
                ctrl.affix.enabled = data.enabled;
                if (data.top) {
                  ctrl.affix.style.top = data.top + 'px';
                }
                if (data.bottom) {
                  ctrl.affix.style.bottom = data.bottom + 'px';
                }
                deferred.resolve(ctrl.affix.enabled);
              } catch (ignored) {
                deferred.reject();
              }
            }
          );
          return deferred.promise;
        }

        function loadAnexos(artigo) {
          artigo.collapsed = !artigo.collapsed;
          if (!angular.isArray(artigo.anexos)) {
            artigo.anexos = [];
          }
          if (!artigo.anexos.length && !artigo.collapsed) {
            artigo.promise = ctrl.loadAnexosClassificadores().then(
              function (anexosClassificadores) {
                artigo.promise = ProdutosFactory.getAnexos(storage.tipoTabelaImagens.none.id, artigo.nArtigo).then(function (response) {
                  if (response.data.length) {
                    angular.forEach(response.data, function (ficheiro) {
                      if (!ficheiro.dodGDocClassifica || anexosClassificadores.indexOf(ficheiro.dodGDocClassifica.toString()) === -1) {
                        return;
                      }
                      if (!artigo.anexos[ficheiro.dodGDocClassifica]) {
                        artigo.anexos[ficheiro.dodGDocClassifica] = {
                          classificador: ficheiro.dodGDocClassifica,
                          descricao: ficheiro.descricaoClassificador,
                          files: []
                        };
                      }
                      artigo.anexos[ficheiro.dodGDocClassifica].files.push({
                        id: ficheiro.docId,
                        folderId: ficheiro.folderId,
                        nome: ficheiro.nomeFicheiro,
                        deleted: ficheiro.deleted
                      });
                    });
                  }
                })['finally'](function () {
                  artigo.loaded = true;
                  artigo.promise = null;
                });
              },
              function () {
                artigo.loaded = true;
                artigo.promise = null;
              }
            );
          }
        }

        function loadAnexosClassificadores() {
          var deferred = $q.defer();

          if (!ctrl.anexosClassificadores) {
            if (!ctrl.promiseAnexosClassificadores) {
              ctrl.promiseAnexosClassificadores = configFactory.getConfigSite();
              ctrl.promiseAnexosClassificadores.then(function (response) {
                  var data = response.siteClassificadorAnexos;
                  if (!data) {
                    data = '';
                  }
                  ctrl.anexosClassificadores = data.split(',');
                  ctrl.anexosClassificadores = ctrl.anexosClassificadores.map(function (anexo) {
                    return anexo.toString();
                  });
                  deferred.resolve(ctrl.anexosClassificadores);
                }
              )['finally'](function () {
                ctrl.promiseAnexosClassificadores = null;
              });
            }
          } else {
            deferred.resolve(ctrl.anexosClassificadores);
          }

          return deferred.promise;
        }
      }
    })
    .component('lojaEdit', {
      bindings: {
        item: '<'
      },
      templateUrl: 'app/components/widgets/loja/loja.edit.html',
      controller: /* ngInject */function () {
        var ctrl = this;
        ctrl.refresh = function () {
        };
      }
    });
})();

(function () {
  'use strict';

  angular.module('erpRetail')
    .run(/*@ngInject*/ function (WidgetsFactory) {
      WidgetsFactory.register('loja-classificadores', 'loja-classificadores-edit', 'Loja classificadores');
    })
    .component('lojaClassificadores', {
      bindings: {
        item: '=',
        properties: '<?'
      },
      templateUrl: 'app/components/widgets/lojaclassificadores/lojaclassificadores.html',
      controller: /*@ngInject*/ function ($q, $scope, $filter, $state, configFactory, $rootScope, storage, plStorage, plCompsService, PopAlert, cgClass, ProdutosFactory) {
        var ctrl = this;
        var defaultOptions = {};
        var state = $state.current.name;
        var sessionSearch = state + '(search)';
        var sessionQ = state + '(q)';
        var sessionCurrentPage = state + '(currentPage)';
        var sessionSortOrder = state + '(sortorder)';
        var sessionLvClassificador = state + '(viewClassificador)';

        ctrl.options = {};
        ctrl.session = plStorage('session')('loja');
        ctrl.classificadorList = [];
        ctrl.sortList = [];
        ctrl.promise = null;

        ctrl.ctrl = {};
        ctrl.produtos = {};
        ctrl.pageSize = 8;
        ctrl.itemsPerRow = 4;
        ctrl.paginationOptions = {
          perPage: ctrl.pageSize,
          paginationRange: 8,
          lines: [4, 8, 12, 16, 20, 24]
        };
        ctrl.offset = 0;

        ctrl.search = ctrl.session.get(sessionSearch, ctrl.search);
        ctrl.filtrosEmpty = {};
        ctrl.filtros = angular.copy(ctrl.filtrosEmpty);

        ctrl.classificadoresList = configFactory.classificadoresList;
        ctrl.classificadores = configFactory.classificadores;
        ctrl.classificadorName = '';
        ctrl.classificador = '';

        ctrl.q = ctrl.session.get(sessionQ, ctrl.q);
        ctrl.currentPage = ctrl.session.get(sessionCurrentPage, ctrl.currentPage);
        ctrl.sortorder = ctrl.session.get(sessionSortOrder, ctrl.sortorder);
        ctrl.listViewClassificador = ctrl.session.get(sessionLvClassificador, 'box');

        ctrl.anexosClassificadores = null;
        ctrl.promiseAnexosClassificadores = null;

        ctrl.$onInit = init;
        ctrl.getTags = getTags;
        ctrl.loadClassificadorList = loadClassificadorList;
        ctrl.setListViewClassificador = setListViewClassificador;
        ctrl.getClassificador = getClassificador;
        ctrl.sortOrderChanged = sortOrderChanged;
        ctrl.getClassificadorCaption = getClassificadorCaption;
        ctrl.findSearchTags = findSearchTags;
        ctrl.filtroAdd = filtroAdd;
        ctrl.filtroRemove = filtroRemove;
        ctrl.filtroTagRemove = filtroTagRemove;
        ctrl.getFiltro = getFiltro;
        ctrl.orderFiltro = orderFiltro;
        ctrl.onPageChange = onPageChange;
        ctrl.loadTags = loadTags;
        ctrl.doSearch = doSearch;
        ctrl.shouldAffix = shouldAffix;
        ctrl.loadAnexos = loadAnexos;
        ctrl.loadAnexosClassificadores = loadAnexosClassificadores;

        /////////////

        function processaClassificadores() {
          ctrl.filtros = angular.copy(ctrl.filtrosEmpty);
          var familias = ctrl.produtos.classificadores.familia;
          var subFamilias = ctrl.produtos.classificadores.subfa;
          var grandesFamilias = ctrl.produtos.classificadores.grandefamilia;
          var classes = ctrl.produtos.classificadores.classe;
          var categorias = ctrl.produtos.classificadores.categoria;
          var tipos = ctrl.produtos.classificadores.tipo;
          var tags = ctrl.produtos.classificadores.tags;
          var i;

          for (i = 0; i < familias.length; i++) {
            if (familias[i].nfamilia > 0 && familias[i].nome) {
              ctrl.filtros.familias.push({
                key: familias[i].nfamilia,
                value: familias[i].nome
              });
            }
          }

          for (i = 0; i < subFamilias.length; i++) {
            ctrl.filtros.subFamilias.push({
              key: subFamilias[i].nsubFa,
              value: subFamilias[i].nome
            });
          }

          for (i = 0; i < classes.length; i++) {
            ctrl.filtros.classes.push({
              key: classes[i].classe,
              value: classes[i].descricao
            });
          }

          for (i = 0; i < tipos.length; i++) {
            ctrl.filtros.tipos.push({
              key: tipos[i].codTpArt,
              value: tipos[i].nome
            });
          }

          for (i = 0; i < grandesFamilias.length; i++) {
            ctrl.filtros.grandesFamilias.push({
              key: grandesFamilias[i].ndepart,
              value: grandesFamilias[i].nome
            });
          }

          for (i = 0; i < categorias.length; i++) {
            if (categorias[i].descricao)
              ctrl.filtros.categorias.push({
                key: categorias[i].categoria,
                value: categorias[i].descricao
              });
          }

          //Os tags funcionam de forma diferente.
          //existe um dicionario em que a chave é o campo tagDefId (ctrl.artigoTags) e cada valor tem o array com as tags dessa definição

          for (i = 0; i < tags.length; i++) {
            var item = tags[i];
            var existe = false;
            var myNewItem = ctrl.filtros.tags[item.tagDefId];
            if (angular.isUndefined(myNewItem)) {
              myNewItem = {
                key: item.tagDefId,
                value: []
              };
              ctrl.filtros.tags[item.tagDefId] = myNewItem;
            }
            var stag = ctrl.findSearchTags({
              key: item.tagDefId,
              name: item.valor
            });
            for (var j = 0; j < item.list.length; j++) {
              var myTagValue = item.list[j];
              existe = false;
              if (stag)
                for (var n = 0; n < stag.values.length; n++) {
                  if (stag.values[n].value === myTagValue.valor) {
                    existe = true;
                    break;
                  }
                }
              if (existe) continue;
              var t = {
                key: j + 1,
                value: myTagValue.valor
              };
              myNewItem.value.push(t);
            }
          }
          ctrl.loadClassificadorList();
        }

        function getTags(id) {
          var myItem = ctrl.filtros.tags[id];
          if (myItem) {
            return myItem.value;
          }
          return null;
        }

        function getSearch() {
          var ret = angular.copy(ctrl.filtrosEmpty);
          //familias: [], subFamilias: [], grandesFamilias: [], classes: [], categorias: [], tipos: [], tags: []
          ctrl.search.familias.forEach(function (item) {
            ret.familias.push(item.key);
          });
          ctrl.search.subFamilias.forEach(function (item) {
            ret.subFamilias.push(item.key);
          });
          ctrl.search.grandesFamilias.forEach(function (item) {
            ret.grandesFamilias.push(item.key);
          });
          ctrl.search.classes.forEach(function (item) {
            ret.classes.push(item.key);
          });
          ctrl.search.categorias.forEach(function (item) {
            ret.categorias.push(item.key);
          });
          ctrl.search.tipos.forEach(function (item) {
            ret.tipos.push(item.key);
          });
          ctrl.search.tags.forEach(function (item) {
            var o = {
              id: item.key,
              name: item.value,
              tags: []
            };
            item.values.forEach(function (tag) {
              o.tags.push({
                name: tag.value
              });
            });
            if (o.tags.length > 0) {
              ret.tags.push(o);
            }

          });

          return ret;
        }

        function pesquisaArtigos() {
          ctrl.offset = 0;
          if (ctrl.currentPage > 1) {
            ctrl.offset = (ctrl.currentPage - 1) * ctrl.pageSize;
          }

          ctrl.session.set(sessionSearch, ctrl.search);
          ctrl.session.set(sessionQ, ctrl.q);
          ctrl.session.set(sessionCurrentPage, ctrl.currentPage);
          ctrl.session.set(sessionSortOrder, ctrl.sortorder);
          var search = getSearch();

          var r = storage.pesquisa(ctrl.q, null, null, search.familias, search.subFamilias, search.grandesFamilias, search.classes,
            search.categorias, search.tipos, ctrl.sortorder, ctrl.offset, ctrl.pageSize, false, null, null, false, search.tags, true, ctrl.classificador);
          r.then(function (obj) {
            ctrl.produtos = obj.data;
            ctrl.produtos.data = ctrl.produtos.data.map(function (produto) {
              produto.qtd = produto.qtdMinEncome || 1;
              produto.collapsed = true;
              return produto;
            });
            processaClassificadores();
          })['finally'](function () {
            ctrl.promise = null;
          });
          ctrl.promise = r;
          return r;
        }

        function init() {
          ctrl.affix = {
            enabled: ctrl.shouldAffix(),
            style: {
              top: '1px',
              bottom: '1px'
            }
          };
          ctrl.classificadorName = ctrl.item.data.classificador0;
          ctrl.classificador = storage.getClassificadorByName(ctrl.classificadorName);
          if (ctrl.classificador) {
            ctrl.classificador = ctrl.classificador.id;
          }
          ctrl.sortList = [
            {name: 'STORE_SORT_ALPHA_ASC', value: 'artigonome'},
            {name: 'STORE_SORT_ALPHA_DESC', value: 'artigonome desc'}
          ];
          ctrl.ctrl = {
            config: {},
            noimage: storage.noimage,
            getImagem: storage.getImagem,
            getImagemByDocId: storage.getImagemByDocId,
            loadAnexos: ctrl.loadAnexos,
            getAnexoUrl: ProdutosFactory.getAnexoUrl,
            addBasket: function (item) {
              return storage.addBasket(item);
            },
            getDatetime: function () {
              return $rootScope.getDatetime;
            },
            showDetail: function (item) {
              return storage.showDetail(item);
            },
            showDetailClassificador: function (item) {
              return storage.showDetailClassificador(item);
            }
          };
          ctrl.search = _.merge({}, {
            familias: [],
            subFamilias: [],
            grandesFamilias: [],
            classes: [],
            categorias: [],
            tipos: [],
            tags: []
          }, ctrl.search);
          ctrl.filtrosEmpty = {
            familias: [],
            subFamilias: [],
            grandesFamilias: [],
            classes: [],
            categorias: [],
            tipos: [],
            tags: []
          };
          ctrl.options = _.merge({}, defaultOptions, ctrl.properties);
          ctrl.setListViewClassificador(ctrl.listViewClassificador);
          configFactory.getConfigSite().then(function (data) {
            ctrl.ctrl.config = data;
            ctrl.itemsPerRow = parseInt(data.siteLojaItemsPerRow) || 4;
          });
          ctrl.sortorder = ctrl.sortorder || 'artigonome';
          pesquisaArtigos();
        }

        function loadClassificadorList() {
          if (!storage.getClassificadorById(ctrl.classificador)) {
            PopAlert.showError('Classificador escolhido inválido');
            return;
          }
          ctrl.produtos.page.total = ctrl.produtos.textosClassificadores.length;
          var min = ctrl.offset;
          var max = ctrl.offset + ctrl.pageSize;

          // Order list if necessary
          var classificadores = ctrl.produtos.textosClassificadores;
          if (ctrl.sortorder && ctrl.sortorder.indexOf('nome') !== -1) {
            var reversed = ctrl.sortorder.indexOf('desc') !== -1;
            classificadores = $filter('orderBy')(classificadores, 'titulo', reversed);
          }

          ctrl.classificadorList = [];
          angular.forEach(classificadores, function (item, index) {
            if (item.tabelasTextos && index >= min && index <= max) {
              var newItem = {
                tabela: ctrl.classificador,
                chave: item.tabelasTextos.nChave,
                ordem: 1,
                descricao: '',
                titulo: item.tabelasTextos ? item.tabelasTextos.titulo : null,
                note: item.tabelasTextos ? item.tabelasTextos.note : null,
                docId: item.imagem ? item.imagem.docId : null,
                imagens: item.imagens,
                nArtigo: item.nArtigo,
                anexos: [],
                promise: null,
                loaded: false
              };
              ctrl.classificadorList.push(newItem);
            }
          });
        }

        function setListViewClassificador(view) {
          if (view) {
            ctrl.listViewClassificador = view;
          }
          if (view === 'list') {
            ctrl.boxTemplateClassificador = 'classificador.list';
          } else {

            ctrl.boxTemplateClassificador = 'classificador.box';
          }
          ctrl.session.set(sessionLvClassificador, view);
        }

        function getClassificador(data) {
          return configFactory.getClassificador(data);
        }

        function sortOrderChanged(order) {
          if (order) {
            ctrl.sortorder = order;
          }
          pesquisaArtigos();
        }

        function getClassificadorCaption(data) {
          return configFactory.getClassificadorCaption(data);
        }

        function findSearchTags(obj) {
          var tags = ctrl.search.tags;
          for (var i = 0; i < tags.length; i++) {
            if (tags[i].key === obj.key) {
              return tags[i];
            }
          }
          obj.values = [];
          tags.push(obj);
          return obj;
        }

        function filtroAdd(itemClassificador, item) {
          var a;
          if (itemClassificador.tipo === 'tags') {
            var id = {
              key: itemClassificador.id,
              value: itemClassificador.caption
            };
            a = ctrl.findSearchTags(id).values;
          } else {
            a = ctrl.search[itemClassificador.tipo];
          }
          item._index = a.length;
          a.push(item);
          ctrl.currentPage = 1;
          pesquisaArtigos();
        }

        function filtroRemove(name, key) {
          var aux = ctrl.search[name];
          if (name === 'tags') {
            return;
          }
          var idx = aux.indexOf(key);
          if (idx > -1) {
            aux.splice(idx, 1);
          }
          ctrl.currentPage = 1;
          pesquisaArtigos();
        }

        function filtroTagRemove(taginfo, tag) {
          var aux = ctrl.findSearchTags(taginfo);
          if (!aux.values)
            return;
          var values = aux.values;
          var idx = values.indexOf(tag);
          if (idx > -1) {
            values.splice(idx, 1);
          }
          ctrl.currentPage = 1;
          pesquisaArtigos();
        }

        function getFiltro(classificador) {
          if (!ctrl.filtros) {
            return [];
          }
          var filtro = [];
          if (classificador.tipo === 'tags') {
            filtro = ctrl.getTags(classificador.id);
          }
          else {
            filtro = ctrl.filtros[classificador.tipo];
          }
          return ctrl.orderFiltro(filtro);
        }

        function orderFiltro(filtro) {
          if (!angular.isArray(filtro) || !filtro.length) {
            return filtro;
          }
          var toFilter = [];
          var orderBy = 'value';
          for (var i = 0; i < filtro.length; i++) {
            var current = filtro[i];
            if (!current && current !== 0 || !current.value && current.value !== 0) {
              continue;
            }
            var value = plCompsService.parseNumber(current.value);
            if (!isFinite(value)) {
              return $filter('orderBy')(filtro, ['value', 'key']);
            }
            if (value || value === 0) {
              orderBy = 'orderedValue';
              current.orderedValue = value;
              toFilter.push(current);
            }
          }
          return $filter('orderBy')(toFilter, [orderBy, 'key']);
        }

        function onPageChange(newPageNumber, perPage) {
          ctrl.currentPage = newPageNumber;
          ctrl.pageSize = perPage;
          pesquisaArtigos();
        }

        function loadTags(query) {
          var deferred = $q.defer();

          if (!ctrl.produtos || !ctrl.produtos.classificadores || !ctrl.produtos.classificadores.tags)
            return;

          var ret = [];
          var tags = angular.fromJson(ctrl.produtos.classificadores.tags);
          for (var i = 0; i < tags.length; i++) {
            var itemTag = tags[i];
            for (var j = 0; j < itemTag.list.length; j++) {
              var item = itemTag.list[j];
              if ((item.valor || item.valor === 0) && cgClass.accentFold(item.valor).toLowerCase().indexOf(query) >= 0) {
                ret.push({
                  id: ret.length + 1,
                  text: item.valor
                });
                if (ret.length === 10)
                  break;
              }
            }
          }
          deferred.resolve(ret);
          return deferred.promise;
        }

        function doSearch() {
          ctrl.currentPage = 1;
          pesquisaArtigos();
        }

        function shouldAffix() {
          var deferred = $q.defer();
          configFactory.getConfigSite().then(
            function (response) {
              try {
                var data = angular.fromJson(response.siteClassificadoresAffix);
                data = data.lojaclassificadores;
                ctrl.affix.enabled = data.enabled;
                if (data.top) {
                  ctrl.affix.style.top = data.top + 'px';
                }
                if (data.bottom) {
                  ctrl.affix.style.bottom = data.bottom + 'px';
                }
                deferred.resolve(ctrl.affix.enabled);
              }
              catch (ignored) {
                deferred.reject();
              }
            }
          );
          return deferred.promise;
        }

        function loadAnexos(artigo) {
          artigo.collapsed = !artigo.collapsed;
          if (!angular.isArray(artigo.anexos)) {
            artigo.anexos = [];
          }
          if (!artigo.anexos.length && !artigo.collapsed) {
            artigo.promise = ctrl.loadAnexosClassificadores().then(
              function (anexosClassificadores) {
                artigo.promise = ProdutosFactory.getAnexos(storage.tipoTabelaImagens.none.id, artigo.nArtigo).then(function (response) {
                  if (response.data.length) {
                    angular.forEach(response.data, function (ficheiro) {
                      if (!ficheiro.dodGDocClassifica || anexosClassificadores.indexOf(ficheiro.dodGDocClassifica.toString()) === -1) {
                        return;
                      }
                      if (!artigo.anexos[ficheiro.dodGDocClassifica]) {
                        artigo.anexos[ficheiro.dodGDocClassifica] = {
                          classificador: ficheiro.dodGDocClassifica,
                          descricao: ficheiro.descricaoClassificador,
                          files: []
                        };
                      }
                      artigo.anexos[ficheiro.dodGDocClassifica].files.push({
                        id: ficheiro.docId,
                        folderId: ficheiro.folderId,
                        nome: ficheiro.nomeFicheiro,
                        deleted: ficheiro.deleted
                      });
                    });
                  }
                })['finally'](function () {
                  artigo.loaded = true;
                  artigo.promise = null;
                });
              },
              function () {
                artigo.loaded = true;
                artigo.promise = null;
              }
            );
          }
        }

        function loadAnexosClassificadores() {
          var deferred = $q.defer();

          if (!ctrl.anexosClassificadores) {
            if (!ctrl.promiseAnexosClassificadores) {
              ctrl.promiseAnexosClassificadores = configFactory.getConfigSite();
              ctrl.promiseAnexosClassificadores.then(function (response) {
                  var data = response.siteClassificadorAnexos;
                  if (!data) {
                    data = '';
                  }
                  ctrl.anexosClassificadores = data.split(',');
                  ctrl.anexosClassificadores = ctrl.anexosClassificadores.map(function (anexo) {
                    return anexo.toString();
                  });
                  deferred.resolve(ctrl.anexosClassificadores);
                }
              )['finally'](function () {
                ctrl.promiseAnexosClassificadores = null;
              });
            }
          }
          else {
            deferred.resolve(ctrl.anexosClassificadores);
          }

          return deferred.promise;
        }
      }
    })
    .component('lojaClassificadoresEdit', {
      bindings: {
        item: '<'
      },
      templateUrl: 'app/components/widgets/lojaclassificadores/lojaclassificadores.edit.html',
      controller: /* ngInject */ function () {
        var ctrl = this;

        ctrl.zones = [];
        ctrl.classificadores = [];

        ctrl.init = init;
        ctrl.refresh = refresh;

        ctrl.init();

        /////////////

        function init() {
          ctrl.zones = [{nome: 'Em cima'},
            {nome: 'No meio'},
            {nome: 'No fundo'}
          ];
          ctrl.classificadores = [{nome: 'Nenhum'},
            {nome: 'Tipo de Artigo'},
            {nome: 'Grande Família'},
            {nome: 'Família'},
            {nome: 'Sub-família'},
            {nome: 'Categoria'},
            {nome: 'Classe'}];
        }

        function refresh() {
        }
      }
    });
})();

(function () {
  'use strict';
  angular.module('erpRetail')

    .run(['WidgetsFactory', function (WidgetsFactory) {
      WidgetsFactory.register('widget-produtos', 'widget-produtos-edit', 'Produtos');
    }])

    .directive('widgetProdutos', function () {

      var controller = ['$scope', 'WidgetsFactory', 'Utils', 'storage', 'ProdutosFactory', 'configFactory', '$rootScope', 'Auth', 'clienteService',
        function ($scope, WidgetsFactory, Utils, storage, ProdutosFactory, configFactory, $rootScope, Auth, clienteService) {
          var vm = this;
          vm.item = $scope.item;
          vm.ctrl = {
            config: {},
            noimage: storage.noimage,
            getImagem: storage.getImagem,
            addBasket: function (item) {
              return storage.addBasket(item);
            },
            getDatetime: function () {
              return $rootScope.getDatetime;
            },
            showDetail: function (item) {
              return storage.showDetail(item);
            },
            showDetailClassificador: function (item) {
              return storage.showDetailClassificador(item);
            }
          };

          vm.cliente = {};
          vm.user = Auth.getCurrentUser();

          if (angular.isDefined(vm.user.token)) {
            vm.getUserInfo = function () {
              clienteService.getCliente().then(function (cliente) {
                vm.cliente = cliente;
              });
            };
            vm.getUserInfo();
          }

          vm.produtos = [];
          vm.getDatetime = $rootScope.getDatetime;
          configFactory.getConfigSite().then(
            function (config) {
              $scope.config = config;
            });


          vm.refresh = function () {

            WidgetsFactory.log('widgetProdutos refresh');
            if (Utils.isNullOrUndefined(vm.item.data.tipo)) {
              vm.produtos = [];
              return;
            }

            if (vm.item.data.tipo === 0) {
              storage.getProdutosEmPromocao().then(function (data) {
                vm.produtos = data.data.data;
              });
            } else if (vm.item.data.tipo === 1) {
              ProdutosFactory.getProdutosCatalogo(vm.item.data.catalogo.mbcatalogoCabID).then(function (produtos) {
                vm.produtos = produtos;
              });
            }
          };

          vm.refresh();

          configFactory.getConfigSite().then(function (data) {
            vm.ctrl.config = data;
          });

          return vm;
        }];

      function link(scope, element, attrs, $compile) {
        //scope.$watch('item', function () {
        //    scope.refresh();
        //});

      }

      return {
        restrict: 'E',
        scope: {
          item: '=item'
        },
        templateUrl: 'app/components/widgets/produtos/produtos.html',
        link: link,
        controller: controller,
        controllerAs: 'vm'
      };

    })

    .directive('widgetProdutosEdit', function () {

      var controller = ['WidgetsFactory', 'ProdutosFactory', 'Utils', '$scope', function (WidgetsFactory, ProdutosFactory, Utils, $scope) {
        $scope.catalogos = [];

        $scope.tipos = [{tipo: 0, name: 'Promoções nos artigos'}, {tipo: 1, name: 'Catalogos'}];

        $scope.refresh = function () {
          if (Utils.isNullOrUndefined($scope.item.data.tipo)) {
            $scope.item.data.tipo = 0;
          }
          ProdutosFactory.getCatalogos().then(
            function (data) {
              $scope.catalogos = data;
              if ($scope.catalogos.length > 0) $scope.item.data.catalogo = data[0];
            });
        };

        $scope.refresh();
      }];

      //function link(scope, element, attrs, $compile) {
      //    scope.$watch('item', function () {
      //        scope.refresh();
      //    });
      //
      //}

      return {
        restrict: 'E',
        scope: {
          item: '=item'
        },
        templateUrl: 'app/components/widgets/produtos/produtos.edit.html',
        //link: link,
        controller: controller
      };

    });
})();

(function () {
  'use strict';

  angular.module('erpRetail')
    .component('reservasEstadiasEdit', {
      bindings: {
        item: '<'
      },
      templateUrl: 'app/components/widgets/reservasestadias/reservasestadias.edit.html',
      controller: /* ngInject */ function (WidgetsFactory) {
        var ctrl = this;

        ctrl.tinymceOptions = {};

        ctrl.$onInit = init;
        ctrl.$onChanges = onChanges;
        ctrl.refresh = refresh;

        /////////////

        function init() {
          ctrl.tinymceOptions = {
            resize: false,
            toolbar: 'insertfile undo redo | styleselect | bold italic | alignleft aligncenter alignright alignjustify |' +
            ' bullist numlist outdent indent | insertfile  link image'
          };
        }

        function onChanges(reservasEstadias) {
          if (reservasEstadias && reservasEstadias.item && !reservasEstadias.item.isFirstChange()) {
            ctrl.refresh(reservasEstadias.item.currentValue);
          }
        }

        function refresh(item) {
          WidgetsFactory.log('reservasEstadias refresh');
        }
      }
    });
})();

(function () {
  'use strict';

  angular.module('erpRetail')
    .config(function (API_URL, REST_APIProvider, cgReservasEstadiasProvider) { // jshint ignore:line
      cgReservasEstadiasProvider.setConfig({
        apiBaseUrl: API_URL + 'api',
        apiEndPoint: '/reservasEstadias',
        imageFallbackSource: REST_APIProvider.PRODUTOS_NOIMAGE, // jshint ignore:line
        templatesHTML: {
          rgpdTermsBody: 'app/components/widgets/reservasestadias/reservasestadias.rgpd.html'
        }
      });
    })
    .run(function (WidgetsFactory) {
      WidgetsFactory.register('reservas-estadias', 'reservas-estadias-edit', 'widgets.reservasestadias.title');
    })
    .component('reservasEstadias', {
      bindings: {
        item: '=',
        properties: '<?'
      },
      templateUrl: 'app/components/widgets/reservasestadias/reservasestadias.html',
      controllerAs: '$ctrl',
      controller: /*@ngInject*/ function ($uiRouterGlobals) {
        var ctrl = this;

        ctrl.token = null;

        ctrl.$onInit = init;

        /////////////

        function init() {
          ctrl.token = $uiRouterGlobals.params.token;
        }
      }
    });
})();

(function () {
  'use strict';

  angular.module('erpRetail')
    .controller('widgetEditController', function ($uibModalInstance, WidgetsFactory, item, Utils, $rootScope) {
      var ctrl = this;
      ctrl.scope=$rootScope;
      ctrl.scope.widgetChanged=ctrl.scope.widgetChanged|| 1;

      ctrl.item = {};
      ctrl.itemCopy = {};
      if (Utils.isNullOrUndefined(item.publishAfter)) item.publishAfter=new Date();
      ctrl.dateFrom = item.publishAfter;
      ctrl.timeFrom = item.publishAfter;

      if (Utils.isNullOrUndefined(item.publishedTo)) item.publishedTo=new Date('1/1/2050 12:00:00 PM');
      ctrl.dateTo = item.publishedTo;
      ctrl.timeTo = item.publishedTo;


      ctrl.$onInit = init;
      ctrl.editDirective = editDirective;
      ctrl.save = save;
      ctrl.cancel = cancel;

      /////////////

      function init() {
        ctrl.item = item;
        ctrl.itemCopy = angular.copy(item);
      }

      function editDirective() {
        var name = WidgetsFactory.getEdit(item.name);
        return '<' + name + ' item=\'$ctrl.item\'></' + name + '>';
      }

      function save() {
        ctrl.item.publishAfter = Utils.combineDateTime(new Date(ctrl.dateFrom), new Date(ctrl.timeFrom)).getTime();
        ctrl.item.publishedTo = Utils.combineDateTime(new Date(ctrl.dateTo), new Date(ctrl.timeTo)).getTime();
        ctrl.scope.widgetChanged=ctrl.scope.widgetChanged+1;
        $uibModalInstance.close(ctrl.item);
      }

      function cancel() {
        $uibModalInstance.dismiss(ctrl.itemCopy);
      }
    });
})();

(function () {
  'use strict';

  angular.module('erpRetail')
    .component('widgetsEdit', {
      bindings: {
        items: '=',
        order: '='
      },
      templateUrl: 'app/components/widgets/widgets.edit.html',
      controller: /*@ngInject*/ function ($uibModal, WidgetsFactory) {
        var ctrl = this;

        ctrl.list = WidgetsFactory.list;
        ctrl.sortOptions = {
          accept: function (sourceItemHandleScope, destSortableScope) {
            return false;
          },
          itemMoved: function (event) {
            //$log.debug(event);
          },
          orderChanged: function (event) {
            //$log.debug(event);
          },
          containment: '#board'
        };

        ctrl.add = add;
        ctrl.delete = fnDelete;
        ctrl.edit = edit;

        /////////////

        function add(item) {
          var aux = angular.copy(item);
          aux.data = {};
          ctrl.items.push(aux);
        }

        function fnDelete(item) {
          var idx = ctrl.items.indexOf(item);
          ctrl.items.splice(idx, 1);
        }

        function edit(item) {
          var modalInstance = $uibModal.open({
            size: 'lg',
            templateUrl: 'app/components/widgets/widget.edit.html',
            controllerAs: '$ctrl',
            controller: 'widgetEditController',
            resolve: {
              item: function () {
                return item;
              }
            }
          });

          modalInstance.result.then(
            function (itemSave) {
              var index = ctrl.items.indexOf(itemSave);
              if (index !== -1) {
                ctrl.items[index] = itemSave;
              }
            },
            function (itemRevert) {
              var index = ctrl.items.indexOf(itemRevert);
              if (index !== -1) {
                ctrl.items[index] = itemRevert;
              }
            }
          );
        }
      }
    });
})();

(function () {
  'use strict';

  angular.module('erpRetail')
    .factory('WidgetsFactory', function ($log, Utils) {
      var widgets = [];
      var factory = {
        run: run,
        register: register,
        log: log,
        getWidget: getWidget,
        getEdit: getEdit
      };

      factory.run();

      return factory;

      /////////////

      function run() {
        Object.defineProperty(factory, 'list', {
          get: function () {
            return widgets;
          }
        });
      }

      function register(name, edit, description) {
        widgets.push({name: name, edit: edit, description: description});
      }

      function log(msg) {
        $log.log(msg);
      }

      function getWidget(name) {
        for (var i = 0; i < widgets.length; i++) {
          if (Utils.sameText(widgets[i].name, name)) {
            return widgets[i];
          }
        }
        return null;
      }

      function getEdit(name) {
        var aux = factory.getWidget(name);
        if (aux === null) {
          return null;
        }
        return aux.edit;
      }
    });
})();

(function () {
  'use strict';

  angular.module('erpRetail')
    .component('widgets', {
      bindings: {
        items: '='
      },
      templateUrl: 'app/components/widgets/widgets.html'
    })
    .component('widgetBuild', {
      bindings: {
        item: '<'
      },
      controller: /*@ngInject*/ function ($compile, $scope, $element, $rootScope, Utils) {
        var ctrl = this;

        ctrl.item = {};

        ctrl.$onInit = init;
        ctrl.$onChanges = onChanges;
        ctrl.doCompile = doCompile;
        ctrl.getDateTime=$rootScope.getDatetime;

        /////////////

        function init() {
          ctrl.item = ctrl.item || {};

          ctrl.doCompile();
        }

        function onChanges(widgetBuild) {
          if (widgetBuild && widgetBuild.item && !widgetBuild.item.isFirstChange()) {
            ctrl.doCompile(widgetBuild.item.currentValue);
          }
        }

        function doCompile(item) {
          item = item || ctrl.item;
          item.isVisible=Utils.isNullOrUndefined(item.publishAfter) || Utils.isNullOrUndefined(item.publishedTo) ||
            (ctrl.getDateTime.getTime() >=  item.publishAfter && ctrl.getDateTime.getTime() <= item.publishedTo);
          var html = '<' + item.name + ' item=\'$ctrl.item\' ></' + item.name + '>';

          // When the 'compile' expression changes assign it into the current DOM
          $element.html(html);

          /* compile the new DOM and link it to the current $scope.
           * NOTE: we only compile .childNodes so that
           * we don't get into infinite loop compiling ourselves */
          $compile($element.contents())($scope);
        }
      }
    });
})();

(function () {
  'use strict';

  angular.module('erpRetail')
    .value('uiTinymceConfig', {
      resize: false,
      theme: 'modern',
      plugins: 'advlist autolink lists link image anchor visualblocks code table contextmenu paste',
      toolbar: 'insertfile undo redo | styleselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | insertfile  link image',
      'file_browser_callback': function (fieldName, url, type, win) {
        win.document.getElementById(fieldName).value = 'my browser value';
      }
    })
    .config(function () {
      tinyMCE.baseURL = '/node_modules/tinymce';
    })
    .config(compileServiceConfig);

  function /*@ngInject*/ compileServiceConfig($compileProvider, ENV, $logProvider) {
    // disable debug data on prod profile to improve performance
    $compileProvider.debugInfoEnabled(ENV === 'dev');

    /*
     If you wish to debug an application with this information
     then you should open up a debug console in the browser
     then call this method directly in this console:

     angular.reloadWithDebugInfo();
     */
    $logProvider.debugEnabled(ENV === 'dev');
  }
})();

(function () {
  'use strict';

  angular.module('erpRetail')
    .config(function ($urlRouterProvider, $httpProvider, $stateProvider, $locationProvider) {
      $httpProvider.interceptors.push('errorHandlerInterceptor');
      $httpProvider.interceptors.push('authInterceptor');
      $httpProvider.interceptors.push('notificationInterceptor');
      $httpProvider.defaults.useXDomain = true;
      delete $httpProvider.defaults.headers.common['X-Requested-With'];

      $locationProvider.html5Mode(false);
      $urlRouterProvider.otherwise('pagina/inicio');
    });
})();

(function () {
  'use strict';

  angular.module('CookieComponent', ['ui.bootstrap', 'ngCookies'])
    .factory('sharedDataServiceCookie', function ($rootScope) {
      var sharedDataServiceCookie = {};
      sharedDataServiceCookie.prepForEmitPolicy = function () {
        $rootScope.$broadcast('handlePolicy');
      };
      return sharedDataServiceCookie;
    })

    .controller('CookieController', function ($scope, $element, $window, $log, $cookies, sharedDataServiceCookie, $uibModal) {
      $scope.init = function () {
        $scope.cookieVar = false;
        $scope.scroll = false;
        $scope.click = false;
        if (!$scope.ngModel)
          $scope.ngModel = 0;
        sharedDataServiceCookie.hasCookie = $scope.cookieVar;
        $scope.output = $scope.ngModel;
      };

      $scope.showCookieConsent = function () {
        if (angular.isUndefined(typeof($cookies.get('cookieConsent')))) {
          $scope.cookieVar = false;
          return true;
        } else {
          $scope.cookieVar = true;
          return false;
        }
      };

      $scope.$on('handlePolicy', function () {
        var size = {};
        //todo filipe model
        var modalInstance = $uibModal.open({
          templateUrl: 'policyContent.html',
          controller: ModalInstancePolicyController,
          size: size,
          resolve: {
            Data: function () {
              return sharedDataServiceCookie.hasCookie;
            }
          }
        });

        modalInstance.result.then(function () {

        }, function () {
          $log.info('Modal dismissed at: ' + new Date());
        });
      });

      $scope.getCookie = function () {
        return angular.isDefined(typeof($cookies.get('cookieConsent')));
      };

      $scope.openPolicyPanel = function () {
        sharedDataServiceCookie.prepForEmitPolicy();
      };

      $scope.closePanel = function () {
        $cookies.put('cookieConsent', 'y');
        sharedDataServiceCookie.hasCookie = true;
        $element.hide();
      };

      // enable on scroll if with-scroll attr is true
      angular.element($window).bind('scroll', function () {
        if (!$scope.scroll) {
          $cookies.put('cookieConsent', 'y');
          sharedDataServiceCookie.hasCookie = true;
          $scope.scroll = true;
        }
      });

      // enable on click
      angular.element($window).bind('click', function () {
        if (!$scope.click) {
          $cookies.put('cookieConsent', 'y');
          sharedDataServiceCookie.hasCookie = true;
          $scope.click = true;
        }
      });
    })

    .directive('cookie', /*@ngInject*/ function ($document, $cookies, sharedDataServiceCookie) {
      return {
        require: '^?ngModel',
        restrict: 'E',
        replace: true,
        transclude: true,
        templateUrl: 'app/cookie-bar/cookiebar.html',
        scope: {color: '@', ngModel: '=', moreText: '@', closeText: '@', bodyText: '@', withScroll: '@'},
        controller: 'CookieController',
        link: function (scope, element, attr, ngModel) {
          scope.$watch(function () {
            if (angular.isDefined(typeof($cookies.get('cookieConsent'))))
              sharedDataServiceCookie.hasCookie = true;
            if (sharedDataServiceCookie.hasCookie)
              ngModel.$setViewValue(sharedDataServiceCookie.hasCookie);
          });
        }
      };
    });

  // Please note that $uibModalInstance represents a modal window (instance) dependency.
  // It is not the same as the $modal service used above.
  /*@ngInject*/
  function ModalInstancePolicyController($scope, $uibModalInstance, $cookies, sharedDataServiceCookie) {
    $scope.close = function () {
      $cookies.put('cookieConsent', 'y');
      sharedDataServiceCookie.hasCookie = true;
      $uibModalInstance.dismiss();
    };
  }
})();

(function () {
    'use strict';

    angular.module('erpRetail')
      .controller('Erro404Controller', ['$rootScope', '$scope', '$state', '$window', 'Utils',
            function ($rootScope, $scope, $state, $window, Utils) {

                $scope.goBack = function () {
                    if (Utils.isNullOrUndefined($rootScope.lastState)) {
                        $state.go($rootScope.lastState.name);
                    } else {
                        $window.history.back();
                    }
                };

            }]);
}());

(function () {
    'use strict';
    angular.module('erpRetail')
        .config(['$stateProvider', function ($stateProvider) {
            $stateProvider
              .state('noresponse', {
                url: '/noresponse',
                title: 'Sem resposta',
                templateUrl: 'app/erros/noresponse.html',
                controller: 'Erro404Controller'
                })
              .state('e404', {
                parent: 'loja',
                url: '/404',
                title: 'Sem resposta',
                templateUrl: 'app/erros/404.html'
                });
        }]);
}());

(function () {
  'use strict';

  angular.module('erpRetail')
    .factory('authInterceptor', function ($rootScope, $q, $cookies, $location, $log) {
      return {
        // Add authorization token to headers
        request: function (config) {
          config.headers = config.headers || {};
          var token = $cookies.get('token');
          if (token) {
            config.headers.authToken = token;
          }
          return config;
        },
        // Intercept 401s and redirect you to login
        responseError: function (response) {
          if (response.status === 401 || response.status === 403) {
            // remove any stale tokens
            $cookies.remove('token');
            $location.path('/login');
            return $q.reject(response);
          }
          if (response.status === 0) {
            return $q.reject(response);
          }
          else {
            return $q.reject(response);
          }
        }
      };
    });
})();

(function () {
  'use strict';

  angular.module('erpRetail')
    .factory('errorHandlerInterceptor', function ($location, $injector, $q, $state, cgexception) {
      return {
        'responseError': function (rejection) {
          if (rejection.stack) {
            //javascript error
            return $q.reject(rejection);
          }

          // In case server doesn't return a JSON response (usually 401 status error)
          if (!angular.isObject(rejection) || !rejection.config) {
            return $q.reject(rejection);
          }

          var exception = cgexception.get(rejection);

          if (rejection.status === -1 || rejection.data.message && rejection.data.message.indexOf('Connection refused') !== -1) {
            $state.go('disconnected', rejection);
          }

          if (exception && exception.class !== 'unknown') {
            var plAlertService = $injector.get('plAlertService');
            if (cgexception.isFatal(exception.class)) {
              plAlertService.error('error.server.exception');
            }
            else {
              plAlertService.error(exception.message);
            }
          }

          return $q.reject(rejection);
        }
      };
    });
})();

(function () {
  'use strict';

  angular.module('erpRetail')
    .factory('notificationInterceptor', function ($q, $injector) {
      function response(data) {
        // In case server doesn't return a JSON response
        if (angular.isObject(data) && data.headers) {
          var alertKey = data.headers('app-alert');
          if (angular.isString(alertKey)) {
            var plAlertService = $injector.get('plAlertService');
            plAlertService.error(alertKey, {delay: 10000});
          }
        }
        return data;
      }

      return {
        responseError: function (data) {
          data = response(data);
          return $q.reject(data);
        },
        response: function (data) {
          response(data);
          return data;
        }
      };
    });
})();

(function () {
  'use strict';

  angular.module('erpRetail')
    .controller('CarrinhoController', /*@ngInject*/ function ($rootScope, $q, storage, Auth, $state, clienteService, paisesService, Utils, PopAlert,
                                                              PagamentosFactory, configFactory, alteraModaraModal, TransportadorasFactory, documentoService) {
      var ctrl = this;

      ctrl.storage = storage;
      ctrl.quantity1 = 1;
      ctrl.condicoesPagamento = {};
      ctrl.meiosPagamento = [];
      ctrl.transportadoras = [];
      ctrl.definition = {};
      ctrl.steps = {};
      ctrl.currentStep = {};
      ctrl.clienteMoradasAlt = {};
      ctrl.paises = {};
      ctrl.affix = {};
      ctrl.affixResumo = {};
      ctrl.transportadora = {};
      ctrl.moradaEntrega = {};
      ctrl.moradaFaturacao = {};
      ctrl.plNavWizard = {};
      ctrl.form = {};
      ctrl.config = $rootScope.$config.data;
      ctrl.moradaEntregaDiferente = false;

      ctrl.$onInit = init;
      ctrl.removeBasket = removeBasket;
      ctrl.removeAllBasket = removeAllBasket;
      ctrl.calcBasket = calcBasket;
      ctrl.addBasket = addBasket;
      ctrl.removeQtdBasket = removeQtdBasket;
      ctrl.checkout2 = checkout2;
      ctrl.carrinhoTotal = carrinhoTotal;
      ctrl.carrinhoList = carrinhoList;
      ctrl.showDetail = showDetail;
      ctrl.setNCondPag = setNCondPag;
      ctrl.editMorada = editMorada;
      ctrl.newMoradaAlt = newMoradaAlt;
      ctrl.loadTransportadoras = loadTransportadoras;
      ctrl.loadMoralPickup = loadMoralPickup;
      ctrl.beforeStepChange = beforeStepChange;
      ctrl.changedStep = changedStep;
      ctrl.onEnvioChange = onEnvioChange;
      ctrl.validateStepCarrinho = validateStepCarrinho;
      ctrl.validateStepMoradas = validateStepMoradas;
      ctrl.validateStepEnvio = validateStepEnvio;
      ctrl.loadMeiosPagamento = loadMeiosPagamento;
      ctrl.validateStepResumo = validateStepResumo;
      ctrl.submitForm = submitForm;
      ctrl.getButtonNextCaption = getButtonNextCaption;
      ctrl.newOrder = newOrder;
      ctrl.getDocumento = getDocumento;
      ctrl.updateMoradas = updateMoradas;
      ctrl.moradaEntregaDiferenteChange = moradaEntregaDiferenteChange;
      ctrl.atualizaMorada = atualizaMorada;
      ctrl.affixTotal = affixTotal;
      ctrl.eventUser = $rootScope.$on('storage-loaded', function (event, args) {
        if (!angular.equals(Auth.currentUser, {}))
          atualizaMorada();
          calcBasket();
      });

      /////////////

      function init() {

        ctrl.affix = {
          enabled: ctrl.changedStep(),
          style: {
            top: '1px',
            bottom: '1px'
          }
        };
        ctrl.affixResumo = {
          enabled: true,
          style: {
            top: '90px',
            bottom: '120px'
          }
        };

        ctrl.definition = {
          items: []
        };

        ctrl.stepEnvioIsVisible = false;

        var list = configFactory.transportadorasList;
        var i;
        for (i = 0; i < list.length; i++) {
          var item = list[i];
          if (item.visible) {
            ctrl.stepEnvioIsVisible = true;
            break;
          }
        }

        ctrl.steps = [
          {
            caption: 'carrinho.steps.step1', name: 'step1', icon: 'fa-shopping-cart', visible: true,
            templateUrl: 'app/loja/carrinho/steps/step1.carrinho.html'
          },
          {
            caption: 'carrinho.steps.step2', name: 'step2', icon: 'fa-address-card-o', visible: true,
            templateUrl: 'app/loja/carrinho/steps/step2.moradas.html'
          },
          {
            caption: 'carrinho.steps.step3', name: 'step3', icon: 'fa-truck fa-flip-horizontal', visible: ctrl.stepEnvioIsVisible,
            templateUrl: 'app/loja/carrinho/steps/step3.envio.html'
          },
          {
            caption: 'carrinho.steps.step4', name: 'step4', icon: 'fa-file-text', visible: true,
            templateUrl: 'app/loja/carrinho/steps/step4.resumo.html'
          },
          {
            caption: 'carrinho.steps.step5', name: 'step5', icon: 'fa-check-circle', visible: true,
            templateUrl: 'app/loja/carrinho/steps/step5.encomenda.html'
          }
        ];

        if (storage.clienteData !== null && angular.isDefined(storage.clienteData)) {
          ctrl.moradaEntrega = storage.clienteData.moradaEntrega;
          ctrl.clienteMoradasAlt = storage.clienteData.clienteMoradasAlt;
          ctrl.moradaFaturacao = storage.clienteData.moradaFaturacao;
          ctrl.clienteMoradasAltEdit = storage.clienteData.clienteMoradasAltEdit;
        }
        ctrl.atualizaMorada();

        ctrl.paises = storage.paises;

      }

      function atualizaMorada() {
        if (storage.clienteData !== null && angular.isDefined(storage.clienteData)) {
          ctrl.moradaEntrega = storage.clienteData.moradaEntrega;
          ctrl.clienteMoradasAlt = storage.clienteData.clienteMoradasAlt;
          ctrl.moradaFaturacao = storage.clienteData.moradaFaturacao;
          ctrl.clienteMoradasAltEdit = storage.clienteData.clienteMoradasAltEdit;
        }
      }

      function newMoradaAlt(tipo) {
        return alteraModaraModal.alteraMorada().then(function (novaMorada) {
          var newMoradaAlt = {
            moralid: '{00000000-0000-0000-0000-000000000000}',
            nconta: ctrl.storage.clienteData.cliente.nconta,
            nome: novaMorada.nome,
            rua: '',
            cpost: novaMorada.cpost,
            localidade: novaMorada.localidade,
            nipc: novaMorada.nipc || '',
            observacoes: '',
            morada: novaMorada.morada,
            desativado: false,
            facidGuidId: ctrl.storage.clienteData.cliente.facidGuidId,
            contactoNome: novaMorada.contactoNome,
            contactoTelefone: novaMorada.contactoTelefone || '',
            codPaisIso: novaMorada.paisIso.codPaisIso
          };
          clienteService.newMoradaAlternativa(newMoradaAlt, function (data) {
              ctrl.clienteMoradasAlt.push(data);
              if (tipo === 'newMoradaFaturacao') {
                ctrl.moradaFaturacao = data;
              }
              if (tipo === 'newMoradaEntrega') {
                ctrl.moradaEntrega = data;
              }
            }
          );
        });
      }

      function updateMoradas(novaMorada) {
        if (angular.isUndefined(novaMorada.moralid) || (novaMorada.moralid === ctrl.moradaFaturacao.moralid)) {
          ctrl.moradaFaturacao = novaMorada;
        }
        if (novaMorada.moralid === ctrl.moradaEntrega.moralid) {
          ctrl.moradaEntrega = novaMorada;
        }
      }

      function editMorada(morada) {
        return alteraModaraModal.alteraMorada(morada).then(function (novaMorada) {
          var index = ctrl.clienteMoradasAlt.findIndex(function (item) {
            return item.moralid === novaMorada.moralid;
          });
          _.merge(ctrl.clienteMoradasAlt[index], novaMorada);
          if (ctrl.clienteMoradasAlt[index].isPrincipal === true) {
            var cliente = {
              nconta: ctrl.storage.clienteData.cliente.nconta,
              nome: ctrl.moradaFaturacao.contactoNome,
              morada: ctrl.moradaFaturacao.morada,
              codPostal: ctrl.moradaFaturacao.cpost,
              localidade: ctrl.moradaFaturacao.localidade,
              nif: ctrl.moradaFaturacao.nipc,
              facidGuidId: ctrl.storage.clienteData.cliente.facidGuidId,
              email: ctrl.storage.clienteData.cliente.email,
              telefone: ctrl.moradaFaturacao.contactoTelefone,
              nifReal: ctrl.moradaFaturacao.nipc,
              isContaIdentAlternativa: ctrl.storage.clienteData.cliente.isContaIdentAlternativa,
              codPaisIso: ctrl.moradaFaturacao.paisIso.codPaisIso,
              paisIso: {
                codPaisIso: ctrl.moradaFaturacao.paisIso.codPaisIso,
                nomePais: ctrl.moradaFaturacao.paisIso.nomePais
              }
            };
            clienteService.save(cliente, function (data) {
              ctrl.updateMoradas(data.data);
            });
          } else {
            delete ctrl.moradaEntrega.open;
            clienteService.updateMoradaAlternativa(novaMorada, novaMorada.moralid, function () {
              ctrl.updateMoradas(novaMorada);
            });
          }
        });
      }

      function setNCondPag(ncondpag) {
        storage.ncondpag = 0;
        for (var i = 0; i < storage.condicoesPagamentoList.length; i++) {
          if (storage.condicoesPagamentoList[i].ncondpag !== ncondpag)
            storage.condicoesPagamentoList[i].checked = false;
        }
        for (i = 0; i < storage.condicoesPagamentoList.length; i++) {
          if (storage.condicoesPagamentoList[i].checked) {
            storage.ncondpag = storage.condicoesPagamentoList[i].ncondpag;
            break;
          }
        }
        ctrl.calcBasket();
      }

      function removeBasket(item) {
        var index = storage.cesto.indexOf(item);
        storage.cesto.splice(index, 1);
        storage.calcBasket();
        PopAlert.showSuccess('Artigo removido do carrinho com succeso');
      }

      function removeAllBasket() {
        storage.cesto = [];
        storage.calcBasket();
      }

      function calcBasket() {
        storage.calcBasket();
      }

      function addBasket(artigo) {
        var aux = _.find(storage.cesto, function (rw) {
          return rw.nArtigo === artigo.nArtigo;
        });
        if (angular.isUndefined(aux)) {
          aux = artigo;

          aux.qtd = artigo.qtd || 1.0;
          storage.cesto.push(aux);
        } else if (artigo.qtd) {
          aux.qtd += artigo.qtd;
        } else {
          aux.qtd++;
        }
        PopAlert.showSuccess(artigo.nome + ' adicionado ao carrinho');
        storage.calcBasket();
      }

      function removeQtdBasket(artigo) {
        var aux = _.find(storage.cesto, function (rw) {
          return rw.nArtigo === artigo.nArtigo;
        });
        if (angular.isUndefined(aux)) {
          aux = artigo;
          aux.qtd = 1.0;
          storage.cesto.push(aux);
        } else {
          aux.qtd--;
        }
        storage.calcBasket();
      }

      function carrinhoTotal() {
        return storage.carrinhoTotal;
      }

      function carrinhoList() {
        return storage.cesto;
      }

      function showDetail(artigo) {
        storage.showDetail(artigo);
      }

      function loadTransportadoras() {
        var deferred = $q.defer();

        PagamentosFactory.transportadoras(ctrl.moradaEntrega.paisIso.codPaisIso, ctrl.moradaEntrega.cpost).then(function (data) {
          var i;
          var j;
          ctrl.transportadoras = [];
          ctrl.transportadora = {};
          storage.codTransportadora = 0;
          var list = configFactory.transportadorasList;
          for (i = 0; i < list.length; i++) {
            var item = list[i];
            if (!item.visible) continue;
            for (j = 0; j < data.length; j++) {
              var item1 = data[j];
              if (item.codTransportadora === item1.codTransportadora) {
                ctrl.transportadoras.push(item1);
                break;
              }
            }
          }

          if (ctrl.transportadoras.length > 0 && (angular.isUndefined(storage.codTransportadora) || storage.codTransportadora === 0)) {
            storage.codTransportadora = ctrl.transportadoras[0].codTransportadora;
            ctrl.transportadora = ctrl.transportadoras[0];
            ctrl.loadMoralPickup();
            ctrl.calcBasket();
          }
          deferred.resolve(true);
        });
        return deferred.promise;
      }

      function loadMoralPickup() {
        var deferred = $q.defer();
        ctrl.moradasAlternativasTransportadoras = [];
        if (ctrl.transportadora.nContaPickup) {
          TransportadorasFactory.moradasAlternativas(storage.codTransportadora).then(function (data) {
            ctrl.moradasAlternativasTransportadoras = data;
            if (data.length)
              ctrl.moradaPickup = data[0];
            deferred.resolve(true);
          });
        }
        return deferred.promise;
      }

      function validateStepCarrinho() {

        if (angular.isUndefined(ctrl.storage.cesto) || !ctrl.storage.cesto.length) {
          PopAlert.showError($rootScope.globalTranslate('carrinho.stepCarrinho.carrinhoVazio'));
          return false;
        }

        if (!Auth.isLoggedIn()) {
          PopAlert.alert($rootScope.globalTranslate('CART_ERROR_MUST_BE_LOGGIN'), $rootScope.globalTranslate('CART_ERROR_MUST_BE_LOGGIN_TEXT'), function (e) {
            if (e) {
              $state.go('login', {ReturnState: 'loja.carrinho'});
            }
          });
          return false;
        }
        return true;
      }

      function validateStepMoradas() {

        if ((angular.isUndefined(ctrl.moradaEntrega.paisIso) || !ctrl.moradaEntrega.paisIso.codPaisIso) || (angular.isUndefined(ctrl.storage.cesto) || !ctrl.storage.cesto.length)) {
          PopAlert.showError($rootScope.globalTranslate('carrinho.stepMoradas.paisNaoDefinido'));
          return false;
        }

        if (!ctrl.moradaEntrega.cpost) {
          PopAlert.showError($rootScope.globalTranslate('carrinho.stepMoradas.codigoPostalNaoDefinido'));
          return false;
        }

        if (!ctrl.moradaEntrega.cpost) {
          PopAlert.showError($rootScope.globalTranslate('carrinho.stepMoradas.codigoPostalNaoDefinido'));
          return false;
        }

        if (!ctrl.storage.clienteData.cliente.completed) {
          PopAlert.alert($rootScope.globalTranslate('CONTACTS_ADDRESS_REQUIRED'), $rootScope.globalTranslate('CONTACTS_ADDRESS_REQUIRED_TEXT'), function (e) {
            if (e) {
              ctrl.editMorada(ctrl.moradaFaturacao);
            } else {
              PopAlert.showError($rootScope.globalTranslate('carrinho.stepMoradas.moradaNaoCompleta'));
            }
          });
          return false;
        }

        if (ctrl.moradaEntregaDiferente === false) {
          ctrl.moradaEntrega = ctrl.moradaFaturacao;
        }

        return true;
      }

      function validateStepEnvio() {
        if (!storage.codTransportadora) {
          PopAlert.showError($rootScope.globalTranslate('carrinho.stepEnvio.transporteNaoDefinido'));
          return false;
        }

        if ((angular.isUndefined(ctrl.storage.cesto) || !ctrl.storage.cesto.length) || angular.isDefined(ctrl.transportadora) &&
          angular.isDefined(ctrl.transportadora.nContaPickup) && ctrl.transportadora.nContaPickup !== '' && !ctrl.moradaPickup) {
          PopAlert.showError($rootScope.globalTranslate('carrinho.stepEnvio.localPickupNaoDefinido'));
          return false;
        }

        return true;
      }

      function validateStepResumo() {
        if (ctrl.meiosPagamento.length > 0 && !ctrl.nCaixa) {
          PopAlert.showError($rootScope.globalTranslate('carrinho.stepResumo.meioPagamentoNaoDefinido'));
          return false;
        }
        return true;
      }

      function loadMeiosPagamento() {
        var deferred = $q.defer();
        documentoService.getMeiosPagamento().then(function (data) {
          ctrl.meiosPagamento = data;
          if (ctrl.meiosPagamento.tipo === 2) {
            ctrl.meiosPagamento.icon = '<i class="fa fa-credit-card"></i>';
          }
          if (ctrl.meiosPagamento.tipo === 8) {
            ctrl.meiosPagamento.icon = '<i class="fa fa-bank"></i>';
          }
          if (ctrl.meiosPagamento.tipo === 9) {
            ctrl.meiosPagamento.icon = '<i class="fa fa-paypal"></i>';
          }

          deferred.resolve(true);
        });
        return deferred.promise;
      }

      function beforeStepChange(currentStep, previousStep, type, nextStep) {
        if ((nextStep === ctrl.definition.items[1]) || (currentStep === ctrl.definition.items[0] && type === 'next')) {
          if (!ctrl.validateStepCarrinho()) return false;

          return true;//ctrl.loadTransportadoras();
        } else if ((nextStep === ctrl.definition.items[2]) || (currentStep === ctrl.definition.items[1] && type === 'next')) {
          if (!ctrl.validateStepMoradas()) return false;
          if (!ctrl.stepEnvioIsVisible)
            loadMeiosPagamento();
          return ctrl.loadTransportadoras();
        } else if (((nextStep === ctrl.definition.items[3]) || (currentStep === ctrl.definition.items[2] && type === 'next')) && ctrl.stepEnvioIsVisible) {
          if (!ctrl.validateStepEnvio()) return false;
          return loadMeiosPagamento();
        } else if ((nextStep === ctrl.definition.items[4]) || (currentStep === ctrl.definition.items[3] && type === 'next')) {
          if (!ctrl.validateStepResumo()) return false;
          var promise = ctrl.checkout2();
          return promise;
        }
      }

      function changedStep(currentStep, previousStep) {
        ctrl.currentStep = currentStep;
        ctrl.previousStep = previousStep;

        if (ctrl.currentStep) {
          ctrl.affixTotal();
        }
      }

      function affixTotal() {
        if (ctrl.currentStep.id === 'step1') {
          ctrl.affix.enabled = true;
          ctrl.affix.style.top = '90px';
          ctrl.affix.style.bottom = '120px';
          ctrl.affix.class = 'affix';
        }
        if (ctrl.currentStep.id === 'step4') {
          ctrl.affixResumo.enabled = true;
          ctrl.affixResumo.style.top = '90px';
          ctrl.affixResumo.style.bottom = '120px';
          ctrl.affixResumo.class = 'affix';

          ctrl.affix.enabled = false;
          ctrl.affix.style.top = '1px';
          ctrl.affix.style.bottom = '1px';
          ctrl.affix.class = '';
        }
        if (ctrl.currentStep.id !== 'step4' && ctrl.currentStep.id !== 'step1') {
          ctrl.affix.enabled = false;
          ctrl.affix.style.top = '1px';
          ctrl.affix.style.bottom = '1px';
          ctrl.affix.class = '';

          ctrl.affixResumo.enabled = false;
          ctrl.affixResumo.style.top = '1px';
          ctrl.affixResumo.style.bottom = '1px';
          ctrl.affixResumo.class = '';
        }
      }

      function onEnvioChange(item) {
        ctrl.transportadora = item;
        ctrl.moradaPickup = {};
        ctrl.calcBasket();
        ctrl.loadMoralPickup();
      }

      function submitForm() {
        ctrl.plNavWizard.nextStep();
      }

      function getButtonNextCaption() {
        if (ctrl.definition.items[3].active)
          return ctrl.config.finalizaCompra;
        else
          return $rootScope.globalTranslate('carrinho.seguinte');
      }

      function checkout2() {
        //Aqui tenho de validar tudo

        //Carrinho
        if (ctrl.storage.carrinhoTotal.nItens === 0) {
          PopAlert.showInfo($rootScope.globalTranslate('carrinho.stepResumo.carrinhoVazio'));
          return false;
        }
        //Moradas
        if (Utils.isNullOrEmpty(ctrl.moradaFaturacao)) {
          PopAlert.showInfo($rootScope.globalTranslate('carrinho.stepResumo.moradaFaturacaoInvalida'));
          return false;
        }
        if (Utils.isNullOrEmpty(ctrl.moradaEntrega)) {
          PopAlert.showInfo($rootScope.globalTranslate('carrinho.stepResumo.moradaEntregaInvalida'));
          return false;
        }
        //Envio
        if (storage.codTransportadora === 0 && ctrl.stepEnvioIsVisible) {
          PopAlert.showError($rootScope.globalTranslate('carrinho.stepResumo.meioEnvioInvalido'));
          return false;
        }
        if (!Utils.isNullOrEmpty(ctrl.transportadora.nContaPickup)) {
          if (Utils.isNullOrEmpty(ctrl.moradaPickup)) {
            PopAlert.showError($rootScope.globalTranslate('carrinho.stepResumo.moradaPickupInvalida'));
            return false;
          }
        }

        storage.cesto.cab = {
          nCaixa: ctrl.nCaixa,
          ncondpag: 0,
          codTransportadora: storage.codTransportadora,
          custoTransporte: 0,
          moradaFaturacao: ctrl.moradaFaturacao,
          moradaEntrega: ctrl.moradaEntrega,
          moradaPickup: ctrl.moradaPickup
        };

        var defered = $q.defer();

        PopAlert.confirm($rootScope.globalTranslate('Confirmar'), $rootScope.globalTranslate('CART_PAGE_FINALIZAR_COMPRA'), function (e) {
          if (e) {
            documentoService.gerarDoc().then(function (data) {
              ctrl.doc = data;
              ctrl.activeDoc = ctrl.doc.MBFaccbId;

              ctrl.getDocumento();

              defered.resolve();
            });
          } else {
            defered.reject();
          }
        });
        //Meio de pagamento
        return defered.promise;
      }

      function newOrder() {
        // return $state.reload('loja');
        return $state.go('loja.home', {id: 'inicio'});
      }

      function getDocumento() {
        var deferred = $q.defer();
        documentoService.getDoc(ctrl.doc.MBFaccbId)
          .then(function (response) {
            deferred.resolve(response);
          })
          .catch(function (reason) {
            deferred.reject(reason);
          });
        return deferred.promise;
      }

      function moradaEntregaDiferenteChange() {
        if (ctrl.moradaEntregaDiferente === false) {
          ctrl.moradaEntrega = ctrl.moradaFaturacao;
        }
      }
    });
}());

/**
 * Created by cg on 30/09/14.
 */
(function () {
  'use strict';

  angular.module('erpRetail')
    .controller('ContatosController', /*@ngInject*/ function ($scope, EmpresaFactory, emailService, Utils, PopAlert) {

      var ctrl = this;

      ctrl.empresa = {};
      ctrl.form = {};
      ctrl.submited = false;

      ctrl.sendMail = sendMail;
      ctrl.refresh = refresh;
      ctrl.init = init;

      ctrl.init();

      ////////////////

      function init() {
        ctrl.refresh();
      }

      function refresh() {
        EmpresaFactory.get().then(function (empresa) {
          ctrl.empresa = empresa;
        });
      }

      function sendMail(form) {
        if (form.$valid) {
          emailService.sendContact(ctrl.form.from, ctrl.form.email, ctrl.form.message).then(function () {
              PopAlert.showInfo(Utils.translate('Email de contacto enviado com sucesso!'));
              ctrl.submited = true;
              ctrl.form.message = '';
            },
            function () {
              PopAlert.showError(Utils.translate('Ocorreu um erro ao enviar o email! Por favor tente mais tarde!'));
            });
        }
      }
    });
}());

/**
 * Created by cg on 30/09/14.
 */
(function () {
  'use strict';

  angular.module('erpRetail')
    .controller('HomeController', /*@ngInject*/ function ($scope, storage, Auth) {

      var ctrl = this;

      ctrl.storage = storage;
      ctrl.user = {};
      ctrl.isLoggedIn = false;
      ctrl.isAdmin = false;  //TODO actualizar

      ctrl.refreshUser = refreshUser;
      ctrl.refresh = refresh;
      ctrl.onLoad = onLoad;
      ctrl.init = init;

      ctrl.init();

      ////////////////

      function init() {
        ctrl.onLoad();
      }

      function refreshUser() {
        ctrl.user = Auth.getCurrentUser();
        Auth.isLoggedInAsync(function (isLoggedIn) {
          ctrl.isLoggedIn = isLoggedIn;
          ctrl.isAdmin = Auth.isAdmin();
        });
      }

      function refresh() {
        ctrl.refreshUser();
        //storage.reload();
      }

      function onLoad() {
        ctrl.refresh();

        $scope.$on('event-login', function (event, args) {
          ctrl.refreshUser();
        });

        $scope.$on('event-user', function (event, args) {
          ctrl.refreshUser();
        });

        $scope.$on('event-logout', function (event, args) {
          ctrl.refreshUser();
        });
      }
    })

    .controller('PaginaShowController', /*@ngInject*/ function (pagina) {
      var ctrl = this;
      ctrl.pagina = pagina;
    });
}());

(function () {
  'use strict';

  angular.module('erpRetail')
    .config(/*@ngInject*/ function ($stateProvider) {
      $stateProvider
        .state('loja', {
          url: '?token',
          title: 'Loja',
          abstract: true,
          views: {
            '': {
              templateUrl: 'app/loja/index.html',
              controller: 'HomeController',
              controllerAs: 'ctrl'
            },
            'header': {
              templateUrl: 'app/loja/header.html',
              controller: 'HomeController',
              controllerAs: 'ctrl'
              //},
              //"footer": {
              //    template: $rootScope.config.modelo.footer, //"app/loja/footer.html",
              //    controller: "HomeController"
            }
          },
          resolve: {
            config: ['configFactory', function (configFactory) {
              return configFactory.getConfigSite();
            }]
          },
          params: {
            token: {
              type: 'string',
              value: null,
              squash: true
            }
          }
        })
        .state('loja.home', {
          url: '/pagina/:id',
          title: 'Home',
          templateUrl: 'app/loja/home/homedyn.html',
          resolve: {
            config: ['configFactory', function (configFactory) {
              return configFactory.getConfigSite();
            }],
            pagina: function (PaginasFactory, $stateParams, config, MenuService, $state, Utils) {
              function gogo(cod, page, title) {
                var stateParamsClone = {};
                if ($stateParams.id === page) {
                  stateParamsClone.id = Utils.toNumber(cod);
                  $state.go($state.current, stateParamsClone);
                }
                return $stateParams.id <= 0;
              }

              if (gogo(config.pages.home, 'inicio', 'Home')) return;
              if (gogo(config.pages.termos, 'termos', 'Termos')) return;
              if (gogo(config.pages.contactos, 'contactos', 'Contactos')) return;

              var t = PaginasFactory.load($stateParams.id);
              t.then(
                function (obj) {
                  $state.current.title = obj.data.title;
                  if (!Utils.isNullOrUndefined(obj.data.name)) {
                    $stateParams.id = obj.data.name;
                  }
                },
                function () {
                  // página não encontrada
                  $state.go('e404');
                }
              );
              return t;
            }
          },
          controller: 'PaginaShowController',
          controllerAs: 'ctrl'
        })
        .state('loja.contatos', {
          url: '/contactos',
          title: 'Contactos',
          templateUrl: 'app/loja/contatos/contatos.html',
          controller: 'ContatosController',
          controllerAs: 'ctrl'
        })
        .state('loja.carrinho', {
          url: '/carrinho',
          title: 'Carrinho',
          controller: 'CarrinhoController',
          controllerAs: '$ctrl',
          templateUrl: 'app/loja/carrinho/carrinho.html'
        });
    })
    .run(/*@ngInject*/ function ($transitions, $log, Auth, configFactory) {
      $transitions.onStart({}, function ($transition) {
        Auth.isLoggedInAsync(function () {
          handleRedirect(configFactory, $transition);
        });
      });
    });

  function handleRedirect(configFactory, transition) {
    var toState = transition.$to();
    var params = transition.params();
    if (toState.self.name !== 'loja.home') {
      return;
    }

    configFactory.getConfigSite().then(
      function (response) {
        var statesToRedirect = [
          'inicio',
          'termos'
        ];

        for (var i = 0; i < statesToRedirect.length; i++) {
          var state = statesToRedirect[i];
          if (state.indexOf(params.id) !== -1) {
            var page = '';

            switch (state) {
              case 'inicio':
                page = 'home';
                break;
              case 'termos':
                page = 'termos';
                break;
              default:
                return;
            }

            page = response.pages[page];
            if (page) {
              transition.router.stateService.go('loja.home', {id: page});
            }
            break;
          }
        }
      }
    );
  }
})();

(function () {
  'use strict';

  angular.module('erpRetail')
    .controller('MeioPagamentoController', function ($state, $stateParams, documentoService, Utils, PagamentosFactory) {
      var ctrl = this;

      ctrl.meiosPagamento = [];
      ctrl.doc = {};

      ctrl.refresh = refresh;
      ctrl.setMeioPagamento = setMeioPagamento;

      function refresh() {
        if (Utils.isNullOrUndefined($stateParams.MBFaccbId)) {
          $state.go('home');
        }
        documentoService.getDoc($stateParams.MBFaccbId).then(function (response) {
          ctrl.doc = response.data;
        });
        documentoService.getMeiosPagamento().then(function (data) {
          ctrl.meiosPagamento = data;
          if (ctrl.meiosPagamento.length === 0) {
            $state.go('loja.documentos', {mbfaccbId: $stateParams.MBFaccbId});

          } else if (ctrl.meiosPagamento.length === 1) {
            PagamentosFactory.goPagamento(data[0].tipo, $stateParams.MBFaccbId);
          }
        });
      }

      function setMeioPagamento(item) {
        ctrl.meioPagamento = item;
        PagamentosFactory.goPagamento(ctrl.meioPagamento.tipo, $stateParams.MBFaccbId, 'pagar', 'novo');
      }

      ctrl.refresh();
    })
    .controller('PayPalController', function ($state, $stateParams, documentoService, Utils, PagamentosFactory, $log, $window) {
      var ctrl = this;

      ctrl.message = 'A aguardar por paypal...';
      ctrl.init = init;

      function init() {
        if (Utils.isNullOrUndefined($stateParams.MBFaccbId)) {
          $state.go('home');
          return;
        }
        if (Utils.sameText($stateParams.action, 'Cancelado')) {
          ctrl.message = 'Pagamento foi cancelado!...';
          PagamentosFactory.paypal($stateParams.MBFaccbId, $stateParams.action, $stateParams.payKey);
          $state.go('loja.documentos', {mbfaccbId: $stateParams.MBFaccbId});
          return;
        }
        if (Utils.sameText($stateParams.action, 'ok')) {
          ctrl.message = 'Pagamento efetuado com sucesso!...';
          PagamentosFactory.paypal($stateParams.MBFaccbId, $stateParams.action, $stateParams.payKey);
          $state.go('loja.documentos', {mbfaccbId: $stateParams.MBFaccbId});
          return;
        }

        ctrl.message = 'A redirecionar para o site paypal...';

        PagamentosFactory.paypal($stateParams.MBFaccbId, 'pagar', '').then(function (data) {
          $log.debug(data);
          if (data.status === 0) {
            $window.location = data.url;
          } else {
            $state.go('loja.documentos');
          }
        });
      }

      ctrl.init();
    })
    .config(function ($stateProvider) {
      $stateProvider
        .state('loja.pagamento', {
          url: '/pagamento',
          title: 'Pagamento',
          templateUrl: 'app/loja/pagamento/pagamento.html',
          abstract: true
        })
        .state('loja.pagamento.paypal', {
          url: '/paypal/:MBFaccbId/:payKey/:action',
          title: 'Pagamento por Paypal',
          templateUrl: 'app/loja/pagamento/paypal.html',
          controller: 'PayPalController',
          controllerAs: 'paypal'
        });
    });
}());

(function () {
  'use strict';

  angular.module('erpRetail')
    .config(/*@ngInject*/ function ($stateProvider, $urlRouterProvider) {
      $stateProvider
        .state('loja.produtos', {
          abstract: false,
          url: '/produtos',
          title: 'Produtos',
          templateUrl: 'app/loja/produtos/produtos.html',
          resolve: {
            config: /*@ngInject*/ function (configFactory) {
              return configFactory.getConfigSite();
            }
          },
          params: {
            paramMenu: {}
          }
        })
        .state('loja.produto', {
          url: '/produto/:nartigo',
          title: 'Loja',
          templateUrl: 'app/loja/produtos/produtos.detalhe.html',
          resolve: {
            config: /*@ngInject*/ function (configFactory) {
              return configFactory.getConfigSite();
            },
            produto: function (storage, $stateParams) {
              return storage.getArtigo($stateParams.nartigo);
            }
          },
          controller: /*@ngInject*/ function ($scope, $stateParams, storage, configFactory, config, produto, Auth, clienteService) {
            $scope.item = produto;
            $scope.storage = storage;
            $scope.classificadores = configFactory.classificadores;
            $scope.config = config;

            $scope.cliente = {};
            $scope.user = Auth.getCurrentUser();

            if (angular.isDefined($scope.user.token)) {
              $scope.getUserInfo = function () {
                clienteService.getCliente().then(function (cliente) {
                  $scope.cliente = cliente;
                });
              };
              $scope.getUserInfo();
            }

            $scope.getFlatImagens = function (imagens) {
              return imagens.map(function (imagem) {
                return storage.imagePath + imagem.docId;
              });
            };
          }
        })
        .state('loja.classificador', {
          url: '/classificador/:tabela/:nchave/:ordem',
          title: 'Classificador',
          templateUrl: 'app/loja/produtos/produtos.classificador.detalhe.html',
          resolve: {
            config: ['configFactory', function (configFactory) {
              return configFactory.getConfigSite();
            }],
            classificador: function (storage, $stateParams) {
              return storage.getTextoClassificador($stateParams.tabela, $stateParams.nchave, $stateParams.ordem);
            }
          },
          params: {
            clearSearch: {
              type: 'bool',
              value: false
            }
          },
          controller: /*@ngInject*/ function ($scope, $stateParams, storage, configFactory, config, classificador, ProdutosFactory) {
            $scope.classificador = classificador;
            $scope.storage = storage;
            $scope.classificadores = configFactory.classificadores;
            $scope.config = config;
            $scope.anexos = [];
            $scope.showAnexos = false;
            $scope.getFileUrl = ProdutosFactory.getAnexoUrl;

            ProdutosFactory.getAnexos($stateParams.tabela, $stateParams.nchave).then(
              function (response) {
                if (response.data.length) {
                  angular.forEach(response.data, function (ficheiro) {
                    if (angular.isUndefined(ficheiro.dodGDocClassifica) || ficheiro.dodGDocClassifica === null) {
                      return;
                    }
                    if (!$scope.anexos[ficheiro.dodGDocClassifica]) {
                      $scope.anexos[ficheiro.dodGDocClassifica] = {
                        classificador: ficheiro.dodGDocClassifica,
                        descricao: ficheiro.descricaoClassificador,
                        files: []
                      };
                    }
                    $scope.anexos[ficheiro.dodGDocClassifica].files.push({
                      id: ficheiro.docId,
                      folderId: ficheiro.folderId,
                      nome: ficheiro.nomeFicheiro,
                      deleted: ficheiro.deleted
                    });
                  });
                  $scope.showAnexos = true;
                }
              },
              function () {
                $scope.showAnexos = false;
              }
            );
          }
        });
    });
})();

(function () {
  'use strict';

  angular.module('erpRetail')
    .controller('DocumentosClienteController', /*@ngInject*/ function ($document, $state, $timeout, $transition$, documentosService, documentoService, Utils, $q, $translate) {
      var ctrl = this;

      ctrl.params = $transition$.params();
      ctrl.callback = {};
      ctrl.pdfUrl = '#';
      ctrl.definition = {};
      ctrl.search = '';
      ctrl.restoreDoc = ctrl.params.mbfaccbId;

      ctrl.init = init;
      ctrl.onLoad = onLoad;
      ctrl.onDocSelect = onDocSelect;
      ctrl.onDocDetail = onDocDetail;
      ctrl.canPay = canPay;
      ctrl.getStatus = getStatus;

      ctrl.init();

      /////////////

      function init() {
        ctrl.definition = {
          order: 'stampInsert desc',
          page: 1,
          options: {
            perPage: 10
          },
          fields: [
            {name: 'stampInsert', type: 'timestamp', visible: false, caption: ''},
            {name: 'ndocAsString', type: 'text', caption: 'ACOOUNT_DOCS_TABLE_TH_NDOC'},
            {name: 'dataDoc', type: 'date', caption: 'ACCOUNT_DOCS_TABLE_TH_DATA'},
            {name: 'estado', caption: 'ACCOUNT_DOCS_TABLE_TH_ESTADO'},
            {name: 'total', align: 'right', type: 'currency', caption: 'ACCOUNT_DOCS_TABLE_TH_TOTAL'},
            {name: 'estadoLabel', caption: ' '}
          ]
        };
      }

      function onLoad(search, order, page, perpage) {
        var deferred = $q.defer();
        documentosService.getCliente(search, page, perpage, order)
          .then(function (response) {
            response.list = response.list.map(function (item, index) {
              item._$ctrl = ctrl;
              item._canPay = ctrl.canPay(item);
              item.statusSync = ctrl.getStatus(item.statusSync);
              if (item.estado === 'PaypalCompleted' || item.estado === 'PayedSettedByAdmin') {
                item.estadoLabel = '<i class="fa fa-check text-success"></i>';
              } else {
                item.estadoLabel = '<i class="fa fa-credit-card text-primary"></i>';
              }
              item.estado = $translate.instant('DOC_ESTADO_' + item.estado);
              if (ctrl.restoreDoc && ctrl.restoreDoc === item.mbfaccbId) {
                ctrl.onDocDetail(item).then(function () {
                  item._detailOpen = true;
                  $timeout(function () {
                    var element = angular.element('pl-table table > tbody:nth-child(' + (index + 1) + ') > tr.detail').get(0);
                    if (element) {
                      element.scrollIntoView();
                    }
                  });
                });
                ctrl.restoreDoc = undefined;
              }
              return item;
            });
            deferred.resolve(response);
          })
          .catch(function (reason) {
            deferred.reject(reason);
          });
        return deferred.promise;
      }

      function onDocSelect(item) {
        item._detailOpen = !item._detailOpen;
        if (item._detailOpen) {
          return ctrl.onDocDetail(item);
        }
      }

      function onDocDetail(item) {
        if (item._thedoc) {
          return;
        }
        var deferred = $q.defer();
        documentoService.getDoc(item.mbfaccbId)
          .then(function (response) {
            item._thedoc = response.data;
            deferred.resolve();
          })
          .catch(function (reason) {
            deferred.reject(reason);
          });
        return deferred.promise;
      }

      function canPay(item) {
        return (!Utils.isNullOrEmpty(item) && Utils.sameText(item.estado, 'PaypalSend') || Utils.sameText(item.estado, 'EsperaPagamento'));
      }


      function getStatus(item) {
        return documentosService.getStatus(item);
      }
    });
})();

(function () {
  'use strict';

  angular.module('erpRetail')
    .run(function ($templateRequest, $templateCache) {
      $templateRequest('app/loja/utilizador/encomendas/fatura.html').then(function (template) {
        $templateCache.put('template-encomendas-fatura', template);
      });
    })
    .controller('EncomendasController', /*@ngInject*/ function ($rootScope, $q, $state, $transition$, documentosService, documentoService, Utils, PopAlert) {
      var ctrl = this;

      ctrl.params = $transition$.params();
      ctrl.isDocSynced = true;
      ctrl.callback = {};
      ctrl.definition = {};

      ctrl.init = init;
      ctrl.onLoad = onLoad;
      ctrl.onDocSelect = onDocSelect;
      ctrl.onDocDetail = onDocDetail;

      ctrl.init();

      /////////////

      function init() {
        ctrl.definition = {
          order: 'stampInsert desc',
          options: {
            perPage: 10
          },
          fields: [
            {name: 'stampInsert', type: 'timestamp', visible: false, caption: ''},
            {name: 'nDoc', type: 'text', caption: 'ACOOUNT_DOCS_TABLE_TH_NDOC'},
            {name: 'dataDoc', type: 'date', caption: 'ACCOUNT_DOCS_TABLE_TH_DATA'},
            {name: 'totalDocumento', align: 'right', type: 'currency', caption: 'ACCOUNT_DOCS_TABLE_TH_TOTAL'},
            {name: 'nomeEstado', caption: 'ADMIN_DOCS_TABLE_TH_STATE'}
          ]
        };

        ctrl.onLoad();
      }

      //// NOVO
      function onLoad(search, order, page, perpage) {
        var deferred = $q.defer();
        documentosService.getEncomendas(search, page, perpage, order)
          .then(function (response) {
            var linhas = response.data.map(function (item) {
              item._$ctrl = ctrl;
              return item;
            });
            deferred.resolve(linhas);
          })
          .catch(function (reason) {
            deferred.reject(reason);
            PopAlert.showError($rootScope.globalTranslate('utilizador.encomendas.fetchError'));
          });
        return deferred.promise;
      }

      function onDocSelect(item) {
        item._detailOpen = !item._detailOpen;
        if (item._detailOpen) {
          item.isDocSynced = item.faccbId !== 0;
          item._activeDoc = item.isDocSynced ? item.faccbId : item.mbfaccbid;
          return ctrl.onDocDetail(item);
        }
      }


      function onDocDetail(item) {
        if (item._thedoc) {
          return;
        }
        var deferred = $q.defer();
        var request = item.isDocSynced ? documentoService.getDocOnline : documentoService.getDoc;

        request(item._activeDoc).then(
          function (response) {           
            item._thedoc = item.isDocSynced ? response.data.data : response.data;
            deferred.resolve();
          }
        ).catch(function (reason) {
          deferred.reject(reason);
        });

        return deferred.promise;
      }
    });
})();

(function () {
  'use strict';

  angular.module('erpRetail')
    .controller('FaturasController', /*@ngInject*/ function ($rootScope, $q, $state, $transition$, documentosService, documentoService, Utils, PopAlert) {
      var ctrl = this;

      ctrl.params = $transition$.params();

      ctrl.list = [];
      ctrl.activeDoc = null;
      ctrl.config = {};
      ctrl.source = {};
      ctrl.pdfUrl = '#';
      ctrl.callback = {};
      ctrl.definition = {};
      ctrl.ndoc = '';

      ctrl.init = init;
      ctrl.onLoad = onLoad;
      ctrl.onDocSelect = onDocSelect;
      ctrl.onDocDetail = onDocDetail;

      ctrl.init();

      /////////////

      function init() {
        ctrl.definition = {
          order: 'stampInsert desc',
          options: {
            perPage: 10
          },
          fields: [
            {name: 'stampInsert', type: 'timestamp', visible: false, caption: ''},
            {name: 'docNome', type: 'text', caption: 'ACOOUNT_DOCS_TABLE_TH_DOCNOME'},
            {name: 'nDoc', type: 'text', caption: 'ACOOUNT_DOCS_TABLE_TH_NDOC'},
            {name: 'dataDoc', type: 'date', caption: 'ACCOUNT_DOCS_TABLE_TH_DATA'},
            {name: 'totalDocumento', align: 'right', type: 'currency', caption: 'ACCOUNT_DOCS_TABLE_TH_TOTAL'},
            {name: 'nomeEstado', caption: 'ADMIN_DOCS_TABLE_TH_STATE'}
          ]
        };

        ctrl.onLoad();
      }

      function onLoad(search, order, page, perpage) {
        var deferred = $q.defer();
        documentosService.getComerciais(ctrl.ndoc, page, perpage, order)
          .then(function (response) {
            var linhas = response.data.list.map(function (item) {
              item._$ctrl = ctrl;

              return item;
            });
            deferred.resolve(linhas);
          })
          .catch(function (reason) {
            deferred.reject(reason);
            PopAlert.showError($rootScope.globalTranslate('utilizador.faturas.fetchError'));
          });
        return deferred.promise;
      }

      function onDocSelect(item) {
        item._detailOpen = !item._detailOpen;
        if (item._detailOpen) {
          return ctrl.onDocDetail(item);
        }
      }

      function onDocDetail(item) {
        if (item._thedoc) {
          return;
        }
        var deferred = $q.defer();
        documentoService.getDocOnline(item.faccbId)
          .then(function (response) {
            item._thedoc = response.data.data;
            deferred.resolve();
          })
          .catch(function (reason) {
            deferred.reject(reason);
          });
        return deferred.promise;
      }
    });
})();

(function () {
  'use strict';

  angular.module('erpRetail')
    .controller('MovimentosAbertoController', /*@ngInject*/ function ($rootScope, $q, $state, documentosService, documentoService, Utils, PopAlert) {
      var ctrl = this;

      ctrl.definition = {};
      ctrl.init = init;
      ctrl.onLoad = onLoad;

      ctrl.init();

      /////////////

      function init() {
        ctrl.definition = {
          order: 'stampInsert desc',
          options: {
            perPage: 10
          },
          fields: [
            {name: 'stampInsert', type: 'timestamp', visible: false, caption: ''},
            {name: 'nConta', type: 'text', caption: 'utilizador.movimentos.nConta'},
            {name: 'nDocumentoFac', type: 'text', caption: 'utilizador.movimentos.nDocFac'},
            {name: 'dataDoc', type: 'date', caption: 'utilizador.movimentos.dataDoc'},
            {name: 'dataVenc', type: 'date', caption: 'utilizador.movimentos.dataVenc'},
            {name: 'debito', align: 'right', type: 'currency', caption: 'utilizador.movimentos.debito'},
            {name: 'credito', align: 'right', type: 'currency', caption: 'utilizador.movimentos.credito'},
            {name: 'saldo', align: 'right', type: 'currency', caption: 'utilizador.movimentos.saldo'},
            {name: 'nDocExterno', type: 'text', caption: 'utilizador.movimentos.nDocExterno'},
            {name: 'nRequisicao', type: 'text', caption: 'utilizador.movimentos.nRequisicao'}
          ]
        };

        ctrl.onLoad();
      }

      function onLoad(search, order, page, perpage) {
        var deferred = $q.defer();
        documentosService.getMovimentos(search, page, perpage, order)
          .then(function (response) {
            var linhas = response.data.list.map(function (item) {
              item._$ctrl = ctrl;
              return item;
            });
            deferred.resolve(linhas);
          })
          .catch(function (reason) {
            deferred.reject(reason);
            PopAlert.showError($rootScope.globalTranslate('utilizador.movimentos.fetchError'));
          });
        return deferred.promise;
      }
    });
})();

(function () {
  'use strict';

  angular.module('erpRetail')
    .controller('PerfilController', /*@ngInject*/ function ($scope, $q, Auth, clienteService, configFactory, $state, $translate, PopAlert, paisesService,
                                                            $transition$, alteraModaraModal) {

      var ctrl = this;

      ctrl.user = {};
      ctrl.cliente = {};
      ctrl.clienteMoradasAlt = {};
      ctrl.perfil = {};
      ctrl.paises = {};

      ctrl.$onInit = init;
      ctrl.refresh = refresh;
      ctrl.editMoradaFaturacao = editMoradaFaturacao;
      ctrl.editMoradaEntrega = editMoradaEntrega;
      ctrl.deleteMoradaEntrega = deleteMoradaEntrega;
      ctrl.newMorada = newMorada;
      
      /////////////

      function init() {
        ctrl.refresh();
      }

      function refresh() {
        ctrl.user = Auth.getCurrentUser();
        ctrl.perfil.email = ctrl.user.email;

        clienteService.getCliente().then(function (cliente) {
          ctrl.cliente = cliente;

          ctrl.moradaFaturacao = {
            nconta: ctrl.cliente.nconta,
            moralid: '{00000000-0000-0000-0000-000000000000}',
            nome: 'Principal',
            contactoNome: ctrl.cliente.nome,
            morada: ctrl.cliente.morada,
            localidade: ctrl.cliente.localidade,
            cpost: ctrl.cliente.codPostal,
            paisIso: {
              codPaisIso: ctrl.cliente.paisIso.codPaisIso,
              nomePais: ctrl.cliente.paisIso.nomePais
            },
            nipc: ctrl.cliente.nifReal,
            contactoTelefone: ctrl.cliente.telefone,
            isPrincipal: true,
            completed: ctrl.cliente.completed,
            canChangeNIF : ctrl.cliente.canChangeNIF
          };

          ctrl.clienteMoradasAlt = [];
          if (angular.isDefined(ctrl.moradaFaturacao) && ctrl.moradaFaturacao.completed) {
            clienteService.getClienteMoradasAlternativas().then(function (clienteMoradasAlt) {
              ctrl.clienteMoradasAlt = clienteMoradasAlt;
            });
          }
        });

        paisesService.getPaises().then(function (paises) {
          ctrl.paises = paises;
        });

        $translate.refresh();
      }

      function newMorada() {
        return alteraModaraModal.alteraMorada().then(function (novaMorada) {
          ctrl.newMoradaAlt = novaMorada;

          var newMoradaAlt = {
            moralid: '{00000000-0000-0000-0000-000000000000}',
            nconta: ctrl.cliente.nconta,
            nome: ctrl.newMoradaAlt.nome,
            rua: '',
            cpost: ctrl.newMoradaAlt.cpost,
            localidade: ctrl.newMoradaAlt.localidade,
            nipc: ctrl.newMoradaAlt.nipc || '',
            observacoes: '',
            morada: ctrl.newMoradaAlt.morada,
            desativado: false,
            facidGuidId: ctrl.cliente.facidGuidId,
            contactoNome: ctrl.newMoradaAlt.contactoNome,
            contactoTelefone: ctrl.newMoradaAlt.contactoTelefone || '',
            codPaisIso: ctrl.newMoradaAlt.paisIso.codPaisIso
          };

          clienteService.newMoradaAlternativa(newMoradaAlt, function (data) {
            ctrl.clienteMoradasAlt.push(data);
            $state.go('^.mostra');
          });
        });
      }

      function editMoradaFaturacao(morada) {
        return alteraModaraModal.alteraMorada(morada).then(function (novaMorada) {
          ctrl.moradaFaturacao = novaMorada;

          var cliente = {
            nconta: ctrl.cliente.nconta,
            nome: ctrl.moradaFaturacao.contactoNome,
            morada: ctrl.moradaFaturacao.morada,
            codPostal: ctrl.moradaFaturacao.cpost,
            localidade: ctrl.moradaFaturacao.localidade,
            nif: ctrl.moradaFaturacao.nipc,
            facidGuidId: ctrl.cliente.facidGuidId,
            email: ctrl.cliente.email,
            telefone: ctrl.moradaFaturacao.contactoTelefone,
            nifReal: ctrl.moradaFaturacao.nipc,
            isContaIdentAlternativa: ctrl.cliente.isContaIdentAlternativa,
            paisIso: {
              codPaisIso: ctrl.moradaFaturacao.paisIso.codPaisIso,
              nomePais: ctrl.moradaFaturacao.paisIso.nomePais
            },
            codPaisIso: ctrl.moradaFaturacao.paisIso.codPaisIso
          };
          clienteService.save(cliente, function () {
            $state.go('^.mostra');
          });
        });
      }

      function editMoradaEntrega(morada) {
        return alteraModaraModal.alteraMorada(morada).then(function (novaMorada) {
          var index = ctrl.clienteMoradasAlt.findIndex(function (item) {
            return item.moralid === novaMorada.moralid;
          });
          _.merge(ctrl.clienteMoradasAlt[index], novaMorada);

          delete novaMorada.open;

          clienteService.updateMoradaAlternativa(novaMorada, novaMorada.moralid, false, function () {
            $state.go('^.mostra');
          });
        });
      }

      function deleteMoradaEntrega(morada) {
        return alteraModaraModal.deleteMorada(morada).then(function (novaMorada) {
          var index = ctrl.clienteMoradasAlt.findIndex(function (item) {
            return item.moralid === novaMorada.moralid;
          });
          _.merge(ctrl.clienteMoradasAlt[index], novaMorada);

          novaMorada.desativado = true;
          delete novaMorada.open;

          clienteService.updateMoradaAlternativa(novaMorada, novaMorada.moralid, true, function () {
            ctrl.refresh();
            $state.go('^.mostra');
          });
        });
      }

      $scope.$on('event-user', function (event, args) {
        ctrl.refresh();
      });
      $scope.$on('event-login', function (event, args) {
        ctrl.refresh();
      });

    });
}());

(function () {
  'use strict';

  angular.module('erpRetail')
    .config(/*@ngInject*/ function ($stateProvider) {
      $stateProvider
        .state('loja.documentos', {
          url: '/documentos/:mbfaccbId',
          title: 'Documentos',
          params: {
            authenticate: true,
            mbfaccbId: { // Optional parameter
              value: null,
              squash: true,
              dynamic: true
            }
          },
          templateUrl: 'app/loja/utilizador/documentos/documentos.html',
          controller: 'DocumentosClienteController',
          controllerAs: 'ctrl'
        })
        .state('loja.perfil', {
          url: '/perfil',
          title: 'Perfil',
          abstract: true,
          params: {authenticate: true},
          templateUrl: 'app/loja/utilizador/perfil/perfil.html',
          controller: 'PerfilController',
          controllerAs: 'ctrl',
          resolve: {
            translatePartialLoader: function ($translate, $translatePartialLoader) {
              $translatePartialLoader.addPart('utilizador.perfil');
              return $translate.refresh();
            }
          }
        })
        .state('loja.perfil.mostra', {
          url: '/mostra',
          title: 'Perfil',
          params: {authenticate: true},
          templateUrl: 'app/loja/utilizador/perfil/perfil.dadosfaturacao.html',
          controller: 'PerfilController',
          controllerAs: 'ctrl'
        })
        .state('loja.perfil.editar', {
          url: '/edita',
          title: 'Perfil',
          params: {authenticate: true},
          templateUrl: 'app/loja/utilizador/perfil/perfil.dadosfaturacao.edit.html',
          controller: 'PerfilController',
          controllerAs: 'ctrl'
        })
        .state('loja.perfil.editarMorada', {
          url: '/editaMorada/:moralid',
          title: 'Perfil',
          params: {
            authenticate: true,
            moralid: {value: null, squash: true, dynamic: true}
          },
          templateUrl: 'app/loja/utilizador/perfil/perfil.morada.edit.html',
          controller: 'PerfilController',
          controllerAs: 'ctrl'
        })
        .state('loja.encomendas', {
          url: '/encomendas/:faccbId',
          title: 'Encomendas pendentes',
          params: {
            authenticate: true,
            faccbId: {value: null, squash: true, dynamic: true}
          },
          templateUrl: 'app/loja/utilizador/encomendas/encomendas.html',
          controller: 'EncomendasController',
          controllerAs: 'ctrl'
        })
        .state('loja.faturas', {
          url: '/faturas/:faccbId',
          title: 'Faturas',
          params: {
            authenticate: true,
            faccbId: {value: null, squash: true, dynamic: true}
          },
          templateUrl: 'app/loja/utilizador/faturas/faturas.html',
          controller: 'FaturasController',
          controllerAs: 'ctrl'
        })
        .state('loja.movimentosAberto', {
          url: '/movimentosaberto',
          title: 'Movimentos em Aberto',
          params: {authenticate: true},
          templateUrl: 'app/loja/utilizador/movimentosAberto/movimentosAberto.html',
          controller: 'MovimentosAbertoController',
          controllerAs: 'ctrl'
        });
    });
})();

(function () {
  'use strict';

  angular.module('erpRetail')
    .factory('apiService', function () {
      var factory = {
        buildQueryRaw: buildQueryRaw,
        buildQuery: buildQuery
      };
      return factory;

      function buildQueryRaw(params) {
        return {
          recordCount: params.recordCount,
          startOffset: params.startOffset,
          pesquisa: params.pesquisa,
          order: params.order
        };
      }

      function buildQuery(search, page, perPage, order) {
        var offset = 0;
        if (page > 1) {
          offset = (page - 1) * perPage;
        }
        return factory.buildQueryRaw({
          recordCount: perPage,
          startOffset: offset,
          pesquisa: search,
          order: order
        });
      }
    });
})();

(function () {
  'use strict';

  angular.module('erpRetail')
    .factory('Auth', ['$location', '$rootScope', '$http', 'User', '$cookies', '$q', '$state', '$log', 'REST_API', '$localStorage',
      function ($location, $rootScope, $http, User, $cookies, $q, $state, $log, REST_API, $localStorage) {
        var that = {
          currentUser: {},
          userCall: null,
          confirmemail: {},
          resettoken: ''
        };

        that.refreshUser = function () {
          that.userCall = User.get();
          that.userCall.then(function (user) {
            that.currentUser = user;
            that.confirmemail = {};
            that.userCall = null;
            $rootScope.$broadcast('event-user');
            return user;
          }, function (error) {
            that.currentUser = {};
            that.userCall = null;
            $rootScope.$broadcast('event-user');
          });
        };

        /**
         * Authenticate user and save token
         *
         * @param  {Object}   user     - login info
         * @param  {Function} callback - optional
         * @return {Promise}
         */
        that.login = function (user, callback) {
          var cb = callback || angular.noop;
          var deferred = $q.defer();
          //$log.info('login');
          $http.post(REST_API.HOST + REST_API.LOGIN, {
            email: user.email,
            password: user.password
          }).then(function (obj) {
            $cookies.put('token', obj.data.user.token);
            that.userCall = null;
            that.currentUser = obj.data.user;
            $rootScope.$broadcast('event-user');
            deferred.resolve(obj.data);
            return cb();
          }, function (err) {
            deferred.reject(err);
            this.logout();
            return cb(err);
          }.bind(this));

          return deferred.promise;
        };

        /**
         * Delete access token and user info
         */
        that.logout = function () {
          $cookies.remove('token');
          that.currentUser = {};
          that.userCall = null;
          $localStorage.cesto = [];
          $rootScope.$broadcast('event-logout');
          if (that.getToken() !== null) {
            $http.get(REST_API.HOST + REST_API.LOGOUT);
          }
        };

        /**
         * Gets all available info on authenticated user
         *
         * @return {Object} user
         */
        that.getCurrentUser = function () {
          return that.currentUser;
        };

        that.isLoggedIn = function () {
          return that.currentUser.hasOwnProperty('roles');
        };

        /**
         * Waits for currentUser to resolve before checking if user is logged in
         */
        that.isLoggedInAsync = function (cb) {
          if (that.userCall !== null) {
            that.userCall.then(function (user) {
              that.currentUser = user;
              that.userCall = null;
              cb(that.isLoggedIn(true));
            }, function () {
              that.currentUser = {};
              that.userCall = null;
              cb(false);
            });
          } else if (that.isLoggedIn()) {
            cb(true);
          } else {
            cb(false);
          }
        };

        /**
         * Check if a user is an admin
         *
         * @return {Boolean}
         */
        that.isAdmin = function () {
          if (!that.isLoggedIn()) return false;
          if (that.currentUser === null) return false;
          for (var i = 0; i < that.currentUser.roles.length; i++) {
            var item = that.currentUser.roles[i];
            if (item.name === 'admin') return true;
          }

          return false;
        };

        /**
         * Get auth token
         */
        that.getToken = function () {
          return $cookies.get('token');
        };

        /**
         * Criar utilizador
         */
        that.createUser = function (u) {
          var u1 = User.createUser(u);
          that.confirmemail.email = u.email;
          that.confirmemail.state = 'LOGIN_EMAIL_SENT';
          return u1;
        };

        that.baseUrl = function () {
          var aux = $location.absUrl();
          aux = aux.split('#');
          if (aux.length > 0) {
            return aux[0] + '#!';
          }
        };

        that.sendEmailToConfirm = function (email, send) {
          that.confirmemail.email = email;
          that.confirmemail.state = 'LOGIN_EMAIL_SENDING';

          $http.post(REST_API.HOST + REST_API.USER_EMAIL_CONFIRM, {
            email: email, baseUrl: that.baseUrl()
          }).then(function (obj) {
            that.confirmemail.state = 'LOGIN_EMAIL_SENT';
          }, function (err) {
            $log.error(err);
            that.confirmemail.state = 'LOGIN_EMAIL_SENT_ERROR';
          });
        };

        that.getEmailToConfirm = function () {
          return that.confirmemail;
        };

        that.validatetoken = function (token) {

          var deferred = $q.defer();

          $http.post(REST_API.HOST + REST_API.USER_EMAIL_VALIDATION, {
            token: token
          }).then(function (data) {
            deferred.resolve(data.data);
          }, function (err) {
            deferred.reject(err);
            $log.debug(err);
          });
          return deferred.promise;
        };

        that.recuperar = function (email) {
          var deferred = $q.defer();

          $http.post(REST_API.HOST + REST_API.USER_EMAIL_RECOVER, {
            email: email, baseUrl: that.baseUrl()
          }).then(function (data) {
            deferred.resolve(data.data);
          }, function (err) {
            deferred.reject(err);
          });
          return deferred.promise;
        };

        that.setRecover = function (token) {
          that.resettoken = token;
        };

        that.getRecover = function () {
          return that.resettoken;
        };

        that.passwordValidator = function (password) {

          if (!password) {
            return 'LOGIN_ERROR_PASS_INVALID';
          }

          if (password.length < 5) {
            return 'LOGIN_ERROR_PASS_VALIDATION';
          }
          /*if (!password.match(/[A-Z]/)) {
           return 'A palavra-passe dev ter pelo menos uma letra maiúscula!';
           }

           if (!password.match(/[0-9]/)) {
           return 'A palavra-passe deve ter pelo menos 1 número!';
           }*/

          return true;
        };

        that.novaPassword = function (token, password) {
          var deferred = $q.defer();

          $http.post(REST_API.HOST + REST_API.USER_NOVA_PASSWORD, {
            token: token,
            password: password,
            baseUrl: that.baseUrl()
          }).then(function (data) {
            deferred.resolve(data.data);
          }, function (err) {
            deferred.reject(err);
            $log.debug(err);
          });
          return deferred.promise;
        };

        if ($cookies.get('token')) {
          that.refreshUser();
        }

        return that;
      }]);
}());

/**
 * Created by Pedro Lopes on 08/10/14.
 */
(function () {
  'use strict';

  angular.module('erpRetail')
    .factory('clienteService', /*@ngInject*/ function ($resource, $q, $http, REST_API, $log, Auth, PopAlert, $translate) {
      var service = {
        getCliente: getCliente,
        getClienteAll: getClienteAll,
        getClienteMoradasAlternativas: getClienteMoradasAlternativas,
        save: save,
        newMoradaAlternativa: newMoradaAlternativa,
        updateMoradaAlternativa: updateMoradaAlternativa,
        query: query,
        validateNif: validateNif,
        nifValidator: nifValidator
      };
      return service;

      function getCliente() {
        var deferred = $q.defer();

        $http.get(REST_API.HOST + REST_API.CLIENTE)
          .then(function (data) {
            deferred.resolve(data.data);
          });
        return deferred.promise;
      }

      function getClienteAll() {
        var deferred = $q.defer();

        $http.get(REST_API.HOST + REST_API.ADMIN_CLIENTES_ALL)
          .then(function (data) {
            deferred.resolve(data.data);
          });
        return deferred.promise;
      }

      function getClienteMoradasAlternativas() {
        var deferred = $q.defer();

        $http.get(REST_API.HOST + REST_API.CLIENTEMORADASALTERNATIVAS)
          .then(function (data) {
            deferred.resolve(data.data);
          });
        return deferred.promise;
      }

      function save(cliente, okfunc) {
        $http.post(REST_API.HOST + REST_API.CLIENTE, cliente)
          .then(function (data) {
            Auth.refreshUser();
            PopAlert.showInfo('Cliente atualizado');
            okfunc(data);
          }, function (data) {
            $log.error('erro a gravar cliente');
            $log.error(data);
            PopAlert.postError();
          });
      }

      function newMoradaAlternativa(morada, okfunc) {
        $http.post(REST_API.HOST + REST_API.CLIENTEMORADASALTERNATIVASEDIT, morada)
          .then(function (data) {
            PopAlert.showInfo('Morada criada');
            okfunc(data.data);
          }, function (data) {
            $log.error('erro a gravar morada');
            $log.error(data);
            PopAlert.postError();
          });
      }

      function updateMoradaAlternativa(morada, id, isDelete, okfunc) {
        $http.put(REST_API.HOST + REST_API.CLIENTEMORADASALTERNATIVASEDIT + '/' + id, morada)
          .then(function (data) {
            if (isDelete === true) {
              PopAlert.showInfo('Morada apagada');
            } else {
              PopAlert.showInfo('Morada atualizada');
            }

            okfunc();
          }, function (data) {
            $log.error('erro ao atualizar morada');
            $log.error(data);
            PopAlert.postError();
          });
      }

      function query(search, order, page, perpage) {
        var deferred = $q.defer();
        var config = {
          params: {
            pesquisa: search
          }
        };
        $http.get(REST_API.HOST + REST_API.CLIENTES, config).then(function (data) {

          var obj = {
            list: data.data.data,
            total: data.data.page.records
          };
          deferred.resolve(obj);
        });
        return deferred.promise;
      }

      function validateNif(contribuinte) {
        if (!angular.isString(contribuinte) || contribuinte.length !== 9) {
          return false;
        }
        // algoritmo de validação do NIF de acordo com
        // http://pt.wikipedia.org/wiki/N%C3%BAmero_de_identifica%C3%A7%C3%A3o_fiscal
        var temErro = false;
        if (
          contribuinte.substr(0, 1) !== '1' && // pessoa singular
          contribuinte.substr(0, 1) !== '2' && // pessoa singular
          contribuinte.substr(0, 1) !== '3' && // pessoa singular
          contribuinte.substr(0, 2) !== '45' && // pessoa singular não residente
          contribuinte.substr(0, 1) !== '5' && // pessoa colectiva
          contribuinte.substr(0, 1) !== '6' && // administração pública
          contribuinte.substr(0, 2) !== '70' && // herança indivisa
          contribuinte.substr(0, 2) !== '71' && // pessoa colectiva não residente
          contribuinte.substr(0, 2) !== '72' && // fundos de investimento
          contribuinte.substr(0, 2) !== '77' && // atribuição oficiosa
          contribuinte.substr(0, 2) !== '79' && // regime excepcional
          contribuinte.substr(0, 1) !== '8' && // empresário em nome individual (extinto)
          contribuinte.substr(0, 2) !== '90' && // condominios e sociedades irregulares
          contribuinte.substr(0, 2) !== '91' && // condominios e sociedades irregulares
          contribuinte.substr(0, 2) !== '98' && // não residentes
          contribuinte.substr(0, 2) !== '99' // sociedades civis
        ) {
          temErro = true;
        }
        var check1 = contribuinte.substr(0, 1) * 9;
        var check2 = contribuinte.substr(1, 1) * 8;
        var check3 = contribuinte.substr(2, 1) * 7;
        var check4 = contribuinte.substr(3, 1) * 6;
        var check5 = contribuinte.substr(4, 1) * 5;
        var check6 = contribuinte.substr(5, 1) * 4;
        var check7 = contribuinte.substr(6, 1) * 3;
        var check8 = contribuinte.substr(7, 1) * 2;

        var total = check1 + check2 + check3 + check4 + check5 + check6 + check7 + check8;
        var divisao = total / 11;
        var modulo11 = total - parseInt(divisao) * 11;
        var comparador = 0;
        if (modulo11 === 1 || modulo11 === 0) {
          comparador = 0;
        } // excepção
        else {
          comparador = 11 - modulo11;
        }

        var ultimoDigito = contribuinte.substr(8, 1) * 1;
        if (ultimoDigito !== comparador) {
          temErro = true;
        }

        return !temErro;
      }

      function nifValidator(value) {
        return function () {
          return {
            value: angular.isFunction(value) ? value() : value,
            message: $translate.instant('validators.nif', {value: ''}),
            validate: function (name, ngModel) {
              if (this.value === false) {
                return true;
              }
              return ngModel && service.validateNif(ngModel);
            }
          };
        };
      }
    });
})();

/**
 * Created by Pedro Lopes on 03/10/14.
 */
(function () {
  'use strict';

  angular.module('erpRetail')
    .factory('configFactory', function ($http, REST_API, $q, $filter, $log, $rootScope, $state, Utils, CONFIG, $templateCache) {
      var factory = this;
      factory.isLoading = false;
      //factory.config = CONFIG.SITE_CONFIG;
      factory.classificadores = {};

      factory.deferredGetConfig = $q.defer();

      factory.getClassificadorCaption = function (classificador) {
        var aux = factory.getClassificador(classificador);
        if (aux === null) return '';
        return factory.getClassificador(classificador).caption;
      };

      factory.getClassificadorTags = function () {
        var ret = [];
        for (var i = 0; i < factory.classificadoresList.length; i++) {
          if (factory.classificadoresList[i].tipo === 'tags')
            ret.push(factory.classificadoresList[i]);
        }
        return ret;
      };

      factory.getClassificador = function (classificador) {
        for (var i = 0; i < factory.classificadoresList.length; i++) {
          if ((classificador.tipo === factory.classificadoresList[i].tipo) &&
            (classificador.id === factory.classificadoresList[i].id))
            return factory.classificadoresList[i];
        }
        return null;
      };

      factory.saveClassificadores = function (list) {
        var deferred = $q.defer();
        factory.classificadoresList = $filter('orderBy')(factory.classificadoresList, 'position');
        $http.post(REST_API.HOST + REST_API.CONFIG_CLASSIFICADORES, list)
          .then(function (data) {
            deferred.resolve(data.data);
          }, function (err) {
            $log.debug(err);
            deferred.reject(err);
          });
        return deferred.promise;
      };

      factory.saveCondicoesPagamento = function (list) {
        var deferred = $q.defer();
        factory.condicoesPagamentoList = $filter('orderBy')(factory.condicoesPagamentoList, 'position');
        for (var i = 0; i < list.length; i++) {
          delete list[i].descricao;
        }
        $http.post(REST_API.HOST + REST_API.CONFIG_CONDICOES_PAGAMENTO, list)
          .then(function (data) {
            deferred.resolve(data.data);
          }, function (err) {
            $log.debug(err.data);
            deferred.reject(err.data);
          });
        return deferred.promise;
      };

      factory.saveTransportadoras = function (list) {
        var deferred = $q.defer();
        factory.transportadorasList = $filter('orderBy')(factory.transportadorasList, 'position');
        for (var i = 0; i < list.length; i++) {
          delete list[i].nome;
        }
        $http.post(REST_API.HOST + REST_API.CONFIG_TRANSPORTADORAS, list)
          .then(function (data) {
            deferred.resolve(data.data);
          }, function (err) {
            $log.debug(err.data);
            deferred.reject(err.data);
          });
        return deferred.promise;
      };

      factory.getConfigSiteAdmin = function () {
        var deferred = $q.defer();

        $http.get(REST_API.HOST + REST_API.CONFIG_SITE_ADMIN)
          .then(function (data) {
            deferred.resolve(data.data);
          }, function (err) {
            $log.debug(err);
            deferred.reject(err);
          });
        return deferred.promise;
      };

      factory.refreshConfig = function () {
        factory.classificadores.grandeFamilia = factory.getClassificador({tipo: 'grandesFamilias', id: 0});
        factory.classificadores.subFamilia = factory.getClassificador({tipo: 'subFamilias', id: 0});
        factory.classificadores.familia = factory.getClassificador({tipo: 'familias', id: 0});
        factory.classificadores.classes = factory.getClassificador({tipo: 'classes', id: 0});
        factory.classificadores.categoria = factory.getClassificador({tipo: 'categorias', id: 0});
        factory.classificadores.tipo = factory.getClassificador({tipo: 'tipos', id: 0});
        factory.classificadores.tags = factory.getClassificadorTags();

        $templateCache.put('produto.box', $rootScope.$config.data.modelos.box);
        $templateCache.put('produto.detalhe', $rootScope.$config.data.modelos.detalhe);
        $templateCache.put('produto.list', $rootScope.$config.data.modelos.list);
        $templateCache.put('produto.promocao', $rootScope.$config.data.modelos.promocao);
        $templateCache.put('main.css', $rootScope.$config.data.modelos.maincss);

        $templateCache.put('classificador.box', $rootScope.$config.data.modelos.classificadorbox);
        $templateCache.put('classificador.detalhe', $rootScope.$config.data.modelos.classificadordetalhe);
        $templateCache.put('classificador.list', $rootScope.$config.data.modelos.classificadorlist);
        $templateCache.put('carrinho', $rootScope.$config.data.modelos.carrinho);

        $rootScope.$config.loaded = true;
      };

      factory.getTemplate = function (template) {
        if (!$rootScope.$config.loaded) {
          var deferred = $q.defer();
          factory.getConfigSite().then(function (data) {
            deferred.resolve($templateCache.get(template));
          });
          return deferred.promisse;
        }
        return $templateCache.get(template);
      };

      factory.getConfigSite = function () {
        //$log.info('getConfigSite');
        var deferred = factory.deferredGetConfig;
        if ($rootScope.$config.loaded) {
          deferred.resolve($rootScope.$config.data);
          //$log.info('getConfigSite: ok - already loaded');
          return deferred.promise;
        }
        if (factory.isLoading) {
          return deferred.promise;
        }
        factory.isLoading = true;

        if (CONFIG.USE_DEFAULT) {
          $rootScope.$config.loaded = true;
          $rootScope.$config.data = CONFIG.SITE_CONFIG;
          factory.refreshConfig();
          //$log.info('getConfigSite: ok - Default');
          deferred.resolve($rootScope.$config.data);
          return deferred.promise;
        }

        if ($rootScope.$config.loaded) {
          deferred.resolve($rootScope.$config.data);
        } else {

          $http.get(REST_API.HOST + REST_API.CONFIG_SITE)
            .then(function (data) {
              $rootScope.$config.data = data.data;

              factory.refreshConfig();
              $rootScope.$config.loaded = true;
              //$log.info("config load");
              deferred.resolve(data.data);
              //$log.info('getConfigSite: ok - http loaded');
              factory.isLoading = false;
            }, function (err) {
              //$log.debug(err);
              deferred.reject(err);

              //factory.isLoading = false;
              //$log.info('getConfigSite: error - http');
            });
        }
        return deferred.promise;
      };

      factory.getValue = function (item) {
        var deferred = $q.defer();
        $http.get(REST_API.HOST + REST_API.CONFIG_VALUE + '/' + item).then(
          function (response) {
            deferred.resolve(response);
          },
          function (error) {
            deferred.reject(error);
          }
        );
        return deferred.promise;
      };

      factory.saveValue = function (item, callback) {
        var deferred = $q.defer();
        var cb = callback || angular.noop;
        $http.post(REST_API.HOST + REST_API.CONFIG_VALUE, item).then(
          function (response) {
            cb(true, response);
            deferred.resolve(response);
          },
          function (error) {
            cb(false, error);
            deferred.reject(error);
          }
        );
        return deferred.promise;
      };

      factory.getInfo = function (callback) {
        var cb = callback || angular.noop;
        $http.get(REST_API.HOST + REST_API.CONFIG_INFO)
          .then(function (data) {
            cb(true, data.data);
          }, function (err) {
            cb(false, err);
          });
      };

      factory.getMenuBuild = function () {
        var deferred = $q.defer();

        $http.get(REST_API.HOST + REST_API.CONFIG_MENU_BUILD)
          .then(function (data) {
            deferred.resolve(data.data);
          }, function (err) {
            $log.debug(err);
            deferred.reject(err);
          });
        return deferred.promise;
      };

      factory.refresh = function (reset) {
        if (reset) $rootScope.$config.loaded = false;
        //$log.info("config refresh");
        if (CONFIG.USE_DEFAULT) {
          return CONFIG.SITE_CONFIG;
        } else
          factory.getConfigSite().then(
            function (value) {
              return value;
            }
          );
      };

      //factory.run=function () {
      //   if (factory.loaded) return;
      //   factory.refresh();
      //};
      //
      //
      //
      //factory.run();

      Object.defineProperty(factory, 'classificadoresList', {
        get: function () {
          return $rootScope.$config.data.classificadores;
        },
        set: function (value) {
          $rootScope.$config.data.classificadores = value;
        }
      });

      Object.defineProperty(factory, 'condicoesPagamentoList', {
        get: function () {
          return $rootScope.$config.data.condicoesPagamento;
        },
        set: function (value) {
          $rootScope.$config.data.condicoesPagamento = value;
        }
      });

      Object.defineProperty(factory, 'transportadorasList', {
        get: function () {
          return $rootScope.$config.data.transportadoras;
        },
        set: function (value) {
          $rootScope.$config.data.transportadoras = value;
        }
      });

      return factory;
    });
}());

(function () {
  'use strict';

  angular.module('erpRetail')
    .factory('cttService', function ($http, $q, REST_API) {
      var service = {
        getRegionByCodPostal: getRegionByCodPostal
      };
      return service;

      ///////////

      function getRegionByCodPostal(codPostal) {
        return $http.get(REST_API.HOST + REST_API.CTT_CODIGO_POSTAL, {params: {inCodPos: codPostal}});
      }
    });
}());

/**
 * Created by Pedro Lopes on 08/10/14.
 */
(function () {
  'use strict';

  angular.module('erpRetail')
    .factory('documentoService', function ($resource, $q, $http, $window, REST_API, storage, Auth, Utils) {
      return {
        getDoc: function (mbfaccbid) {
          var deferred = $q.defer();
          if (Utils.isNullOrUndefined(mbfaccbid)) {
            deferred.reject();
          } else {
            $http.get(REST_API.HOST + REST_API.DOCUMENTO + '/' + mbfaccbid)
              .then(function (response) {
                deferred.resolve(response);
              })
              .catch(function (reason) {
                deferred.reject(reason);
              });
          }
          return deferred.promise;
        },
        getMeiosPagamento: function () {
          var deferred = $q.defer();

          $http.get(REST_API.HOST + REST_API.MEIOS_PAGAMENTO)
            .then(function (data) {
              deferred.resolve(data.data);
            });
          return deferred.promise;
        },
        getReferenciasMB: function (mbfaccbid) {
          var deferred = $q.defer();
          if (Utils.isNullOrUndefined(mbfaccbid)) {
            deferred.reject();
          } else {
            $http.get(REST_API.HOST + REST_API.REFERENCIASMB + '/' + mbfaccbid)
              .then(function (response) {
                deferred.resolve(response);
              })
              .catch(function (reason) {
                deferred.reject(reason);
              });
          }
          return deferred.promise;
        },
        getDocOnline: function (faccbid) {
          var deferred = $q.defer();
          $http.get(REST_API.HOST + REST_API.DOCUMENTOS_ONLINE + '/' + faccbid).then(
            function (data) {
              deferred.resolve(data);
            },
            function (error) {
              deferred.reject(error);
            }
          );
          return deferred.promise;
        },
        gerarDoc: function () {
          var deferred = $q.defer();
          var lista = [];
          for (var i = 0; i < storage.cesto.length; i++) {
            lista.push({
              qtd: storage.cesto[i].qtd,
              nArtigo: storage.cesto[i].nArtigo
            });
          }
          var param = {
            'cab': storage.cesto.cab,
            'linhas': lista
          };

          $http.post(REST_API.HOST + REST_API.CHECKOUT, param)
            .then(function (data) {
              storage.clear();
              deferred.resolve(data.data);
            }, function (err) {
              deferred.reject(err);
            });

          return deferred.promise;

        },
        getPdfUrl: function (id) {
          return REST_API.HOST +
            REST_API.DOCUMENTOS_EXPORT +
            '/' + id +
            '?nvias=1' +
            '&segundavia=0' +
            '&api_key=' + Auth.getToken();
        }
      };
    });
})();

/**
 * Created by Pedro Lopes on 08/10/14.
 */
(function () {
  'use strict';

  angular.module('erpRetail')
    .factory('documentosService', function ($resource, $q, $http, REST_API, apiService) {
      return {
        getAll: function () {
          var deferred = $q.defer();
          $http.get(REST_API.HOST + REST_API.DOCUMENTOS_ALL).then(
            function (data) {
              deferred.resolve(data.data);
            },
            function (error) {
              deferred.reject(error);
            }
          );
          return deferred.promise;
        },
        getCliente: function (search, page, perpage, order) {
          var deferred = $q.defer();
          $http.get(REST_API.HOST + REST_API.DOCUMENTOS_CLIENTE, {params: apiService.buildQuery(search, page, perpage, order)}).then(
            function (response) {
              var obj = {
                list: response.data.data,
                total: response.data.page.records
              };
              deferred.resolve(obj);
            },
            function (error) {
              deferred.reject(error);
            }
          );
          return deferred.promise;
        },
        getComerciais: function () {
          var deferred = $q.defer();
          $http.get(REST_API.HOST + REST_API.DOCUMENTOS_COMERCIAIS).then(
            function (data) {
              deferred.resolve(data);
            },
            function (error) {
              deferred.reject(error);
            }
          );
          return deferred.promise;
        },
        getEncomendas: function () {
          var deferred = $q.defer();
          $http.get(REST_API.HOST + REST_API.DOCUMENTOS_ENCOMENDAS).then(
            function (data) {
              deferred.resolve(data);
            },
            function (error) {
              deferred.reject(error);
            }
          );
          return deferred.promise;
        },
        getMovimentos: function () {
          var deferred = $q.defer();
          $http.get(REST_API.HOST + REST_API.DOCUMENTOS_MOVIMENTOS).then(
            function (data) {
              deferred.resolve(data);
            },
            function (error) {
              deferred.reject(error);
            }
          );
          return deferred.promise;
        },
        getStatus: function (status) {
          switch (status) {
            case 'ssNaoSincronizado':
              return 'Não sincronizado';
            case 'ssSincronizado':
              return 'Sincronizado';
            case 'ssComErroBackOffice':
              return 'Erro no BackOffice';
            case 'ssProcessadoBackOffice':
              return 'Processado no BackOffice';
            default:
              return status;
          }
        }
      };
    });
}());

/**
 * Created by Pedro Lopes on 08/10/14.
 */
(function () {
  'use strict';

  angular.module('erpRetail')
    .factory('emailService', /*@ngInject*/ function ($rootScope, $q, $http, REST_API, plCompsService) {
      return {
        sendContact: function (name, email, message) {
          var deferred = $q.defer();

          $http.post(REST_API.HOST + REST_API.EMAIL_CONTACT, {
            name: name,
            email: email,
            message: message
          })
            .then(function (data) {
              deferred.resolve(data.data);
            }, function (data) {
              deferred.reject(data.data);
            });

          return deferred.promise;
        },

        validatorEmailExists: function (oldEmail) {
          return {
            value: null,
            message: 'utilizador.errorEmailExists',
            validate: function (name, email) {
              var deferred = $q.defer();

              if (oldEmail && oldEmail === email) {
                deferred.resolve(true);
              }
              else {
                plCompsService.debounce(function () {
                  var url = REST_API.HOST + REST_API.USER_EMAIL_EXISTS + '/' + email;
                  $http.get(url).then(
                    function () {
                      // Invalid
                      deferred.resolve(false);
                    },
                    function () {
                      // Valid
                      deferred.resolve(true);
                    }
                  );
                }, 500, 'validatorEmailExists');
              }

              return deferred.promise;
            }
          };
        }
      };
    });
})();

(function () {
    'use strict';

    angular.module('erpRetail')
        .factory('EmpresaFactory', ['$q', '$http', 'REST_API', function ($q, $http, REST_API) {
            return {
                get: function () {
                    var deferred = $q.defer();

                    $http.get(REST_API.HOST + REST_API.EMPRESA)
                        .then(function (data) {
                            deferred.resolve(data.data);
                        });
                    return deferred.promise;
                }
            };
        }]);
}());

(function () {
  'use strict';

  angular.module('erpRetail')
    .factory('ImagensFactory', ['$q', '$http', 'REST_API', 'Utils', function ($q, $http, REST_API, Utils) {


      return {
        getList: function (folder) {
          var deferred = $q.defer();
          var url = REST_API.HOST + REST_API.IMAGE_LIST;
          if (!Utils.isNullOrEmpty(folder)) {
            url += '/' + folder;
          }
          $http.get(url)
            .then(function (data) {
              deferred.resolve(data.data);
            }, function (err) {
              deferred.reject(err);
            });
          return deferred.promise;
        },
        getImagem: function (src, def) {
          if (Utils.isNullOrEmpty(src) && !Utils.isNullOrEmpty(def)) {
            return def;
          }
          var url = REST_API.HOST + REST_API.IMAGE_GET;
          url += '/' + src;
          return url;
        },
        getUrlImagem: function (folder, name) {

          var url = REST_API.HOST + REST_API.IMAGE_GET;
          if (!Utils.isNullOrEmpty(folder)) {
            url += '/' + folder;
          }
          url += '/' + name;
          return url;
        },
        deleteImagem: function (folder, name) {
          var deferred = $q.defer();
          var url = this.getUrlImagem(folder, name);
          $http.delete(url)
            .then(function (data) {
              deferred.resolve(data.data);
            }, function (error) {
              deferred.reject(error);
            });
          return deferred.promise;
        },

        renameImagem: function (folder, from, to) {
          var deferred = $q.defer();
          $http.post(REST_API.HOST + REST_API.IMAGE_RENAME, {folder: folder, from: from, to: to})
            .then(function (data) {
              deferred.resolve(data.data);
            }, function (err) {
              deferred.reject(err.data);
            });
          return deferred.promise;
        }
      };
    }]);
}());


/**
 * Created by Luis on 09/02/2015.
 */
(function () {
  'use strict';

  angular.module('erpRetail')
    .factory('MenuService', function (Utils, $log, $state) {
      var that = this;

      this.menuHome = {id: 0, state: 'loja.home', active: 'loja.home', title: 'Home'};
      this.menuLoja = {id: -1, state: 'loja.produtos', active: 'loja.produtos', title: 'Loja'};
      this.menuCarrinho = {id: -2, state: 'loja.carrinho', active: 'loja.carrinho', title: 'Carrinho'};
      this.menuContatos = {id: -3, state: 'loja.contatos', active: 'loja.contatos', title: 'Contactos'};
      this.menuAdmin = {id: -4, state: 'admin.config', active: 'admin', title: 'Admin'};
      this.menuLogin = {id: -5, state: 'login', active: 'login', title: 'Autenticação'};
      this.menuUser = {id: -6, state: 'user', active: 'user', title: 'Utilizador'};
      this.menuUserPerfil = {id: -7, state: 'loja.perfil.mostra', active: 'loja.perfil.mostra', title: 'Perfil'};
      this.menuUserDocs = {id: -8, state: 'loja.documentos', active: 'loja.documentos', title: 'Documentos'};
      this.menuEncomendas = {id: -10, state: 'loja.encomendas', active: 'loja.encomendas', title: 'Encomendas'};
      this.menuFaturas = {id: -11, state: 'loja.faturas', active: 'loja.faturas', title: 'Faturas'};
      this.menuMovimentosAbertos = {id: -12, state: 'loja.movimentosAberto', active: 'loja.movimentosAberto', title: 'Movimentos em Aberto'};
      this.menuUserSair = {id: -9, state: 'logout', active: '', title: 'Sair'};
      this.menuClassificadores = {id: -13, state: 'loja.produtos', active: 'loja.produtos', title: 'Classificadores'};

      this.menuSystem = [];

      this.hasNodes = function (item) {
        return !Utils.isNullOrUndefined(item) && !Utils.isNullOrUndefined(item.nodes) && item.nodes.length > 0;
      };

      this.getMenu = function (id) {

        var aux = parseInt(id);
        if ((aux > 0) || isNaN(aux)) {
          return {id: id, state: 'loja.home', active: 'loja.home', title: ''};
        }
        for (var i = 0; i < that.menuSystem.length; i++) {
          if (that.menuSystem[i].id === id)
            return that.menuSystem[i];
        }
        return that.menuHome;
      };

      this.getState = function (id) {
        var aux = parseInt(id);
        if ((aux >= 0) || isNaN(aux)) {
          return 'loja.home({id: \'' + id + '\'})';
        }

        for (var i = 0; i < that.menuSystem.length; i++) {
          if (that.menuSystem[i].id === id)
            return that.menuSystem[i].state;
        }
        return that.menuHome.state;
      };

      this.go = function (item) {
        var aux = parseInt(item.pageId);
        if ((aux > 0) || isNaN(aux)) {
          if (Utils.isNullOrUndefined(item.url)) {
            $state.go(that.getState(item.pageId));
          }
          else {
            $state.go('loja.home', {id: item.url});
          }
        }
        else {
          var id = parseInt(item.pageId);
          if (id) {
            item.pageId = id;
          }
          $state.go(that.getState(item.pageId));
        }
      };

      this.getUrl = function (item) {
        var url = '';
        var aux = parseInt(item.pageId);
        if (aux > 0 || isNaN(aux)) {
          if (Utils.isNullOrUndefined(item.url)) {
            url = that.getState(item.pageId);
          }
          else {
            url = 'loja.home({id: \'' + item.url + '\'})';
          }
        }
        else {
          url = that.getState(item.pageId);
        }
        return url;
      };

      this.refresh = function () {
        that.menuSystem = [];
        that.menuSystem.push(that.menuHome);
        that.menuSystem.push(that.menuLoja);
        that.menuSystem.push(that.menuCarrinho);
        that.menuSystem.push(that.menuContatos);
        that.menuSystem.push(that.menuAdmin);
        that.menuSystem.push(that.menuLogin);
        that.menuSystem.push(that.menuUser);
        that.menuSystem.push(that.menuUserPerfil);
        that.menuSystem.push(that.menuUserDocs);
        that.menuSystem.push(that.menuEncomendas);
        that.menuSystem.push(that.menuFaturas);
        that.menuSystem.push(that.menuMovimentosAbertos);
        that.menuSystem.push(that.menuUserSair);
        that.menuSystem.push(that.menuClassificadores);
        return that.menuSystem;
      };

      this.getMenuSystem = function () {
        return that.menuSystem;
      };

      this.refresh();

      return this;
    });
}());

(function () {
    'use strict';

    angular.module('erpRetail')
        .factory('ModelosFactory', ['$q', '$http', 'REST_API', function ($q, $http, REST_API) {
            return {
                get: function () {
                    var deferred = $q.defer();

                    $http.get(REST_API.HOST + REST_API.MODELOS)
                        .then(function (data) {
                            deferred.resolve(data.data);
                        });
                    return deferred.promise;
                },
                getTipos: function (textos) {
                    var deferred = $q.defer();
                    $http.get(REST_API.HOST + REST_API.MODELOS_TIPOS)
                        .then(function (data) {
                            deferred.resolve(data.data);
                        });
                    return deferred.promise;
                },
                getTexto: function (tipo) {
                    var deferred = $q.defer();
                  $http.get(REST_API.HOST + REST_API.MODELOS + '/' + tipo)
                        .then(function (data) {
                            deferred.resolve(data.data);
                        });
                    return deferred.promise;
                },
                getOriginal: function (type) {
                    var deferred = $q.defer();
                  $http.get(REST_API.HOST + REST_API.MODELOS_ORIGINAL + '/' + type)
                        .then(function (data) {
                            deferred.resolve(data.data);
                        });
                    return deferred.promise;
                },
                save: function (type, subject, html) {
                    var deferred = $q.defer();
                    $http.post(REST_API.HOST + REST_API.MODELOS, {
                        tipo: type,
                        subject: subject,
                        html: html
                    })
                        .then(function (data) {
                            deferred.resolve(data.data);
                        });
                    return deferred.promise;
                }
            };
        }]);
}());

(function () {
  'use strict';

  angular.module('erpRetail')
    .factory('PagamentosFactory', function ($q, $http, $log, REST_API, $state) {
      return {
        paypal: function (MBFaccbId, estado, token) {
          var deferred = $q.defer();
          $http.post(REST_API.HOST + REST_API.PAGAMENTO_PAYPAL, {MBFaccbId: MBFaccbId, estado: estado, token: token})
            .then(function (response) {
              deferred.resolve(response.data);
            })
            .catch(function (reason) {
              $log.error(reason);
              deferred.reject(reason);
            });
          return deferred.promise;
        },

        goPagamento: function (item, MBFaccbId) {
          if (item === 9) { //'PAYPAL'
            $state.go('loja.pagamento.paypal', {MBFaccbId: MBFaccbId, payKey: '', action: ''});
          }
        },

        setPayed: function (MBFaccbId, motivo) {
          var deferred = $q.defer();
          $http.post(REST_API.HOST + REST_API.PAGAMENTO_SET_PAYED + '/' + MBFaccbId, {descricao: motivo})
            .then(function (response) {
              deferred.resolve(response.data);
            })
            .catch(function (reason) {
              $log.error(reason);
              deferred.reject(reason);
            });
          return deferred.promise;
        },

        condicoesPagamento: function (pesquisa, startoffset, recordcount) {
          var deferred = $q.defer();
          $http.get(REST_API.HOST + REST_API.PAGAMENTO_CONDICOES_PAGAMENTO, {pesquisa: pesquisa, startoffset: startoffset, recordcount: recordcount})
            .then(function (response) {
              deferred.resolve(response.data);
            })
            .catch(function (reason) {
              $log.error(reason);
              deferred.reject(reason);
            });
          return deferred.promise;
        },

        transportadoras: function (codPaisIso, codPostal) {
          var deferred = $q.defer();
          $http.get(REST_API.HOST + REST_API.PAGAMENTO_TRANSPORTADORAS + '/' + codPaisIso + '/' + codPostal)
            .then(function (response) {
              deferred.resolve(response.data);
            })
            .catch(function (reason) {
              $log.error(reason);
              deferred.reject(reason);
            });
          return deferred.promise;
        }
      };
    });
}());

(function () {
  'use strict';

  angular.module('erpRetail')
    .factory('PaginasFactory', ['$q', '$http', 'REST_API', '$log', 'configFactory', 'Utils', function ($q, $http, REST_API, $log, configFactory, Utils) {
      var that = this;

      that.load = function (id) {
        var deferred = $q.defer();
        if (Utils.isNullOrUndefined(id)) {
          deferred.reject('not found');
          return deferred.promise;
        }

        $http.get(REST_API.HOST + REST_API.PAGINA + '/' + id)
          .then(function (data) {
            deferred.resolve(data.data);
          }, function (err) {
            $log.debug(err.data);
            deferred.reject(err.data);
          });
        return deferred.promise;
      };

      that.getAll = function () {
        var deferred = $q.defer();

        $http.get(REST_API.HOST + REST_API.PAGINAS_TODAS)
          .then(function (data) {
            deferred.resolve(data.data);
          }, function (err) {
            $log.debug(err.data);
            deferred.reject(err.data);
          });
        return deferred.promise;
      };

      that.save = function (pagina) {
        var deferred = $q.defer();

        $http.post(REST_API.HOST + REST_API.PAGINA + '/' + pagina.id, pagina)
          .then(function (data) {
            deferred.resolve(data.data);
          }, function (err) {
            $log.debug(err.data);
            deferred.reject(err.data);
          });
        return deferred.promise;
      };

      that.deletePagina = function (pagina) {
        var deferred = $q.defer();

        $http.delete(REST_API.HOST + REST_API.PAGINA + '/' + pagina.id, pagina)
          .then(function (data) {
            deferred.resolve(data.data);
          }, function (err) {
            $log.debug(err.data);
            deferred.reject(err.data);
          });
        return deferred.promise;
      };

      return that;
    }]);
}());

(function () {
  'use strict';

  angular.module('erpRetail')
    .factory('paisesService', /*@ngInject*/ function ($resource, $q, $http, REST_API) {
      return {
        getPaises: function () {
          var deferred = $q.defer();

          $http.get(REST_API.HOST + REST_API.PAISES)
            .then(function (data) {
              deferred.resolve(data.data);
            });
          return deferred.promise;
        }
      };
    });
})();

/**
 * Created by Pedro Lopes on 08/10/14.
 */
(function () {
  'use strict';

  angular.module('erpRetail')
    .factory('ProdutosFactory', function ($q, $http, REST_API) {
      return {
        getCatalogos: function () {
          var deferred = $q.defer();
          $http.get(REST_API.HOST + REST_API.PRODUTOS_CATALOGOS, {cache: true})
            .then(function (data) {
              deferred.resolve(data.data);
            }, function (err) {
              deferred.reject(err.data);
            });
          return deferred.promise;
        },
        getProdutosCatalogo: function (catalogoId) {
          var deferred = $q.defer();
          $http.get(REST_API.HOST + REST_API.PRODUTOS_CATALOGO + '/' + catalogoId, {cache: true})
            .then(function (data) {
              deferred.resolve(data.data);
            }, function (err) {
              deferred.reject(err.data);
            });
          return deferred.promise;
        },
        getAnexos: function (classificador, chave) {
          var deferred = $q.defer();
          $http.get(REST_API.HOST + REST_API.PRODUTO_ANEXOS + '/' + classificador + '/' + chave).then(
            function (response) {
              deferred.resolve(response);
            },
            function (error) {
              deferred.reject(error);
            }
          );
          return deferred.promise;
        },
        getAnexoUrl: function (id) {
          return REST_API.HOST + REST_API.PRODUTO_DOCUMENTO + '/' + id;
        }
      };
    });
}());

(function () {
  'use strict';

  angular.module('erpRetail')
    .factory('storage', function ($rootScope, $sessionStorage, $localStorage, $http, $q, $state, $log, configFactory, REST_API, Utils, PopAlert, Lightbox, paisesService,
                                  Auth, clienteService, PagamentosFactory) {
        var factory = this;

        factory.init = init;
        factory.clear = clear;
        factory.loadCliente = loadCliente;
        factory.reloadCondicoesPagamento = reloadCondicoesPagamento;
        factory.loadPaises = loadPaises;
        factory.getClassificadorByName = getClassificadorByName;
        factory.getClassificadorById = getClassificadorById;
        factory.showArtigos = showArtigos;
        factory.showDetail = showDetail;
        factory.showDetailClassificador = showDetailClassificador;
        factory.getImagem = getImagem;
        factory.getImagemByDocId = getImagemByDocId;
        factory.getfirstImagem = getfirstImagem;
        factory.qtdInc = qtdInc;
        factory.addBasket = addBasket;
        factory.addBasketByNArtigo = addBasketByNArtigo;
        factory.calcBasket = calcBasket;
        factory.getArtigo = getArtigo;
        factory.calcBasketOnline = calcBasketOnline;
        factory.getProdutosEmPromocao = getProdutosEmPromocao;
        factory.pesquisa = pesquisa;
        factory.getTextoClassificador = getTextoClassificador;
        factory.openLightboxModal = openLightboxModal;
        factory.loadCondicoesPagamentoList = loadCondicoesPagamentoList;
        factory.fillDescricaoCondicaoPagamento = fillDescricaoCondicaoPagamento;
        factory.loadCondicoesPagamentoList = loadCondicoesPagamentoList;

        factory.eventUser = $rootScope.$on('event-user', function (event, args) {
          if (angular.equals(Auth.currentUser, {})) {
            factory.clienteData = {};
            clear();
          } else {
            init();
          }
        });

        factory.eventUserLoggedOut = $rootScope.$on('event-logout', function (event, args) {
          factory.clear();
        });


        function clear() {
          factory.cesto = [];
          factory.carrinhoTotal = {
            nItens: 0,
            custoTransporte: 0.0,
            desconto: 0.0,
            total: 0.0
          };

          factory.ncondpag = 0;
          factory.codTransportadora = 0;

          if (angular.isArray(factory.condicoesPagamentoList)) {
            factory.condicoesPagamentoList = factory.condicoesPagamentoList.map(function (item) {
              item.checked = false;
              return item;
            });
          }
        }

        function init() {
          factory.clear();
          factory.loadDefered = $q.defer();
          factory.loadPromise = factory.loadDefered.promise;


          $localStorage = $localStorage.$default({cesto: []});
          factory.clientPromise = $q.defer();
          factory.ncondpag = 0;
          factory.codTransportadora = 0;

          factory.carrinhoTotal = {nItens: 0, total: 0};
          factory.lastSearch = '';
          factory.noimage = REST_API.PRODUTOS_NOIMAGE;
          factory.imagePath = REST_API.HOST + REST_API.PRODUTOS_IMAGE_PATH;
          factory.clienteData = null;

          factory.step = 1;
          factory.qtdMin = 1;
          factory.qtdMax = 999;

          factory.tipoTabelaImagens = {
            none: {id: 0, identifier: ''},
            tipoArtigo: {id: 1, identifier: 'codTpArt'},
            grFamilia: {id: 2, identifier: 'ndepart'},
            familia: {id: 3, identifier: 'nfamilia'},
            subFamilia: {id: 4, identifier: 'nsubFa'},
            categoria: {id: 5, identifier: 'categoria'},
            classe: {id: 6, identifier: 'classe'}
          };
          Object.defineProperty(factory, 'cesto', {
            get: function () {
              return $localStorage.cesto;
            },
            set: function (value) {
              $localStorage.cesto = value;
              factory.calcBasket();
            }
          });

          loadPaises();

          factory.reloadCondicoesPagamento().then(function () {
            factory.loadCondicoesPagamentoList();
          });
          loadCliente();
        }

        init();

        function loadPaises() {
          paisesService.getPaises().then(function (paises) {
            factory.paises = paises;
          });
        }

        function getClassificadorByName(name) {
          switch (name) {
            case 'Classe':
              return factory.tipoTabelaImagens.classe;
            case 'Tipo de Artigo':
              return factory.tipoTabelaImagens.tipoArtigo;
            case 'Grande Família':
              return factory.tipoTabelaImagens.grFamilia;
            case 'Família':
              return factory.tipoTabelaImagens.familia;
            case 'Sub-família':
              return factory.tipoTabelaImagens.subFamilia;
            case 'Categoria':
              return factory.tipoTabelaImagens.categoria;
          }
        }

        function getClassificadorById(id) {
          var classificador = null;
          angular.forEach(factory.tipoTabelaImagens, function (tipo) {
            if (id === tipo.id) {
              classificador = tipo;
            }
          });
          return classificador;
        }

        function showArtigos() {
          if (angular.isUndefined(factory.lastUrlName)) {
            $state.go('loja.produtos');
          } else {
            $state.go(factory.lastUrlName);
          }
        }

        function showDetail(artigo) {
          factory.lastUrlName = $state.current.name;
          $state.go('loja.produto', {nartigo: artigo.nArtigo || artigo.nartigo});
        }

        function showDetailClassificador(classificador) {
          factory.lastUrlName = $state.current.name;
          $state.go('loja.classificador', {tabela: classificador.tabela, nchave: classificador.chave, ordem: classificador.ordem, clearSearch: true});
        }

        function getImagem(artigo) {
          if (!artigo || !artigo.imagem) {
            return factory.noimage;
          }
          return factory.imagePath + artigo.imagem;
        }

        function getImagemByDocId(docId) {

          if (Utils.isNullOrUndefined(docId)) return factory.noimage;
          return factory.imagePath + docId;
        }

        function getfirstImagem(imagens) {
          if (Utils.isNullOrUndefined(imagens)) return factory.noimage;
          if (Utils.isNullOrUndefined(imagens[0])) return factory.noimage;

          return factory.imagePath + imagens[0].docId.replace('{', '').replace('}', '');
        }

        function qtdInc(value, item) {
          item.qtd += value;
        }

        function addBasket(artigo) {
          var aux = _.find(factory.cesto, function (rw) {
            return rw.nArtigo === artigo.nArtigo;
          });
          if (angular.isUndefined(aux) || !aux) {
            aux = angular.copy(artigo);
            if (!aux.qtd || aux.qtdMinEncome && aux.qtdMinEncome > 0 && aux.qtd < aux.qtdMinEncome) {
              aux.qtd = aux.qtdMinEncome;
            }
            aux.qtd = aux.qtd || 1.0;
            aux.preco *= aux.qtdPorUnidade1;
            factory.cesto.push(aux);
          } else if (artigo.qtd) {
            aux.qtd += artigo.qtd;
          } else {
            aux.qtd++;
          }
          PopAlert.showSuccess(artigo.nome + ' adicionado ao carrinho');
          factory.calcBasket();
        }

        function addBasketByNArtigo(nArtigo) {
          factory.getArtigo(nArtigo).then(
            function (response) {
              factory.addBasket(response.artigo);
            },
            function (error) {
              $log.error(error);
              PopAlert.showError('CART_ERROR_ADD_TO_CART');
            }
          );
        }

        function calcBasket() {
          factory.calcBasketOnline(factory.ncondpag, factory.codTransportadora).then(function (data) {

            factory.carrinhoTotal = {
              nItens: 0.0,
              totalSemDesconto: 0.0,
              total: data.cab.custoTransporte,
              desconto: 0.0,
              custoTransporte:
              data.cab.custoTransporte
            };
            for (var i = 0; i < factory.cesto.length; i++) {

              factory.carrinhoTotal.nItens += parseInt((factory.cesto[i].qtd));
              var precoSemDesconto = factory.cesto[i].qtd * factory.cesto[i].precoSemDesconto;
              var desconto = precoSemDesconto - factory.cesto[i].valorLinha;
              factory.carrinhoTotal.totalSemDesconto += precoSemDesconto;
              factory.carrinhoTotal.total += factory.cesto[i].valorLinha;
              factory.carrinhoTotal.desconto += desconto;
            }
          }, function (error) {
            $log.error(error);
            PopAlert.showError('CART_ERROR_CALC');
          });
        }

        function getArtigo(nArtigo) {
          if (Utils.isNullOrEmpty(nArtigo)) return null;
          var deferred = $q.defer();
          $http.get(REST_API.HOST + REST_API.PRODUTO_DETALHE + '/' + nArtigo)
            .then(function (data) {
              data.data.artigo.qtd = data.data.artigo.qtdMinEncome || 1;
              data.data.artigo.collapsed = true;
              deferred.resolve(data.data);
            }, function (err) {
              deferred.reject(err.data);
            });
          return deferred.promise;
        }

        function calcBasketOnline(ncondpag, codTransportadora) {

          var deferred = $q.defer();


          var lista = [];
          for (var i = 0; i < factory.cesto.length; i++) {
            lista.push({
              qtd: factory.cesto[i].qtd,
              nArtigo: factory.cesto[i].nArtigo
            });
          }
          var param = {
            'cab': {
              'ncondpag': ncondpag,
              'codTransportadora': codTransportadora
            },
            'linhas': lista
          };

          $http.post(REST_API.HOST + REST_API.PRODUTO_BASKET_CALC, param)
            .then(function (data) {

              //factory.cesto = param.linhas;
              for (var i = 0; i < param.linhas.length; i++) {
                for (var j = 0; j < factory.cesto.length; j++) {
                  if (factory.cesto[j].nArtigo === data.data.linhas[i].nArtigo) {
                    factory.cesto[j].precoSemDesconto = data.data.linhas[i].calculoPrecos.precoSemDesconto;
                    factory.cesto[j].valorLinha = data.data.linhas[i].calculoPrecos.valorLinha;
                    break;
                  }
                }
              }
              deferred.resolve(data.data);
            }, function (err) {
              deferred.reject(err.data);
            });
          return deferred.promise;
        }

        function getProdutosEmPromocao() {
          return factory.pesquisa(null, null, null, null, null, null, null, null, null, null,
            null, null, true, null, null, null, null, null);
        }

        function pesquisa(pesquisa, catalogoCab, catalogoClasse, familia, subFamilia, grandeFamilia, classe, categoria, tipo, orderBy,
                          startOffset, recordCount, emPromo, livreLong04, livreLong05, comStockPotOuAReceber, tags, classificadores, tabelaTextosClassificadores) {
          var p = {
            params: {
              pesquisa: pesquisa,
              catalogoCab: catalogoCab,
              catalogoClasse: catalogoClasse,
              familia: familia,
              grandeFamilia: grandeFamilia,
              subFamilia: subFamilia,
              classe: classe,
              categoria: categoria,
              tipoArtigo: tipo,
              orderBy: orderBy,
              startOffset: startOffset,
              recordCount: recordCount,
              emPromo: emPromo,
              livreLong04: livreLong04,
              livreLong05: livreLong05,
              comStockPotOuAReceber: comStockPotOuAReceber,
              tags: tags ? angular.toJson(tags) : null,
              classificadores: classificadores,
              tabelaTextosClassificadores: tabelaTextosClassificadores
            }
          };
          return $http.get(REST_API.HOST + REST_API.PRODUTO_PESQUISA, p);
        }

        function getTextoClassificador(tabela, chave, ordem) {
          var deferred = $q.defer();
          var u = REST_API.HOST + REST_API.PRODUTO_TEXTO_CLASSIFICADOR + '/' + tabela + '/' + chave + '/' + ordem;
          $http.get(u)
            .then(function (data) {
              deferred.resolve(data.data);
            }, function (err) {
              deferred.reject(err.data);
            });
          return deferred.promise;
        }

        function openLightboxModal(images, index) {
          return Lightbox.openModal(images, index, {templateUrl: 'app/components/lightbox/lightbox.html'});
        }

        function loadCliente() {
          if (Auth.isLoggedIn()) {
            clienteService.getCliente().then(function (cliente) {
              factory.clienteData = {};
              factory.clienteData.cliente = cliente;
              factory.clienteData.clienteMoradasAlt = [{
                moralid: '{00000000-0000-0000-0000-000000000000}',
                nome: 'Principal',
                contactoNome: factory.clienteData.cliente.nome,
                morada: factory.clienteData.cliente.morada,
                localidade: factory.clienteData.cliente.localidade,
                cpost: factory.clienteData.cliente.codPostal,
                codPaisIso: factory.clienteData.cliente.paisIso.codPaisIso,
                paisIso: {
                  codPaisIso: factory.clienteData.cliente.paisIso.codPaisIso,
                  nomePais: factory.clienteData.cliente.paisIso.nomePais
                },
                nipc: factory.clienteData.cliente.nifReal,
                contactoTelefone: factory.clienteData.cliente.telefone,
                isPrincipal: true,
                completed: factory.clienteData.cliente.completed,
                canChangeNIF: factory.clienteData.cliente.canChangeNIF
              }];
              if (cliente.completed) {
                clienteService.getClienteMoradasAlternativas().then(function (clienteMoradasAlt) {
                  factory.clienteData.clienteMoradasAlt = factory.clienteData.clienteMoradasAlt.concat(clienteMoradasAlt);
                  factory.clienteData.moradaEntrega = factory.clienteData.clienteMoradasAlt[0];
                  factory.clienteData.moradaFaturacao = factory.clienteData.clienteMoradasAlt[0];
                  factory.clienteData.clienteMoradasAltEdit = angular.copy(clienteMoradasAlt);
                  factory.clientPromise.resolve(factory.clienteData);
                  factory.loadDefered.resolve();
                  $rootScope.$broadcast('storage-loaded');
                });
              } else {
                factory.clienteData.moradaEntrega = factory.clienteData.clienteMoradasAlt[0];
                factory.clienteData.moradaFaturacao = factory.clienteData.clienteMoradasAlt[0];
                factory.clienteData.clienteMoradasAltEdit = [];
                factory.clientPromise.resolve(factory.clienteData);
                factory.loadDefered.resolve();
                $rootScope.$broadcast('storage-loaded');
              }
            });
          }
        }

        function reloadCondicoesPagamento() {
          var deferred = $q.defer();
          PagamentosFactory.condicoesPagamento('', -1, -1).then(
            function (pagamList) {
              factory.pagamList = pagamList;
              deferred.resolve();
            },
            function (err) {
              deferred.reject(err);
            }
          );
          return deferred.promise;
        }

        function loadCondicoesPagamentoList() {
          var defered = $q.defer();
          configFactory.getConfigSite().then(
            function (data) {
              factory.condicoesPagamentoList = data.condicoesPagamento;
              factory.fillDescricaoCondicaoPagamento();
              return defered.resolve();
            }, function (err) {
              return defered.reject(err);
            }
          );
          return defered.promise;
        }

        function fillDescricaoCondicaoPagamento() {
          for (var i = 0; i < factory.condicoesPagamentoList.length; i++) {
            var item = factory.condicoesPagamentoList[i];
            for (var j = 0; j < factory.pagamList.length; j++) {
              var pagam = factory.pagamList[j];
              if (pagam.ncondpag === item.ncondpag) {
                item.descricao = pagam.descricao;
                break;
              }
            }
          }
        }

        return factory;
      }
    );
}());

(function () {
  'use strict';

  angular.module('erpRetail')
    .factory('TransportadorasFactory', ['$q', '$http', 'REST_API', '$log', '$state',
      function ($q, $http, REST_API, $log, $state) {
        return {
          moradasAlternativas: function (codTransportadora) {
            var deferred = $q.defer();
            $http.get(REST_API.HOST + REST_API.TRANSPORTADORAS+'/'+codTransportadora+'/moradasalternativas')
              .then(function (data) {
                deferred.resolve(data.data);
              }, function (err) {
                $log.debug(err.data);
                deferred.reject(err.data);
              });
            return deferred.promise;
          },
          all: function () {
            var deferred = $q.defer();
            $http.get(REST_API.HOST + REST_API.TRANSPORTADORAS+'/all')
              .then(function (data) {
                deferred.resolve(data.data);
              }, function (err) {
                $log.debug(err.data);
                deferred.reject(err.data);
              });
            return deferred.promise;
          }
        };
      }]);
}());

(function () {
  'use strict';

  angular.module('erpRetail')
    .factory('User', function ($q, $http, REST_API, $log) {
      return {
        get: function () {
          var deferred = $q.defer();

          $http.get(REST_API.HOST + REST_API.USER_ME)
            .then(function (data) {
              deferred.resolve(data.data);
            }, function (err) {
              $log.debug(err);
              deferred.reject(err.data);
            });
          return deferred.promise;
        },
        getUser: function (id) {
          var deferred = $q.defer();

          $http.get(REST_API.HOST + REST_API.USER + '/' + id)
            .then(function (data) {
              deferred.resolve(data.data);
            }, function (err) {
              $log.debug(err.data);
              deferred.reject(err.data);
            });
          return deferred.promise;
        },
        saveUser: function (id, user) {
          var deferred = $q.defer();

          $http.post(REST_API.HOST + REST_API.USER + '/' + id, user)
            .then(function (data) {
              deferred.resolve(data.data);
            }, function (err) {
              $log.debug(err.data);
              deferred.reject(err.data);
            });
          return deferred.promise;
        },
        createUser: function (user) {
          var deferred = $q.defer();
          $http.post(REST_API.HOST + REST_API.USER_ME, user)
            .then(function (data) {
              deferred.resolve(data.data);
            }, function (err) {
              $log.debug(err.data);
              deferred.reject(err.data);
            });
          return deferred.promise;
        },
        getAll: function () {
          var deferred = $q.defer();

          $http.get(REST_API.HOST + REST_API.USER_ALL)
            .then(function (data) {
              deferred.resolve(data.data);
            }, function (err) {
              $log.debug(err.data);
              deferred.reject(err.data);
            });
          return deferred.promise;
        },
        mudarPassword: function (id, password) {
          var deferred = $q.defer();
          $http.post(REST_API.HOST + REST_API.USER + '/' + id + REST_API.USER_MUDAR_PASSWORD, {password: password})
            .then(
              function (response) {
                deferred.resolve(response.data);
              },
              function (error) {
                deferred.reject(error.data);
              }
            );
          return deferred.promise;
        }
      };
    });
}());

(function () {
  'use strict';

  angular.module('erpRetail')
    .factory('Utils', /*@ngInject*/ function ($rootScope) {
      var service = {
        isNullOrUndefined: function (obj) {
          return angular.isUndefined(obj) || obj === null;
        },
        isNullOrEmpty: function (obj) {
          var ret = angular.isUndefined(obj) || obj === null;
          if (ret) {
            return ret;
          }
          return obj === '';
        },
        translate: function (value, params) {
          return $rootScope.globalTranslate(value, params);
        },
        sameText: function (value1, value2) {
          if (value1 === null && value2 === null) {
            return true;
          }
          if (value1 === null && value2 !== null) {
            return false;
          }
          if (value1 !== null && value2 === null) {
            return false;
          }
          return (value1.toLowerCase() === value2.toLowerCase());
        },
        toNumber: function (value) {
          if (service.isNullOrEmpty(value)) {
            return 0;
          }
          return parseInt(value);
        },
        combineDateTime: function(date, time){
          var myDate=date;
          var myTime=time;
          if (angular.isString(date))
            myDate = new Date(date);
          if (angular.isString(time))
            myTime = new Date(time);
            

        var datePart = myDate.toISOString().substring(0, 10);
        var timePart = myTime.toISOString().substring(10, 24);
        return new Date(datePart + timePart);
      }
      };
      return service;
    });
})();
(function(){'use strict';angular.module('erpRetail').run(['$templateCache', function($templateCache) {$templateCache.put('app/outdated.html','<h6>O seu browser est&aacute; desatualizado!</h6><p>Atualize o seu browser para ter uma melhor experi&ecirc;ncia e visualiza&ccedil;&atilde;o deste site. <a id="btnUpdateBrowser" href="http://outdatedbrowser.com/pt">Atualize o seu browser agora</a></p><p class="last"><a href="#" id="btnCloseUpdateBrowser" title="Fechar">&times;</a></p><!--<div id="outdated">--><!--    <h6>O seu browser est\xE1 desatualizado!</h6>\r\n\r\n    <p>Actualize o seu browser para uma correta visualiza\xE7\xE3o deste website. </p>\r\n\r\n    <div class="page-header"></div>\r\n    <div class="row">\r\n\r\n        <div class="col-md-3">\r\n            <center>\r\n                <img src="assets/images/browsers/chrome_logo.png"/>\r\n                <br><br>\r\n\r\n                <p><strong>GOOGLE CHROME</strong></p>\r\n                <br>\r\n\r\n                <p><a id="btnUpdate" href="//www.google.com/chrome" target="_blank">DOWNLOAD</a></p>\r\n                <br><br>\r\n            </center>\r\n        </div>\r\n        <div class="col-md-3">\r\n            <center>\r\n                <img src="assets/images/browsers/firefox_logo.png"/>\r\n                <br><br>\r\n\r\n                <p><strong>MOZILLA FIREFOX</strong></p>\r\n                <br>\r\n\r\n                <p><a id="btnUpdate" href="//www.mozilla.org/firefox/new/" target="_blank">DOWNLOAD</a></p>\r\n                <br><br>\r\n            </center>\r\n        </div>\r\n        <div class="col-md-3">\r\n            <center>\r\n                <img src="assets/images/browsers/ie_logo.png"/>\r\n                <br><br>\r\n\r\n                <p><strong>INTERNET EXPLORER</strong></p>\r\n                <br>\r\n\r\n                <p><a href="//windows.microsoft.com/en-us/internet-explorer/download-ie" id="btnUpdate" target="_blank">DOWNLOAD</a>\r\n                </p>\r\n                <br><br>\r\n            </center>\r\n        </div>\r\n        <div class="col-md-3">\r\n            <center>\r\n                <img src="assets/images/browsers/opera_logo.png"/>\r\n                <br><br>\r\n\r\n                <p><strong>OPERA</strong></p>\r\n                <br>\r\n\r\n                <p><a href="//www.opera.com/download" id="btnUpdate" target="_blank">DOWNLOAD</a></p>\r\n                <br><br>\r\n            </center>\r\n        </div>\r\n    </div>\r\n    <p id="btnClose"><a href>Close</a></p>--><!--</div>-->');
$templateCache.put('app/admin/admin.html','<div id="wrapper"><div id="page-wrapper" ui-view></div></div>');
$templateCache.put('app/admin/footer.html','');
$templateCache.put('app/admin/header.html','<nav class="navbar navbar-default navbar-cg-hardware-admin navbar-fixed-top" role="navigation" style="margin-bottom: 0"><div class="navbar-header"><button type="button" class="navbar-toggle" data-toggle="collapse" data-target=".navbar-collapse"><span class="sr-only">Toggle navigation</span> <span class="icon-bar"></span> <span class="icon-bar"></span> <span class="icon-bar"></span></button> <a class="navbar-brand navbar-brand-cg" ui-sref="loja.home({id:\'inicio\'})" href><img ng-src="{{getLogo()}}" width="150" height="auto" alt="Logo"></a></div><ul class="nav navbar-nav navbar-right collapse navbar-collapse"><li><a ui-sref="loja.home({id:\'inicio\'})" target="_blank"><i class="fa fa-home fa-fw"></i> {{\'MENU_TOP_HOME\' | translate}}</a></li><li class="dropdown"><a class="dropdown-toggle" data-toggle="dropdown" href="#"><i class="fa fa-user fa-fw"></i> {{user.name}} <i class="fa fa-caret-down"></i></a><ul class="dropdown-menu" role="menu"><li ng-class="{active: $state.includes(\'user.perfil.mostra\')}"><a ui-sref="loja.perfil.mostra"><i class="fa fa-edit fa-fw"></i> {{\'MENU_TOP_USER_PERFIL\' | translate}}</a></li><li ng-class="{active: $state.includes(\'user.documentos\')}"><a ui-sref="loja.documentos"><i class="fa fa-archive fa-fw"></i> {{\'MENU_TOP_USER_DOCS\' | translate}}</a></li><li class="divider"></li><li><a ui-sref="logout"><i class="fa fa-sign-out fa-fw"></i> {{\'MENU_TOP_USER_LOGOUT\' | translate}}</a></li></ul></li></ul><div class="navbar-default sidebar"><div class="sidebar-nav collapse navbar-collapse"><ul class="nav" id="side-menu"><li><a href ng-class="{active: $state.includes(\'admin.config\')}" ui-sref="admin.config"><i class="fa fa-cogs fa-fw"></i> {{\'MENU_ADMIN_CONF\' | translate}}</a></li><li><a href ng-class="{active: $state.includes(\'admin.sincronizacao\')}" ui-sref="admin.sincronizacao"><i class="fa fa-refresh fa-fw"></i> {{\'MENU_ADMIN_SYNC\' | translate}}</a></li><li><a href ng-class="{active: $state.includes(\'admin.clientes\')}" ui-sref="admin.clientes"><i class="fa fa-group fa-fw"></i> {{\'MENU_ADMIN_CLIENTS\' | translate}}</a></li><li><a href ng-class="{active: $state.includes(\'admin.documentos\')}" ui-sref="admin.documentos"><i class="fa fa-archive fa-fw"></i> {{\'MENU_ADMIN_DOCS\' | translate}}</a></li><li><a href ng-class="{active: $state.includes(\'admin.paginas\')}" ui-sref="admin.paginas.list"><i class="fa fa-file fa-fw"></i> {{\'MENU_ADMIN_PAGINAS\' | translate}}</a></li><li><a href ng-class="{active: $state.includes(\'admin.menu\')}" ui-sref="admin.menu"><i class="fa fa-reorder fa-fw"></i> {{\'MENU_ADMIN_MENU\' | translate}}</a></li><li><a href ng-class="{active: $state.includes(\'admin.utilizadores\')}" ui-sref="admin.utilizadores.list"><i class="fa fa-user fa-fw"></i> {{\'MENU_ADMIN_USERS\' | translate}}</a></li><li><a href ng-class="{active: $state.includes(\'admin.modelos\')}" ui-sref="admin.modelos"><i class="fa fa-file-text fa-fw"></i> {{\'MENU_ADMIN_MODELOS\' | translate}}</a></li><li><a href ng-class="{active: $state.includes(\'admin.imagens\')}" ui-sref="admin.imagens.lista"><i class="fa fa-picture-o fa-fw"></i> {{\'MENU_ADMIN_IMAGENS\' | translate}}</a></li></ul></div></div></nav>');
$templateCache.put('app/cookie-bar/cookiebar.html','<div><div class="cookies-bar" ng-init="init()" ng-show="showCookieConsent()"><div><span class="cookies-bar-text">{{bodyText}} <a href ng-click="openPolicyPanel()">{{moreText}}.&nbsp;</a> </span><span class="cookies-bar-button"><button type="button" class="btn btn-primary-cg btn-xs cookies-bar-button-text" href ng-click="closePanel()">OK</button> </span><!--<a href ng-click="closePanel()">{{closeText}}</a>--><!--<a class="cookies-bar-close pull-right" href ng-click="closePanel()">&times;</a>--> <input type="hidden" ng-model="cookieVar"></div></div><div><script type="text/ng-template" id="policyContent.html"><div class="modal-header">\r\n                <h3 class="modal-title">Cookies</h3>\r\n            </div>\r\n\r\n            <div class="modal-body" style="margin: 20px;">\r\n                <h2>Cookies</h2>\r\n\r\n                <p>\r\n                    Cookies s\xE3o ficheiros que s\xE3o gravados no seu computador que t\xEAm como \xFAnico objectivo simplificar a\r\n                    sua navega\xE7\xE3o neste site\r\n                    (estes cookies n\xE3o podem conter v\xEDrus nem ser executados, pois n\xE3o s\xE3o ficheiros activos).\r\n                </p>\r\n\r\n                <h3>O que \xE9 um cookie?</h3>\r\n\r\n                <p>\r\n                    \u201CCookies\u201D s\xE3o pequenas etiquetas de software que s\xE3o armazenadas no seu computador atrav\xE9s do\r\n                    navegador (browser),\r\n                    retendo apenas informa\xE7\xE3o relacionada com as suas prefer\xEAncias, n\xE3o incluindo, como tal, os seus\r\n                    dados pessoais.</p>\r\n\r\n                <h3>Para que servem os Cookies?</h3>\r\n\r\n                <p>\r\n                    Os cookies servem para ajudar a determinar a utilidade, interesse e o n\xFAmero de utiliza\xE7\xF5es dos seus\r\n                    websites,\r\n                    permitindo uma navega\xE7\xE3o mais r\xE1pida e eficiente, eliminando a necessidade de introduzir\r\n                    repetidamente as mesmas informa\xE7\xF5es.\r\n                </p>\r\n\r\n\r\n                <h3>Que tipo de cookies utilizamos?</h3>\r\n                Existem dois grupos cookies que podem ser utilizados:<br>\r\n                <strong>Cookies permanentes</strong> - s\xE3o cookies que ficam armazenados ao n\xEDvel do browser nos seus\r\n                equipamentos de acesso (pc, mobile e tablet) e que s\xE3o utilizados sempre que faz uma nova visita a um\r\n                dos nossos websites. S\xE3o utilizados, geralmente, para direcionar a navega\xE7\xE3o aos interesses do\r\n                utilizador, permitindo-nos prestar um servi\xE7o mais personalizado.<br>\r\n                <strong>Cookies de sess\xE3o</strong> - s\xE3o cookies tempor\xE1rios que permanecem no arquivo de cookies do seu\r\n                browser at\xE9 sair do website. A informa\xE7\xE3o obtida por estes cookies serve para analisar padr\xF5es de\r\n                tr\xE1fego na web, permitindo-nos identificar problemas e fornecer uma melhor experiencia de navega\xE7\xE3o.\r\n                De seguida, indicamos os tipos de cookies existentes:<br>\r\n                <strong>- Cookies estritamente necess\xE1rios</strong>\r\n                Permitem que navegue no website e utilize as suas aplica\xE7\xF5es, bem como aceder a \xE1reas seguras do\r\n                website. Sem estes cookies, os servi\xE7os que tenha requerido n\xE3o podem ser prestados;<br>\r\n                <strong>- Cookies Anal\xEDticos</strong>\r\n                S\xE3o utilizados anonimamente para efeitos de cria\xE7\xE3o e an\xE1lise de estat\xEDsticas, no sentido de\r\n                melhorar o funcionamento do website;<br>\r\n                <strong>- Cookies de Funcionalidade</strong>\r\n                Guardam as prefer\xEAncias do utilizador relativamente \xE0 utiliza\xE7\xE3o do site, de forma que n\xE3o seja\r\n                necess\xE1rio voltar a configurar o site cada vez que o visita;<br>\r\n                <strong>- Cookies de Terceiros</strong>\r\n                Medem o sucesso de aplica\xE7\xF5es e a efic\xE1cia da publicidade de terceiros. Podem tamb\xE9m ser utilizados\r\n                no sentido de personalizar um widget com dados do utilizador<br>\r\n                <strong>- Cookies de Publicidade</strong>\r\n                Direcionam a publicidade em fun\xE7\xE3o dos interesses de cada utilizador, sendo que, al\xE9m disso, limitam\r\n                a quantidade de vezes que v\xEA o an\xFAncio, ajudando a medir a efic\xE1cia da publicidade e o sucesso da\r\n                organiza\xE7\xE3o do website;<br>\r\n\r\n\r\n            </div>\r\n\r\n            <div class="modal-footer">\r\n                <button class="btn btn-primary" ng-click="close()">Fechar</button>\r\n            </div></script></div></div>');
$templateCache.put('app/erros/404.html','<div class="container content-margin-login"><div class="row"><div class="col-md-12"><div class="col-md-4 col-md-offset-4 text-center well"><!--<img ng-src="{{getLogo()}}" alt="Logo" />\r\n                <hr>--><h2><i class="fa fa-exclamation-triangle fa-2x fa-fw"></i><br>404</h2><!--  <h1></h1>--><p data-translate="NO_RESPONSE_404_INFO"></p><hr><button class="btn btn-primary-cg btn-block" ui-sref="loja.home({id:\'inicio\'})"><i class="fa fa-home fa-fw"></i> {{\'MENU_TOP_HOME\' | translate}}</button></div></div></div></div>');
$templateCache.put('app/erros/noresponse.html','<div class="container content-margin-login"><div class="row"><div class="col-md-12"><div class="col-md-4 col-md-offset-4 text-center"><img src="assets/images/ERPRetail-services-inv.png" alt="Logo"><hr><h2><i class="fa fa-exclamation-triangle fa-2x fa-fw"></i><br>503</h2><p>Sem resposta no servidor</p><hr><button class="btn btn-cg btn-block" ng-click="goBack()"><i class="fa fa-refresh fa-fw"></i> {{\'NO_RESPONSE_RETRY\' | translate}}</button></div></div></div></div>');
$templateCache.put('app/loja/footer.html','<!-- FOOTER ---><!--<footer>--><div class="footer footer-menu"><div class="container" ng-cloak><div class="row"><div class="col-xs-12 col-sm-3 col-md-3 col-lg-3"><h4 class="text-uppercase" data-translate="MENU_FOOTER_TITLE_STORE"></h4><!--<div class="page-header-cg"></div>--><ul class="list-unstyled" ng-cloak><li><a ui-sref="loja.home({id:\'inicio\'})" data-translate="MENU_TOP_HOME"></a></li><li><a ui-sref="loja.produtos.box" data-translate="MENU_TOP_STORE"></a></li><li><a ui-sref="loja.carrinho" data-translate="MENU_TOP_CART"></a></li></ul></div><div class="col-xs-12 col-sm-3 col-md-3 col-lg-3"><h4 class="text-uppercase" data-translate="MENU_FOOTER_TITLE_ACCOUNT"></h4><!--<div class="page-header-cg"></div>--><ul class="list-unstyled"><li><a ui-sref="login" data-translate="LOGIN"></a></li><li><a ui-sref="signup" data-translate="LOGIN_SIGNUP"></a></li><li ng-show="isLoggedIn"><a ui-sref="loja.perfil.mostra" data-translate="MENU_TOP_USER_PERFIL"></a></li><li ng-show="isLoggedIn"><a ui-sref="loja.documentos" data-translate="MENU_TOP_USER_DOCS"></a></li></ul></div><div class="col-xs-12 col-sm-3 col-md-3 col-lg-3"><h4 class="text-uppercase" data-translate="MENU_FOOTER_TITLE_COMPANY"></h4><!--<div class="page-header-cg"></div>--><ul class="list-unstyled"><!--<li><a class="text-primary" href>Sobre n\xF3s</a></li>--><li ng-show="$config.data.pages.contactos"><a href ui-sref="loja.home({id:\'contactos\'})" data-translate="MENU_TOP_CONTACTS"></a></li><li ng-show="$config.data.pages.termos"><a href ui-sref="loja.home({id:\'termos\'})">Termos e condi\xE7\xF5es</a></li></ul></div><div class="col-xs-12 col-sm-3 col-md-3 col-lg-3" ng-show="$config.data.social.facebook || $config.data.social.twitter || $config.data.social.googleplus || $config.data.social.linkedin || $config.data.social.youtube ||  $config.data.social.instagram"><h4 class="text-uppercase" data-translate="MENU_FOOTER_TITLE_SOCIAL"></h4><!--<div class="page-header-cg"></div>--><p class="font-social"><a class="icon-f" ng-show="$config.data.social.facebook" href="{{ $config.data.social.facebook }}"><i class="fa fa-facebook-square"></i> </a><a class="icon-t" ng-show="$config.data.social.twitter" href="{{ $config.data.social.twitter }}"><i class="fa fa-twitter-square"></i> </a><a class="icon-g" ng-show="$config.data.social.googleplus" href="{{ $config.data.social.googleplus }}"><i class="fa fa-google-plus-square"></i> </a><a class="icon-l" ng-show="$config.data.social.linkedin" href="{{ $config.data.social.linkedin }}"><i class="fa fa-linkedin-square"></i> </a><a class="icon-y" ng-show="$config.data.social.youtube" href="{{ $config.data.social.youtube }}"><i class="fa fa-youtube-square"></i> </a><a class="text-primary" ng-show="$config.data.social.instagram" href="{{ $config.data.social.instagram }}"><i class="fa fa-instagram"></i></a></p></div></div></div></div><div class="trademark-wrapper"><div class="container"><p class="trademark hidden-xs"><span class="pull-left">Powered by: <a href="http://www.centralgest.com" target="_blank">CentralGest</a> </span><span class="pull-right">\xA9 {{getDatetime | date:\'yyyy\'}} {{$config.data.siteName}} \xB7 Todos os direitos reservados</span><br></p><div class="hidden-sm hidden-md hidden-lg">Powered by: <a href="http://www.centralgest.com" target="_blank">CentralGest</a><br>\xA9 {{getDatetime | date:\'yyyy\'}} {{$config.data.siteName}} \xB7 Todos os direitos reservados</div></div></div><!--</footer>--><!-- FOOTER --->');
$templateCache.put('app/loja/header.html','<site-menu logo="getLogo()" menu="$config.data.menu"></site-menu>');
$templateCache.put('app/loja/index.html','<!-- CONTENT --><div id="content-ui-view" ui-view></div><div compile="$config.data.modelos.footer"></div><!-- CONTENT -->');
$templateCache.put('app/account/confirma_email/confirma_email.html','<div class="container content-margin"><div class="row"><div class="col-md-12"><div class="col-md-4 col-md-offset-4 well well-large"><center><img ng-src="{{getLogoLogin()}}" alt="Logo" width="150" height="41"></center><h2 class="page-header text-center" data-translate="LOGIN_SEND_CONFIRMATION_TITLE"></h2><p class="text-center"><i class="fa fa-send fa-fw fa-5x"></i></p><h4 class="text-center" data-translate="{{email.state}}"></h4><h4 class="text-primary text-center">{{email.email}}</h4><div class="page-header-cg" ng-hide="email.state==\'LOGIN_EMAIL_SENDING\'"></div><button class="btn btn-primary-cg btn-lg btn-block" ng-click="enviar()" ng-hide="email.state===\'LOGIN_EMAIL_SENDING\'" data-translate="LOGIN_SEND_CONFIRMATION_MAIL"></button> <button ui-sref="loja.home({id:\'inicio\'})" class="btn btn-default btn-lg btn-block btn-register" data-translate="BUTTON_BACK"></button></div></div></div></div>');
$templateCache.put('app/account/confirma_token/confirma_token.html','<div class="container content-margin"><div class="row"><div class="col-md-12"><div class="col-md-4 col-md-offset-4 well well-large"><h2 class="page-header text-center" data-translate="EMAIL_TOKEN_VALIDATE"></h2><div class="text-center"><span ng-show="ctrl.state==\'LOGIN_TOKEN_WAIT\'"><i class="fa fa-spinner fa-spin fa-fw fa-5x"></i> </span><span ng-show="ctrl.state==\'LOGIN_TOKEN_NOT_FOUND\'"><i class="fa fa-warning fa-fw fa-5x text-danger"></i></span></div><div class="text-center" ng-class="{\'text-danger\':ctrl.notOk(), \'text-success\':ctrl.state==\'LOGIN_TOKEN_OK\' }"><strong data-translate="EMAIL_TOKEN_VALIDATE_STATE"></strong><span data-translate="{{ctrl.state}}"></span><div class="page-header-cg" ng-show="ctrl.notOk() || ctrl.state==\'LOGIN_TOKEN_EXPIRED\'"></div><div ng-if="ctrl.enableSignUp"><button ng-show="ctrl.notOk()" ui-sref="signup" class="btn btn-primary-cg btn-lg btn-block btn-register" data-translate="LOGIN_SIGNUP"></button></div><button ng-show="ctrl.state==\'LOGIN_TOKEN_EXPIRED\'" class="btn btn-primary btn-lg btn-block" ng-click="ctrl.enviar()" data-translate="LOGIN_SEND_CONFIRMATION_MAIL"></button></div></div></div></div></div>');
$templateCache.put('app/account/disconnected/disconnected.html','<div compile="$ctrl.$config.data.modelos.disconnected"></div>');
$templateCache.put('app/account/login/login.html','<div class="container content-margin-login"><div class="row"><div class="col-md-4 col-md-offset-4 well well-large"><div class="text-center"><img ng-src="{{getLogoLogin()}}" alt="Logo" width="169" height="41"></div><h2 class="page-header"><span data-translate="LOGIN"></span> <span class="pull-right"><i class="fa fa-lock fa-fw"></i></span></h2><form class="form" name="ctrl.formlogin" novalidate angular-validator angular-validator-submit="ctrl.login(ctrl.formlogin.$valid)"><div class="form-group"><div class="icon-addon addon-lg"><input type="email" id="email" class="form-control login-inputs" name="email" ng-model="ctrl.user.email" invalid-message="\'{{\'LOGIN_ERROR_EMAIL_INVALID\' | translate}}\'" required-message="\'{{\'LOGIN_ERROR_EMAIL_REQUIRED\' | translate}}\'" required translate-attr="{\'placeholder\': \'LOGIN_PLACEHOLDER_EMAIL\'}"> <label for="email" class="fa fa-envelope fa-fw"></label></div><div class="icon-addon addon-lg"><input type="password" id="password" class="form-control login-inputs" name="password" ng-model="ctrl.user.password" validator="ctrl.passwordValidator(ctrl.user.password) === true" invalid-message="\'{{\'LOGIN_ERROR_PASS_INVALID\' | translate}}\'" required-message="\'{{\'LOGIN_ERROR_PASS_REQUIRED\' | translate}}\'" required translate-attr="{\'placeholder\': \'LOGIN_PLACEHOLDER_PASS\'}"> <label for="password" class="fa fa-key fa-fw"></label></div></div><div class="helper-block"><p data-translate="{{ctrl.errors.other}}"></p><a href ng-click="ctrl.confirmaEmail()" data-translate="{{ctrl.errors.sendemail}}"></a></div><p><a href ui-sref="user.recover_email({ReturnState: ctrl.params.ReturnState, Params: ctrl.params.Params})" data-translate="LOGIN_PASS_RECOVER_TEXT"></a></p><button class="btn btn-primary-cg btn-lg btn-block btn-login" type="submit" pl-promise="ctrl.promise"><i class="fa fa-sign-in"></i><span data-translate="LOGIN"></span></button><div ng-if="ctrl.enableSignUp"><div class="text-center" data-translate="LOGIN_TEXT_BETWEEN_BUTTONS"></div><button ui-sref="signup" class="btn btn-lg btn-default btn-block btn-register" ng-class="{\'disabled\': ctrl.disableSignUp}" data-translate="LOGIN_SIGNUP" translate-attr="{\'title\': \'LOGIN_SIGNUP_DISABLED\'}" tabindex="0" role="tooltip" data-toggle="tooltip" data-placement="bottom"></button></div></form></div><br><div class="col-md-4 col-md-offset-4"><p class="text-center"><a ui-sref="loja.home({id:\'inicio\'})">Voltar \xE0 p\xE1gina home</a></p></div></div></div>');
$templateCache.put('app/account/nova_palavra_passe/nova_palavra_passe.html','<div class="container content-margin-login"><div class="row"><div class="col-md-12"><div class="col-md-4 col-md-offset-4 well well-large"><center><img ng-src="{{getLogoLogin()}}" alt="Logo" width="150" height="41"></center><form class="form" name="formnova" novalidate angular-validator angular-validator-submit="novaPassword(formnova)" ng-show="ok()"><h3 class="page-header" data-translate="LOGIN_PASS_NEW_TITLE"></h3><div class="icon-addon addon-lg"><input type="password" name="password" placeholder="{{\'LOGIN_PLACEHOLDER_NEW_PASS\' | translate}}" class="form-control login-inputs" id="password" ng-model="password" validator="passwordValidator(password) === true" invalid-message="passwordValidator(password) | translate" required-message="\'{{\'LOGIN_ERROR_PASS_REQUIRED\' | translate}}\'" required> <label for="password" class="fa fa-key fa-fw" rel="tooltip" title="password"></label></div><div class="icon-addon addon-lg"><input type="password" name="password_repeat" placeholder="{{\'LOGIN_SIGNUP_PLACEHOLDER_REPEAT_PASS\' | translate}}" class="form-control login-inputs" id="password_repeat" ng-model="form.confirmPassword" validator="password === form.confirmPassword" invalid-message="\'{{\'LOGIN_SIGNUP_PASS_REPEAT_VALIDATION\' | translate}}\'" required-message="\'{{\'LOGIN_SIGNUP_PASS_REPEAT_REQUIRED\' | translate}}\'" required> <label for="password_repeat" class="fa fa-repeat fa-fw" rel="tooltip" title="password_repeat"></label></div><br><button class="btn btn-primary-cg btn-lg btn-block" type="submit" translate>LOGIN_NEW_PASS_BUTTON</button></form><div class="text-center" ng-hide="ok()"><hr><span data-translate="LOGIN_TOKEN_RECOVER_NOT_OK"></span></div></div></div></div></div>');
$templateCache.put('app/account/recuperar/recuperar.html','<div class="container content-margin-login"><div class="row"><div class="col-md-12"><div class="col-md-4 col-md-offset-4 well well-large"><div class="text-center"><img ng-src="{{getLogoLogin()}}" alt="Logo" width="150" height="41"></div><form class="form" name="formlogin" novalidate angular-validator angular-validator-submit="$ctrl.recuperar(formlogin)"><h3 class="page-header"><span data-translate="LOGIN_PASS_RECOVER_TITLE"></span> <span class="pull-right"><i class="fa fa-key fa-fw"></i></span></h3><label data-translate="LOGIN_PASS_RECOVER_LABEL"></label><div class="icon-addon addon-lg"><input id="email" type="email" class="form-control login-inputs" name="email" ng-model="email" translate-attr="{placeholder: \'LOGIN_PLACEHOLDER_EMAIL\'}" invalid-message="\'{{\'LOGIN_ERROR_EMAIL_INVALID\' | translate}}\'" required-message="\'{{\'LOGIN_ERROR_EMAIL_REQUIRED\' | translate}}\'" required> <label for="email" class="fa fa-envelope fa-fw" rel="tooltip" title="email"></label></div><br><button type="submit" class="btn btn-primary-cg btn-lg btn-block" data-translate="LOGIN_RECOVER_MAIL" pl-promise="$ctrl.promise"></button><div class="text-center" data-translate="LOGIN_TEXT_BETWEEN_BUTTONS"></div><button ui-sref="login({ReturnState: $ctrl.params.ReturnState, Params: $ctrl.params.Params})" class="btn btn-default btn-lg btn-block" data-translate="LOGIN_SIGNUP_CANCEL"></button></form></div></div></div></div>');
$templateCache.put('app/account/signup/signup.html','<div class="container content-margin-login"><div class="row"><div class="col-md-12"><div class="col-md-4 col-md-offset-4 well well-large"><center><img ng-src="{{getLogoLogin()}}" alt="Logo" width="150" height="41"></center><h2 class="page-header"><span data-translate="LOGIN_SIGNUP"></span> <span class="pull-right"><i class="fa fa-lock fa-fw"></i></span></h2><form class="form" name="formSignUp" novalidate angular-validator angular-validator-submit="register(formSignUp)"><div class="form-group"><div class="icon-addon addon-lg"><input type="text" name="username" placeholder="{{\'LOGIN_SIGNUP_PLACEHOLDER_NAME\' | translate}}" class="form-control login-inputs" id="username" ng-model="user.name" required-message="\'{{\'LOGIN_SIGNUP_USER_REQUIRED\' | translate}}\'" required> <label for="username" class="fa fa-user fa-fw" rel="tooltip" title="username"></label></div><div class="icon-addon addon-lg"><input type="email" name="email" placeholder="{{\'LOGIN_PLACEHOLDER_EMAIL\' | translate}}" class="form-control login-inputs" id="email" ng-model="user.email" invalid-message="\'{{\'LOGIN_ERROR_EMAIL_INVALID\' | translate}}\'" required-message="\'{{\'LOGIN_ERROR_EMAIL_REQUIRED\' | translate}}\'" required> <label for="email" class="fa fa-envelope fa-fw" rel="tooltip" title="email"></label></div><div class="icon-addon addon-lg"><input type="password" name="password" placeholder="{{\'LOGIN_PLACEHOLDER_PASS\' | translate}}" class="form-control login-inputs" id="password" ng-model="user.password" validator="passwordValidator(user.password) === true" invalid-message="passwordValidator(user.password) | translate" required-message="\'{{\'LOGIN_ERROR_PASS_REQUIRED\' | translate}}\'" required> <label for="password" class="fa fa-key fa-fw" rel="tooltip" title="password"></label></div><div class="icon-addon addon-lg"><input type="password" name="password_repeat" placeholder="{{\'LOGIN_SIGNUP_PLACEHOLDER_REPEAT_PASS\' | translate}}" class="form-control login-inputs" id="password_repeat" ng-model="form.confirmPassword" validator="user.password === form.confirmPassword" invalid-message="\'{{\'LOGIN_SIGNUP_PASS_REPEAT_VALIDATION\' | translate}}\'" required-message="\'{{\'LOGIN_SIGNUP_PASS_REPEAT_REQUIRED\' | translate}}\'" required> <label for="password_repeat" class="fa fa-repeat fa-fw" rel="tooltip" title="password_repeat"></label></div><p ng-show="form.email.$error.mongoose">{{ errors.email }}</p><p class="help-block" ng-show="form.password.$error.mongoose">{{ errors.password }}</p></div><div><button class="btn btn-primary-cg btn-lg btn-block btn-login" type="submit">{{\'LOGIN_SIGNUP\' | translate}}</button> <button ui-sref="loja.home({id:\'inicio\'})" class="btn btn-default btn-lg btn-block btn-register">{{\'BUTTON_BACK\' | translate}}</button></div></form></div></div></div></div>');
$templateCache.put('app/admin/clientes/clientes.html','<h3 class="page-header-cg">{{$state.current.title}}</h3><form class="col-md-3 pull-right search-position-admin hidden-xs hidden-sm" role="search"><div class="form-group"><div class="input-group input-group-sm"><input type="text" class="form-control" placeholder="{{\'PLACEHOLDER_SEARCH\' | translate}}" ng-model="ctrl.searchText" ng-change="ctrl.updateFiltered()"> <span class="input-group-addon"><span class="glyphicon glyphicon-search"></span></span></div></div></form><table at-table at-paginated at-list="ctrl.filteredList" at-config="ctrl.configClientes" class="table table-striped table-responsive table-condensed table-bordered"><thead></thead><tbody><tr><td at-implicit at-attribute="tipo" at-sortable at-title="{{\'CLIENTS_TABLE_TH_TYPE\' | translate}}"></td><td at-implicit at-attribute="nconta" at-sortable at-title="{{\'CLIENTS_TABLE_TH_ACCOUNT\' | translate}}"></td><td at-implicit at-attribute="nome" at-sortable at-initial-sorting="asc" at-title="{{\'CLIENTS_TABLE_TH_NAME\' | translate}}"></td><td at-implicit at-attribute="localidade" at-sortable at-title="{{\'CLIENTS_TABLE_TH_LOCAL\' | translate}}"></td><td at-implicit at-attribute="email" at-sortable at-title="{{\'CLIENTS_TABLE_TH_EMAIL\' | translate}}"></td><td at-implicit at-attribute="telefone" at-sortable at-title="{{\'CLIENTS_TABLE_TH_PHONE\' | translate}}"></td><td at-implicit at-attribute="telemovel" at-sortable at-title="{{\'CLIENTS_TABLE_TH_MOBILE\' | translate}}"></td></tr></tbody></table><at-pagination at-list="ctrl.filteredList" at-config="ctrl.configClientes"></at-pagination>');
$templateCache.put('app/admin/config/config.classificadores.html','<div class="widget-cg widget-config"><div class="table-responsive"><table class="table table-hover" ui-tree="$ctrl.options"><thead><tr><td>Ordenar</td><td>Nome</td><td>Propriedades</td></tr></thead><tbody ui-tree-nodes ng-model="$ctrl.classificadoresList"><tr ui-tree-node ng-repeat="item in $ctrl.classificadoresList"><td><i class="glyphicon glyphicon-resize-vertical" ui-tree-handle></i></td><td><pl-inline-edit type="text" ng-model="item.caption" on-validate="$ctrl.save"></pl-inline-edit><span>{{\'(\' + item.tipo + \')\'}}</span></td><td><pl-button class="btn-primary" on-click="$ctrl.editProperties(item)" text="Editar propriedades"></pl-button></td></tr></tbody></table></div></div>');
$templateCache.put('app/admin/config/config.classificadores.properties.html','<div class="modal-header"><button type="button" class="close" ng-click="$ctrl.$dismiss()"><span aria-hidden="true">&times; </span><span class="sr-only" data-translate="BUTTON_CLOSE"></span></button><h3 class="modal-title"><span data-translate="MENU_TOP_CLASSIFIER"></span> <strong>{{$ctrl.item.caption}}</strong> ({{$ctrl.item.tipo}})</h3></div><div class="modal-body"><div class="table-responsive"><table class="table table-hover"><thead><tr><td></td><td data-translate="MENU_TOP_STORE"></td><td data-translate="MENU_TOP_CLASSIFIERS"></td></tr></thead><tbody><tr ng-repeat="property in $ctrl.properties"><td data-translate="{{property.caption}}"></td><td><pl-edit type="{{property.type}}" ng-model="$ctrl.item[property.name]"></pl-edit></td><td><pl-edit type="{{property.type}}" ng-model="$ctrl.item[property.name + \'Classificadores\']"></pl-edit></td></tr></tbody></table></div></div><div class="modal-footer"><button class="btn btn-primary-cg" ng-click="$ctrl.doSave()" pl-promise><i class="fa fa-save fa-fw"></i>&nbsp;<span data-translate="BUTTON_SAVE"></span></button> <button class="btn btn-default" ng-click="$ctrl.$dismiss()"><i class="fa fa-remove fa-fw"></i>&nbsp;<span data-translate="BUTTON_CANCEL"></span></button></div>');
$templateCache.put('app/admin/config/config.condicoespagamento.html','<!--{{ $ctrl.condicoesPagamentoList|json}}--><!--{{ $ctrl.pagamList|json}}--><div class="widget-cg widget-config"><div class="table-responsive"><table class="table table-hover" ui-tree="$ctrl.optionsCondicoesPagamento"><thead><tr><td>Ordenar</td><td>Descri\xE7\xE3o</td><td>D</td><td>Taxa</td><td>Vis\xEDvel</td></tr></thead><tbody ui-tree-nodes ng-model="$ctrl.condicoesPagamentoList"><tr ui-tree-node ng-repeat="item in $ctrl.condicoesPagamentoList"><td><i class="glyphicon glyphicon-resize-vertical" ui-tree-handle></i></td><td>{{item.descricao}}</td><td><pl-inline-edit type="number" properties="{decimalsLimit: 0}" ng-model="item.d" on-validate="$ctrl.saveCondicoesPagamento"></pl-inline-edit></td><td><pl-inline-edit type="number" ng-model="item.taxa" on-validate="$ctrl.saveCondicoesPagamento"></pl-inline-edit></td><td><pl-edit type="boolean" ng-model="item.visible" ng-change="$ctrl.saveCondicoesPagamento()"></pl-edit><!--<pl-inline-edit type="boolean" ng-model="item.visible" on-validate="$ctrl.saveCondicoesPagamento" </pl-inline-edit>--></td></tr></tbody></table></div></div>');
$templateCache.put('app/admin/config/config.email.html','<div class="form-horizontal"><config-value item="$ctrl.config.siteEmailSender" configid="\'site.email.sender\'" label="Email de envio"></config-value><config-value item="$ctrl.config.siteEmailContact" configid="\'site.email.contact\'" label="Email de contato"></config-value><config-value item="$ctrl.config.siteEmailContactSubject" configid="\'site.email.contact.subject\'" label="Assunto"></config-value><config-value item="$ctrl.config.siteEmailError" configid="\'site.email.error\'" label="Email de erro"></config-value><div class="col-md-2"></div><button class="btn btn-primary-cg" ng-click="$ctrl.sendEmail()"><i class="fa fa-send fa-fw"></i> Email de Teste</button><hr></div>');
$templateCache.put('app/admin/config/config.erp.html','<div class="form form-horizontal"><div class="form-group"><a href class="btn btn-primary-cg btn-sm" ng-click="$ctrl.saveErp()"><i class="fa fa-save fa-fw"></i>&nbsp;<span data-translate="BUTTON_SAVE"></span></a></div><div class="form-group"><label class="col-md-2 control-label">Tipo Servidor ERP:</label><div class="col-md-8"><select class="form-control" ng-model="$ctrl.erpSyncMethod"><option value="ERP">ERP</option><option value="ERPRest">ERP Rest</option></select></div></div><div ng-hide="$ctrl.erpSyncMethod != \'ERP\'"><div class="form-group"><label class="col-sm-2 control-label">Ip do servidor (aplicacional)</label><div class="col-sm-8"><input type="text" class="form-control" ng-model="$ctrl.config.siteServerName"></div></div><div class="form-group"><label class="col-sm-2 control-label">N\xBA do porto</label><div class="col-sm-8"><input type="text" class="form-control" ng-model="$ctrl.config.siteServerPort"></div></div></div><div ng-hide="$ctrl.erpSyncMethod != \'ERPRest\'"><div class="form-group"><label class="col-sm-2 control-label">URL do Servidor Rest ERP</label><div class="col-sm-8"><input type="text" class="form-control" ng-model="$ctrl.config.siteERPServerURL"></div></div><div class="form-group"><label class="col-sm-2 control-label">ERP Token (CentralGest)</label><div class="col-sm-8"><textarea class="form-control" ng-model="$ctrl.config.ErpRestToken" rows="4">\r\n        </textarea></div></div></div></div>');
$templateCache.put('app/admin/config/config.estado.html','<div class="row"><div class="col-md-10"><dl class="dl-horizontal"><dt data-translate="INFO_INSTALLED_VERSION"></dt><dd>{{$ctrl.getValueOf(\'ApplicationInfo.version\')}} - {{$ctrl.getValueOf(\'ApplicationInfo.date\')}}</dd><dt data-translate="INFO_DB_USER"></dt><dd>{{$ctrl.info.dbUserName}}</dd><dt data-translate="INFO_DB_NAME"></dt><dd>{{$ctrl.info.dbName}}</dd><dt data-translate="INFO_DB_HOST"></dt><dd>{{$ctrl.info.dbHost}}</dd><dt data-translate="INFO_DB_NEMPRESA"></dt><dd>{{$ctrl.info.nEmpresa}}</dd><dt data-translate="INFO_DB_CTRL_STATE"></dt><dd>{{$ctrl.info.ctrlState}}</dd><dt data-translate="INFO_DB_VERSION"></dt><dd>{{$ctrl.info.dbVersion}}</dd><dt data-translate="INFO_DB_DOC_FAC"></dt><dd><i class="fa fa-check icon-success" ng-show="$ctrl.info.docfaStatus.result==0"></i> <i class="fa fa-stop icon-danger" ng-hide="$ctrl.info.docfaStatus.result==0"></i> {{$ctrl.info.docfaStatus.message}}</dd><dt data-translate="INFO_DB_CLIENT"></dt><dd><i class="fa fa-check icon-success" ng-show="$ctrl.info.clienteStatus.result==0"></i> <i class="fa fa-stop icon-danger" ng-hide="$ctrl.info.clienteStatus.result==0"></i> {{$ctrl.info.clienteStatus.message}}</dd><dt data-translate="INFO_PAGAMENTO"></dt><dd><i class="fa fa-check icon-success" ng-show="$ctrl.info.pagamentosStatus.result==0"></i> <i class="fa fa-stop icon-danger" ng-hide="$ctrl.info.pagamentosStatus.result==0"></i> {{$ctrl.info.pagamentosStatus.message}}</dd></dl></div><div class="col-md-2"><div class="pull-right"><i class="fa fa-info-circle info-icon-size text-primary"></i></div></div></div>');
$templateCache.put('app/admin/config/config.html','<h3 class="page-header-cg">{{$state.current.title}}</h3>{{ tabstate }}<pl-tabs><pl-tab ng-repeat="tab in $ctrl.tabs" caption="{{tab.header}}" active="tab.active" select="$ctrl.tabSelect(tab)"><div class="panel panel-admin panel-default"><div class="panel-body"><ng-include class="clearfix" src="tab.src"></ng-include></div></div></pl-tab></pl-tabs>');
$templateCache.put('app/admin/config/config.playvars.html','<div class="clearfix"><div class="row"><div class="col-xs-12 col-lg-3 pull-right"><form class="search-position-admin" role="search"><div class="form-group"><div class="input-group input-group-sm"><input type="text" class="form-control" ng-model="$ctrl.myFilter" ng-change="$ctrl.updateMyFilter()" translate-attr="{\'placeholder\': \'PLACEHOLDER_SEARCH\'}"> <span class="input-group-addon" ng-click="$ctrl.updateMyFilter()"><i class="fa fa-search fa-fw"></i></span></div></div></form></div><div class="col-xs-12 col-lg-9"><div class="table-responsive"><table class="table table-striped table-responsive table-bordered" at-table at-paginated at-list="$ctrl.playFiltered" at-config="$ctrl.config"><thead></thead><tbody><tr><td width="50%" at-implicit at-attribute="key" at-sortable at-initial-sorting="asc" at-title="{{\'CONFIG_TABLE_TH_NOME\' | translate}}"></td><td width="50%" at-implicit at-attribute="value" at-title="{{\'CONFIG_TABLE_TH_VALUE\' | translate}}"></td></tr></tbody></table><at-pagination at-list="$ctrl.playFiltered" at-config="$ctrl.config"></at-pagination></div></div></div></div>');
$templateCache.put('app/admin/config/config.site.html','<div class="form-horizontal"><config-value item="$ctrl.config.siteName" configid="\'site.name\'" label="Nome do site"></config-value><config-value item="$ctrl.config.siteLogo" configid="\'site.logo.url\'" label="URL da imagem (logo)"><button class="btn btn-primary-cg btn-sm" ng-click="$ctrl.getImage()"><i class="fa fa-image fa-fw"></i> Escolher Imagem</button></config-value><config-value item="$ctrl.config.loginLogo" configid="\'site.logo.login\'" label="URL da imagem (logo login)"><button class="btn btn-primary-cg btn-sm" ng-click="$ctrl.getImageLogin()"><i class="fa fa-image fa-fw"></i> Escolher Imagem</button></config-value><config-value item="$ctrl.config.sitefavicon" configid="\'site.favicon\'" label="Url do \xEDcone"><button class="btn btn-primary-cg btn-sm" ng-click="$ctrl.getFavicon()"><i class="fa fa-image fa-fw"></i> Escolher Imagem</button></config-value></div>');
$templateCache.put('app/admin/config/config.social.html','<div class="form-horizontal"><config-value item="$ctrl.config.social.facebook" configid="\'site.social.facebook\'" label="" icon="fa fa-facebook-square fa-2x fa-fw icon-f"></config-value><config-value item="$ctrl.config.social.googleplus" configid="\'site.social.googleplus\'" label="" icon="fa fa-google-plus-square fa-2x fa-fw icon-g"></config-value><config-value item="$ctrl.config.social.linkedin" configid="\'site.social.linkedin\'" label="" icon="fa fa-linkedin-square fa-2x fa-fw icon-l"></config-value><config-value item="$ctrl.config.social.twitter" configid="\'site.social.twitter\'" label="" icon="fa fa-twitter-square fa-2x fa-fw icon-t"></config-value><config-value item="$ctrl.config.social.youtube" configid="\'site.social.youtube\'" label="" icon="fa fa-youtube-square fa-2x fa-fw icon-y"></config-value><config-value item="$ctrl.config.social.instagram" configid="\'site.social.instagram\'" label="" icon="fa fa-instagram fa-2x fa-fw"></config-value></div>');
$templateCache.put('app/admin/config/config.transportadoras.html','<!--<pre>{{ $ctrl.transportadoraList|json}}</pre>--><!--{{ $ctrl.pagamList|json}}--><div class="widget-cg widget-config"><div class="table-responsive"><table class="table table-hover" ui-tree="$ctrl.optionsTransportadoras"><thead><tr><td>Ordenar</td><td>Descri\xE7\xE3o</td><td>Vis\xEDvel</td></tr></thead><tbody ui-tree-nodes ng-model="$ctrl.transportadoraList"><tr ui-tree-node ng-repeat="item in $ctrl.transportadoraList"><td><i class="glyphicon glyphicon-resize-vertical" ui-tree-handle></i></td><td>{{item.nome}}</td><td><pl-edit type="boolean" ng-model="item.visible" ng-change="$ctrl.saveTransportadora()"></pl-edit></td></tr></tbody></table></div></div>');
$templateCache.put('app/admin/config/config.value.html','<pl-group><label><i ng-class="ctrl.icon"></i>{{ctrl.label}}</label><edit><pl-inline-edit type="{{ctrl.type}}" ng-model="ctrl.item" ng-change="ctrl.updateItem(ctrl.configid, ctrl.item)" properties="{trueValue: 1, falseValue: 0}"></pl-inline-edit><div ng-transclude></div></edit></pl-group>');
$templateCache.put('app/admin/config/config.variaveis.html','<div class="clearfix" ng-controller="ConfigVariaveisController as $ctrl"><div class="row"><div class="col-xs-12 col-lg-3 pull-right"><form class="search-position-admin" role="search"><div class="form-group"><div class="input-group input-group-sm"><input type="text" class="form-control" ng-model="$ctrl.searchConfig" ng-change="$ctrl.updateFilteredList()" translate-attr="{\'placeholder\': \'PLACEHOLDER_SEARCH\'}"> <span class="input-group-addon" ng-click="$ctrl.updateFilteredList()"><i class="fa fa-search fa-fw"></i></span></div></div></form></div><div class="col-xs-12 col-lg-9"><div class="table-responsive"><table class="table table-striped table-responsive table-bordered" at-table at-paginated at-list="$ctrl.configlistFiltered" at-config="$ctrl.config"><thead></thead><tbody><tr><td width="50%" at-implicit at-attribute="configID" at-sortable at-initial-sorting="asc" at-title="{{\'CONFIG_TABLE_TH_NOME\' | translate}}"></td><td width="50%" at-attribute="value" at-title="{{\'CONFIG_TABLE_TH_VALUE\' | translate}}"><pl-inline-edit type="text" ng-model="item.value" on-validate="$ctrl.save" on-validate-target="item"></pl-inline-edit></td></tr></tbody></table><at-pagination at-list="$ctrl.configlistFiltered" at-config="$ctrl.config"></at-pagination></div></div></div></div>');
$templateCache.put('app/admin/documentos/documentos.html','<h3 class="page-header-cg">{{$state.current.title}}</h3><div class="row"><div class="col-md-12"><pl-table definition="ctrl.definition" selected="ctrl.model" source="ctrl.onLoad" callback="ctrl.callback" order="ctrl.definition.order" options="ctrl.definition.options" on-select="ctrl.onDocSelect" on-detail="ctrl.onDocDetail"><item-detail><documento source="item._thedoc" target-id="item.mbfaccbId" template="documento" evt-confirm-payment="item._ctrl.confirmedPayment(item, doc)"></documento></item-detail></pl-table></div></div>');
$templateCache.put('app/admin/home/homeedit.html','<h3 class="page-header-cg">{{$state.current.title}}</h3>');
$templateCache.put('app/admin/imagens/imagens.galeria.html','<form class="col-md-3 pull-right search-position-admin hidden-xs hidden-sm" role="search"><div class="form-group"><div class="input-group input-group-sm"><input type="text" class="form-control" placeholder="{{\'PLACEHOLDER_SEARCH\' | translate}}" ng-model="searchimages" ng-change="updateFilter()"> <span class="input-group-addon"><i class="fa fa-search fa-fw"></i></span></div></div></form><button class="btn btn-primary-cg btn-sm" ui-sref="^.upload"><i class="fa fa-upload fa-fw"></i> &nbsp;<span data-translate="IMAGE_UPLOAD"></span></button> <button class="btn btn-success btn-sm" ng-click="refresh()"><i class="fa fa-refresh"></i></button> <button class="btn btn-default btn-sm" ui-sref="^.lista"><i class="fa fa-th-list"></i></button><br><br><br><div class="row"><div class="galeria-admin" ng-repeat="item in filtered | offset: ((currentPage-1)*itemsPerPage) | limitTo: itemsPerPage "><div class="col-sm-12 col-lg-3 col-md-6 col-xs-12"><div class="thumbnail"><div class="thumb-box-parent"><div class="thumb-box-child"><img class="artimage_admin" fallback-src="http://www.placehold.it/100x100/EFEFEF/AAAAAA&text=sem+imagem" ng-src="{{getImagem(item)}}"></div></div><div class="caption-padding"><hr><div class="caption"><p><small><strong><a class="trim-info" href title="{{item.name}}">{{item.name}}</a></strong><br><strong>Data: </strong>{{item.lastModified | date:\'dd-MM-yyyy HH:mm:ss\'}}<br><strong>Tamanho: </strong>{{item.size / 1024 | number}} kb</small></p></div><div class="btn-group btn-group-justified"><div class="btn-group"><button class="btn btn-warning btn-sm" ng-click="showRename(item)"><i class="fa fa-edit fa-fw"></i>&nbsp;<span data-translate="BUTTON_EDIT"></span></button></div><div class="btn-group"><button class="btn btn-default btn-sm" ng-click="showImagem(item)"><i class="fa fa-trash fa-fw"></i>&nbsp;<span data-translate="IMAGE_DELETE"></span></button></div></div></div></div></div></div></div><div class="row"><pagination boundary-links="true" total-items="filtered.length" ng-model="currentPage" max-size="itemsPerPage" class="pagination pull-right pagination-margin" previous-text="&lsaquo;" next-text="&rsaquo;" first-text="&laquo;" last-text="&raquo;" ng-cloak></pagination></div>');
$templateCache.put('app/admin/imagens/imagens.html','<h3 class="page-header-cg">{{$state.current.title}}</h3><div ui-view></div>');
$templateCache.put('app/admin/imagens/imagens.list.html','<form class="col-md-3 pull-right search-position-admin hidden-xs hidden-sm" role="search"><div class="form-group"><div class="input-group input-group-sm"><input type="text" class="form-control" translate-attr="{\'placeholder\': \'PLACEHOLDER_SEARCH\'}" ng-model="searchimages" ng-change="updateFilter()"> <span class="input-group-addon"><i class="fa fa-search fa-fw"></i></span></div></div></form><button class="btn btn-primary-cg btn-sm" ui-sref="^.upload"><i class="fa fa-upload fa-fw"></i> {{\'IMAGE_UPLOAD\' | translate}}</button> <button class="btn btn-success btn-sm" ng-click="refresh()" title="Refrescar tabela"><i class="fa fa-refresh"></i></button> <button class="btn btn-default btn-sm" ui-sref="^.galeria" title="Galeria"><i class="fa fa-th-large"></i></button><table at-table at-paginated at-list="filtered" at-config="grid.config" class="table table-striped table-responsive table-condensed table-bordered"><thead></thead><tbody><tr><td width="10%" ng-click="showImagem(item)"><div class="text-center"><img class="imagens_wrapper" fallback-src="http://www.placehold.it/100x50/EFEFEF/AAAAAA&text=sem+imagem" ng-src="{{getImagem(item)}}"> <i class="fa fa-folder fa-fw" ng-show="item.type==\'folder\'"></i></div></td><td at-implicit at-attribute="name" at-sortable at-title="Nome"></td><td at-attribute="lastModified" at-sortable at-initial-sorting="desc" at-title="Data">{{item.lastModified | date:\'dd-MM-yyyy HH:mm:ss\'}}</td><td at-attribute="size" at-sortable at-title="Tamanho Kb"><span class="pull-right">{{item.size / 1024 | number}}</span></td><td width="2%"><a href ng-click="showRename(item)"><i class="fa fa-edit fa-fw icon-warning"></i></a></td><td width="2%"><a href ng-click="showImagem(item)"><i class="fa fa-trash fa-fw icon-danger"></i></a></td></tr></tbody></table><at-pagination at-list="filtered" at-config="grid.config"></at-pagination>');
$templateCache.put('app/admin/imagens/imagens.rename.html','<div class="modal-header"><button type="button" class="close" ng-click="cancel()"><span aria-hidden="true">&times;</span><span class="sr-only">Close</span></button><h3 class="modal-title">Editar: {{name}}</h3></div><div class="modal-body"><img class="imagens_modal_wrapper" fallback-src="http://www.placehold.it/350x150/EFEFEF/AAAAAA&text=sem+imagem" ng-src="{{getImagem()}}"><hr><div class="form-horizontal"><div class="form-group"><label class="col-sm-2 control-label">Nome</label><div class="col-sm-9"><input type="text" class="form-control" ng-model="name"></div></div></div></div><div class="modal-footer"><button class="btn btn-default btn-warning" ng-click="edit()">Editar</button> <button class="btn btn-default" ng-click="cancel()" data-translate="IMAGE_CLOSE"></button></div>');
$templateCache.put('app/admin/imagens/imagens.show.html','<div class="modal-header"><button type="button" class="close" ng-click="cancel()"><span aria-hidden="true">&times;</span><span class="sr-only">Close</span></button><h3 class="modal-title">{{item.name}}</h3></div><div class="modal-body"><center><img class="imagens_modal_wrapper" fallback-src="http://www.placehold.it/350x150/EFEFEF/AAAAAA&text=sem+imagem" ng-src="{{getImagem()}}"></center></div><div class="modal-footer"><button class="btn btn-default btn-danger" ng-click="delete()" data-translate="IMAGE_DELETE"></button> <button class="btn btn-default" ng-click="cancel()" data-translate="IMAGE_CLOSE"></button></div>');
$templateCache.put('app/admin/imagens/imagens.upload.html','<button class="btn btn-primary-cg btn-sm" ui-sref="^.lista"><i class="fa fa-list"></i> {{\'LISTA_IMAGENS\' | translate}}</button><div nv-file-drop="" uploader="uploader" filters="queueLimit, imageFilter"><div class="row"><div class="col-md-4"><h3 data-translate="SELECT_FILES"></h3><div ng-show="uploader.isHTML5"><!-- 3. nv-file-over uploader="link" over-class="className" --><div class="well my-drop-zone" nv-file-over="" uploader="uploader" data-translate="BASE_DROP_ZONE"></div></div><!-- Example: nv-file-select="" uploader="{Object}" options="{Object}" filters="{String}" --><!-- Multiple--><div class="fileUpload btn btn-default btn-sm"><!--<br/>--> <span><i class="fa fa-upload fa-fw"></i> Escolher ficheiros</span> <input type="file" class="upload" nv-file-select="" uploader="uploader" multiple="multiple"><br></div><!--<input type="file" nv-file-select="" uploader="uploader" multiple  />--><!--Single\r\n      <small>\r\n          <input type="file" nv-file-select="" uploader="uploader" />\r\n      </small>--></div><div class="col-md-8"><h3 data-translate="UPLOAD_QUEUE"></h3><p><span data-translate="UPLOAD_QUEUE_LENGTH"></span>: {{ uploader.queue.length }}</p><table class="table"><thead><tr><th width="30%" data-translate="IMAGE_UPLOAD_NAME"></th><th ng-show="uploader.isHTML5" data-translate="IMAGE_UPLOAD_SIZE"></th><th ng-show="uploader.isHTML5" data-translate="IMAGE_UPLOAD_PROGRESS"></th><th data-translate="IMAGE_UPLOAD_STATUS"></th><th data-translate="IMAGE_UPLOAD_ACTIONS"></th></tr></thead><tbody><tr ng-repeat="item in uploader.queue"><td><strong>{{ item.file.name }}</strong></td><td ng-show="uploader.isHTML5" nowrap="nowrap">{{ item.file.size/1024/1024|number:2 }} MB</td><td ng-show="uploader.isHTML5"><div class="progress" style="margin-bottom: 0;"><div class="progress-bar" role="progressbar" ng-style="{\'width\': item.progress + \'%\' }"></div></div></td><td class="text-center"><span ng-show="item.isSuccess"><i class="fa fa-check fa-fw icon-success"></i></span> <span ng-show="item.isCancel"><i class="fa fa-ban fa-fw icon-warning"></i></span> <span ng-show="item.isError"><i class="fa fa-trash-o fa-fw icon-danger"></i></span></td><td nowrap="nowrap"><button type="button" class="btn btn-success btn-xs" ng-click="item.upload()" ng-disabled="item.isReady || item.isUploading || item.isSuccess"><i class="fa fa-upload fa-fw"></i> Carregar</button> <button type="button" class="btn btn-warning btn-xs" ng-click="item.cancel()" ng-disabled="!item.isUploading"><i class="fa fa-ban fa-fw"></i> Cancelar</button> <button type="button" class="btn btn-danger btn-xs" ng-click="item.remove()"><i class="fa fa-trash-o fa-fw"></i> Apagar</button></td></tr></tbody></table><div><div><!--Queue progress:--><div class="progress" style=""><div class="progress-bar" role="progressbar" ng-style="{ \'width\': uploader.progress + \'%\' }"></div></div></div><button type="button" class="btn btn-success btn-sm" ng-click="uploader.uploadAll()" ng-disabled="!uploader.getNotUploadedItems().length"><i class="fa fa-upload"></i>&nbsp;<span data-translate="BTN_UPLOAD_ALL"></span></button> <button type="button" class="btn btn-warning btn-sm" ng-click="uploader.cancelAll()" ng-disabled="!uploader.isUploading"><i class="fa fa-ban"></i>&nbsp;<span data-translate="BTN_CANCEL_ALL"></span></button> <button type="button" class="btn btn-danger btn-sm" ng-click="uploader.clearQueue()" ng-disabled="!uploader.queue.length"><i class="fa fa-trash"></i>&nbsp;<span data-translate="BTN_REMOVE_ALL"></span></button></div></div></div></div>');
$templateCache.put('app/admin/menu/menu.edit.html','<div class="modal-header"><button type="button" class="close" ng-click="ctrl.cancel()"><span aria-hidden="true">&times; </span><span class="sr-only">Close</span></button><h3 class="modal-title">Editar Menu: {{ctrl.item.title}}</h3></div><div class="modal-body"><div class="form-horizontal"><div class="form-group"><label class="col-sm-2 control-label">Titulo</label><div class="col-sm-10"><input type="text" class="form-control" ng-model="ctrl.item.title"></div></div><div class="form-group"><label class="col-sm-2 control-label">Icon</label><div class="col-sm-10"><input class="form-control" rows="3" ng-model="ctrl.item.fontAwesome"></div></div><div class="form-group" ng-hide="ctrl.item.nodes !== \'\' && ctrl.item.nodes.length > 0"><label class="col-sm-2 control-label">Tipo</label><div class="col-sm-5"><select class="form-control" ng-model="ctrl.tipo" ng-change="ctrl.tipoChange()"><option value="paginas">P\xE1ginas</option><option value="sistema">P\xE1ginas de Sistema</option></select></div><div class="col-sm-5"><select class="form-control" ng-options="item.id as item.title for item in ctrl.tipos" ng-model="ctrl.item.pageId"></select></div></div></div></div><div class="modal-footer"><button class="btn btn-primary-cg" ng-click="ctrl.save()"><i class="fa fa-save fa-fw"></i>&nbsp;<span data-translate="BUTTON_SAVE"></span></button> <button class="btn btn-default" ng-click="ctrl.cancel()"><i class="fa fa-remove fa-fw"></i>&nbsp;<span data-translate="BUTTON_CANCEL"></span></button></div>');
$templateCache.put('app/admin/menu/menu.html','<script type="text/ng-template" id="nodes_renderer.html"><div ui-tree-handle class="tree-node tree-node-content clearfix">\r\n    <div class="pull-left">\r\n      <div class="btn-group btn-group-sm" role="group">\r\n        <button href class="btn btn-success" ng-if="node.nodes && node.nodes.length > 0"\r\n                data-nodrag ng-click="toggle()">\r\n          <i class="fa fa-chevron-right fa-fw" pl-animation-rotate="!collapsed"></i>\r\n        </button>\r\n      </div>\r\n\r\n      <i class="fa fa-fw" ng-class="node.fontAwesome"></i>&nbsp;<span>{{node.title}}</span>\r\n    </div>\r\n\r\n    <div class="cg-buttons pull-right">\r\n      <div class="btn-group btn-group-sm" role="group">\r\n        <button class="btn btn-primary" ng-click="ctrl.newSubItem(node)" ng-if="depth(this) < 2" data-nodrag>\r\n          <i class="fa fa-plus fa-fw"></i>\r\n        </button>\r\n\r\n        <button href class="btn btn-warning" ng-click="ctrl.edit(node)" data-nodrag>\r\n          <i class="fa fa-edit fa-fw"></i>\r\n        </button>\r\n\r\n        <button href class="btn btn-danger" ng-click="remove()" data-nodrag>\r\n          <i class="fa fa-trash fa-fw"></i>\r\n        </button>\r\n      </div>\r\n    </div>\r\n  </div>\r\n\r\n  <div pl-animation-collapse="collapsed">\r\n    <ol ui-tree-nodes="" ng-model="node.nodes">\r\n      <li ng-repeat="node in node.nodes" ui-tree-node ng-include="\'nodes_renderer.html\'"></li>\r\n    </ol>\r\n  </div></script><h3 class="page-header-cg">{{$state.current.title}}</h3><div class="form form-horizontal"><div class="form-group"><a href class="btn btn-primary-cg btn-sm" ng-click="ctrl.save()"><i class="fa fa-save fa-fw"></i>&nbsp;<span data-translate="BUTTON_SAVE"></span></a></div><div class="form-group"><label class="col-md-2 control-label">Home:</label><div class="col-md-4"><select class="form-control" ng-model="ctrl.mnuHome.tipo" ng-change="ctrl.tipoChangeHome(ctrl.mnuHome)"><option value="paginas">P\xE1gina</option><option value="sistema">P\xE1gina de Sistema</option></select></div><div class="col-md-4"><select class="form-control" ng-options="item.id as item.title for item in ctrl.mnuHome.tipos" ng-model="ctrl.mnuHome.page"></select></div></div><div class="form-group"><label class="col-md-2 control-label">Termos:</label><div class="col-md-4"><select class="form-control" ng-model="ctrl.mnuTermos.tipo" ng-change="ctrl.tipoChangeHome(ctrl.mnuTermos)"><option value="paginas">P\xE1gina</option><option value="sistema">P\xE1gina de Sistema</option></select></div><div class="col-md-4"><select class="form-control" ng-options="item.id as item.title for item in ctrl.mnuTermos.tipos" ng-model="ctrl.mnuTermos.page"></select></div></div><div class="form-group"><label class="col-md-2 control-label">Contactos:</label><div class="col-md-4"><select class="form-control" ng-model="ctrl.mnuContactos.tipo" ng-change="ctrl.tipoChangeHome(ctrl.mnuContactos)"><option value="paginas">P\xE1gina</option><option value="sistema">P\xE1gina de Sistema</option></select></div><div class="col-md-4"><select class="form-control" ng-options="item.id as item.title for item in ctrl.mnuContactos.tipos" ng-model="ctrl.mnuContactos.page"></select></div></div></div><hr><div class="text-right"><button class="btn btn-primary" ng-click="ctrl.addEmptyMenu()"><i class="fa fa-plus fa-fw" aria-hidden="true"></i> <span data-translate="admin.menus.addNewMenu"></span></button></div><br><div id="tree-root" ui-tree="options"><ol ui-tree-nodes ng-model="ctrl.data"><li ng-repeat="node in ctrl.data" ui-tree-node ng-include="\'nodes_renderer.html\'"></li></ol></div>');
$templateCache.put('app/admin/modelos/modelos.html','<h3 class="page-header-cg">{{$state.current.title}}</h3><div class="form-horizontal clearfix"><div class="form-group col-md-6"><label class="control-label">Escolha o texto:</label> <select class="form-control" ng-model="textoTipo" ng-options="type.name for type in textotype"></select></div><div class="col-md-1"></div><div class="form-group col-md-5" ng-show="texto.options.subject"><label class="control-label">Assunto:</label> <input type="text" class="form-control" ng-model="texto.subject"></div><div ng-class="myDynamicClass"><label class="control-label">Editar:</label><pre id="editor" ui-ace="aceOption" ng-model="texto.html" ng-change="editorChanged(this)"></pre><button type="button" class="btn btn-warning" ng-click="getDefault()"><i class="fa fa-undo fa-fw"></i>Template original</button> <button type="button" class="btn btn-primary-cg" ng-click="save()"><i class="fa fa-save fa-fw"></i> Guardar</button></div><div class="col-md-4" ng-show="texto.options.vars"><div ng-hide="texto.options.editor"><label class="control-label" data-translate="TEXT_VARIABLES"></label><pre id="editor_json" ng-model="jsonData" ui-ace="{onChange:jsonDataChanged}"></pre></div><div ng-show="texto.options.editor"><label class="control-label" data-translate="TEXT_VARIABLES"></label></div><div class="panel panel-default" ng-show="texto.options.editor"><div class="panel-body"><dl class="modelos dl-horizontal font-12"><div ng-repeat="(key, value) in item" ng-hide="key === \'texto\' && texto.modelo !== \'\'"><dt>@{{key}}</dt><dd class="hidden-txt">{{value}}&nbsp;</dd></div></dl></div></div></div><div class="form-group col-md-12 text-preview"><div class="panel panel-default"><div class="panel-heading"><h3 class="panel-title" data-translate="TEXT_PREVIEW"></h3></div><div class="preview-modelos panel-body"><div ng-hide="texto.options.editor"><div compile="getPreview(texto.html,texto.modelo)"></div></div><div ng-show="texto.options.editor"><dl class="dl-horizontal"><dt ng-show="texto.options.subject" data-translate="TEXT_SUBJECT_PREVIEW"></dt><dd ng-show="texto.options.subject" compile="getPreview(texto.subject,null)"></dd><dt>Texto:</dt><dd class="text-preview-width" compile="getPreview(texto.html,texto.modelo)"></dd></dl></div></div></div></div></div>');
$templateCache.put('app/admin/paginas/paginas.edit.html','<h3 class="page-header-cg"><a ui-sref="^.list"><i class="fa fa-angle-left"></i></a> {{$state.current.title}}</h3><div class="form-horizontal"><div class="form-group"><label class="col-sm-2 control-label">URL da p\xE1gina</label><div class="col-sm-10"><input type="text" class="form-control" ng-model="ctrl.pagina.name"></div></div><div class="form-group"><label class="col-sm-2 control-label" data-translate="PAGINAS_TITULO_LABEL"></label><div class="col-sm-10"><input type="text" class="form-control" ng-model="ctrl.pagina.title"></div></div><div class="form-group"><label class="col-sm-2 control-label" data-translate="PAGINAS_DESC_LABEL"></label><div class="col-sm-10"><textarea class="form-control" rows="3" ng-model="ctrl.pagina.description"></textarea></div></div></div><br><br><hr><div class="form-inline"><div class="form-group"><label class="control-label font-12" ng-hide="ctrl.showOrder">Ordenar</label> <label class="control-label font-12" ng-show="ctrl.showOrder">Pr\xE9-visualizar</label><div class="checkbox"><input type="checkbox" ng-model="ctrl.showOrder"></div></div></div><div class="panel panel-default"><div class="panel-heading" data-translate="PAGINA"></div><div class="panel-body"><widgets-edit class="widget-cg" items="ctrl.pagina.items" order="ctrl.showOrder"></widgets-edit></div></div><br><button type="button" class="btn btn-primary-cg" ng-click="ctrl.save()"><i class="fa fa-save fa-fw"></i>&nbsp;<span data-translate="BUTTON_SAVE"></span></button> <button type="button" class="btn btn-success" ng-click="ctrl.apply()"><i class="fa fa-check fa-fw"></i>&nbsp;<span data-translate="BUTTON_APPLAY"></span></button> <button type="button" class="btn btn-default" ng-click="ctrl.cancel()"><i class="fa fa-ban fa-fw"></i>&nbsp;<span data-translate="BUTTON_CANCEL"></span></button>');
$templateCache.put('app/admin/paginas/paginas.html','<div ui-view></div>');
$templateCache.put('app/admin/paginas/paginas.list.html','<h3 class="page-header-cg">{{$state.current.title}}</h3><form class="col-md-3 pull-right search-position-admin hidden-xs hidden-sm" role="search"><div class="form-group"><div class="input-group input-group-sm"><input type="text" class="form-control" placeholder="{{\'PLACEHOLDER_SEARCH\' | translate}}" ng-model="ctrl.search" ng-change="ctrl.updateFilter()"> <span class="input-group-addon"><i class="fa fa-search fa-fw"></i></span></div></div></form><button class="btn btn-primary-cg btn-sm" ui-sref="^.nova"><i class="fa fa-plus fa-fw"></i> {{\'PAGINAS_NOVA\' | translate}}</button> <button class="btn btn-success btn-sm" ng-click="ctrl.refresh()" title="Refrescar tabela"><i class="fa fa-refresh"></i></button><br><br><table at-table at-paginated at-list="ctrl.filtered" at-config="ctrl.grid.config" class="table table-responsive table-condensed table-bordered table-hover"><thead></thead><tbody><tr><td at-attribute="id" at-sortable at-initial-sorting="asc" at-title="URL" ng-click="ctrl.edit(item)"><a ui-sref="^.edit({id: item.id})">{{item.name}}</a></td><td at-attribute="title" at-sortable at-title="{{\'PAGINAS_LIST_TITLE\' | translate}}" ng-click="ctrl.edit(item)"><p ng-bind-html="item.title| AIhighlight:ctrl.search"></p></td><td at-attribute="description" at-sortable at-title="{{\'PAGINAS_LIST_DESC\' | translate}}" ng-click="ctrl.edit(item)"><p ng-bind-html="item.description| AIhighlight:ctrl.search"></p></td><td at-attribute="publishedOn" at-sortable at-title="{{\'PAGINAS_LIST_WHEN\' | translate}}" ng-click="ctrl.edit(item)">{{item.publishedOn | date : ctrl.format}}</td><td at-attribute="deletePage" at-title="{{\'PAGINAS_LIST_DELETE\' | translate}}"><button type="button" class="btn btn-danger btn-sm" ng-click="ctrl.deletePagina(item)"><i class="fa fa-trash fa-fw"></i></button></td></tr></tbody></table><at-pagination at-list="ctrl.filtered" at-config="ctrl.grid.config"></at-pagination>');
$templateCache.put('app/admin/sincronizacao/sincronizacao.html','<h3 class="page-header-cg">{{$state.current.title}}</h3><div class="panel panel-default"><div class="panel-body"><div class="progress"><div class="progress-bar progress-bar-striped" role="progressbar" ng-style="{width: ((syncState.step * 100 / syncState.stepMax ) | number : 0) + \'%\'}"></div></div><div class="progress"><div class="progress-bar progress-bar-striped" role="progressbar" ng-style="{width: (( syncState.tableRegistos * 100 / syncState.tableTotal ) | number : 0) + \'%\'}"><span>{{syncState.tableRegistos}}/{{syncState.tableTotal}}</span></div></div><div><span data-translate="{{estado}}"></span><br><span>{{syncState.tableRegistos}}/{{syncState.tableTotal}}</span></div><br><div class="text-center"><button type="button" class="btn btn-primary-cg" ng-click="sincroniza()"><i class="fa fa-refresh fa-fw"></i>&nbsp;<span data-translate="BUTTON_SYNC"></span></button> <button type="button" class="btn btn-primary-cg" ng-click="sincronizaTudoCompleto()"><i class="fa fa-refresh fa-fw"></i>&nbsp;<span data-translate="BUTTON_SYNC_ALL"></span></button> <button type="button" class="btn btn-primary-cg" ng-click="sincronizaImagens(true)"><i class="fa fa-file-picture-o fa-fw"></i><span data-translate="BUTTON_SYNC_IMG"></span></button></div></div></div>');
$templateCache.put('app/admin/utilizadores/utilizadores.edit.html','<h3 class="page-header-cg"><a ui-sref="^.list"><i class="fa fa-angle-left"></i></a>{{$state.current.title}}</h3><pl-form name="ctrl.form" properties="{readonly: !ctrl.editing, validators: {required: {value: true}}}"><div class="utilizadores-edit-btn"><button class="btn btn-default btn-sm" ui-sref="^.list" ng-if="ctrl.isEdit && !ctrl.editing || !ctrl.isEdit && ctrl.editing"><i class="fa fa-angle-left fa-fw"></i>&nbsp;<span data-translate="BUTTON_BACK"></span></button> <button class="btn btn-default btn-sm" ng-if="ctrl.isEdit && ctrl.editing" ng-click="ctrl.cancel()"><i class="fa fa-undo fa-fw"></i>&nbsp;<span data-translate="BUTTON_CANCEL"></span></button> <button class="btn btn-warning btn-sm" ng-if="ctrl.isEdit && !ctrl.editing" ng-click="ctrl.edit()"><i class="fa fa-edit fa-fw"></i>&nbsp;<span data-translate="BUTTON_EDIT"></span></button> <button class="btn btn-success btn-sm" ng-if="ctrl.editing" ng-click="ctrl.save()"><i class="fa fa-save fa-fw"></i>&nbsp;<span data-translate="BUTTON_SAVE"></span></button> <button class="btn btn-default btn-sm" ng-if="ctrl.isEdit" ng-disabled="ctrl.mailSent" ng-click="ctrl.requestChangePassword()"><i class="fa fa-lock fa-fw"></i>&nbsp;<span data-translate="utilizador.edit.resendPwEmail"></span></button> <button class="btn btn-info btn-sm" ng-if="ctrl.isEdit" ng-click="ctrl.changePassword()" pl-promise><i class="fa fa-pencil-square-o fa-fw"></i>&nbsp;<span data-translate="utilizador.edit.changePw"></span></button></div><pl-group><label data-translate="utilizador.edit.name"></label><edit><pl-edit type="string" name="name" ng-model="ctrl.item.name"></pl-edit></edit></pl-group><pl-group><label data-translate="utilizador.edit.email"></label><edit><pl-edit type="email" name="email" ng-model="ctrl.item.email" properties="{validators: {uniqueEmail: ctrl.emailValidator}}"></pl-edit></edit></pl-group><pl-group ng-if="ctrl.isEdit" properties="{validators: {required: {value: false}}}"><label data-translate="utilizador.edit.firstName"></label><edit><pl-edit type="string" name="firstName" ng-model="ctrl.item.firstName"></pl-edit></edit></pl-group><pl-group ng-if="ctrl.isEdit" properties="{validators: {required: {value: false}}}"><label data-translate="utilizador.edit.lastName" properties="{validators: {required: {value: false}}}"></label><edit><pl-edit type="string" name="lastName" ng-model="ctrl.item.lastName"></pl-edit></edit></pl-group><pl-group ng-if="ctrl.isEdit"><label data-translate="utilizador.edit.active"></label><edit><pl-edit type="boolean" name="active" ng-model="ctrl.item.active"></pl-edit></edit></pl-group><pl-group ng-if="ctrl.isEdit"><label data-translate="utilizador.edit.validatedEmail"></label><edit><pl-edit type="boolean" name="emailValidated" ng-model="ctrl.item.emailValidated"></pl-edit></edit></pl-group><pl-group><label data-translate="utilizador.edit.NConta"></label><edit><pl-edit type="autocomplete" name="nconta" ng-model="ctrl.item.erp.nconta" properties="{\r\n        source: ctrl.getNClifos,\r\n        onValidate: ctrl.getNClifo,\r\n        rowTemplate: \'{{nconta}} - {{nome}}\',\r\n        selected: ctrl.nContaSelected,\r\n        output: \'{{nconta}}\',\r\n        placeholder: \'N\xBA de Conta\',\r\n        config: ctrl.config\r\n      }"></pl-edit></edit></pl-group></pl-form>');
$templateCache.put('app/admin/utilizadores/utilizadores.edit.password.html','<div class="modal-header"><button type="button" class="close" ng-click="ctrl.cancel()" data-dismiss="modal" aria-hidden="true">&times;</button><h4 class="modal-title" data-translate="utilizador.edit.changePw"></h4></div><div class="modal-body"><pl-form name="ctrl.form" model="ctrl.model" definition="ctrl.definition" template="ctrl.template"></pl-form></div><div class="modal-footer"><button type="button" class="btn btn-primary submit-button" ng-click="ctrl.submit()" pl-promise><i class="fa fa-save fa-fw"></i> <span data-translate="CHANGE"></span></button> <button type="button" class="btn btn-default" ng-click="ctrl.cancel()" pl-promise><i class="fa fa-close fa-fw"></i> <span data-translate="LOGIN_SIGNUP_CANCEL"></span></button></div>');
$templateCache.put('app/admin/utilizadores/utilizadores.html','<div ui-view></div>');
$templateCache.put('app/admin/utilizadores/utilizadores.list.html','<h3 class="page-header-cg">{{$state.current.title}}</h3><div class="row"><div class="col-xs-6"><a ui-sref="admin.utilizadores.new" class="btn btn-primary btn-sm"><i class="fa fa-plus fa-fw"></i>&nbsp;<span data-translate="utilizador.edit.new"></span></a></div><div class="col-xs-3 pull-right"><form class="search-position-admin" role="search"><div class="form-group"><div class="input-group input-group-sm"><input type="text" class="form-control" placeholder="{{\'PLACEHOLDER_SEARCH\' | translate}}" ng-model="ctrl.searchText" ng-change="ctrl.updateFiltered()"> <span class="input-group-addon"><span class="glyphicon glyphicon-search"></span></span></div></div></form></div></div><table at-table at-paginated at-list="ctrl.grid.filteredList" at-config="ctrl.grid.config" class="table table-hover table-striped table-responsive table-condensed table-bordered" pl-promise><thead></thead><tbody><tr ng-click="ctrl.edit(item)"><td at-attribute="name" at-sortable at-initial-sorting="asc" at-title="Nome"><span ng-bind-html="item.name|AIhighlight: searchText"></span></td><td at-attribute="email" at-sortable at-title="Email"><span ng-bind-html="item.email|AIhighlight: searchText"></span></td><td at-attribute="lastLogin" at-sortable at-title="Ult. acesso">{{ item.lastLogin|date:\'dd-MM-yyyy\' }}</td><td at-attribute="stampInsert" at-sortable at-title="Criado em">{{ item.stampInsert|date:\'dd-MM-yyyy\' }}</td><td at-attribute="active" at-sortable at-title="Activo"><i class="fa fa-check fa-fw text-success" ng-show="item.active"></i> <i class="fa fa-close fa-fw text-danger" ng-hide="item.active"></i></td><td at-attribute="emailValidated" at-sortable at-title="Confirmado"><i class="fa fa-check fa-fw text-success" ng-show="item.emailValidated"></i> <i class="fa fa-close fa-fw text-danger" ng-hide="item.emailValidated"></i></td><td at-attribute="erp.nconta" at-sortable at-title="NConta"><span ng-bind-html="item.erp.nconta|AIhighlight: searchText"></span></td><td at-attribute="erp.ncontaAlt" at-sortable at-title="ERP"><i class="fa fa-check fa-fw text-success" ng-show="item.erp.ncontaAlt"></i> <i class="fa fa-close fa-fw text-danger" ng-hide="item.erp.ncontaAlt"></i></td></tr></tbody></table><at-pagination at-list="ctrl.grid.filteredList" at-config="ctrl.grid.config"></at-pagination>');
$templateCache.put('app/components/alteraMoradaModal/altera.morada.modal.html','<div class="modal-header"><button type="button" class="close" ng-click="$ctrl.cancel()" data-dismiss="modal" aria-hidden="true">&times;</button><h4 class="modal-title"><span ng-if="!$ctrl.isNew" data-translate="utilizador.perfil.moradas.altera"></span> <span ng-if="$ctrl.isNew" data-translate="utilizador.perfil.moradas.nova"></span></h4></div><div class="modal-body" pl-promise="$ctrl.promise"><pl-form name="$ctrl.form" definition="$ctrl.definition" model="$ctrl.model"></pl-form></div><div class="modal-footer"><button type="button" class="btn btn-primary submit-button" ng-click="$ctrl.submit()"><i class="fa fa-save fa-fw"></i>&nbsp;<span data-translate="utilizador.perfil.moradas.buttons.modal.gravar"></span></button> <button type="button" class="btn btn-default" ng-click="$ctrl.cancel()" data-dismiss="modal" aria-hidden="true"><i class="fa fa-close fa-fw"></i>&nbsp;<span data-translate="utilizador.perfil.moradas.buttons.modal.cancelar"></span></button></div>');
$templateCache.put('app/components/alteraMoradaModal/delete.morada.modal.html','<div class="modal-header"><button type="button" class="close" ng-click="$ctrl.cancel()" data-dismiss="modal" aria-hidden="true">&times;</button><h4 class="modal-title" data-translate="utilizador.perfil.moradas.apaga"></h4></div><div class="modal-body" pl-promise="$ctrl.promise"><h4 data-translate="utilizador.perfil.moradas.apagaTexto"></h4><div class="well"><dl class="dl-horizontal"><dt data-translate="utilizador.perfil.moradas.identificacao"></dt><dd>{{$ctrl.model.nome}}</dd><dt data-translate="utilizador.perfil.moradas.entrega.name"></dt><dd>{{$ctrl.model.contactoNome}}</dd><dt data-translate="utilizador.perfil.moradas.entrega.address"></dt><dd>{{$ctrl.model.rua}} {{$ctrl.model.morada}}</dd><dt data-translate="utilizador.perfil.moradas.entrega.cp"></dt><dd>{{$ctrl.model.cpost}} - {{$ctrl.model.localidade}}</dd><dt data-translate="utilizador.perfil.moradas.entrega.pais"></dt><dd>{{$ctrl.model.paisIso.nomePais}}</dd><dt data-translate="utilizador.perfil.moradas.entrega.telefone"></dt><dd>{{$ctrl.model.contactoTelefone}}</dd></dl></div></div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="$ctrl.submitDelete()"><i class="fa fa-trash fa-fw"></i> {{\'utilizador.perfil.moradas.buttons.modal.apagar\' | translate}}</button> <button type="button" class="btn btn-default" ng-click="$ctrl.cancel()"><i class="fa fa-close fa-fw"></i> {{\'utilizador.perfil.moradas.buttons.modal.cancelar\' | translate}}</button></div>');
$templateCache.put('app/components/cgmodal/okcancel.html','<div class="modal-header"><button type="button" class="close" ng-click="$ctrl.$dismiss(false)" aria-hidden="true">&times;</button><h4 class="modal-title" data-translate="{{$ctrl.title}}"></h4></div><div class="modal-body" data-translate="{{$ctrl.message}}"></div><div class="modal-footer" pl-navigation selector="pl-button"><pl-button id="btModelOK" class="btn-success" on-click="$ctrl.$close(\'ok\')"><i class="fa fa-check fa-fw"></i>&nbsp;<span data-translate="global.btn.ok"></span></pl-button><pl-button id="btModalCancel" class="btn-default" on-click="$ctrl.$dismiss(\'canceled\')"><i class="fa fa-times fa-fw"></i>&nbsp;<span data-translate="global.btn.cancel"></span></pl-button></div>');
$templateCache.put('app/components/confirmaPagamentoModal/confirma.pagamento.modal.html','<div class="modal-header"><button type="button" class="close" ng-click="$ctrl.cancel()" data-dismiss="modal" aria-hidden="true">&times;</button><h4 class="modal-title"><span data-translate="admin.documento.confirmaPagamentoModal.title"></span></h4></div><div class="modal-body" pl-promise="$ctrl.promise"><span data-translate="admin.documento.confirmaPagamentoModal.body"></span><pl-form name="$ctrl.form" definition="$ctrl.definition" model="$ctrl.model"></pl-form></div><div class="modal-footer"><button type="button" class="btn btn-primary submit-button" ng-click="$ctrl.submit()"><i class="fa fa-save fa-fw"></i>&nbsp;<span data-translate="utilizador.perfil.moradas.buttons.modal.gravar"></span></button> <button type="button" class="btn btn-default" ng-click="$ctrl.cancel()" data-dismiss="modal" aria-hidden="true"><i class="fa fa-close fa-fw"></i>&nbsp;<span data-translate="utilizador.perfil.moradas.buttons.modal.cancelar"></span></button></div>');
$templateCache.put('app/components/imagepick/image.pick.html','<div class="modal-header"><button type="button" class="close" ng-click="$ctrl.cancel()"><span aria-hidden="true">&times;</span><span class="sr-only">Close</span></button><h3>Imagens</h3></div><div class="modal-body"><div class="row"><div class="col-xs-12"><div class="clearfix"><h4>Imagens do servidor</h4><button class="btn btn-success btn-sm" ng-click="$ctrl.refresh(folder)" title="Refrescar tabela"><i class="fa fa-refresh"></i></button> <button class="btn btn-default btn-sm" ng-hide="$ctrl.folder === \'\'" ng-click="$ctrl.refresh(lastFolder)" title="Galeria"><i class="fa fa-chevron-left"></i></button><form class="col-md-3 pull-right search-position-admin hidden-xs hidden-sm" role="search"><div class="form-group"><div class="input-group input-group-sm"><input type="text" class="form-control" ng-model="$ctrl.searchimages" ng-change="$ctrl.updateFilter()" translate-attr="{placeholder: \'PLACEHOLDER_SEARCH\'}"> <span class="input-group-addon"><i class="fa fa-search fa-fw"></i></span></div></div></form></div><table class="table table-hover table-responsive table-condensed table-bordered" at-table at-paginated at-list="$ctrl.grid.filtered" at-config="$ctrl.grid.config"><thead></thead><tbody><tr ng-click="$ctrl.select(item)"><td width="10%" class="text-center"><img class="imagens_wrapper" ng-src="{{::$ctrl.getImagem(item)}}" ng-hide="item.type === \'folder\'" fallback-src="http://www.placehold.it/100x50/EFEFEF/AAAAAA&text=sem+imagem"> <i class="fa fa-folder fa-fw" ng-show="item.type === \'folder\'"></i></td><td at-implicit at-attribute="name" at-sortable at-title="Nome"></td><td at-attribute="lastModified" at-sortable at-initial-sorting="desc" at-title="Data">{{item.lastModified | date : \'dd-MM-yyyy HH:mm:ss\'}}</td><td at-attribute="size" at-sortable at-title="Tamanho Kb"><span class="pull-right">{{item.size / 1024 | number : 0}}</span></td></tr></tbody></table><at-pagination at-list="$ctrl.grid.filtered" at-config="$ctrl.grid.config"></at-pagination></div></div></div><div class="modal-footer"><button class="btn btn-default" ng-click="$ctrl.cancel();" data-translate="BUTTON_CANCEL"></button></div>');
$templateCache.put('app/components/lightbox/lightbox.html','<div class="modal-body" ng-swipe-left="Lightbox.nextImage()" ng-swipe-right="Lightbox.prevImage()"><div class="lightbox-nav"><button class="close" aria-hidden="true" ng-click="Lightbox.closeModal()">\xD7</button><div class="btn-group"><a class="btn btn-sm btn-primary" ng-click="Lightbox.prevImage()" ng-if="Lightbox.images.length > 1" uib-tooltip="Anterior" tooltip-placement="left"><i class="fa fa-chevron-left fa-fw"></i> </a><a class="btn btn-sm btn-primary" ng-href="{{Lightbox.imageUrl}}" target="_blank" uib-tooltip="Abrir numa nova janela" tooltip-placement="bottom"><i class="fa fa-external-link fa-fw"></i> </a><a class="btn btn-sm btn-primary" ng-click="Lightbox.nextImage()" ng-if="Lightbox.images.length > 1" uib-tooltip="Pr\xF3ximo" tooltip-placement="right"><i class="fa fa-chevron-right fa-fw"></i></a></div></div><div class="lightbox-image-container"><div class="lightbox-image-caption"><span data-translate="{{Lightbox.imageCaption}}"></span></div><img ng-if="!Lightbox.isVideo(Lightbox.image)" lightbox-src="{{Lightbox.imageUrl}}"></div></div>');
$templateCache.put('app/components/timePickerModal/time.picker.modal.html','<div class="modal-header"><button type="button" class="close" ng-click="$ctrl.cancel()"><span aria-hidden="true">&times;</span><span class="sr-only">Close</span></button><h3>Data de publica\xE7\xE3o</h3></div><!-- {{$ctrl.item|json}} --><div class="modal-body"><div class="row"><div class="col-xs-12"><div class="clearfix"><pl-form><pl-group><label data-translate="PAGINAS_PUBLISHED_FROM_LABEL"></label><edit><div class="row"><div class="col-sm-6"><pl-datepicker ng-model="$ctrl.item.dateFrom"></pl-datepicker></div><div class="col-sm-6"><pl-timepicker ng-model="$ctrl.item.timeFrom"></pl-timepicker></div></div></edit></pl-group><pl-group><label data-translate="PAGINAS_PUBLISHED_TO_LABEL"></label><edit><div class="row"><div class="col-sm-6"><pl-datepicker ng-model="$ctrl.item.dateTo"></pl-datepicker></div><div class="col-sm-6"><pl-timepicker ng-model="$ctrl.item.timeTo"></pl-timepicker></div></div></edit></pl-group></pl-form></div></div></div></div><div class="modal-footer"><button class="btn btn-primary" ng-click="$ctrl.select(item);" data-translate="BUTTON_OK"></button> <button class="btn btn-default" ng-click="$ctrl.cancel();" data-translate="BUTTON_CANCEL"></button></div>');
$templateCache.put('app/components/widgets/widget.edit.html','<div class="modal-header"><button type="button" class="close" ng-click="$ctrl.cancel()"><span aria-hidden="true">&times;</span><span class="sr-only">Close</span></button><h3 class="modal-title" data-translate="{{$ctrl.item.description}}"></h3></div><div class="modal-body"><!--<pre>{{$ctrl|json}}</pre>--><pl-form><pl-group><label data-translate="PAGINAS_TITULO_LABEL"></label><edit><input type="text" class="form-control" ng-model="$ctrl.item.title"></edit></pl-group><pl-group><label data-translate="PAGINAS_DESC_LABEL"></label><edit><textarea class="form-control" rows="3" ng-model="$ctrl.item.description"></textarea></edit></pl-group><pl-group><label data-translate="PAGINAS_PUBLISHED_FROM_LABEL"></label><edit><div class="row"><div class="col-sm-6"><pl-datepicker ng-model="$ctrl.dateFrom"></pl-datepicker></div><div class="col-sm-6"><pl-timepicker ng-model="$ctrl.timeFrom"></pl-timepicker></div></div></edit></pl-group><pl-group><label data-translate="PAGINAS_PUBLISHED_TO_LABEL"></label><edit><div class="row"><div class="col-sm-6"><pl-datepicker ng-model="$ctrl.dateTo"></pl-datepicker></div><div class="col-sm-6"><pl-timepicker ng-model="$ctrl.timeTo"></pl-timepicker></div></div></edit></pl-group><hr><compile compile="$ctrl.editDirective()"></compile></pl-form></div><div class="modal-footer"><button class="btn btn-primary-cg" ng-click="$ctrl.save()"><i class="fa fa-save fa-fw"></i>&nbsp;<span data-translate="BUTTON_OK"></span></button> <button class="btn btn-default" ng-click="$ctrl.cancel()"><i class="fa fa-remove fa-fw"></i>&nbsp;<span data-translate="BUTTON_CANCEL"></span></button></div>');
$templateCache.put('app/components/widgets/widgets.edit.html','<ul class="list-inline"><li ng-repeat="item in $ctrl.list"><div class="btn btn-default btn-sm" ng-click="$ctrl.add(item)" data-translate="{{item.description}}"></div></li></ul><div ng-show="$ctrl.order"><br><div data-ng-model="$ctrl.items" data-as-sortable="$ctrl.board.dragControlListeners"><div data-ng-repeat="item in $ctrl.items" data-as-sortable-item><div class="input-group" data-as-sortable-item-handle><span class="input-group-addon"><i class="fa fa-arrows-alt fa-fw"></i></span><div class="form-control" data-translate="{{item.description}}"></div><span class="input-group-addon" ng-click="$ctrl.edit(item)"><i class="fa fa-edit fa-fw"></i></span> <span class="input-group-addon" ng-click="$ctrl.delete(item)"><i class="fa fa-remove fa-fw icon-danger"></i></span></div></div></div></div><div ng-hide="$ctrl.order" class="content-margin"><div class="row" data-ng-repeat="item in $ctrl.items"><widget-build item="item"></widget-build></div></div>');
$templateCache.put('app/components/widgets/widgets.html','<div ng-repeat="item in $ctrl.items"><widget-build item="item" ng-show="item.isVisible"></widget-build></div>');
$templateCache.put('app/loja/carrinho/carrinho.html','<div class="container"><ol class="breadcrumb breadcrumb-cg"><li><a ui-sref="loja.home({id:\'inicio\'})"><i class="fa fa-home fa-fw"></i></a></li><li class="active">{{$state.current.title}}</li></ol><h3 class="page-header-cg"><span data-translate="CART_PAGE_TITLE"></span> <a class="text-back text-muted pull-right" ng-click="goBack()"><i class="fa fa-angle-left fa-fw"></i>&nbsp;<span data-translate="CART_PAGE_BACK_TO_STORE"></span></a></h3><br><div class="row carrinho"><div class="col-md-12 font-table-cesto"><div ng-include="\'carrinho\'"></div></div></div></div>');
$templateCache.put('app/loja/carrinho/carrinho.table.html','<table at-table at-list="$ctrl.storage.cesto" class="table cesto-border" ng-if="$ctrl.storage.cesto.length !== 0"><thead class="cartTableHeader cartResumo"></thead><tbody><tr><td at-title="{{\'CART_TABLE_TH_PRODUCT\' | translate}}"><a href ng-click="$ctrl.showDetail(item)"><img class="img-responsive artimageCartResumo" fallback-src="{{$ctrl.storage.noimage}}" ng-src="{{$ctrl.storage.getImagem(item)}}" alt=""></a></td><td class="cesto-preco" at-title="{{\'CART_TABLE_TH_DETAIL\' | translate}}"><a href ng-click="$ctrl.showDetail(item)">{{item.nome}}</a></td><td class="text-nowrap" at-title="{{\'CART_TABLE_TH_PRICE\' | translate}}">{{item.precoSemDesconto | currency: \'\u20AC \'}}</td><td><span ng-show="item.qtdPorUnidade1!==1">{{item.qtdPorUnidade1}}x</span></td><td class="cestoQtd" at-attribute="qtd" at-title="{{\'CART_TABLE_TH_QTD\' | translate}}"><cg-number name="qtd" ng-model="item.qtd" ng-change="$ctrl.calcBasket()" min="item.qtdMinEncome || $ctrl.storage.qtdMin" max="item.qtdMaxEncome || $ctrl.storage.qtdMax" step="item.qtdMultipla || $ctrl.storage.step"></cg-number></td><td class="text-nowrap" at-title="{{\'CART_PAGE_TH_SUBTOTAL\' | translate}}">{{item.precoSemDesconto*item.qtd | currency: \'\u20AC \'}}</td><td><a href ng-click="$ctrl.removeBasket(item)" translate-attr="{\'title\': \'CART_MENU_REMOVE_ICON\'}" ng-if="$ctrl.currentStep.id === \'step1\'"><i class="fa fa-trash-o fa-fw fa-2x"></i></a></td></tr></tbody></table><div ng-if="$ctrl.storage.cesto.length === 0"><h4 data-translate="CART_MENU_EMPTY"></h4></div><div class="cartFooter" ng-if="$ctrl.storage.cesto.length !== 0 && $ctrl.currentStep.id === \'step1\'"><a href ng-click="$ctrl.removeAllBasket()" class="btn btn-primary-cg-invert btn-sm pull-right font-table-cesto"><span class="fa fa-trash fa-fw"></span>&nbsp;<span data-translate="CART_MENU_REMOVE_ALL_BUTTON"></span></a></div>');
$templateCache.put('app/loja/carrinho/carrinho.total.html','<table class="table table-responsive cesto-border"><thead></thead><tr><td class="h5" data-translate="CART_SUBTOTAL"></td><td class="align-cesto h5"><strong>{{$ctrl.storage.carrinhoTotal.totalSemDesconto | currency: \'\u20AC \'}}</strong></td></tr><tr><td class="h5" data-translate="CART_PAGE_PRODUCTS"></td><td class="align-cesto h5"><strong>{{$ctrl.storage.cesto.length}}</strong></td></tr><tr><td class="h5" data-translate="CART_PAGE_QDT"></td><td class="align-cesto h5"><strong>{{$ctrl.storage.carrinhoTotal.nItens}}</strong></td></tr><tr ng-if="$ctrl.storage.carrinhoTotal.custoTransporte >= 0.01"><td class="h5" data-translate="CART_PAGE_DELIVERY"></td><td class="align-cesto h5"><strong>{{$ctrl.storage.carrinhoTotal.custoTransporte | currency: \'\u20AC \'}}</strong></td></tr><tr ng-if="$ctrl.storage.carrinhoTotal.desconto>=0.01"><td class="h5" data-translate="CART_PAGE_DISCOUNT"></td><td class="align-cesto h5"><strong>{{$ctrl.storage.carrinhoTotal.desconto | currency: \'\u20AC \'}}</strong></td></tr><tr class="cesto-fundo"><td class="h3" data-translate="CART_PAGE_TOTAL"></td><td class="align-cesto h3"><strong>{{$ctrl.storage.carrinhoTotal.total | currency: \'\u20AC \'}}</strong></td></tr><tfoot></tfoot></table><a href class="btn btn-success btn-lg btn-block" ng-click="$ctrl.submitForm()" ng-if="$ctrl.storage.cesto.length">{{$ctrl.getButtonNextCaption()}} <i class="fa fa-arrow-right fa-fw"></i></a>');
$templateCache.put('app/loja/contatos/contatos.html','<div class="container content-margin"><ol class="breadcrumb breadcrumb-cg"><li><a ui-sref="loja.home({id:\'inicio\'})"><i class="fa fa-home fa-fw"></i></a></li><li class="active">{{$state.current.title}}</li></ol><div class="row"><div class="col-md-4"><address><h4 class="page-header-cg">{{ctrl.empresa.nomeEmpresa}}</h4><br><div class="margin-dt"><dl class="dl-horizontal"><dt ng-hide="!ctrl.empresa.morada"><abbr title="{{\'CONTACTS_ABBR_ADDRESS\' | translate}}"><i class="fa fa-home fa-fw"></i></abbr></dt><dd>{{ctrl.empresa.morada}}</dd><dd>{{ctrl.empresa.codPostalEmp}} {{ctrl.empresa.freguesiaEmp}}</dd><dd>{{ctrl.empresa.localidaEmp}}</dd><br><dt ng-hide="!ctrl.empresa.telef1Emp"><abbr title="{{\'CONTACTS_ABBR_PHONE\' | translate}}"><i class="fa fa-phone fa-fw"></i></abbr></dt><dd>{{ctrl.empresa.telef1Emp}}</dd><dt ng-hide="!ctrl.empresa.telef2Emp"><abbr title="{{\'CONTACTS_ABBR_MOBILE\' | translate}}"><i class="fa fa-mobile fa-fw"></i></abbr></dt><dd>{{ctrl.empresa.telef2Emp}}</dd><dt ng-hide="!ctrl.empresa.fax1Emp"><abbr title="{{\'CONTACTS_ABBR_FAX\' | translate}}"><i class="fa fa-print fa-fw"></i></abbr></dt><dd>{{ctrl.empresa.fax1Emp}}</dd><dt ng-hide="!ctrl.empresa.email"><abbr title="{{\'CONTACTS_ABBR_EMAIL\' | translate}}"><i class="fa fa-envelope fa-fw"></i></abbr></dt><dd>{{ctrl.empresa.email}}</dd></dl></div></address></div><div class="col-md-8" ng-show="ctrl.submited"><div class="alert alert-success">O formul\xE1rio foi enviado com sucesso!</div><button type="button" class="btn btn-primary-cg" ng-click="ctrl.submited=false"><i class="fa fa-send fa-fw"></i> Enviar novo contacto</button></div><div class="col-md-8" ng-show="!ctrl.submited"><div class="panel panel-primary"><div class="panel-heading"><h3 class="panel-title" data-translate="CONTACTS_CONTACT_FORM"></h3></div><form class="form-horizontal" name="ctrl.formContact" id="formContact" novalidate angular-validator angular-validator-submit="ctrl.sendMail(formContact)" role="form"><div class="panel-body"><div class="form-group"><label class="col-sm-2 control-label" data-translate="CONTACTS_CONTACT_FORM_NAME"></label><div class="col-sm-10"><input type="text" name="from" id="from" ng-model="ctrl.form.from" class="form-control" placeholder="{{\'CONTACTS_CONTACT_FORM_NAME\' | translate}}" required-message="\'{{ \'CONTACTS_ERROR_NAME_REQUIRED\' | translate }}\'" required></div></div><div class="form-group"><label class="col-sm-2 control-label" data-translate="CONTACTS_ABBR_EMAIL"></label><div class="col-sm-10"><input type="email" name="email" id="email" ng-model="ctrl.form.email" class="form-control" placeholder="{{\'CONTACTS_ABBR_EMAIL\' | translate}}" invalid-message="\'{{ \'LOGIN_ERROR_EMAIL_INVALID\' | translate }}\'" required-message="\'{{ \'LOGIN_ERROR_EMAIL_REQUIRED\' | translate }}\'" required></div></div><div class="form-group"><label class="col-sm-2 control-label" data-translate="CONTACTS_CONTACT_FORM_MSG"></label><div class="col-sm-10"><textarea name="message" id="message" class="form-control" ng-model="ctrl.form.message" rows="3" placeholder="{{\'CONTACTS_CONTACT_FORM_MSG\' | translate}}" required-message="\'{{ \'CONTACTS_ERROR_MESSAGE_REQUIRED\' | translate }}\'" required></textarea></div></div></div><div class="panel-footer"><div class="col-md-2"></div><button type="submit" class="btn btn-primary-cg"><i class="fa fa-send fa-fw"></i> {{ \'BUTTON_SEND\' | translate}}</button></div></form></div></div></div><div class="row"><div class="col-md-12"><h4>Localiza\xE7\xE3o</h4><div class="panel panel-default"><div class="panel-body"><iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1679.7114540362243!2d-16.913873799999944!3d32.6481884!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xc605fe2ec871ab7%3A0x23b5ea9713a80bbe!2sHARD+SOFT+-+CENTRALSTORE%2C+LDA.!5e0!3m2!1spt-PT!2spt!4v1437745969803" width="100%" height="300" frameborder="0" style="border:0" allowfullscreen></iframe></div></div></div></div></div>');
$templateCache.put('app/loja/home/home.html','<div id="content"><div ng-controller="MyCarouselController as carousel"><div class="carousel-margin carousel"><carousel interval="myInterval" disable-animation="true"><slide ng-repeat="slide in slides" active="slide.active"><img ng-src="{{slide.image}}" style="margin:auto;"><div class="carousel-caption"><h2>{{slide.text}}</h2></div></slide></carousel></div></div><div class="container home-content-margin"><h3 class="page-header-cg">Promo\xE7\xF5es</h3><div class="row"><div ng-repeat="artigo in ctrl.storage.artigosFiltered| limitTo: 4 "><div class="col-sm-3 col-lg-3 col-md-3"><div class="thumbnail"><div class="thumbnail-box"><center><img class="artimage1" fallback-src="{{ctrl.storage.noimage}}" ng-src="{{ctrl.storage.getImagem(artigo)}}" alt=""></center></div><div class="caption"><h4 class="pull-right">{{artigo.preco | currency:"\u20AC "}}</h4><h4>{{artigo.nome}}</h4><p>{{artigo.classe}}</p><hr><p><button type="button" class="btn btn-default btn-block" ng-click="ctrl.storage.showDetail(artigo)"><i class="fa fa-eye fa-fw"></i> Ver detalhes</button> <button type="button" class="btn btn-primary-cg btn-block" ng-click="ctrl.storage.addBasket(artigo)"><i class="fa fa-shopping-cart fa-fw"></i> {{\'STORE_ADD_TO_CART_BUTTON\' | translate}}</button></p></div></div></div></div></div></div></div>');
$templateCache.put('app/loja/home/homedyn.html','<div><widgets class="widget-cg" items="ctrl.pagina.items"></widgets></div>');
$templateCache.put('app/loja/pagamento/pagamento.html','<div class="container content-margin"><div ui-view></div></div>');
$templateCache.put('app/loja/pagamento/paypal.html','{{paypal.message}}');
$templateCache.put('app/loja/produtos/produtos.classificador.detalhe.html','<div class="container"><ol class="breadcrumb breadcrumb-cg"><li><a ui-sref="loja.home({id:\'inicio\'})"><i class="fa fa-home fa-fw"></i></a></li><li class="active">{{classificador.descricao}}</li></ol><h3 class="page-header-cg"><span ng-show="classificador.imagem.tabela" data-translate="{{classificador.imagem.tabela}}"></span> <span ng-show="!classificador.imagem.tabela">Detalhe do artigo</span> <a class="text-back text-muted pull-right" href ng-click="goBack()"><i class="fa fa-angle-left fa-fw"></i><span data-translate="CART_PAGE_BACK_TO_STORE"></span></a></h3><div ng-include="\'classificador.detalhe\'"></div></div>');
$templateCache.put('app/loja/produtos/produtos.detalhe.html','<div class="container"><ol class="breadcrumb breadcrumb-cg"><li><a ui-sref="loja.home({id:\'inicio\'})"><i class="fa fa-home fa-fw"></i></a></li><li class="active">{{item.artigo.nome}}</li></ol><h3 class="page-header-cg"><span data-translate="STORE_DETAIL_PAGE_TITLE"></span> <a class="text-back text-muted pull-right" href ng-click="goBack()"><i class="fa fa-angle-left fa-fw"></i><span data-translate="CART_PAGE_BACK_TO_STORE"></span></a></h3><div ng-include="\'produto.detalhe\'"></div></div>');
$templateCache.put('app/loja/produtos/produtos.html','<div style="position: relative;"><div class="container"><div class="row"><div class="col-xs-12"><ol class="breadcrumb breadcrumb-cg"><li><a ui-sref="loja.home({id:\'inicio\'})"><i class="fa fa-home fa-fw"></i></a></li><li class="active">{{$state.current.title}}</li></ol></div></div></div><loja></loja></div>');
$templateCache.put('app/components/cgdevtools/cgNumber/cgNumber.html','<!--<div class="input-group input-group-sm">\r\n  <span type="button" class="btn btn-default input-group-addon" ng-click="$ctrl.minus()">\r\n    <strong>-</strong>\r\n  </span>\r\n\r\n  <pl-edit type="number" name="{{$ctrl.name}}" ng-model="$ctrl.value" ng-model-options="{updateOn: \'blur\'}"\r\n           ng-change="$ctrl.changed()" edit-class="\'input-sm fac-doc-footer\'" properties="$ctrl.options">\r\n  </pl-edit>\r\n\r\n  <span type="button" class="btn btn-default input-group-addon" ng-click="$ctrl.plus()">\r\n    <strong>+</strong>\r\n  </span>\r\n</div>--><div class="input-group cg-number"><span type="button" class="btn btn-cg-number input-group-addon" ng-click="$ctrl.minus()"><i class="fa fa-chevron-left"></i></span><pl-edit type="number" name="{{$ctrl.name}}" ng-model="$ctrl.value" ng-model-options="{updateOn: \'blur\'}" ng-change="$ctrl.changed()" edit-class="\'input-sm fac-doc-footer\'" properties="$ctrl.options"></pl-edit><span type="button" class="btn btn-cg-number input-group-addon" ng-click="$ctrl.plus()"><i class="fa fa-chevron-right"></i></span></div>');
$templateCache.put('app/components/directives/cgListNav/cgListNav.html','<div class="row"><div class="col-md-3 btn-group btn-group-cg btn-group-sm hidden-xs hidden-sm pull-left" role="tablist"><p class="btn btn-default-cg disabled hidden-xs hidden-sm" data-translate="STORE_VIEWS_TITLE"></p><button type="button" class="btn btn-default" ng-class="{\'active\': ctrl.listView === \'box\'}" ng-click="ctrl.setListView(\'box\')" ng-disabled="ctrl.options.disabled.btnBox"><span class="glyphicon glyphicon-th-large"></span></button> <button class="btn btn-default" ng-class="{\'active\': ctrl.listView === \'list\'}" ng-click="ctrl.setListView(\'list\')" ng-disabled="ctrl.options.disabled.btnList"><span class="glyphicon glyphicon-align-justify"></span></button></div><div class="col-md-5 btn-group btn-group-sm form-inline"><button type="button" class="btn btn-default-cg disabled hidden-xs hidden-sm" data-translate="STORE_SORT_TITLE"></button><div class="form-group"><div class="input-group-sm"><select class="form-control" title="Sort order" ng-model="ctrl.sortOrder" ng-change="ctrl.sortOrderChanged()" ng-options="item.value as (item.name | translate) for item in ctrl.sortOrders" ng-disabled="ctrl.options.disabled.order"></select></div></div></div><form class="col-md-4 pull-right" name="ctrl.form" ng-submit="ctrl.doSearch(ctrl.form.$valid)" role="search" novalidate><div class="form-group"><div class="input-group input-group-sm"><input type="text" class="input form-control" title="Search" name="search" ng-model="ctrl.searchValue" ng-model-options="{debounce: 500}" ng-change="ctrl.render()" ng-disabled="ctrl.options.disabled.search"><div class="input-group-btn"><button type="button" class="btn btn-default" ng-if="ctrl.searchValue !== \'\'" ng-click="ctrl.cleanSearch()"><i class="fa fa-times"></i></button> <button type="submit" class="btn btn-default"><i class="fa fa-search"></i></button></div></div></div></form></div>');
$templateCache.put('app/components/directives/documento/documento.html','<div ng-if="!$ctrl.hasDoc()" data-translate="NO_DOC_SELECT"></div><div ng-if="$ctrl.hasDoc()"><div id="printfac" class="panel panel-default"><div class="panel-heading"><div class="visible-print visible-print-inline text-center"><img ng-src="{{logo}}" alt="Logo"><br><br></div><h3 class="panel-title"><strong>{{$ctrl.doc.infoDocumentoDesignacao}} N\xBA: </strong>{{$ctrl.doc.faccb.ndocAsString}} <span class="pull-right"><strong data-translate="DOC_FAC_HEADER_DATA"></strong>{{$ctrl.doc.faccb.dataDoc|date:\'dd-MM-yyyy\'}}</span></h3></div><div class="panel-body"><div class="fac-doc"><div class="visible-print visible-print-inline"><p><span class="text-right"><strong data-translate="DOC_FAC_HEADER_NCONTA"></strong> </span><span class="text-right">{{$ctrl.doc.identificacao.nconta}}</span></p><p><span class="text-right"><strong data-translate="DOC_FAC_HEADER_NAME"></strong> </span><span class="text-right">{{$ctrl.doc.identificacao.nome}}</span></p><p><strong data-translate="DOC_FAC_HEADER_ADDRESS"></strong> <span class="text-right">{{$ctrl.doc.identificacao.morada}}</span></p><p><strong data-translate="DOC_FAC_HEADER_CP"></strong> <span class="text-right">{{$ctrl.doc.identificacao.codPostal}}</span>&nbsp; <span class="text-right">{{$ctrl.doc.identificacao.localidade}}</span></p><p><strong data-translate="DOC_FAC_HEADER_NIF"></strong> <span class="text-right">{{$ctrl.doc.identificacao.nifReal}}</span></p></div><div class="row"><div class="col-md-4"><h4 class="page-header-cg" data-translate="carrinho.moradas.faturacao"></h4><dl class="dl-horizontal hidden-print"><dt data-translate="DOC_FAC_HEADER_NAME"></dt><dd>{{$ctrl.doc.identificacao.nome}}</dd><dt data-translate="DOC_FAC_HEADER_ADDRESS"></dt><dd>{{$ctrl.doc.identificacao.morada}}</dd><dt data-translate="DOC_FAC_HEADER_CP"></dt><dd>{{$ctrl.doc.identificacao.codPostal}}&nbsp;{{$ctrl.doc.identificacao.localidade}}</dd><dt data-translate="DOC_FAC_HEADER_NIF"></dt><dd>{{$ctrl.doc.identificacao.nifReal}}</dd><dt>Pa\xEDs:</dt><dd>{{$ctrl.doc.identificacao.paisIso.nomePais}}</dd></dl></div><div class="col-md-4"><h4 class="page-header-cg" data-translate="carrinho.moradas.entrega"></h4><dl class="dl-horizontal hidden-print"><dt data-translate="DOC_FAC_HEADER_NAME"></dt><dd>{{$ctrl.doc.carga.nomedestin1}}</dd><dt data-translate="DOC_FAC_HEADER_ADDRESS"></dt><dd>{{$ctrl.doc.carga.moradaDescarga}}</dd><dt data-translate="DOC_FAC_HEADER_CP"></dt><dd>{{$ctrl.doc.carga.cpostDescarga}}&nbsp;{{$ctrl.doc.carga.localiDescarga}}</dd><dt>Pa\xEDs:</dt><dd>{{$ctrl.doc.paisIsoDesca.nomePais}}</dd></dl></div><div class="col-md-4"><h4 class="page-header-cg" data-translate="carrinho.stepEnvio.transporte"></h4><p>{{$ctrl.doc.transportadora.nome}}</p><p ng-if="!$ctrl.doc.transportadora.nome" data-translate="carrinho.stepResumo.meioEnvioVazio"></p></div></div></div><div class="table-responsive"><table class="table table-striped font-table table-documento"><thead><tr><th width="35%" class="font-table-artigo" data-translate="DOC_FAC_TABLE_TH_PRODUCT"></th><th width="15%" data-translate="DOC_FAC_TABLE_TH_PRICE"></th><th width="5%" data-translate="DOC_FAC_TABLE_TH_QTD"></th><th width="10%" data-translate="DOC_FAC_TABLE_TH_DISCOUNT"></th><th width="15%" data-translate="DOC_FAC_TABLE_TH_IVA"></th><th width="20%" data-translate="DOC_FAC_TABLE_TH_VALUE"></th></tr></thead><tbody><tr ng-repeat="item in $ctrl.doc.linhas"><td>{{item.nome}}</td><td>{{item.prVenda | currency : \'\u20AC\' : 2}}</td><td>{{item.qtd1 | number: 2}}</td><td><span ng-hide="item.d1 === 0">{{item.d1 | number: 2}}%</span> <span ng-hide="item.d2 === 0">{{item.d2 | number: 2}}%</span> <span ng-hide="item.d3 === 0">{{item.d3 | number: 2}}%</span> <span ng-hide="item.d4 === 0">{{item.d4 | number: 2}}%</span> <span ng-hide="item.d5 === 0">{{item.d5 | number: 2}}%</span> <span ng-hide="item.d6 === 0">{{item.d6 | number: 2}}%</span></td><td>{{item.taxaIva | number: 2}}%</td><td>{{item.valorComIva2D | currency : \'\u20AC\' : 2}}</td></tr></tbody></table></div><table class="table table-responsive font-table"><thead class="fac-doc-table text-right"><tr><th width="20%"></th><th width="20%"></th><th width="10%"></th><th width="10%" data-translate="DOC_FAC_TABLE_TH_TAXE"></th><th width="20%" data-translate="DOC_FAC_TABLE_TH_INCIDENCIA"></th><th width="20%" data-translate="DOC_FAC_TABLE_TH_IVA_TOTAl"></th></tr></thead><tbody><tr class="text-right" ng-repeat="item in $ctrl.doc.resumoIva"><td></td><td></td><td></td><td>{{item.taxaIva | number: 2}}</td><td><span class="pull-right">{{item.valorLiquido | currency: \'\u20AC\'}}</span></td><td><span class="pull-right">{{item.valorIva | currency: \'\u20AC\'}}</span></td></tr></tbody></table><hr><div class="row fac-doc-totais clearfix" ng-if="$ctrl.doc.caixa"><div class="col-md-4"><h4 class="page-header-cg" data-translate="utilizador.documento.meioPagamento.title" ng-if="$ctrl.doc.caixa"></h4><div class="panel panel-default panel-pagamento"><div class="panel-heading"><span ng-if="$ctrl.doc.caixa.tipo === 9"><i class="fa fa-paypal fa-fw"></i> <span>{{$ctrl.doc.caixa.nome}}</span> </span><span ng-if="$ctrl.doc.caixa.tipo === 8"><i class="fa fa-bank fa-fw"></i> <span>{{$ctrl.doc.caixa.nome}}</span> </span><span ng-if="$ctrl.doc.caixa.tipo === 2"><i class="fa fa-credit-card fa-fw"></i> <span>{{$ctrl.doc.caixa.nome}}</span></span></div><div class="panel-body" pl-promise="$ctrl.promise"><div ng-if="$ctrl.doc.caixa.tipo === 9"><dl class="dl-horizontal pull-right"><dt data-translate="utilizador.documento.meioPagamento.transferencia.valor"></dt><dd class="text-right">{{$ctrl.doc.faccb.total | currency: \'\u20AC\'}}</dd><dt></dt><dd class="text-right" ng-if="$ctrl.stateName !== \'admin.documentos\'"><button class="btn btn-primary btn-sm btn-block" ng-click="$ctrl.pay($ctrl.doc)" ng-if="$ctrl.canPay($ctrl.doc)" title="Pagar"><i class="fa fa-paypal fa-fw"></i>&nbsp;<span data-translate="utilizador.documento.meioPagamento.paypal.pagar"></span></button></dd></dl></div><div ng-if="$ctrl.doc.caixa.tipo === 8"><dl class="dl-horizontal pull-right"><dt data-translate="utilizador.documento.meioPagamento.transferencia.iban"></dt><dd class="text-right">{{$ctrl.doc.caixa.nib}}</dd><dt data-translate="utilizador.documento.meioPagamento.transferencia.swift"></dt><dd class="text-right">{{$ctrl.doc.caixa.swift}}</dd><dt data-translate="utilizador.documento.meioPagamento.transferencia.valor"></dt><dd class="text-right">{{$ctrl.doc.faccb.total | currency: \'\u20AC\'}}</dd></dl></div><div ng-if="$ctrl.doc.caixa.tipo === 2"><p ng-if="$ctrl.erroMB" data-translate="utilizador.documento.meioPagamento.multibanco.erro"></p><dl class="dl-horizontal pull-right" ng-repeat="item in $ctrl.referenciasmb | filter: {tipo: 0}"><dt data-translate="utilizador.documento.meioPagamento.multibanco.entidade"></dt><dd class="text-right">{{item.entidade}}</dd><dt data-translate="utilizador.documento.meioPagamento.multibanco.referencia"></dt><dd class="text-right">{{item.referencia}}</dd><dt data-translate="utilizador.documento.meioPagamento.multibanco.valor"></dt><dd class="text-right">{{item.montante | currency: \'\u20AC\'}}</dd></dl></div><br><div class="pull-right"><h4 ng-if="!$ctrl.canPay($ctrl.doc) && ($ctrl.doc.mbdocLog.last.estado === \'PaypalCompleted\' || $ctrl.doc.mbdocLog.last.estado === \'PayedSettedByAdmin\')"><label class="label label-success"><i class="fa fa-check fa-fw"></i>&nbsp;<span data-translate="utilizador.documento.meioPagamento.paypal.pago"></span></label></h4><h4 ng-if="!$ctrl.canPay($ctrl.doc) && $ctrl.doc.mbdocLog.last.estado === \'PaypalError\'"><label class="label label-danger"><i class="fa fa-times fa-fw"></i>&nbsp;<span data-translate="utilizador.documento.meioPagamento.paypal.erro"></span></label></h4></div><br><div ng-if="$ctrl.doc.mbdocLog.last.estado != \'PaypalCompleted\' && $ctrl.doc.mbdocLog.last.estado != \'PayedSettedByAdmin\' && ($ctrl.doc.currentUser.roles | filter: {name: \'admin\'}).length == 1"><dl class="dl-horizontal pull-right"><dt></dt><dd class="text-right"><button class="btn btn-primary btn-sm" ng-click="$ctrl.confirmPayment($ctrl.doc)"><i class="fa fa-check fa-fw"></i>&nbsp;<span data-translate="utilizador.documento.meioPagamento.confirmaPagamento"></span></button></dd></dl></div></div></div></div><div class="col-md-4"></div><div class="col-md-4"><h4 class="page-header-cg" data-translate="utilizador.documento.resumo.title"></h4><div class="panel panel-default panel-pagamento"><div class="panel-heading"><i class="fa fa-list fa-fw"></i>&nbsp;<span data-translate="utilizador.documento.resumo.totais"></span></div><div class="panel-body"><dl class="dl-horizontal pull-right"><dt data-translate="DOC_FAC_TABLE_TH_TOTAl"></dt><dd class="text-right">{{$ctrl.doc.faccb.totalLiquido | currency: \'\u20AC\'}}</dd><dt data-translate="DOC_FAC_TABLE_TH_IVA_TOTAl"></dt><dd class="text-right">{{$ctrl.doc.faccb.totalIva | currency: \'\u20AC\'}}</dd><dt data-translate="DOC_FAC_TABLE_TH_TOTAl_FINAL"></dt><dd class="text-right">{{$ctrl.doc.faccb.total | currency: \'\u20AC\'}}</dd></dl></div></div></div></div></div><div class="panel-footer"><div class="fac-doc-footer hidden-print"><button type="button" class="btn btn-default btn-sm" print-div="#printfac" ng-if="$ctrl.showPrint === true"><i class="fa fa-print"></i><span data-translate="BUTTON_PRINT"></span></button> <a ng-attr-href="{{$ctrl.pdfUrl}}" target="_blank" class="btn btn-primary btn-sm" ng-if="$ctrl.showPdf === true"><i class="fa fa-file-pdf-o"></i><span data-translate="BUTTON_PDF"></span></a></div></div></div></div>');
$templateCache.put('app/components/directives/grid/grid.layout.html','<div class="page-header"><a class="pull-right btn btn-primary" ng-click="addWidget()"><i class="glyphicon glyphicon-plus"></i> Add Widget</a> <a class="pull-right btn btn-warning" ng-click="clear()"><i class="glyphicon glyphicon-trash"></i> Clear</a><h1 style="display: inline-block; width: 200px;">Dashboard</h1><select class="form-control" style="width: 150px; margin-bottom: 20px; display:inline-block;" ng-change="changeDashboard()" ng-model="selectedDashboardId" ng-options="d.id as d.name for d in dashboards | object2Array | orderBy:\'id\'"></select></div><div gridster="gridsterOptions"><ul><li gridster-item="widget" ng-repeat="widget in dashboard.widgets"><div class="box" ng-controller="CustomWidgetCtrl"><div class="box-header"><h3>{{ widget.name }}</h3><div class="box-header-btns pull-right"><a title="settings" ng-click="openSettings(widget)"><i class="glyphicon glyphicon-cog"></i></a> <a title="Remove widget" ng-click="remove(widget)"><i class="glyphicon glyphicon-trash"></i></a></div></div><div class="box-content"></div></div></li></ul></div>');
$templateCache.put('app/components/directives/grid/grid.layout.settings.html','<div><form name="_form" class="form-horizontal" ng-submit="submit(_form)"><div class="modal-header"><button type="button" class="close" ng-click="dismiss()" aria-hidden="true">&times;</button><h3>Widget Settings</h3></div><div class="modal-body"><div class="form-group" ng-class="{error: _form.name.$error && _form.submitted}"><label class="control-label col-lg-3 col-md-3">Name</label><div class="col-lg-9 col-md-9"><input name="name" type="text" ng-model="form.name" class="form-control"></div></div><div class="row"><div class="col-lg-6 col-md-6"><div class="form-group" ng-class="{error: _form.sizeX.$error && _form.submitted}"><label class="control-label col-lg-6 col-md-6">Width</label><div class="col-lg-6 col-md-6"><input name="sizeX" ng-model="form.sizeX" class="form-control"></div></div></div><div class="col-lg-6 col-md-6"><div class="form-group"><label class="control-label col-lg-6 col-md-6">Height</label><div class="col-lg-6 col-md-6"><input name="sizeY" ng-model="form.sizeY" class="form-control"></div></div></div></div><div class="row"><div class="col-lg-6 col-md-6"><div class="form-group" ng-class="{error: _form.sizeX.$error && _form.submitted}"><label class="control-label col-lg-6 col-md-6">Column</label><div class="col-lg-6 col-md-6"><input name="col" ng-model="form.col" class="form-control"></div></div></div><div class="col-lg-6 col-md-6"><div class="form-group"><label class="control-label col-lg-6 col-md-6">Row</label><div class="col-lg-6 col-md-6"><input name="row" ng-model="form.row" class="form-control"></div></div></div></div></div><div class="modal-footer"><a ng-click="remove()" class="btn btn-danger pull-left" tabindex="-1"><i class="glyphicon glyphicon-trash"></i>Delete</a> <a ng-click="dismiss()" class="btn btn-default" tabindex="-1"><i class="glyphicon glyphicon-remove"></i>Cancel</a> <button type="submit" class="btn btn-primary btn-lg"><i class="glyphicon glyphicon-ok"></i>Save</button></div></form></div>');
$templateCache.put('app/components/directives/image/image.gallery.html','<div class="row"><div class="galeria" ng-repeat="image in $ctrl.images"><a ng-click="$ctrl.openLightboxWidgetModal($index)"><div class="col-xs-12 col-sm-6 col-md-3"><div class="thumbnail"><div class="thumb-box-parent"><div class="thumb-box-child"><img class="artimage_admin" ng-src="{{image.thumbUrl}}"></div></div></div></div></a></div></div>');
$templateCache.put('app/components/directives/image/lightbox-cg.html','<div class="modal-body" ng-swipe-left="Lightbox.nextImage()" ng-swipe-right="Lightbox.prevImage()"><div class="lightbox-nav"><button class="close" aria-hidden="true" ng-click="Lightbox.closeModal()">\xD7</button><div class="btn-group"><a class="btn btn-sm btn-primary" ng-click="Lightbox.prevImage()" ng-if="Lightbox.images.length > 1" uib-tooltip="Anterior" tooltip-placement="left"><i class="fa fa-chevron-left fa-fw"></i> </a><a class="btn btn-sm btn-primary" ng-href="{{Lightbox.imageUrl}}" target="_blank" uib-tooltip="Abrir numa nova janela" tooltip-placement="bottom"><i class="fa fa-external-link fa-fw"></i> </a><a class="btn btn-sm btn-primary" ng-click="Lightbox.nextImage()" ng-if="Lightbox.images.length > 1" uib-tooltip="Pr\xF3ximo" tooltip-placement="right"><i class="fa fa-chevron-right fa-fw"></i></a></div></div><div class="lightbox-image-container"><img ng-if="!Lightbox.isVideo(Lightbox.image)" lightbox-src="{{Lightbox.imageUrl}}"><div class="lightbox-image-caption"><span data-translate="{{Lightbox.imageCaption}}"></span></div></div></div>');
$templateCache.put('app/components/directives/menu/menu.html','<!-- NAV BAR --><div class="navbar navbar-default navbar-cg-hardware navbar-fixed-top" role="navigation"><div class="container brand"><div class="navbar-header"><button type="button" class="navbar-toggle front collapsed" data-toggle="collapse" data-target="#navbar-collapse-id"><span class="sr-only">Menu</span> <span class="icon-bar"></span> <span class="icon-bar"></span> <span class="icon-bar"></span></button> <button type="button" class="btn navbar-carrinho hidden-sm hidden-md hidden-lg pull-right" ng-controller="CarrinhoController as carrinho" ui-sref="loja.carrinho"><i class="fa fa-shopping-cart fa-fw"></i> <span class="badge badge-cg" ng-if="carrinho.storage.carrinhoTotal.nItens == 0 ">{{carrinho.storage.carrinhoTotal.nItens}}</span> <span class="badge progress-bar-success animation-badge" ng-if="carrinho.storage.carrinhoTotal.nItens >= 1">{{carrinho.storage.carrinhoTotal.nItens}}</span></button> <a ui-sref="loja.home({id:\'inicio\'})" class="navbar-brand navbar-brand-cg"><img ng-src="{{ctrl.logo}}" width="150" height="41" alt="Logo"></a></div><div class="collapse navbar-collapse" id="navbar-collapse-id"><ul class="nav navbar-nav navbar-right"><li ng-class="ctrl.getMenuActiveClass(item)" ng-repeat="item in ctrl.menu" ng-if="!ctrl.menuHide(item)" uib-dropdown><a ng-attr-ui-sref="{{ctrl.ms.getUrl(item)}}" ng-if="!ctrl.ms.hasNodes(item) && item.pageId !== ctrl.ms.menuCarrinho.id &&\r\n          item.pageId !== ctrl.ms.menuClassificadores.id" data-toggle="collapse" data-target="#navbar-collapse-id.in"><i class="fa fa-fw" ng-class="item.fontAwesome"></i> {{ctrl.menuCaption(item)}} </a><a href class="dropdown-toggle hidden-xs" ng-if="item.pageId === ctrl.ms.menuCarrinho.id" data-toggle="dropdown" ng-controller="CarrinhoController as carrinho"><i class="fa fa-fw" ng-class="item.fontAwesome"></i> {{ctrl.menuCaption(item)}} <span class="badge badge-cg" ng-if="carrinho.storage.carrinhoTotal.nItens === 0 ">{{carrinho.storage.carrinhoTotal.nItens}}</span> <span class="badge progress-bar-success animation-badge" ng-if="carrinho.storage.carrinhoTotal.nItens >= 1">{{carrinho.storage.carrinhoTotal.nItens}} </span><span class="caret"></span> </a><a ui-sref="loja.carrinho" ng-if="item.pageId === ctrl.ms.menuCarrinho.id" class="hidden-sm hidden-md hidden-lg" data-toggle="collapse" data-target="#navbar-collapse-id.in" ng-controller="CarrinhoController as carrinho"><i class="fa fa-fw" ng-class="item.fontAwesome"></i> {{ctrl.menuCaption(item)}} <span class="badge badge-cg" ng-if="carrinho.storage.carrinhoTotal.nItens === 0 ">{{carrinho.storage.carrinhoTotal.nItens}}</span> <span class="badge progress-bar-success animation-badge" ng-if="carrinho.storage.carrinhoTotal.nItens >= 1">{{carrinho.storage.carrinhoTotal.nItens}} </span></a><a href ng-if="ctrl.ms.hasNodes(item)" class="dropdown-toggle vertical-last-divider" data-toggle="dropdown"><i class="fa fa-fw" ng-class="item.fontAwesome"></i> {{ctrl.menuCaption(item)}} <span class="caret"></span> </a><a href class="dropdown-toggle" ng-if="item.pageId === ctrl.ms.menuClassificadores.id" data-toggle="dropdown" uib-dropdown-toggle auto-close="outsideClick"><i class="fa fa-fw" ng-class="item.fontAwesome"></i> {{ctrl.menuCaption(item)}} <span class="caret"></span></a><ul class="dropdown-menu" role="menu" ng-if="ctrl.ms.hasNodes(item)" site-sub-menu menu="item.nodes"></ul><ul class="dropdown-menu" role="menu" ng-if="item.pageId === ctrl.ms.menuCarrinho.id" site-carrinho-sub-menu></ul><ul class="dropdown-menu top-menu-classificadores" role="menu" ng-if="item.pageId === ctrl.ms.menuClassificadores.id" uib-dropdown-menu site-classificadores-sub-menu></ul></li></ul></div></div></div>');
$templateCache.put('app/components/directives/menu/menu.submenu.carrinho.html','<div ng-controller="CarrinhoController as carrinho"><div class="scroller"><table at-table at-list="carrinho.storage.cesto" class="table table-responsive table-hover font-12" ng-cloak ng-hide="carrinho.storage.cesto.length==0"><thead></thead><tbody><tr><td at-title="{{\'CART_TABLE_TH_PRODUCT\' | translate}}"><a href ng-click="carrinho.showDetail(item)"><img class="img-responsive artimage-cart-menu" fallback-src="{{carrinho.storage.noimage}}" ng-src="{{carrinho.storage.getImagem(item)}}" alt=""></a></td><td at-title="{{\'CART_TABLE_TH_DETAIL\' | translate}}"><a href ng-click="carrinho.showDetail(item)">{{item.nome}}</a></td><td at-attribute="qtd" at-title="{{\'CART_TABLE_TH_QTD\' | translate}}"><span>{{item.qtd}}</span> <span ng-show="item.qtdPorUnidade1 !== 1">x {{item.qtdPorUnidade1}}</span></td><td class="text-nowrap" at-title="{{\'CART_TABLE_TH_PRICE\' | translate}}">{{item.precoSemDesconto | currency: \'\u20AC\'}}</td><td><a href ng-click="carrinho.removeBasket(item)" translate-attr="{\'title\': \'CART_MENU_REMOVE_ICON\'}"><i class="fa fa-trash-o fa-fw"></i></a></td></tr></tbody><tfoot></tfoot></table><div class="cesto-menu-vazio" ng-show="carrinho.storage.cesto.length==0"><h5 class="text-center" data-translate="CART_MENU_EMPTY"></h5><br><br></div></div><div class="cartFooter-menu text-right"><h5><strong><span data-translate="CART_SUBTOTAL"></span> {{carrinho.storage.carrinhoTotal.totalSemDesconto | currency: \'\u20AC \'}}</strong></h5><div><a href ui-sref="loja.carrinho" class="btn btn-sm btn-primary-cg"><i class="fa fa-shopping-cart fa-fw" aria-hidden="true"></i>&nbsp;<span data-translate="CART_MENU_GO_BUTTON"></span></a></div><div><a href class="btn btn-sm btn-default" ng-click="carrinho.removeAllBasket(item)" ng-hide="carrinho.storage.cesto.length==0"><i class="fa fa-trash fa-fw" aria-hidden="true"></i>&nbsp;<span data-translate="CART_MENU_REMOVE_ALL_BUTTON"></span></a></div></div></div>');
$templateCache.put('app/components/directives/menu/menu.submenu.classificadores.html','<!--<li ng-repeat="item1 in ctrl.menuProdutos" ng-class="{\'dropdown-submenu\' : item1.child && item1.child.length}">\r\n  <a href="" class="dropdown-toggle" data-toggle="dropdown">\r\n    {{item1.nome}}\r\n  </a>\r\n  <ul class="dropdown-menu">\r\n    <li ng-repeat="item2 in item1.child">\r\n      <a class="submenu-header" href="#">\r\n        {{item2.nome}}\r\n      </a>\r\n      <ul class="submenu-classificadores">\r\n        <li ng-repeat="item3 in item2.childs">\r\n          <a href="#">{{item3.nome}}</a>\r\n        </li>\r\n      </ul>\r\n    </li>\r\n  </ul>\r\n</li>--><pl-navpill><pl-panel caption="{{item1.name}}" ng-repeat="item1 in ctrl.menuProdutos"><div class="row"><ul><li class="col-md-4" ng-repeat="item2 in item1.childs"><a class="submenu-header" ng-click="ctrl.menuClick(item2)">{{item2.name}}</a><ul><li ng-repeat="item3 in item2.childs"><a ng-click="ctrl.menuClick(item3)">{{item3.name}}</a></li></ul></li></ul></div></pl-panel></pl-navpill>');
$templateCache.put('app/components/directives/menu/menu.submenu.html','<li ng-class="ctrl.getMenuActiveClass(item)" ng-repeat="item in ctrl.menu"><a ng-attr-ui-sref="{{ctrl.ms.getUrl(item)}}"><i class="fa fa-fw" ng-class="item.fontAwesome"></i> {{ctrl.menuCaption(item)}}</a></li>');
$templateCache.put('app/components/widgets/breadcrumb/breadcrumb.edit.html','<ng-form editable-form name="tableform" onbeforesave="" onaftersave="saveTable()"><table class="table table-responsive table-condensed table-bordered table-hover"><thead><tr style="font-weight: bold"><td>Tit\xFAlo</td><td></td></tr></thead><tbody><tr><td><span editable-text="item.data.breadcrumb.titulo" e-name="title" e-form="rowform">{{ item.data.breadcrumb.titulo || \'vazio\' }}</span></td><td><button type="button" ng-show="tableform.$visible" ng-click="removeItem(item.data.breadcrumb.titulo)" class="btn btn-danger btn-sm pull-right"><i class="fa fa-trash fa-fw"></i></button></td></tr></tbody></table><div class="btn-edit"><button type="button" class="btn btn-warning btn-sm" ng-show="!tableform.$visible" ng-click="tableform.$show()"><i class="fa fa-edit fa-fw"></i> {{\'BUTTON_EDIT\' | translate}}</button></div><div class="btn-form" ng-show="tableform.$visible"><button type="button" ng-disabled="tableform.$waiting" ng-click="addItem()" class="btn btn-success btn-sm pull-right"><i class="fa fa-plus fa-fw"></i> {{\'BUTTON_ADD_ROW\' | translate}}</button> <button type="button" ng-disabled="tableform.$waiting" class="btn btn-primary-cg btn-sm" ng-click="save()"><i class="fa fa-save fa-fw"></i> {{\'BUTTON_SAVE\' | translate}}</button> <button type="button" ng-disabled="tableform.$waiting" ng-click="tableform.$cancel()" class="btn btn-default btn-sm"><i class="fa fa-remove fa-fw"></i>{{\'BUTTON_CANCEL\' | translate}}</button></div></ng-form>');
$templateCache.put('app/components/widgets/breadcrumb/breadcrumb.html','<div class="container"><div class="row"><div class="col-xs-12"><ol class="breadcrumb breadcrumb-cg"><li><a ui-sref="loja.home({id:\'inicio\'})"><i class="fa fa-home fa-fw"></i></a></li><li class="active">{{item.data.breadcrumb.titulo}}</li></ol></div></div></div>');
$templateCache.put('app/components/widgets/carousel/carousel.edit.html','<ng-form name="$ctrl.tableform" editable-form><!--<pre>{{$ctrl|json}}</pre>--><div class="table-responsive"><table class="table table-responsive table-condensed table-bordered table-hover"><thead><tr style="font-weight: bold"><td class="col-md-1" data-translate="PAGINAS_CAROUSEL_EDIT_TITLE"></td><td class="col-md-1" data-translate="PAGINAS_CAROUSEL_EDIT_TEXT"></td><td class="col-md-2" data-translate="PAGINAS_CAROUSEL_EDIT_LINK"></td><td class="col-md-2" data-translate="PAGINAS_CAROUSEL_EDIT_LINK_BTNTEXT"></td><td class="col-md-2" data-translate="PAGINAS_CAROUSEL_EDIT_IMAGE"></td><td class="col-md-2" data-translate="PAGINAS_CAROUSEL_EDIT_TIME"></td><td class="col-md-2"><button type="button" class="btn btn-success btn-sm" ng-disabled="$ctrl.tableform.$waiting" ng-click="$ctrl.addItem()"><i class="fa fa-plus fa-fw"></i></button></td></tr></thead><tbody><tr ng-repeat="item in $ctrl.item.data.carousel.items"><td><input class="form-control" type="text" ng-model="item.titulo"></td><td><input class="form-control" type="text" ng-model="item.text"></td><td><input class="form-control" type="text" ng-model="item.link"></td><td><input class="form-control" type="text" ng-model="item.linkBtnText"></td><td><img class="imagens_wrapper" fallback-src="http://www.placehold.it/100x50/EFEFEF/AAAAAA&text=sem+imagem" ng-src="{{$ctrl.getImagem(item.image)}}"></td><td><span>{{item.dateTime.from | date:\'dd/MM/yyyy\'}} {{item.dateTime.from | date:\'HH:mm:ss\' || \'vazio\'}}</span> <span>{{item.dateTime.to | date:\'dd/MM/yyyy\'}} {{item.dateTime.to | date:\'HH:mm:ss\' || \'vazio\'}}</span></td><td><button type="button" class="btn btn-primary-cg btn-sm" ng-click="$ctrl.addImage(item)"><i class="fa fa-image fa-fw"></i></button> <button type="button" class="btn btn-primary-cg btn-sm" ng-click="$ctrl.openTimePickerModal(item)"><i class="fa fa-calendar fa-fw"></i></button> <button type="button" class="btn btn-danger btn-sm" ng-click="$ctrl.removeItem(item)"><i class="fa fa-trash fa-fw"></i></button></td></tr></tbody></table></div></ng-form>');
$templateCache.put('app/components/widgets/carousel/carousel.html','<!--<pre>{{$ctrl|json}}</pre>--><div class="carousel-margin carousel"><div uib-carousel interval="$ctrl.myInterval" active="$ctrl.active"><div uib-slide ng-repeat="slide in $ctrl.carouselItems track by slide._index " index="slide._index"><img class="image-mask img-responsive" ng-src="{{$ctrl.getImagem(slide.image)}}" style="margin:auto;"><div class="myCaption carousel-caption"><h1 ng-class="{\'myColor\': $first}" ng-hide="slide.titulo == \'\'">{{slide.titulo}}</h1><h3 ng-class="{\'myColor\': $first}" ng-hide="slide.text == \'\'">{{slide.text}}</h3><a class="btn btn-cg-carousel btn-lg hidden-xs" href="{{slide.link}}" ng-hide="slide.link == \'\'">{{slide.linkBtnText}}</a> <a class="btn btn-cg-carousel btn-sm hidden-lg hidden-md hidden-sm" href="{{slide.link}}" ng-hide="slide.link == \'\'">{{slide.linkBtnText}}</a><br><br></div></div></div></div>');
$templateCache.put('app/components/widgets/contactosInfo/contactos.info.edit.html','<form class="well" editable-form name="tableform" onbeforesave="" onaftersave="saveTable()"><div class="form-horizontal"><div class="form-group"><label class="col-sm-2 control-label">Nome empresa</label><div class="col-sm-10"><input type="text" class="form-control" ng-model="item.data.empresa.nomeEmpresa"></div></div><div class="form-group"><label class="col-sm-2 control-label">Morada</label><div class="col-sm-10"><input type="text" class="form-control" ng-model="item.data.empresa.morada"></div><label class="col-sm-2 control-label">Icon</label><div class="col-sm-10"><input class="form-control" rows="3" ng-model="item.data.fontAwesome.empresa.morada"></div></div><div class="form-group"><label class="col-sm-2 control-label">C\xF3digo Postal</label><div class="col-sm-10"><input type="text" class="form-control" ng-model="item.data.empresa.codPostalEmp"></div></div><div class="form-group"><label class="col-sm-2 control-label">Freguesia</label><div class="col-sm-10"><input type="text" class="form-control" ng-model="item.data.empresa.freguesiaEmp"></div></div><div class="form-group"><label class="col-sm-2 control-label">Localidade</label><div class="col-sm-10"><input type="text" class="form-control" ng-model="item.data.empresa.localidaEmp"></div></div><div class="form-group"><label class="col-sm-2 control-label">Telefone</label><div class="col-sm-10"><input type="text" class="form-control" ng-model="item.data.empresa.telef1Emp"></div><label class="col-sm-2 control-label">Icon</label><div class="col-sm-10"><input class="form-control" rows="3" ng-model="item.data.fontAwesome.empresa.telef1Emp"></div></div><div class="form-group"><label class="col-sm-2 control-label">Tel\xE9movel</label><div class="col-sm-10"><input type="text" class="form-control" ng-model="item.data.empresa.telef2Emp"></div><label class="col-sm-2 control-label">Icon</label><div class="col-sm-10"><input class="form-control" rows="3" ng-model="item.data.fontAwesome.empresa.telef2Emp"></div></div><div class="form-group"><label class="col-sm-2 control-label">Fax</label><div class="col-sm-10"><input type="text" class="form-control" ng-model="item.data.empresa.fax1Emp"></div><label class="col-sm-2 control-label">Icon</label><div class="col-sm-10"><input class="form-control" rows="3" ng-model="item.data.fontAwesome.empresa.fax1Emp"></div></div><div class="form-group"><label class="col-sm-2 control-label">Email</label><div class="col-sm-10"><input type="text" class="form-control" ng-model="item.data.empresa.email"></div><label class="col-sm-2 control-label">Icon</label><div class="col-sm-10"><input class="form-control" rows="3" ng-model="item.data.fontAwesome.empresa.email"></div></div></div></form>');
$templateCache.put('app/components/widgets/contactosInfo/contactos.info.html','<div class="container"><div class="row"><div class="col-md-4"><address><h4 class="page-header-cg">{{item.data.empresa.nomeEmpresa}}</h4><br><div class="margin-dt"><dl class="dl-horizontal"><dt ng-show="item.data.fontAwesome.empresa.morada"><abbr title="{{\'CONTACTS_ABBR_ADDRESS\' | translate}}"><i class="fa fa-fw" ng-class="item.data.fontAwesome.empresa.morada"></i></abbr></dt><dd ng-show="item.data.empresa.morada">{{item.data.empresa.morada}}</dd><dd ng-show="item.data.empresa.codPostalEmp || item.data.empresa.freguesiaEmp">{{item.data.empresa.codPostalEmp}} {{item.data.empresa.freguesiaEmp}}</dd><dd ng-show="item.data.empresa.localidaEmp">{{item.data.empresa.localidaEmp}}</dd><br><dt ng-show="item.data.fontAwesome.empresa.telef1Emp"><abbr title="{{\'CONTACTS_ABBR_PHONE\' | translate}}"><i class="fa fa-fw" ng-class="item.data.fontAwesome.empresa.telef1Emp"></i></abbr></dt><dd ng-show="item.data.empresa.telef1Emp">{{item.data.empresa.telef1Emp}}</dd><dt ng-show="item.data.fontAwesome.empresa.telef2Emp"><abbr title="{{\'CONTACTS_ABBR_MOBILE\' | translate}}"><i class="fa fa-fw" ng-class="item.data.fontAwesome.empresa.telef2Emp"></i></abbr></dt><dd ng-show="item.data.empresa.telef2Emp">{{item.data.empresa.telef2Emp}}</dd><dt ng-show="item.data.fontAwesome.empresa.fax1Emp"><abbr title="{{\'CONTACTS_ABBR_FAX\' | translate}}"><i class="fa fa-fw" ng-class="item.data.fontAwesome.empresa.fax1Emp"></i></abbr></dt><dd ng-show="item.data.empresa.fax1Emp">{{item.data.empresa.fax1Emp}}</dd><dt ng-show="item.data.fontAwesome.empresa.email"><abbr title="{{\'CONTACTS_ABBR_EMAIL\' | translate}}"><i class="fa fa-fw" ng-class="item.data.fontAwesome.empresa.email"></i></abbr></dt><dd ng-show="item.data.empresa.email">{{item.data.empresa.email}}</dd></dl></div></address></div><div class="col-md-8" ng-show="submited"><div class="alert alert-success">O formul\xE1rio foi enviado com sucesso!</div><button type="button" class="btn btn-primary-cg" ng-click="submited=false"><i class="fa fa-send fa-fw"></i> Enviar novo contacto</button></div><div class="col-md-8" ng-show="!submited"><div class="panel panel-primary"><div class="panel-heading panel-cg"><h3 class="panel-title" data-translate="CONTACTS_CONTACT_FORM"></h3></div><form class="form-horizontal" name="formContact" id="formContact" novalidate angular-validator angular-validator-submit="sendMail(formContact)" role="form"><div class="panel-body"><div class="form-group"><label class="col-sm-2 control-label" data-translate="CONTACTS_CONTACT_FORM_NAME"></label><div class="col-sm-10"><input type="text" name="from" id="from" ng-model="form.from" class="form-control" placeholder="{{\'CONTACTS_CONTACT_FORM_NAME\' | translate}}" required-message="\'{{ \'CONTACTS_ERROR_NAME_REQUIRED\' | translate }}\'" required></div></div><div class="form-group"><label class="col-sm-2 control-label" data-translate="CONTACTS_ABBR_EMAIL"></label><div class="col-sm-10"><input type="email" name="email" id="email" ng-model="form.email" class="form-control" placeholder="{{\'CONTACTS_ABBR_EMAIL\' | translate}}" invalid-message="\'{{ \'LOGIN_ERROR_EMAIL_INVALID\' | translate }}\'" required-message="\'{{ \'LOGIN_ERROR_EMAIL_REQUIRED\' | translate }}\'" required></div></div><div class="form-group"><label class="col-sm-2 control-label" data-translate="CONTACTS_CONTACT_FORM_MSG"></label><div class="col-sm-10"><textarea name="message" id="message" class="form-control" ng-model="form.message" rows="3" placeholder="{{\'CONTACTS_CONTACT_FORM_MSG\' | translate}}" required-message="\'{{ \'CONTACTS_ERROR_MESSAGE_REQUIRED\' | translate }}\'" required></textarea></div></div></div><div class="panel-footer"><div class="col-md-2"></div><button type="submit" class="btn btn-primary-cg"><i class="fa fa-send fa-fw"></i> {{ \'BUTTON_SEND\' | translate}}</button></div></form></div></div></div></div>');
$templateCache.put('app/components/widgets/googleMaps/google.maps.edit.html','<form class="well" editable-form name="tableform" onbeforesave="" onaftersave="saveTable()"><div class="form-horizontal"><div class="form-group"><label class="col-sm-2 control-label">Titulo</label><div class="col-sm-10"><input type="text" class="form-control" ng-model="item.data.titulo"></div></div><div class="form-group"><label class="col-sm-2 control-label">Google Maps (embed)</label><div class="col-sm-10"><textarea type="text" class="form-control" rows="5" ng-model="item.data.url"></textarea></div></div></div></form>');
$templateCache.put('app/components/widgets/googleMaps/google.maps.html','<div class="container-fluid"><div class="container"><h4 class="page-header-cg">{{item.data.titulo}}</h4><div class="panel panel-default"><div class="panel-body"><iframe ng-src="{{trustSrc(item.data.url)}}" width="100%" height="300" frameborder="0" style="border:0" allowfullscreen></iframe></div></div><br></div></div>');
$templateCache.put('app/components/widgets/htmlCol3/html.col3.edit.html','<ng-form editable-form name="tableform" onbeforesave="" onaftersave="saveTable()"><div class="row"><div class="col-md-3"><label>T\xEDtulo 1</label> <input class="form-control" type="text" ng-model="item.data.html.titulo1"><br><label>URL 1</label> <input class="form-control" type="text" ng-model="item.data.html.url1"><div class="thumbnail"><img class="imagens_wrapper" fallback-src="http://www.placehold.it/100x50/EFEFEF/AAAAAA&text=sem+imagem" ng-src="{{getImagem(item.data.html.imgUrl1)}}"></div><button type="button" ng-click="addImage1(item)" class="btn btn-primary-cg btn-sm"><i class="fa fa-image fa-fw"></i></button> <button type="button" ng-click="item.data.html.imgUrl1 = \'\'" class="btn btn-danger btn-sm"><i class="fa fa-trash fa-fw"></i></button></div><div class="col-md-3"><label>T\xEDtulo 2</label> <input class="form-control" type="text" ng-model="item.data.html.titulo2"><br><label>URL 2</label> <input class="form-control" type="text" ng-model="item.data.html.url2"><div class="thumbnail"><img class="imagens_wrapper" fallback-src="http://www.placehold.it/100x50/EFEFEF/AAAAAA&text=sem+imagem" ng-src="{{getImagem(item.data.html.imgUrl2)}}"></div><button type="button" ng-click="addImage2(item)" class="btn btn-primary-cg btn-sm"><i class="fa fa-image fa-fw"></i></button> <button type="button" ng-click="item.data.html.imgUrl2 = \'\'" class="btn btn-danger btn-sm"><i class="fa fa-trash fa-fw"></i></button></div><div class="col-md-3"><label>T\xEDtulo 3</label> <input class="form-control" type="text" ng-model="item.data.html.titulo3"><br><label>URL 3</label> <input class="form-control" type="text" ng-model="item.data.html.url3"><div class="thumbnail"><img class="imagens_wrapper" fallback-src="http://www.placehold.it/100x50/EFEFEF/AAAAAA&text=sem+imagem" ng-src="{{getImagem(item.data.html.imgUrl3)}}"></div><button type="button" ng-click="addImage3(item)" class="btn btn-primary-cg btn-sm"><i class="fa fa-image fa-fw"></i></button> <button type="button" ng-click="item.data.html.imgUrl3 = \'\'" class="btn btn-danger btn-sm"><i class="fa fa-trash fa-fw"></i></button></div><div class="col-md-3"><label>T\xEDtulo 4</label> <input class="form-control" type="text" ng-model="item.data.html.titulo4"><br><label>URL 4</label> <input class="form-control" type="text" ng-model="item.data.html.url4"><div class="thumbnail"><img class="imagens_wrapper" fallback-src="http://www.placehold.it/100x50/EFEFEF/AAAAAA&text=sem+imagem" ng-src="{{getImagem(item.data.html.imgUrl4)}}"></div><button type="button" ng-click="addImage4(item)" class="btn btn-primary-cg btn-sm"><i class="fa fa-image fa-fw"></i></button> <button type="button" ng-click="item.data.html.imgUrl4 = \'\'" class="btn btn-danger btn-sm"><i class="fa fa-trash fa-fw"></i></button></div></div></ng-form><br><br><label>Texto coluna 1</label> <textarea ui-tinymce="tinymceOptions" ng-model="item.data.html.texto1"></textarea> <label>Texto coluna 2</label> <textarea ui-tinymce="tinymceOptions" ng-model="item.data.html.texto2"></textarea> <label>Texto coluna 3</label> <textarea ui-tinymce="tinymceOptions" ng-model="item.data.html.texto3"></textarea> <label>Texto coluna 4</label> <textarea ui-tinymce="tinymceOptions" ng-model="item.data.html.texto4"></textarea>');
$templateCache.put('app/components/widgets/htmlCol3/html.col3.html','<div class="container"><div class="row"><h3 ng-hide="!item.title" class="page-header-cg">{{item.title}}</h3><div class="col-md-3 pull-left"><h3 ng-hide="!item.data.html.titulo1" class="page-header-cg">{{item.data.html.titulo1}}</h3><a href="{{item.data.html.url1}}"><img class="img-responsive" ng-show="item.data.html.imgUrl1" ng-src="{{getImagem(item.data.html.imgUrl1)}}" style="margin:auto;"></a><br><div ng-hide="!item.data.html.texto1" ng-bind-html="item.data.html.texto1"></div></div><div class="col-md-3 pull-left"><h3 ng-hide="!item.data.html.titulo2" class="page-header-cg">{{item.data.html.titulo2}}</h3><a href="{{item.data.html.url2}}"><img class="img-responsive" ng-show="item.data.html.imgUrl2" ng-src="{{getImagem(item.data.html.imgUrl2)}}" style="margin:auto;"></a><br><div ng-hide="!item.data.html.texto2" ng-bind-html="item.data.html.texto2"></div></div><div class="col-md-3 pull-left"><h3 ng-hide="!item.data.html.titulo3" class="page-header-cg">{{item.data.html.titulo3}}</h3><a href="{{item.data.html.url3}}"><img class="img-responsive" ng-show="item.data.html.imgUrl3" ng-src="{{getImagem(item.data.html.imgUrl3)}}" style="margin:auto;"></a><br><div ng-hide="!item.data.html.texto3" ng-bind-html="item.data.html.texto3"></div></div><div class="col-md-3 pull-left"><h3 ng-hide="!item.data.html.titulo4" class="page-header-cg">{{item.data.html.titulo4}}</h3><a href="{{item.data.html.url4}}"><img class="img-responsive" ng-show="item.data.html.imgUrl4" ng-src="{{getImagem(item.data.html.imgUrl4)}}" style="margin:auto;"></a><br><div ng-hide="!item.data.html.texto4" ng-bind-html="item.data.html.texto4"></div></div></div></div>');
$templateCache.put('app/components/widgets/htmlCol4/html.col4.edit.html','<ng-form editable-form name="tableform" onbeforesave="" onaftersave="$ctrl.saveTable()"><div class="row"><div class="col-md-4"><label>T\xEDtulo 1</label> <input class="form-control" type="text" ng-model="$ctrl.item.data.html.titulo1"><br><label>URL 1</label> <input class="form-control" type="text" ng-model="$ctrl.item.data.html.url1"><div class="thumbnail"><img class="imagens_wrapper" fallback-src="http://www.placehold.it/100x50/EFEFEF/AAAAAA&text=sem+imagem" ng-src="{{$ctrl.getImagem($ctrl.item.data.html.imgUrl1)}}"></div><button type="button" ng-click="$ctrl.addImage1($ctrl.item)" class="btn btn-primary-cg btn-sm"><i class="fa fa-image fa-fw"></i></button> <button type="button" ng-click="$ctrl.item.data.html.imgUrl1 = \'\'" class="btn btn-danger btn-sm"><i class="fa fa-trash fa-fw"></i></button></div><div class="col-md-4"><label>T\xEDtulo 2</label> <input class="form-control" type="text" ng-model="$ctrl.item.data.html.titulo2"><br><label>URL 2</label> <input class="form-control" type="text" ng-model="$ctrl.item.data.html.url2"><div class="thumbnail"><img class="imagens_wrapper" fallback-src="http://www.placehold.it/100x50/EFEFEF/AAAAAA&text=sem+imagem" ng-src="{{$ctrl.getImagem($ctrl.item.data.html.imgUrl2)}}"></div><button type="button" ng-click="$ctrl.addImage2($ctrl.item)" class="btn btn-primary-cg btn-sm"><i class="fa fa-image fa-fw"></i></button> <button type="button" ng-click="$ctrl.item.data.html.imgUrl2 = \'\'" class="btn btn-danger btn-sm"><i class="fa fa-trash fa-fw"></i></button></div><div class="col-md-4"><label>T\xEDtulo 3</label> <input class="form-control" type="text" ng-model="$ctrl.item.data.html.titulo3"><br><label>URL 3</label> <input class="form-control" type="text" ng-model="$ctrl.item.data.html.url3"><div class="thumbnail"><img class="imagens_wrapper" fallback-src="http://www.placehold.it/100x50/EFEFEF/AAAAAA&text=sem+imagem" ng-src="{{$ctrl.getImagem($ctrl.item.data.html.imgUrl3)}}"></div><button type="button" ng-click="$ctrl.addImage3($ctrl.item)" class="btn btn-primary-cg btn-sm"><i class="fa fa-image fa-fw"></i></button> <button type="button" ng-click="$ctrl.item.data.html.imgUrl3 = \'\'" class="btn btn-danger btn-sm"><i class="fa fa-trash fa-fw"></i></button></div></div></ng-form><br><br><label>Texto coluna 1</label> <textarea ui-tinymce="$ctrl.tinymceOptions" ng-model="$ctrl.item.data.html.texto1"></textarea> <label>Texto coluna 2</label> <textarea ui-tinymce="$ctrl.tinymceOptions" ng-model="$ctrl.item.data.html.texto2"></textarea> <label>Texto coluna 3</label> <textarea ui-tinymce="$ctrl.tinymceOptions" ng-model="$ctrl.item.data.html.texto3"></textarea>');
$templateCache.put('app/components/widgets/htmlCol4/html.col4.html','<div class="container"><div class="row"><h3 ng-hide="!$ctrl.item.title" class="page-header-cg">{{$ctrl.item.title}}</h3><div class="col-md-4 pull-left"><h3 ng-hide="!$ctrl.item.data.html.titulo1" class="page-header-cg">{{$ctrl.item.data.html.titulo1}}</h3><a href="{{$ctrl.item.data.html.url1}}"><img class="img-responsive" ng-show="$ctrl.item.data.html.imgUrl1" ng-src="{{$ctrl.getImagem($ctrl.item.data.html.imgUrl1)}}" style="margin:auto;"></a><br><div ng-hide="!$ctrl.item.data.html.texto1" ng-bind-html="$ctrl.item.data.html.texto1"></div></div><div class="col-md-4 pull-left"><h3 ng-hide="!$ctrl.item.data.html.titulo2" class="page-header-cg">{{$ctrl.item.data.html.titulo2}}</h3><a href="{{$ctrl.item.data.html.url2}}"><img class="img-responsive" ng-show="$ctrl.item.data.html.imgUrl2" ng-src="{{$ctrl.getImagem($ctrl.item.data.html.imgUrl2)}}" style="margin:auto;"></a><br><div ng-hide="!$ctrl.item.data.html.texto2" ng-bind-html="$ctrl.item.data.html.texto2"></div></div><div class="col-md-4 pull-left"><h3 ng-hide="!$ctrl.item.data.html.titulo3" class="page-header-cg">{{$ctrl.item.data.html.titulo3}}</h3><a href="{{$ctrl.item.data.html.url3}}"><img class="img-responsive" ng-show="$ctrl.item.data.html.imgUrl3" ng-src="{{$ctrl.getImagem($ctrl.item.data.html.imgUrl3)}}" style="margin:auto;"></a><br><div ng-hide="!$ctrl.item.data.html.texto3" ng-bind-html="$ctrl.item.data.html.texto3"></div></div></div></div>');
$templateCache.put('app/components/widgets/htmlCol6Image/html.col6Image.edit.html','<ng-form editable-form name="tableform"><div class="thumbnail"><img class="imagens_wrapper" ng-src="{{getImagem(item.data.html.imgUrl)}}"></div><button type="button" ng-click="addImage(item)" class="btn btn-primary-cg btn-sm"><i class="fa fa-image fa-fw"></i> {{\'BUTTON_IMAGE_PICK\' | translate}}</button> <button type="button" ng-click="item.data.html.imgUrl = \'\'" class="btn btn-danger btn-sm"><i class="fa fa-trash fa-fw"></i></button></ng-form><div class="page-header-cg"></div><label>Texto</label> <textarea ui-tinymce ng-model="item.data.html.texto"></textarea>');
$templateCache.put('app/components/widgets/htmlCol6Image/html.col6Image.html','<div class="container"><div class="row"><div class="col-md-12"><h3 class="page-header-cg" ng-hide="!item.title">{{item.title}}</h3></div></div><div class="row"><div class="col-md-6 text-center" ng-show="item.data.html.imgUrl"><img class="img-responsive" ng-src="{{getImagem(item.data.html.imgUrl)}}"></div><div class="col-md-6"><div ng-show="item.data.html.texto" ng-bind-html="item.data.html.texto"></div></div></div></div>');
$templateCache.put('app/components/widgets/htmlCol9Col3/html.col9.col3.edit.html','<ng-form editable-form name="tableform" onbeforesave="" onaftersave="saveTable()"><div class="thumbnail"><img class="imagens_wrapper" ng-src="{{getImagem(item.data.html.imgUrl)}}"></div><button type="button" ng-click="addImage(item)" class="btn btn-primary-cg btn-sm"><i class="fa fa-image fa-fw"></i> {{\'BUTTON_IMAGE_PICK\' | translate}}</button> <button type="button" ng-click="item.data.html.imgUrl = \'\'" class="btn btn-danger btn-sm"><i class="fa fa-trash fa-fw"></i></button></ng-form><div class="page-header-cg"></div><label>Texto1</label> <textarea ui-tinymce ng-model="item.data.html.texto1"></textarea> <label>Texto2</label> <textarea ui-tinymce ng-model="item.data.html.texto2"></textarea>');
$templateCache.put('app/components/widgets/htmlCol9Col3/html.col9.col3.html','<div class="container"><div class="row"><div class="col-md-12"><h3 ng-hide="!item.title" class="page-header-cg">{{item.title}}</h3><div class="col-md-6" style="margin-left: -25px" ng-show="item.data.html.imgUrl"><img class="img-responsive" ng-src="{{getImagem(item.data.html.imgUrl)}}" style="margin:auto;"></div><div class="col-md-9" style="margin-left: -15px;border-right: 1px solid #e7e7e7"><h3 ng-show="item.title1">{{item.title1}}</h3><div ng-show="item.data.html.texto1" ng-bind-html="item.data.html.texto1"></div></div><div class="col-md-3"><h3 ng-show="item.title2">{{item.title2}}</h3><div ng-show="item.data.html.texto2" ng-bind-html="item.data.html.texto2"></div></div></div></div></div>');
$templateCache.put('app/components/widgets/htmlCollapse/html.collapse.edit.html','<ng-form editable-form name="tableform" onbeforesave="" onaftersave="saveTable()" class="my-tabs"><tabset active="activeJustified" justified="true"><tab index="0" heading="Icon"><div class="well well-sm"><input class="form-control" type="text" ng-model="item.data.fontAwesome.titulo"></div></tab><tab index="1" heading="Titulo"><div class="well well-sm"><input class="form-control" type="text" ng-model="item.data.html.titulo"></div></tab><tab index="2" heading="Imagem"><div class="well well-sm"><div class="thumbnail"><img class="imagens_wrapper" fallback-src="http://www.placehold.it/100x50/EFEFEF/AAAAAA&text=sem+imagem" ng-src="{{getImagem(item.data.html.imgUrl)}}"></div><button type="button" ng-click="addImage(item)" class="btn btn-primary-cg btn-sm"><i class="fa fa-image fa-fw"></i></button> <button type="button" ng-click="item.data.html.imgUrl = \'\'" class="btn btn-danger btn-sm"><i class="fa fa-trash fa-fw"></i></button></div></tab><tab index="3" heading="Descri\xE7\xE3o"><textarea ui-tinymce ng-model="item.data.html.textoDesc"></textarea></tab><tab index="3" heading="Conte\xFAdo"><textarea ui-tinymce ng-model="item.data.html.texto"></textarea></tab></tabset></ng-form>');
$templateCache.put('app/components/widgets/htmlCollapse/html.collapse.html','<div class="container"><div class="row"><h3 ng-hide="!item.title" class="page-header-cg">{{item.title}}</h3><div class="col-md-12"><h3 ng-hide="!item.data.html.titulo" class="page-header-cg" ng-click="isCollapsed.titulo = !isCollapsed.titulo"><span ng-show="item.data.fontAwesome.titulo"><i class="fa fa-fw" ng-class="item.data.fontAwesome.titulo"></i> </span>{{item.data.html.titulo}} <span class="pull-right" style="font-size: 14px"><i class="fa" ng-class="{\'fa-plus fa-fw\': !isCollapsed.titulo}"></i> <i class="fa" ng-class="{\'fa-minus fa-fw\': isCollapsed.titulo}"></i></span></h3><div class="col-md-2" style="margin-left: -25px;" ng-show="item.data.html.imgUrl"><img class="img-responsive" ng-src="{{getImagem(item.data.html.imgUrl)}}" width="140" height="auto" style="margin:auto;"></div><div ng-class="{\'\': !item.data.html.imgUrl,\'col-md-10\': item.data.html.imgUrl}"><div ng-hide="!item.data.html.textoDesc" ng-bind-html="item.data.html.textoDesc"></div><div collapse="!isCollapsed.titulo"><div ng-hide="!item.data.html.texto" ng-bind-html="item.data.html.texto"></div></div></div></div></div></div>');
$templateCache.put('app/components/widgets/htmlFull/html.full.edit.html','<textarea ui-tinymce="tinymceOptions" ng-model="item.data.html"></textarea>');
$templateCache.put('app/components/widgets/htmlFull/html.full.html','<div class="container"><div class="row"><div class="col-md-12"><h3 class="page-header-cg" ng-hide="!item.title">{{item.title}}</h3><div ng-bind-html="item.data.html"></div></div></div></div>');
$templateCache.put('app/components/widgets/htmlFullButton/html.full.button.edit.html','<form class="well" editable-form name="tableform" onbeforesave="" onaftersave="saveTable()"><div class="form-horizontal"><div class="form-group"><label class="col-sm-2 control-label">Texto do bot\xE3o</label><div class="col-sm-10"><input type="text" class="form-control" ng-model="item.data.buttonText"></div></div><div class="form-group"><label class="col-sm-2 control-label">Url do bot\xE3o</label><div class="col-sm-10"><input type="text" class="form-control" ng-model="item.data.url"></div></div><div class="form-group"><label class="col-sm-2 control-label">Cor do bot\xE3o (btn-primary ...)</label><div class="col-sm-10"><input type="text" class="form-control" ng-model="item.data.btnClass"></div></div></div></form>');
$templateCache.put('app/components/widgets/htmlFullButton/html.full.button.html','<div class="container"><div class="row"><div class="col-md-4"></div><div class="col-md-4"><a class="btn btn-block btn-lg" ng-class="item.data.btnClass" href="{{item.data.url}}"><i class="fa fa-tags fa-fw"></i> {{item.data.buttonText}}</a></div><div class="col-md-4"></div></div></div>');
$templateCache.put('app/components/widgets/htmlHalf/html.half.edit.html','<ng-form editable-form name="tableform" onbeforesave="" onaftersave="saveTable()"><div class="thumbnail"><img class="imagens_wrapper" ng-src="{{getImagem(item.data.html.imgUrl)}}"></div><button type="button" ng-click="addImage(item)" class="btn btn-primary-cg btn-sm"><i class="fa fa-image fa-fw"></i> {{\'BUTTON_IMAGE_PICK\' | translate}}</button> <button type="button" ng-click="item.data.html.imgUrl = \'\'" class="btn btn-danger btn-sm"><i class="fa fa-trash fa-fw"></i></button></ng-form><div class="page-header-cg"></div><label>Texto1</label> <textarea ui-tinymce="tinymceOptions" ng-model="item.data.html.texto1"></textarea> <label>Texto2</label> <textarea ui-tinymce="tinymceOptions" ng-model="item.data.html.texto2"></textarea>');
$templateCache.put('app/components/widgets/htmlHalf/html.half.html','<div class="container"><div class="row"><div class="col-md-6" ng-show="item.data.html.imgUrl"><img class="img-responsive" ng-src="{{getImagem(item.data.html.imgUrl)}}" style="margin:auto;"></div><div class="col-md-9"><h3 ng-show="item.title1">{{item.title1}}</h3><div ng-show="item.data.html.texto1" ng-bind-html="item.data.html.texto1"></div></div><div class="col-md-3"><h3 ng-show="item.title2">{{item.title2}}</h3><div ng-show="item.data.html.texto2" ng-bind-html="item.data.html.texto2"></div></div></div></div>');
$templateCache.put('app/components/widgets/htmlImageFull/html.image.full.edit.html','<ng-form editable-form name="tableform" onbeforesave="" onaftersave="saveTable()"><div class="thumbnail"><img class="imagens_wrapper" fallback-src="http://www.placehold.it/100x50/EFEFEF/AAAAAA&text=sem+imagem" ng-src="{{getImagem(item.data.imgUrl)}}"></div><button type="button" ng-click="addImage(item)" class="btn btn-primary-cg btn-sm"><i class="fa fa-image fa-fw"></i> {{\'BUTTON_IMAGE_PICK\' | translate}}</button> <button type="button" ng-click="item.data.imgUrl=\'\'" class="btn btn-danger btn-sm"><i class="fa fa-trash fa-fw"></i></button></ng-form>');
$templateCache.put('app/components/widgets/htmlImageFull/html.image.full.html','<div class="container"><img class="img-responsive" ng-src="{{getImagem(item.data.imgUrl)}}" style="margin:auto;"></div>');
$templateCache.put('app/components/widgets/htmlSaftFuncs/html.saft.funcionalidades.edit.html','<textarea ui-tinymce="tinymceOptions" ng-model="item.data.html"></textarea>');
$templateCache.put('app/components/widgets/htmlSaftFuncs/html.saft.funcionalidades.html','<div class="container content-margin"><div class="row"><h3 class="page-header-cg" ng-hide="!item.title">{{item.title}}</h3><div class="col-md-1"></div><div class="col-md-10"><div class="table-responsive"><table class="table table-condensed table-striped table-no-border"><thead><tr><th class="text-right funcs-2017"><h4>Funcionalidades</h4></th><th class="text-center funcs-corporate">Corporate<br><small>a partir 50.000 registos</small></th><th class="text-center funcs-pro">Profissional<br><small>a partir 50.000 registos</small></th></tr></thead><tbody><tr><td class="text-right funcs-2017">Visualiza\xE7\xE3o de balancetes e extratos comparativos</td><td class="text-center"><i class="fa fa-check fa-fw green"></i></td><td class="text-center"><i class="fa fa-check fa-fw green"></i></td></tr><tr><td class="text-right funcs-2017">An\xE1lise por rubrica contabil\xEDstica</td><td class="text-center"><i class="fa fa-check fa-fw green"></i></td><td class="text-center"><i class="fa fa-check fa-fw green"></i></td></tr><tr><td class="text-right funcs-2017">Importa\xE7\xE3o manual do ficheiro de compras do efatura</td><td class="text-center"><i class="fa fa-check fa-fw green"></i></td><td class="text-center"><i class="fa fa-check fa-fw green"></i></td></tr><tr><td class="text-right funcs-2017">Execu\xE7\xE3o a 64 bits</td><td class="text-center"><i class="fa fa-check fa-fw green"></i></td><td class="text-center"><i class="fa fa-check fa-fw green"></i></td></tr><tr><td class="text-right funcs-2017">Download do efatura online</td><td class="text-center"><i class="fa fa-times fa-fw red"></i></td><td class="text-center"><i class="fa fa-check fa-fw green"></i></td></tr><tr><td class="text-right funcs-2017">Concilia\xE7\xE3o autom\xE1tica da contabilidade com o efatura</td><td class="text-center"><i class="fa fa-times fa-fw red"></i></td><td class="text-center"><i class="fa fa-check fa-fw green"></i></td></tr><tr><td class="text-right funcs-2017">An\xE1lises multiper\xEDodo</td><td class="text-center"><i class="fa fa-times fa-fw red"></i></td><td class="text-center"><i class="fa fa-check fa-fw green"></i></td></tr><tr><td class="text-right funcs-2017">An\xE1lises por tipologia de lan\xE7amentos</td><td class="text-center"><i class="fa fa-times fa-fw red"></i></td><td class="text-center"><i class="fa fa-check fa-fw green"></i></td></tr><tr><td class="text-right funcs-2017">Download de dados dos Recibos Verdes Eletr\xF3nicos</td><td class="text-center"><i class="fa fa-times fa-fw red"></i></td><td class="text-center"><i class="fa fa-check fa-fw green"></i></td></tr><tr><td class="text-right funcs-2017">Amostragem ao acaso e aleat\xF3ria</td><td class="text-center"><i class="fa fa-times fa-fw red"></i></td><td class="text-center"><i class="fa fa-check fa-fw green"></i></td></tr><tr><td class="text-right funcs-2017">Conclus\xF5es de auditoria</td><td class="text-center"><i class="fa fa-times fa-fw red"></i></td><td class="text-center"><i class="fa fa-check fa-fw green"></i></td></tr><tr><td></td><td class="text-center"><strong>Desde 75\u20AC</strong></td><td class="text-center"><strong>Desde 115\u20AC</strong></td></tr><tr style="background-color: #fff"><td style="border-top: none"></td><td style="border-top: none"><a class="btn btn-corporate btn-sm btn-block" href="#!/loja/pagina/analisador-saft-corporate"><i class="fa fa-tags fa-fw"></i> Ver planos</a></td><td style="border-top: none"><a class="btn btn-pro btn-sm btn-block" href="#!/loja/pagina/analisador-saft-profissional"><i class="fa fa-tags fa-fw"></i> Ver planos</a></td></tr></tbody></table></div></div><div class="col-md-1"></div></div></div>');
$templateCache.put('app/components/widgets/htmlTabs/html.tabs.edit.html','<ng-form editable-form name="tableform" onbeforesave="" onaftersave="saveTable()"><div class="checkbox"><label><input type="checkbox" ng-click="justified == true"> Justificado</label></div><table class="table table-responsive table-condensed table-bordered table-hover"><thead><tr style="font-weight: bold"><td class="col-md-3">Titulo</td><td class="col-md-3" data-translate="PAGINAS_CAROUSEL_EDIT_TEXT"></td><td class="col-md-4" data-translate="PAGINAS_CAROUSEL_EDIT_IMAGE"></td><td class="col-md-2" ng-show="tableform.$visible"></td></tr></thead><tbody><tr ng-repeat="item in item.data.tab.items"><td><span editable-text="item.titulo" e-form="tableform">{{ item.titulo || \'vazio\' }}</span></td><td><textarea ui-tinymce="tinymceOptions" ng-model="item.text"></textarea></td><td><img class="imagens_wrapper" fallback-src="http://www.placehold.it/100x50/EFEFEF/AAAAAA&text=sem+imagem" ng-src="{{getImagem(item.image)}}"></td><td ng-show="tableform.$visible"><button type="button" ng-click="addImage(item)" class="btn btn-primary-cg btn-sm"><i class="fa fa-image fa-fw"></i></button> <button type="button" ng-click="removeItem(item)" class="btn btn-danger btn-sm pull-right"><i class="fa fa-trash fa-fw"></i></button></td></tr></tbody></table><div class="btn-edit"><button type="button" class="btn btn-warning btn-sm" ng-show="!tableform.$visible" ng-click="tableform.$show()"><i class="fa fa-edit fa-fw"></i> &nbsp;<span data-translate="BUTTON_EDIT"></span></button></div><div class="btn-form" ng-show="tableform.$visible"><button type="button" ng-disabled="tableform.$waiting" ng-click="addItem()" class="btn btn-success btn-sm pull-right"><i class="fa fa-plus fa-fw"></i> &nbsp;<span data-translate="BUTTON_ADD_ROW"></span></button> <button type="submit" ng-disabled="tableform.$waiting" class="btn btn-primary-cg btn-sm"><i class="fa fa-save fa-fw"></i> &nbsp;<span data-translate="BUTTON_SAVE"></span></button> <button type="button" ng-disabled="tableform.$waiting" ng-click="tableform.$cancel()" class="btn btn-default btn-sm"><i class="fa fa-remove fa-fw"></i>&nbsp;<span data-translate="BUTTON_CANCEL"></span></button></div></ng-form>');
$templateCache.put('app/components/widgets/htmlTabs/html.tabs.html','<div class="container"><div class="row"><div class="col-md-12"><h3 ng-hide="!item.title" class="page-header-cg">{{item.title}}</h3><tabset active="activeJustified" justified="true"><tab index="{{tab.titulo}}" heading="{{tab.titulo}}" ng-repeat="tab in item.data.tab.items"><br><div class="col-md-2" ng-hide="!tab.image" style="margin-left: -25px;"><img class="img-responsive" ng-src="{{getImagem(tab.image)}}" width="140" height="auto" style="margin:auto;"></div><div ng-class="{\'\': !tab.image,\'col-md-10\': tab.image}"><!--<p>{{tab.text}}</p>--><div ng-hide="!tab.text" ng-bind-html="tab.text"></div></div></tab></tabset></div></div></div><div class="page-header"></div>');
$templateCache.put('app/components/widgets/imgGallery/imgGallery.edit.html','<ng-form name="$ctrl.tableform" editable-form onaftersave="$ctrl.saveTable($data)"><div class="table-responsive"><table class="table table-condensed table-bordered table-hover"><thead><tr style="font-weight: bold"><td style="width:10px">URL</td><td style="width:10px">ThumbUrl</td><td style="width:10px">Caption</td><td style="width:10px" ng-show="$ctrl.tableform.$visible"><button type="button" class="btn btn-success btn-sm" ng-disabled="$ctrl.tableform.$waiting" ng-click="$ctrl.addItem()"><i class="fa fa-plus fa-fw"></i></button></td></tr></thead><tbody><tr ng-repeat="item in $ctrl.item.data.imgGallery.items"><td><div editable-text="item.url">{{item.url || \'vazio\'}}</div></td><td><div editable-text="item.thumbUrl">{{item.thumbUrl || \'vazio\'}}</div></td><td><div editable-text="item.caption">{{item.caption || \'vazio\'}}</div></td><td ng-show="$ctrl.tableform.$visible"><button type="button" class="btn btn-primary-cg btn-sm" ng-click="$ctrl.addImage(item)"><i class="fa fa-image fa-fw"></i></button> <button type="button" class="btn btn-danger btn-sm" ng-click="$ctrl.removeItem(item)"><i class="fa fa-trash fa-fw"></i></button></td></tr></tbody></table></div><div class="btn-edit"><button type="button" class="btn btn-warning btn-sm" ng-show="!$ctrl.tableform.$visible" ng-click="$ctrl.edit()"><i class="fa fa-edit fa-fw"></i>&nbsp;<span data-translate="BUTTON_EDIT"></span></button></div><div class="btn-form" ng-show="$ctrl.tableform.$visible"><button type="button" class="btn btn-primary-cg btn-sm" ng-disabled="$ctrl.tableform.$waiting" ng-click="$ctrl.save()"><i class="fa fa-save fa-fw"></i>&nbsp;<span data-translate="BUTTON_SAVE"></span></button> <button type="button" class="btn btn-default btn-sm" ng-disabled="$ctrl.tableform.$waiting" ng-click="$ctrl.tableform.$cancel()"><i class="fa fa-remove fa-fw"></i>&nbsp;<span data-translate="BUTTON_CANCEL"></span></button></div></ng-form>');
$templateCache.put('app/components/widgets/imgGallery/imgGallery.html','<div class="container"><image-gallery images="$ctrl.item.data.imgGallery.items"></image-gallery></div>');
$templateCache.put('app/components/widgets/jumbotron/jumbotron.edit.html','<form class="well" editable-form name="tableform" onbeforesave="" onaftersave="saveTable()"><div class="form-horizontal"><div class="form-group"><label class="col-sm-2 control-label">Titulo</label><div class="col-sm-10"><input type="text" class="form-control" ng-model="item.data.titulo"></div></div><div class="form-group"><label class="col-sm-2 control-label">Subt\xEDtulo</label><div class="col-sm-10"><textarea class="form-control" rows="3" ng-model="item.data.subTitulo"></textarea></div></div><div class="form-group"><label class="col-sm-2 control-label">Icon</label><div class="col-sm-10"><input class="form-control" rows="3" ng-model="item.data.fontAwesome"></div></div><div class="form-group"><label class="col-sm-2 control-label">Imagem</label><div class="col-sm-10"><img class="imagens_wrapper" fallback-src="http://www.placehold.it/100x50/EFEFEF/AAAAAA&text=sem+imagem" ng-src="{{getImagem(item.data.image)}}"></div></div><button type="button" ng-click="addImage()" class="btn btn-primary-cg btn-sm"><i class="fa fa-image fa-fw"></i> {{\'BUTTON_IMAGE_PICK\' | translate}}</button></div></form>');
$templateCache.put('app/components/widgets/jumbotron/jumbotron.html','<div class="jumbotron-margin"><div back-img="{{getImagem(item.data.image)}}" class="jumbotron"><div class="container"><div class="row jumbotron-caption-margin"><div class="col-md-8"><h1>{{item.data.titulo}}</h1><p>{{item.data.subTitulo}}</p></div><div class="col-md-4"><i class="fa fa-fw jumbotron-icon" ng-class="item.data.fontAwesome"></i></div></div></div></div></div>');
$templateCache.put('app/components/widgets/loja/loja.edit.html','');
$templateCache.put('app/components/widgets/loja/loja.html','<div class="container"><div class="row"><div class="col-xs-12"><h3 class="page-header-cg"><span data-translate="STORE_TITLE"></span> <sup><span class="badge" ng-cloak></span></sup></h3><div class="row"><div class="col-md-3"><div class="loja-affix" pl-affix="$ctrl.affix" ng-style="$ctrl.affix.style"><div class="filtro-margin" ng-repeat="(key, value) in $ctrl.search track by key"><div ng-if="key !== \'tags\' && (item.value || item.value === 0)" ng-repeat="item in value | orderBy : \'_index\' track by $index"><a href class="list-group-item list-group-item-info list-group-item-cg" ng-click="$ctrl.filtroRemove(key,item)"><i class="fa fa-remove fa-fw"></i> {{item.value}}</a></div><div ng-if="key === \'tags\'" ng-repeat="tags in value track by $index"><span ng-repeat="tag in tags.values | orderBy : \'_index\' track by tag.key" ng-if="tag.value || tag.value === 0"><a href class="list-group-item list-group-item-info list-group-item-cg" ng-click="$ctrl.filtroTagRemove(tags,tag)"><i class="fa fa-remove fa-fw"></i> {{tag.value}}</a></span></div></div><div class="accordionHeader"><uib-accordion><div class="acordionProduct" uib-accordion-group is-open="itemcl.open" ng-repeat="itemcl in $ctrl.classificadoresList" ng-if="itemcl.visible && $ctrl.getFiltro(itemcl).length > 1"><uib-accordion-heading><div class="panel-heading-classificadores">{{itemcl.caption}} <i class="pull-right fa fa-chevron-right" pl-animation-rotate="itemcl.open"></i></div></uib-accordion-heading><div class="scroller-filtro"><a href class="list-group list-group-filtro list-group-item list-group-item-filtro" ng-repeat="item in $ctrl.getFiltro(itemcl)" ng-click="$ctrl.filtroAdd(itemcl, item)">{{item.value}}</a></div></div></uib-accordion></div></div></div><div class="col-md-9"><cg-list-nav ng-model="$ctrl.q" list-view="$ctrl.listView" sort-order="$ctrl.sortorder" on-view-change="$ctrl.setListView(listView)" on-sort-order="$ctrl.sortOrderChanged(order)" on-search="$ctrl.doSearch()"></cg-list-nav><div class="row" pl-promise="$ctrl.promise"><div class="cg-classificador-list" ng-init="ctrl = $ctrl.ctrl; item.collapsed = true" dir-paginate="item in $ctrl.produtos.data|itemsPerPage: $ctrl.pageSize track by item.nArtigo" pagination-id="artigos" total-items="$ctrl.produtos.page.total" current-page="$ctrl.currentPage"><div ng-class="{\'clearfix\': $index % $ctrl.itemsPerRow === $ctrl.itemsPerRow - 1}"><ng-include src="$ctrl.boxTemplate"></ng-include></div></div></div><pl-pagination page="$ctrl.currentPage" total="$ctrl.produtos.page.total" on-page-change="$ctrl.onPageChange(page, perPage)" properties="$ctrl.paginationOptions"></pl-pagination></div></div></div></div></div>');
$templateCache.put('app/components/widgets/lojaclassificadores/lojaclassificadores.edit.html','<pl-group><label>Classificador</label><edit><pl-edit type="autocomplete" name="autocomplete" ng-model="$ctrl.item.data.classificador0" properties="{\r\n      source: $ctrl.classificadores,\r\n      rowTemplate: \'{{nome}}\',\r\n      selected: $ctrl.item.data.classificador0,\r\n      output: \'{{nome}}\',\r\n      placeholder: \'Classificador\'\r\n    }"></pl-edit></edit></pl-group>');
$templateCache.put('app/components/widgets/lojaclassificadores/lojaclassificadores.html','<div class="container"><div class="row"><div class="col-xs-12"><h3 class="page-header-cg"><span data-translate="STORE_TITLE"></span> <sup><span class="badge" ng-cloak></span></sup></h3><div class="row"><div class="col-md-3"><div class="classificadores-affix" pl-affix="$ctrl.affix" ng-style="$ctrl.affix.style"><div class="filtro-margin" ng-repeat="(key, value) in $ctrl.search track by $index"><div ng-if="key!==\'tags\' && (item.value || item.value === 0)" ng-repeat="item in value | orderBy : \'_index\' track by $index"><a href class="list-group-item list-group-item-info list-group-item-cg" ng-click="$ctrl.filtroRemove(key,item)"><i class="fa fa-remove fa-fw"></i> {{item.value}}</a></div><div ng-if="key===\'tags\'" ng-repeat="tags in value track by $index"><span ng-repeat="tag in tags.values | orderBy : \'_index\' track by tag.key" ng-if="tag.value || tag.value === 0"><a href class="list-group-item list-group-item-info list-group-item-cg" ng-click="$ctrl.filtroTagRemove(tags,tag)"><i class="fa fa-remove fa-fw"></i> {{tag.value}}</a></span></div></div><div class="accordionHeader"><uib-accordion><div class="acordionProduct" uib-accordion-group is-open="itemcl.openClassificadores" ng-repeat="itemcl in $ctrl.classificadoresList" ng-if="itemcl.visibleClassificadores && $ctrl.getFiltro(itemcl).length > 1"><uib-accordion-heading><div class="panel-heading-classificadores">{{itemcl.caption}} <i class="pull-right fa fa-chevron-right" pl-animation-rotate="itemcl.openClassificadores"></i></div></uib-accordion-heading><div class="scroller-filtro"><a href class="list-group list-group-filtro list-group-item list-group-item-filtro" ng-repeat="item in $ctrl.getFiltro(itemcl)" ng-click="$ctrl.filtroAdd(itemcl,item)">{{item.value}}</a></div></div></uib-accordion></div></div></div><div class="col-md-9"><cg-list-nav ng-model="$ctrl.q" list-view="$ctrl.listViewClassificador" sort-list="$ctrl.sortList" sort-order="$ctrl.sortorder" on-view-change="$ctrl.setListViewClassificador(listView)" on-sort-order="$ctrl.sortOrderChanged(order)" on-search="$ctrl.doSearch()"></cg-list-nav><div class="row" pl-promise="$ctrl.promise"><div class="cg-classificador-list" ng-init="ctrl = $ctrl.ctrl" dir-paginate="classificador in $ctrl.classificadorList|itemsPerPage: $ctrl.pageSize track by $index" pagination-id="classificadorList" total-items="$ctrl.produtos.page.total" current-page="$ctrl.currentPage"><div ng-class="{\'clearfix\': $index % $ctrl.itemsPerRow === $ctrl.itemsPerRow - 1}"><ng-include src="$ctrl.boxTemplateClassificador"></ng-include></div></div></div><pl-pagination page="$ctrl.currentPage" total="$ctrl.produtos.page.total" on-page-change="$ctrl.onPageChange(page, perPage)" properties="$ctrl.paginationOptions"></pl-pagination></div></div></div></div></div>');
$templateCache.put('app/components/widgets/produtos/produtos.edit.html','<select class="form-control" ng-model="item.data.tipo" ng-options="tipo.tipo as tipo.name for tipo in tipos" convert-to-number></select><div ng-show="item.data.tipo===1">Catalogo: <select class="form-control" ng-model="item.data.catalogo" ng-options="item.nome for item in catalogos"></select></div>');
$templateCache.put('app/components/widgets/produtos/produtos.html','<div class="container" ng-show="vm.produtos.length>0"><h3 class="page-header-cg">{{vm.item.title}}</h3><div class="row" ng-init="ctrl = vm.ctrl"><div ng-repeat="item in vm.produtos"><ng-include src="\'produto.promocao\'"></ng-include></div></div></div>');
$templateCache.put('app/components/widgets/reservasestadias/reservasestadias.edit.html','<div><h4 data-translate="widgets.reservasestadias.edit.header"></h4><textarea ui-tinymce="$ctrl.tinymceOptions" ng-model="$ctrl.item.data.sectionStartHeader"></textarea></div>');
$templateCache.put('app/components/widgets/reservasestadias/reservasestadias.html','<div class="container reservasestadias"><div class="row"><div class="col-xs-12"><cg-reservas-estadias token="$ctrl.token" section-start-header="$ctrl.item.data.sectionStartHeader" section-rgpd-terms="$ctrl.item.data.sectionRgpdTerms"></cg-reservas-estadias></div></div></div>');
$templateCache.put('app/components/widgets/reservasestadias/reservasestadias.rgpd.html','<div compile="$config.data.modelos.rgpd"></div>');
$templateCache.put('app/loja/carrinho/steps/step1.carrinho.html','<div class="row"><div class="col-md-9"><div ng-include="\'app/loja/carrinho/carrinho.table.html\'"></div></div><div class="col-md-3"><div class="carrinhoTotalAffix" pl-affix="$ctrl.affix" ng-style="$ctrl.affix.style"><div ng-include="\'app/loja/carrinho/carrinho.total.html\'"></div></div></div></div>');
$templateCache.put('app/loja/carrinho/steps/step2.moradas.html','<div class="row"><div class="col-md-9 cartPanel"><div class="col-md-6"><div class="panel panel-default"><div class="panel-heading text-uppercase" data-translate="carrinho.moradas.faturacao"></div><div class="panel-body"><div class="row"><div class="col-md-6"><form><select class="form-control input-sm" ng-options="moradaFaturacao.nome for moradaFaturacao in $ctrl.clienteMoradasAlt" ng-model="$ctrl.moradaFaturacao"></select></form><br><button class="btn btn-warning btn-sm" ng-click="$ctrl.editMorada($ctrl.moradaFaturacao)"><i class="fa fa-pencil"></i> <span data-translate="utilizador.perfil.moradas.buttons.editar"></span></button> <button class="btn btn-primary btn-sm" ng-click="$ctrl.newMoradaAlt(\'newMoradaFaturacao\')" ng-if="$ctrl.storage.clienteData.cliente.completed"><i class="fa fa-plus-circle"></i> <span data-translate="utilizador.perfil.moradas.buttons.nova"></span></button></div><div class="col-md-6"><span class="font-12">{{$ctrl.moradaFaturacao.contactoNome}}<br>{{$ctrl.moradaFaturacao.rua}} {{$ctrl.moradaFaturacao.morada}}<br>{{$ctrl.moradaFaturacao.cpost}} {{$ctrl.moradaFaturacao.localidade}}<br>{{$ctrl.moradaFaturacao.paisIso.nomePais}}</span></div></div></div></div><pl-edit type="checkbox" ng-model="$ctrl.moradaEntregaDiferente" properties="{label: \'carrinho.stepMoradas.moradaEntregaDiferente\'}" ng-change="$ctrl.moradaEntregaDiferenteChange()" ng-if="$ctrl.storage.clienteData.cliente.completed"></pl-edit></div><div class="col-md-6"><div class="panel panel-default" ng-if="$ctrl.moradaEntregaDiferente"><div class="panel-heading text-uppercase" data-translate="carrinho.moradas.entrega"></div><div class="panel-body"><div class="row"><div class="col-md-6"><form><select class="form-control input-sm" ng-options="moradaEntrega.nome for moradaEntrega in $ctrl.clienteMoradasAlt" ng-model="$ctrl.moradaEntrega"></select></form><br><button class="btn btn-warning btn-sm" ng-click="$ctrl.editMorada($ctrl.moradaEntrega)"><i class="fa fa-pencil"></i> <span data-translate="utilizador.perfil.moradas.buttons.editar"></span></button> <button class="btn btn-primary btn-sm" ng-click="$ctrl.newMoradaAlt(\'newMoradaEntrega\')"><i class="fa fa-plus-circle"></i> <span data-translate="utilizador.perfil.moradas.buttons.nova"></span></button></div><div class="col-md-6"><span class="font-12">{{$ctrl.moradaEntrega.contactoNome}}<br>{{$ctrl.moradaEntrega.rua}} {{$ctrl.moradaEntrega.morada}}<br>{{$ctrl.moradaEntrega.cpost}} {{$ctrl.moradaEntrega.localidade}}<br>{{$ctrl.moradaEntrega.paisIso.nomePais}}</span></div></div></div></div></div></div><div class="col-md-3"><div ng-include="\'app/loja/carrinho/carrinho.total.html\'"></div></div></div>');
$templateCache.put('app/loja/carrinho/steps/step3.envio.html','<div class="row"><div class="col-md-9 cartPanel"><div class="col-md-6"><div class="panel" ng-class="{\'panel-danger\': !$ctrl.transportadoras.length, \'panel-default\': $ctrl.transportadoras.length}"><div class="panel-heading" data-translate="carrinho.stepEnvio.transporte"></div><div class="panel-body"><div class="row"><div class="col-sm-12"><p ng-if="!$ctrl.transportadoras.length" data-translate="carrinho.stepEnvio.transporteIndisponivel"></p><pl-form ng-if="$ctrl.transportadoras.length"><div ng-repeat="item in $ctrl.transportadoras track by item.codTransportadora"><pl-edit type="radio" ng-model="$ctrl.storage.codTransportadora" properties="{value: item.codTransportadora, label: item.nome}" ng-change="$ctrl.onEnvioChange(item)"></pl-edit></div></pl-form></div></div></div></div></div><div class="col-md-6" ng-if="$ctrl.transportadora.nContaPickup"><div class="panel panel-default"><div class="panel-heading" data-translate="carrinho.stepEnvio.localPickup"></div><div class="panel-body"><div class="row"><div class="col-sm-12"><form><select class="form-control input-sm" ng-options="moradapickup.nome for moradapickup in $ctrl.moradasAlternativasTransportadoras" ng-model="$ctrl.moradaPickup"></select></form><p class="font-12">{{$ctrl.moradaPickup.contactoNome}}<br>{{$ctrl.moradaPickup.rua}} {{$ctrl.moradaPickup.morada}}<br>{{$ctrl.moradaPickup.cpost}} {{$ctrl.moradaPickup.localidade}}<br>{{$ctrl.moradaPickup.paisIso.nomePais}}</p></div></div></div></div></div></div><div class="col-md-3"><div ng-include="\'app/loja/carrinho/carrinho.total.html\'"></div></div></div>');
$templateCache.put('app/loja/carrinho/steps/step4.resumo.html','<div class="row"><div class="col-md-9 cartPanel"><div ng-include="\'app/loja/carrinho/carrinho.table.html\'"></div><div class="panel panel-default"><div class="panel-heading" data-translate="carrinho.stepResumo.moradas"></div><div class="panel-body"><div class="row"><div class="col-md-4"><h6 class="page-header-cg text-uppercase font-bold" data-translate="carrinho.moradas.faturacao"></h6><p class="font-12">{{$ctrl.moradaFaturacao.contactoNome}}<br>{{$ctrl.moradaFaturacao.rua}} {{$ctrl.moradaFaturacao.morada}}<br>{{$ctrl.moradaFaturacao.cpost}} {{$ctrl.moradaFaturacao.localidade}}<br>{{$ctrl.moradaFaturacao.paisIso.nomePais}}</p></div><div class="col-md-4"><h6 class="page-header-cg text-uppercase font-bold" data-translate="carrinho.moradas.entrega"></h6><p class="font-12" ng-hide="$ctrl.transportadora.nContaPickup">{{$ctrl.moradaEntrega.contactoNome}}<br>{{$ctrl.moradaEntrega.rua}} {{$ctrl.moradaEntrega.morada}}<br>{{$ctrl.moradaEntrega.cpost}} {{$ctrl.moradaEntrega.localidade}}<br>{{$ctrl.moradaEntrega.paisIso.nomePais}}</p><p class="font-12" ng-show="$ctrl.transportadora.nContaPickup">{{$ctrl.moradaPickup.nome}}<br>{{$ctrl.moradaPickup.rua}} {{$ctrl.moradaPickup.morada}}<br>{{$ctrl.moradaPickup.cpost}} {{$ctrl.moradaPickup.localidade}}<br>{{$ctrl.moradaPickup.paisIso.nomePais}}</p></div><div class="col-sm-4"><h6 class="page-header-cg text-uppercase font-bold" data-translate="carrinho.stepEnvio.transporte"></h6><p class="font-12">{{$ctrl.transportadora.nome}}</p><p class="font-12" ng-if="!$ctrl.transportadora.nome" data-translate="carrinho.stepResumo.meioEnvioVazio"></p></div></div></div></div><div class="panel panel-default" ng-if="($ctrl.storage.condicoesPagamentoList| filter:{visible:true}).length>0"><div class="panel-heading text-uppercase" data-translate="CART_DISCOUNT_CONDITIONS"></div><div class="panel-body"><ul class="list-group"><li class="list-group-item" ng-repeat="item in $ctrl.storage.condicoesPagamentoList  | filter : {visible: true}"><div class="row"><div class="col-sm-1"><h4><span class="label label-success" ng-if="item.taxa > 0">{{CART_PAGE_DISCOUNT| translate}} {{item.taxa}}%</span></h4></div><div class="col-sm-11"><pl-edit type="boolean" ng-model="item.checked" properties="{value: item.ncondpag, label: item.descricao}" ng-change="$ctrl.setNCondPag(item.ncondpag)"></pl-edit></div></div></li></ul></div></div><div class="panel panel-default" ng-if="$ctrl.meiosPagamento.length > 0"><div class="panel-heading" data-translate="carrinho.stepResumo.meioPagamento"></div><div class="panel-body"><div class="row"><div class="col-md-12"><pl-form><ul class="list-group"><li class="list-group-item" ng-repeat="item in $ctrl.meiosPagamento track by item.ncaixa"><div class="row"><div class="col-sm-1"><img src="assets/images/multibanco-logo.png" width="60%" ng-if="item.tipo === 2"> <img src="assets/images/transferencia-logo.png" width="60%" ng-if="item.tipo === 8"> <img src="assets/images/paypal-logo.png" width="60%" ng-if="item.tipo === 9"></div><div class="col-sm-11"><pl-edit type="radio" ng-model="$ctrl.nCaixa" properties="{value: item.ncaixa, label: item.nome, icon: item.icon}" ng-change="$ctrl.onMeioPagamentoChange(item)"></pl-edit></div></div></li></ul></pl-form></div></div></div></div></div><div class="col-md-3"><div class="carrinhoTotalResumoAffix" pl-affix="$ctrl.affixResumo" ng-style="$ctrl.affixResumo.style"><div ng-include="\'app/loja/carrinho/carrinho.total.html\'"></div></div></div></div>');
$templateCache.put('app/loja/carrinho/steps/step5.encomenda.html','<div class="row"><div class="col-md-12"><documento source="$ctrl.getDocumento" target-id="$ctrl.activeDoc" template="documento"></documento><button type="button" class="btn btn-success pull-right" ng-click="$ctrl.newOrder()" pl-promise><i class="fa fa-repeat" aria-hidden="true"></i>&nbsp;<span data-translate="carrinho.stepEncomenda.novaCompra"></span></button></div></div>');
$templateCache.put('app/loja/utilizador/documentos/documentos.html','<div class="container"><div class="row"><div class="col md-12"><ol class="breadcrumb breadcrumb-cg"><li><a ui-sref="loja.home({id:\'inicio\'})"><i class="fa fa-home fa-fw"></i></a></li><li class="active" data-translate="{{$state.current.title}}"></li></ol><h3 class="page-header-cg" data-translate="{{$state.current.title}}"></h3><!--<input class="form-control input-sm" ng-model="ctrl.search" ng-model-options="{debounce: 500}" autofocus>--><pl-table definition="ctrl.definition" selected="ctrl.model" source="ctrl.onLoad" callback="ctrl.callback" search="ctrl.search" order="ctrl.definition.order" options="ctrl.definition.options" on-select="ctrl.onDocSelect" on-detail="ctrl.onDocDetail"><item-detail><documento source="item._thedoc" target-id="item.mbfaccbId" template="documento"></documento></item-detail></pl-table></div></div></div>');
$templateCache.put('app/loja/utilizador/encomendas/encomendas.html','<div class="container"><ol class="breadcrumb breadcrumb-cg"><li><a ui-sref="loja.home({id:\'inicio\'})"><i class="fa fa-home fa-fw"></i></a></li><li class="active" data-translate="{{$state.current.title}}"></li></ol><h3 class="page-header-cg" data-translate="{{$state.current.title}}"></h3><div class="ng-cloak" ng-cloak><div class="row"><div class="col-md-12"><pl-table definition="ctrl.definition" selected="ctrl.model" source="ctrl.onLoad" callback="ctrl.callback" order="ctrl.definition.order" options="ctrl.definition.options" on-select="ctrl.onDocSelect" on-detail="ctrl.onDocDetail"><item-detail><documento source="item._thedoc" target-id="item._activeDoc" template="documento" ng-if="!item.isDocSynced"></documento><documento source="item._thedoc" target-id="item._activeDoc" template="fatura" ng-if="item.isDocSynced"></documento></item-detail></pl-table></div></div></div></div><!--\r\n<div class="container">\r\n  <ol class="breadcrumb breadcrumb-cg">\r\n    <li><a ui-sref="loja.home({id:\'inicio\'})"><i class="fa fa-home fa-fw"></i></a></li>\r\n    <li class="active" data-translate="{{$state.current.title}}"></li>\r\n  </ol>\r\n  <h3 class="page-header-cg" data-translate="{{$state.current.title}}"></h3>\r\n\r\n  <div class="ng-cloak" ng-cloak>\r\n    <div class="row">\r\n      <div class="col-md-6">\r\n        <table class="table table-striped table-responsive table-bordered" at-table at-paginated at-list="ctrl.list" at-config="ctrl.config">\r\n          <thead></thead>\r\n          <tbody>\r\n          <tr class="table-doc" ng-class="{\'info\': ctrl.isSelected(item)}" ng-click="ctrl.setActive(item)">\r\n            <td at-attribute="nDoc" at-implicit at-title="{{\'ACOOUNT_DOCS_TABLE_TH_NDOC\' | translate}}"></td>\r\n\r\n            <td at-attribute="dataDoc" at-sortable at-initial-sorting="desc" at-title="{{\'ACCOUNT_DOCS_TABLE_TH_DATA\' | translate}}">{{item.dataDoc |\r\n              date:\'dd-MM-yyyy\'}}\r\n            </td>\r\n\r\n            <td class="text-right" at-attribute="totalDocumento" at-sortable at-title="{{\'ACCOUNT_DOCS_TABLE_TH_TOTAL\' | translate}}">\r\n              {{item.totalDocumento | currency : \'\u20AC\'}}\r\n            </td>\r\n\r\n            <td at-attribute="nomeEstado" at-implicit at-sortable at-title="{{\'ADMIN_DOCS_TABLE_TH_STATE\' | translate}}"></td>\r\n          </tr>\r\n          </tbody>\r\n        </table>\r\n        <at-pagination at-list="ctrl.list" at-config="ctrl.config"></at-pagination>\r\n      </div>\r\n      <div class="col-md-6">\r\n        <documento source="ctrl.source"\r\n                   target-id="ctrl.activeDoc"\r\n                   template="ctrl.template"\r\n                   show-print="!ctrl.isDocSynced"\r\n                   show-pdf="ctrl.isDocSynced"\r\n                   pdf-url="ctrl.pdfUrl">\r\n        </documento>\r\n      </div>\r\n\r\n    </div>\r\n  </div>\r\n</div>-->');
$templateCache.put('app/loja/utilizador/encomendas/fatura.html','<div ng-if="!$ctrl.hasDoc()" data-translate="NO_DOC_SELECT"></div><div ng-if="$ctrl.hasDoc()"><div id="printfac" class="panel panel-default"><div class="panel-heading"><div class="visible-print visible-print-inline text-center"><img ng-src="{{logo}}" alt="Logo"><br><br></div><h3 class="panel-title"><strong>{{$ctrl.doc.cab.docNome}} N\xBA: </strong>{{$ctrl.doc.cab.nDoc}} <span class="pull-right"><strong data-translate="DOC_FAC_HEADER_DATA"></strong>{{$ctrl.doc.cab.dataDoc | date:\'dd-MM-yyyy\'}}</span></h3></div><div class="panel-body"><div class="fac-doc"><div class="visible-print visible-print-inline"><p><span class="text-right"><strong data-translate="DOC_FAC_HEADER_NCONTA"></strong> </span><span class="text-right">{{$ctrl.doc.clifo.nConta}}</span></p><p><span class="text-right"><strong data-translate="DOC_FAC_HEADER_NAME"></strong> </span><span class="text-right">{{$ctrl.doc.clifo.nome}}</span></p><p><strong data-translate="DOC_FAC_HEADER_ADDRESS"></strong> <span class="text-right">{{$ctrl.doc.clifo.rua + \', \' + $ctrl.doc.clifo.nomePais}}</span></p><p><strong data-translate="DOC_FAC_HEADER_CP"></strong> <span class="text-right">{{$ctrl.doc.clifo.codPostal}}</span>&nbsp; <span class="text-right">{{$ctrl.doc.clifo.localidade}}</span></p><p><strong data-translate="DOC_FAC_HEADER_NIF"></strong> <span class="text-right">{{$ctrl.doc.clifo.nifReal}}</span></p></div><dl class="dl-horizontal hidden-print"><dt data-translate="DOC_FAC_HEADER_NCONTA"></dt><dd>{{$ctrl.doc.clifo.nConta}}</dd><dt data-translate="DOC_FAC_HEADER_NAME"></dt><dd>{{$ctrl.doc.clifo.nome}}</dd><dt data-translate="DOC_FAC_HEADER_ADDRESS"></dt><dd>{{$ctrl.doc.clifo.rua + \', \' + ctrl.doc.clifo.nomePais}}</dd><dt data-translate="DOC_FAC_HEADER_CP"></dt><dd>{{$ctrl.doc.clifo.codPostal}}&nbsp;{{$ctrl.doc.clifo.localidade}}</dd><dt data-translate="DOC_FAC_HEADER_NIF"></dt><dd>{{$ctrl.doc.clifo.nifReal}}</dd></dl></div><div class="table-responsive"><table class="table table-striped font-table table-documento" at-table at-list="$ctrl.doc.linhas"><thead></thead><tbody><tr><td width="35%" class="font-table-artigo" at-implicit at-attribute="nomeArtigo" at-title="{{\'DOC_FAC_TABLE_TH_PRODUCT\' | translate}}"></td><td width="15%" class="table-currency" at-attribute="prVenda" at-title="{{\'DOC_FAC_TABLE_TH_PRICE\' | translate}}">{{item.prVenda1 | currency : \'\u20AC \' : 2}}</td><td width="5%" at-attribute="qtd1" at-title="{{\'DOC_FAC_TABLE_TH_QTD\' | translate}}">{{item.qtd1 | number: 2}}</td><td width="10%" at-attribute="desconto" at-title="{{\'DOC_FAC_TABLE_TH_DISCOUNT\' | translate}}"><span ng-hide="item.d1 === 0">{{item.d1 | number: 2}}%</span> <span ng-hide="item.d2 === 0">{{item.d2 | number: 2}}%</span> <span ng-hide="item.d3 === 0">{{item.d3 | number: 2}}%</span> <span ng-hide="item.d4 === 0">{{item.d4 | number: 2}}%</span> <span ng-hide="item.d5 === 0">{{item.d5 | number: 2}}%</span> <span ng-hide="item.d6 === 0">{{item.d6 | number: 2}}%</span></td><td width="15%" at-attribute="taxaIva" at-title="{{\'DOC_FAC_TABLE_TH_IVA\' | translate}}">{{item.taxaIva | number: 2}}%</td><td width="20%" at-attribute="valorComIva2D" at-title="{{\'DOC_FAC_TABLE_TH_VALUE\' | translate}}">{{item.prVendaIvaInc | currency : \'\u20AC \' : 2}}</td></tr></tbody></table></div><hr><div class="fac-doc-totais clearfix"><dl class="dl-horizontal pull-right"><div><dt data-translate="DOC_FAC_TABLE_TH_TOTAl"></dt><dd class="text-right">{{$ctrl.doc.cab.totalLiquido | currency: \'\u20AC \'}}</dd></div><div><dt data-translate="DOC_FAC_TABLE_TH_IVA_TOTAl"></dt><dd class="text-right">{{$ctrl.doc.cab.totalIva | currency: \'\u20AC \'}}</dd></div><div><dt data-translate="DOC_FAC_TABLE_TH_TOTAl_FINAL"></dt><dd class="text-right">{{$ctrl.doc.cab.totalDocumento | currency: \'\u20AC \'}}</dd></div></dl></div></div><div class="panel-footer"><div class="fac-doc-footer hidden-print"><button type="button" class="btn btn-default btn-sm" print-div="#printfac" ng-if="$ctrl.showPrint === true"><i class="fa fa-print"></i><span data-translate="BUTTON_PRINT"></span></button> <a ng-attr-href="{{$ctrl.pdfUrl}}" target="_blank" class="btn btn-primary btn-sm" ng-if="$ctrl.showPdf === true"><i class="fa fa-file-pdf-o"></i><span data-translate="BUTTON_PDF"></span></a></div></div></div></div>');
$templateCache.put('app/loja/utilizador/faturas/faturas.html','<div class="container"><ol class="breadcrumb breadcrumb-cg"><li><a ui-sref="loja.home({id:\'inicio\'})"><i class="fa fa-home fa-fw"></i></a></li><li class="active" data-translate="{{$state.current.title}}"></li></ol><h3 class="page-header-cg" data-translate="{{$state.current.title}}"></h3><div class="ng-cloak" ng-cloak><div class="row"><div class="col-md-12"><pl-table definition="ctrl.definition" selected="ctrl.model" source="ctrl.onLoad" callback="ctrl.callback" order="ctrl.definition.order" options="ctrl.definition.options" on-select="ctrl.onDocSelect" on-detail="ctrl.onDocDetail"><item-detail><documento source="item._thedoc" target-id="item.faccbId" template="fatura"></documento></item-detail></pl-table></div></div></div></div>');
$templateCache.put('app/loja/utilizador/movimentosAberto/movimentosAberto.html','<div class="container"><ol class="breadcrumb breadcrumb-cg"><li><a ui-sref="loja.home({id:\'inicio\'})"><i class="fa fa-home fa-fw"></i></a></li><li class="active" data-translate="{{$state.current.title}}"></li></ol><h3 class="page-header-cg" data-translate="{{$state.current.title}}"></h3><div class="ng-cloak" ng-cloak><div class="row"><div class="col-md-12"><pl-table definition="ctrl.definition" selected="ctrl.model" source="ctrl.onLoad" callback="ctrl.callback" order="ctrl.definition.order" options="ctrl.definition.options" on-select="ctrl.onDocSelect" on-detail="ctrl.onDocDetail"></pl-table></div></div></div></div>');
$templateCache.put('app/loja/utilizador/perfil/perfil.dadosfaturacao.html','<div class="panel panel-primary"><div class="panel-heading panel-cg"><h3 class="panel-title" data-translate="utilizador.perfil.moradas.title"></h3></div><div class="panel-body"><div class="row"><div class="col-md-6"><h4 class="page-header-cg" data-translate="utilizador.perfil.moradas.fatura.title"></h4><dl class="dl-horizontal"><dt data-translate="utilizador.perfil.moradas.fatura.cliente"></dt><dd>{{ctrl.moradaFaturacao.nconta}}</dd><dt data-translate="utilizador.perfil.moradas.fatura.name"></dt><dd>{{ctrl.moradaFaturacao.contactoNome}}</dd><dt data-translate="utilizador.perfil.moradas.fatura.address"></dt><dd>{{ctrl.moradaFaturacao.morada}}</dd><dt data-translate="utilizador.perfil.moradas.fatura.cp"></dt><dd>{{ctrl.moradaFaturacao.cpost}} - {{ctrl.moradaFaturacao.localidade}}</dd><dt data-translate="utilizador.perfil.moradas.fatura.pais"></dt><dd>{{ctrl.moradaFaturacao.paisIso.nomePais}}</dd><dt data-translate="utilizador.perfil.moradas.fatura.nif"></dt><dd>{{ctrl.moradaFaturacao.nipc}}</dd><dt data-translate="utilizador.perfil.moradas.fatura.telefone"></dt><dd>{{ctrl.moradaFaturacao.contactoTelefone}}</dd><br><dt></dt><dd><a href ng-click="ctrl.editMoradaFaturacao(ctrl.moradaFaturacao)" class="btn btn-warning"><i class="fa fa-edit"></i> {{\'utilizador.perfil.moradas.buttons.editar\' | translate}}</a></dd></dl></div><div class="col-md-6"><h4 class="page-header-cg" data-translate="utilizador.perfil.moradas.entrega.title"></h4><uib-accordion><div uib-accordion-group is-open="moradaEntrega.open" ng-repeat="moradaEntrega in ctrl.clienteMoradasAlt"><uib-accordion-heading>{{moradaEntrega.nome}} <i class="pull-right fa" ng-class="{\'fa-chevron-down\': moradaEntrega.open, \'fa-chevron-right\': !moradaEntrega.open}"></i></uib-accordion-heading><dl class="dl-horizontal"><dt data-translate="utilizador.perfil.moradas.entrega.name"></dt><dd>{{moradaEntrega.contactoNome}}</dd><dt data-translate="utilizador.perfil.moradas.entrega.address"></dt><dd>{{moradaEntrega.rua}} {{moradaEntrega.morada}}</dd><dt data-translate="utilizador.perfil.moradas.entrega.cp"></dt><dd>{{moradaEntrega.cpost}} - {{moradaEntrega.localidade}}</dd><dt data-translate="utilizador.perfil.moradas.entrega.pais"></dt><dd>{{moradaEntrega.paisIso.nomePais}}</dd><dt data-translate="utilizador.perfil.moradas.entrega.telefone"></dt><dd>{{moradaEntrega.contactoTelefone}}</dd><br><dt></dt><dd><a href ng-click="ctrl.editMoradaEntrega(moradaEntrega)" class="btn btn-warning btn-sm"><i class="fa fa-edit"></i> {{\'utilizador.perfil.moradas.buttons.editar\' | translate}} </a><a href ng-click="ctrl.deleteMoradaEntrega(moradaEntrega)" class="btn btn-danger btn-sm"><i class="fa fa-trash"></i> {{\'utilizador.perfil.moradas.buttons.apagar\' | translate}}</a></dd></dl></div></uib-accordion><button ng-click="ctrl.newMorada()" class="btn btn-primary-cg" ng-if="ctrl.moradaFaturacao.completed"><i class="fa fa-plus-circle"></i> {{\'utilizador.perfil.moradas.buttons.nova\' | translate}}</button></div></div></div></div>');
$templateCache.put('app/loja/utilizador/perfil/perfil.html','<div class="container"><ol class="breadcrumb breadcrumb-cg"><li><a ui-sref="loja.home({id:\'inicio\'})"><i class="fa fa-home fa-fw"></i></a></li><li class="active" data-translate="utilizador.perfil.title"></li></ol><div class="panel panel-primary"><div class="panel-heading panel-cg"><h3 class="panel-title" data-translate="utilizador.perfil.title"></h3></div><div class="panel-body"><div class="row"><div class="col-md-2 text-primary"><span class="glyphicon glyphicon-user"></span></div><div class="col-md-8"><dl class="dl-horizontal"><dt></dt><dd><h3>{{ctrl.user.name}}</h3></dd><dt data-translate="utilizador.perfil.email"></dt><dd>{{ctrl.user.email}}</dd><dt data-translate="utilizador.perfil.email_valid"></dt><dd>{{ctrl.user.emailValidated}}</dd><span ng-show="ENV===\'dev\'"><dt data-translate="utilizador.perfil.token"></dt><dd>{{ctrl.user.token}}</dd></span><dt data-translate="utilizador.perfil.roles"></dt><dd ng-repeat="role in ctrl.user.roles">{{role.name}}</dd></dl></div><div class="col-md-2"></div></div></div></div><div ui-view></div></div>');}]);})();